/* assets/configurator-base-lib.js */

(function (global) {
  'use strict';

  var VERSION = 'pool-v10-lightcut';   /* pool-v10 (Marek 2026-11-04 09:44 "Na rezu je zbytecne moc tmava plocha vody, vypada to neprirozene"): the water's section fill a light clear blue (the hidden bodies' colour 0x92cdf0, was 0x4f9fd1) */
  /* previous: var VERSION = 'pool-v9-water';   /* pool-v9 (Marek 2026-11-04 08:37 "aby byla voda solid, ktery vyplnuje jen volny prostor jako v realite a pocital se z ni i jeji objem"): THE WATER A SOLID OF THE FREE SPACE -- the stairs carved out of the deep water (a notch on their wall) with a shallow water block over each tread (as over the zones' shelves); a hidden closed body per block so the section tool fills the water's cut in blue; the water volume (the top bar's OBJEM and the bill's waterVol) summed from those blocks less the divider pillars (was: the footprint's / the inner area x depth, the stairs not taken off -- the top bar even used the outer footprint); the hidden bodies' sides wound by the polygon (byWinding), the centroid test turned the stairs' notch inward and the cut skipped the body; the full-width stairs' outline spike removed; the deep block from the floor finish's top and the 20 mm wall lining taken off the volume (POOL_FIN_T); a stairs / style change no longer turns the cut off (_forceRender3DFlush's 3D-2D-3D round trip, _poolRoundTrip) *-/ */
  /* previous: var VERSION = 'pool-v7-buyer'; */

  /* Default fence polygon -- 20x20m closed square. Fence is independent
     of any house foundation so we pick a generous starting envelope; the
     user can drag any corner to reshape and the rest of the engine
     handles arbitrary convex/concave outlines just as in base. */
  var FT = 0.3048;
  function _defaultPoolPolygon() {
    var LONG = 20 * FT, SHORT = 12 * FT;        /* default pool 20 x 12 ft */
    /* Desktop -> landscape (long side horizontal); mobile / everything else
       -> portrait (long side vertical). */
    var isDesktop = (typeof window !== 'undefined' && window.matchMedia &&
                     window.matchMedia('(min-width: 1024px) and (pointer: fine)').matches);
    var halfX, halfZ;
    if (isDesktop) { halfX = LONG / 2; halfZ = SHORT / 2; }
    else           { halfX = SHORT / 2; halfZ = LONG / 2; }
    return [
      [-halfX, -halfZ],
      [ halfX, -halfZ],
      [ halfX,  halfZ],
      [-halfX,  halfZ]
    ];
  }
  var DEFAULT_POLYGON = _defaultPoolPolygon();

  var STATE = {
    variant: 1,
    lvl: 1,
    isMetric: false,
    /* Fresh load / restart shows the 3D model. The view is deliberately not
       persisted -- boot() frames it with fitCameraToFootprint() and the 2D
       plan is one tap away. */
    view: '3d',
    opacity2D: 0.15,
    vizStage: 1,
    slopeDeg: 0,
    slopeActive: false,
    mapLocked: false,
    polygon: JSON.parse(JSON.stringify(DEFAULT_POLYGON)),
    /* Pool basin depth (m). null = use the current variant default.
       Adjustable via the depth slider. Replaces the fence "woodHeight". */
    depth: null,
    /* Water-edge system: 'skimmer' (water ~150 mm below coping, wall-mounted
       skimmers) or 'overflow' (water at coping level, perimeter overflow
       channel + balancing tank) or 'infinite' (vanishing edge: chosen edges
       overflow over a knife-edge into an open gutter, the rest behave as
       skimmer). Toggled by the edge-type button. */
    edgeType: 'skimmer',
    /* For 'infinite': which footprint edge indices are vanishing/overflow
       edges (the rest are skimmer-style). Empty -> default to the longest edge. */
    infiniteEdges: [],
    /* Wall material for the block variant: 'concrete' (hollow formwork blocks
       + concrete fill) or 'eps' (EPS lost-formwork + solid concrete core).
       Orthogonal to the variant; ignored for gunite. Toggled by the material
       button. Stairs stay concrete in both cases. */
    wallMaterial: 'concrete',
    /* Pool interior surface finish: 'liner' | 'plaster' | 'tiles' | 'pebble' |
       'inox'. Drives the FINISHES branch of the BoQ. Geometry-neutral.
       Toggled by the surface button in the info bar. */
    surface: 'liner',
    /* Technology shaft (underground plastic box with a lid) placed beside the
       pool. {x,z} world centre; null = auto-place next to the longest wall.
       Size is derived from the water volume. Drag-positioned in 2D. */
    shaft: null,
    /* Whirlpool / jacuzzi placeholder for the future separate configurator.
       {x,z} world centre; null = auto-place beside the longest wall. Draggable
       anywhere in 2D; never affects the pool shape. */
    whirlpool: null,
    /* Overflow balance/surge tank (underground box). Like the shaft: draggable
       in 2D, sized by water volume. Only used/shown in overflow edge mode. */
    tank: null,
    /* Skimmers + return jets: arrays of {x,z} world positions. null = derive
       from the auto-layout (by perimeter) and then become draggable in 2D.
       Height is fixed (water line / below); only X/Z move. */
    skimmers: null,
    jets: null,
    /* Pool lights. lightStage 0 = off; 1..5 = density (lights per length).
       Stage 1 = 1 light / 5 m of wall. lightPos: 'A' top | 'B' middle |
       'C' bottom (vertical position on the wall). */
    lightStage: 0,
    lightPos: 'A',
    lights: null,
    /* Electrical panel (wall-mounted distribution cabinet). Position like the
       shaft: draggable in 2D, mounted on the wall (raised) in 3D. */
    panel: null,
    /* Stairs: mode = none | ladder | corner1 (short, 2 blocks wide, 1-block
       tread) | corner2 (long, 3 blocks wide, 2-block tread) | full (whole
       edge). slot = placement index into the edgexend list, advanced by the
       mirror button (clockwise + mirror to the opposite wall). */
    stairsMode: 'none',
    stairsSlot: 0
  };
  var DEFAULTS = JSON.parse(JSON.stringify(STATE));

  var MAX_COORD = 30.0;
  var SNAP_M = 0.050;

  /* Pool variants -- three wall-construction systems. All share the same
     basin geometry (slab, gravel bed, coping, depth range); they differ
     only in how the perimeter wall is built, which drives the wall BoQ.
       1 concrete_block -- ztracene bedneni (concrete formwork blocks) + rebar + concrete fill
       2 eps_block      -- polystyrene (EPS) lost-formwork blocks + rebar + concrete core
       3 gunite         -- sprayed concrete (shotcrete) over a dense rebar cage
     The overflow/skimmer edge system is an orthogonal toggle (STATE.edgeType). */
  var POOL_BASIN = {
    depthM:        1.5,    /* default basin depth (slider) */
    depthMinM:     0.20,   /* legacy; effective min is 1 row (course) -- see getCurrentDepthRange */
    depthMaxM:     2.5,
    slabThickM:    0.20,   /* reinforced bottom slab */
    slabOverhangM: 0.15,   /* slab extends 150 mm beyond the wall outer face */
    bedGravelM:    0.15,   /* compacted gravel bedding under the slab */
    bedGravelOverhangM: 0.25,  /* gravel base extends 250 mm past the wall (slab 150 + 100) */
    freeboardM:    0.15,   /* skimmer: water line below coping; overflow: ~0 */
    copingWidthM:  0.30,   /* lemovaci kamen width */
    excavOversizeM:0.40    /* working space dug beyond the shell, each side */
  };
  function _basin(extra) {
    var o = {};
    for (var k in POOL_BASIN) if (POOL_BASIN.hasOwnProperty(k)) o[k] = POOL_BASIN[k];
    if (extra) for (var k2 in extra) if (extra.hasOwnProperty(k2)) o[k2] = extra[k2];
    return o;
  }
  var VARIANT_DEFAULTS = {
    concrete_block: _basin({
      wallThickM: 0.30,    /* 300 mm formwork block */
      blockL:     0.50, blockH: 0.25, blockW: 0.30,  /* ztracene bedneni 500x250x300 */
      wallSystem: 'block'
    }),
    eps_block: _basin({
      wallThickM: 0.30,    /* EPS faces + ~200 mm concrete core */
      blockL:     1.00, blockH: 0.25, blockW: 0.30,  /* EPS bednici tvarnice 1000x250x300 */
      coreThickM: 0.20,    /* poured concrete core inside the EPS block */
      wallSystem: 'eps'
    }),
    gunite: _basin({
      wallThickM: 0.25,    /* sprayed shotcrete thickness */
      wallSystem: 'gunite'
    })
  };

  var VARIANT_LVL_OVERRIDES = {
    /* Fence variants don't use construction-level tiers; this map is
       kept (empty) so getVariantDefaults still resolves cleanly. */
  };

  /* -- Masonry block module -----------------------------------------
     The footprint snaps to whole blocks and the wall is laid course by
     course, so the module differs per unit system. On a unit toggle the
     footprint re-snaps to the nearest whole-block dimension in the new
     unit (see toggleUnits). Concrete-block spec:
       metric   500x200x250 mm  -> len 0.50, course 0.20, width 0.25
       imperial 16x8x12 in      -> len 0.4064, course 0.2032, width 0.3048
     EPS-block walls reuse the same snap/course module (their facing
     block size only changes the on-screen brick subdivision).  */
  var IN = 0.0254;
  function _blockModule() {
    return STATE.isMetric
      ? { len: 0.50,        course: 0.20,       width: 0.25       }
      : { len: 16 * IN,     course: 8 * IN,     width: 12 * IN    };
  }
  /* Facing module -- the block size actually DRAWN on the wall and the depth
     course step. Concrete uses the snap module above; EPS lost-formwork forms
     are larger (1000x250 / 48x16"), so they tile the wall differently and the
     depth steps by their taller course. The footprint snap, wall thickness and
     stairs all stay on _blockModule() so the geometry is unchanged on toggle
     and the stairs remain concrete. */
  function _facingModule() {
    if (variantKey() === 'eps_block') {
      return STATE.isMetric
        ? { len: 1.00,      course: 0.25,       width: 0.25       }
        : { len: 48 * IN,   course: 16 * IN,    width: 12 * IN    };
    }
    return _blockModule();
  }
  function _variantUsesBlocks() {
    var vk = variantKey();
    return vk === 'concrete_block' || vk === 'eps_block';
  }
  /* Effective wall thickness -- block variants follow the block width
     (unit-dependent); gunite uses its static sprayed thickness. */
  function _effectiveWallThick(d) {
    return _variantUsesBlocks() ? _blockModule().width : d.wallThickM;
  }
  /* Re-snap every polygon vertex onto the active grid (whole blocks for block
     variants, fine 5 cm / 2" for gunite). Used when units toggle so the model
     re-snaps to the new unit's grid. */
  function _snapPolygonToBlockGrid() {
    if (!STATE.polygon) return;
    for (var i = 0; i < STATE.polygon.length; i++) {
      STATE.polygon[i][0] = _clampCoord(snap(STATE.polygon[i][0]));
      STATE.polygon[i][1] = _clampCoord(snap(STATE.polygon[i][1]));
    }
  }

  /* -- Zones (kids / relax) -------------------------------------------
     2D slots, ARM-BASED. Each arm of the pool (a protruding leg ending in a
     short "cap" wall) gets a stack of up to two zones in a row inward from its
     end wall, so relax + kids can sit next to each other. The 2nd zone only
     appears when the arm is long enough; otherwise one. An arm end is an edge
     whose two corners are both convex and where the pool runs deeper inward
     than the edge is wide; two arms facing each other (e.g. a plain rectangle)
     split the depth so their stacks meet at most in the middle. Recomputed
     every render -> follows the shape in real time. Returns
     { quad:[[x,z]x4], wall, slot }. */
  var ZONE_LEN_M  = 1.5;   /* default depth of one zone, inward from the wall */
  var ZONE_MIN_DEPTH = 0.6; /* smallest zone depth when dragged shallower */
  var ZONE_OPACITY     = 0.20;  /* overlay opacity (lower = less prominent) */
  var ZONE_PAD_M       = 0.12;  /* gap between the overlay card and the edges */
  var WHIRL_PLACEHOLDER_M = 1.0; /* decent placeholder, not the real footprint */
  var WHIRL_GAP_M      = 0.5;   /* gap between the pool and the whirlpool card */
  function _computeZones(poly) {
    if (!poly || poly.length < 3) return [];
    var n = poly.length;
    /* winding (signed area; CCW if > 0) */
    var sa = 0;
    for (var w = 0; w < n; w++) { var ww = (w + 1) % n; sa += poly[w][0] * poly[ww][1] - poly[ww][0] * poly[w][1]; }
    var ccw = sa > 0;
    /* ray from (px,pz) along (dx,dz): nearest edge ahead -> {dist, edge} */
    function ray(px, pz, dx, dz, skip) {
      var best = Infinity, bei = -1;
      for (var k = 0; k < n; k++) {
        if (k === skip) continue;
        var a = poly[k], b = poly[(k + 1) % n];
        var ex = b[0] - a[0], ez = b[1] - a[1];
        var den = dx * ez - dz * ex;
        if (Math.abs(den) < 1e-9) continue;
        var t = ((a[0] - px) * ez - (a[1] - pz) * ex) / den;
        var u = ((a[0] - px) * dz - (a[1] - pz) * dx) / den;
        if (t > 1e-4 && u >= -1e-6 && u <= 1 + 1e-6 && t < best) { best = t; bei = k; }
      }
      return { dist: best, edge: bei };
    }
    /* convexity at vertex i (matches winding for a convex corner) */
    function convexAt(i) {
      var P = poly[(i - 1 + n) % n], C = poly[i], N = poly[(i + 1) % n];
      var cr = (C[0] - P[0]) * (N[1] - C[1]) - (C[1] - P[1]) * (N[0] - C[0]);
      return ccw ? (cr > 0) : (cr < 0);
    }
    /* pass 1 -- arm-end edges: a protruding finger's cap. Both corners convex
       AND both adjacent edges (the finger's side walls) at least as long as the
       cap (finger at least as deep as wide on both sides). A clearly-deeper cap
       is always an arm (rectangle short ends, elongated fingers). A square-ish
       cap (sides ~ cap) is an arm ONLY if it is a genuine protrusion -- i.e. a
       reflex/concave corner sits just past one of its side walls (the L finger),
       which excludes the four equal sides of a plain square basin. armDepth =
       how far the finger runs inward before it opens into the body. */
    var arms = [];
    for (var e = 0; e < n; e++) {
      var A = poly[e], B = poly[(e + 1) % n], pA = poly[(e - 1 + n) % n], nB = poly[(e + 2) % n];
      if (!convexAt(e) || !convexAt((e + 1) % n)) continue;
      var ex = B[0] - A[0], ez = B[1] - A[1], elen = Math.hypot(ex, ez);
      if (elen < 0.4) continue;
      var sidePrev = Math.hypot(A[0] - pA[0], A[1] - pA[1]);   /* finger side walls */
      var sideNext = Math.hypot(nB[0] - B[0], nB[1] - B[1]);
      var sideMin = Math.min(sidePrev, sideNext);
      var reflexPrev = !convexAt((e - 1 + n) % n);             /* side wall opens at a reflex? */
      var reflexNext = !convexAt((e + 2) % n);
      var nearReflex = reflexPrev || reflexNext;
      var clearlyDeeper = sideMin > elen * 1.02;
      /* arm = a genuine protrusion (a side wall opens at a reflex corner) OR the
         short end of a basin (cap clearly narrower than its sides, e.g. a plain
         rectangle). Accepts WIDE shallow arms; rejects long body side walls
         (no reflex, not a short end) and plain square basins. */
      if (!nearReflex && !clearlyDeeper) continue;
      /* arm depth = how far the finger runs inward before it opens. For a reflex
         protrusion: distance to the nearest opening. For a basin short end: the
         span across to the far wall. */
      var armDepth;
      if (nearReflex) {
        armDepth = Infinity;
        if (reflexPrev) armDepth = Math.min(armDepth, sidePrev);
        if (reflexNext) armDepth = Math.min(armDepth, sideNext);
      } else {
        armDepth = sideMin;
      }
      var nx = -ez / elen, nz = ex / elen;
      var mx = (A[0] + B[0]) / 2, mz = (A[1] + B[1]) / 2;
      if (!_pointInPolygonOrBoundary(mx + nx * 0.05, mz + nz * 0.05, poly)) { nx = -nx; nz = -nz; }
      var r = ray(mx, mz, nx, nz, e);
      if (isFinite(r.dist) && r.dist < armDepth) armDepth = r.dist;   /* don't cross the body wall */
      if (armDepth < ZONE_LEN_M - 1e-6) continue;             /* arm shorter than one zone (1.5 m) */
      /* anchor the zone at the cap end AWAY from the inner (reflex) corner; the
         free width edge then slides toward the reflex (but never past it). */
      var anchorEnd = (reflexPrev && !reflexNext) ? 1 : 0;
      arms.push({ e: e, A: A, B: B, nx: nx, nz: nz, elen: elen, depth: armDepth, anchorEnd: anchorEnd, hit: (isFinite(r.dist) ? r.edge : -1), gap: (isFinite(r.dist) ? r.dist : armDepth * 2) });
    }
    var armSet = {};
    for (var ai = 0; ai < arms.length; ai++) armSet[arms[ai].e] = true;
    /* pass 2 -- emit one ARM record per detected finger (the slots are laid out
       later by _layoutZones, which reads each zone's custom depth). Halve the
       usable depth where two arms face each other (e.g. the two ends of a plain
       rectangle) so stacks meet at most in the middle. */
    var out = [];
    for (var q = 0; q < arms.length; q++) {
      var arm = arms[q];
      var facing = armSet[arm.hit] === true;
      var usable = facing ? Math.min(arm.depth, arm.gap / 2) : arm.depth;
      if (usable < ZONE_LEN_M - 1e-6) continue;
      out.push({
        wall: arm.e,
        ax: arm.A[0], az: arm.A[1], bx: arm.B[0], bz: arm.B[1],
        nx: arm.nx, nz: arm.nz,
        anchorEnd: arm.anchorEnd, capW: arm.elen, armDepth: usable
      });
    }
    return out;
  }
  /* Full-width zone quad for an arm between inward depths s0..s1. */
  function _armZoneQuad(a, s0, s1) {
    return [
      [a.ax + a.nx * s0, a.az + a.nz * s0],
      [a.bx + a.nx * s0, a.bz + a.nz * s0],
      [a.bx + a.nx * s1, a.bz + a.nz * s1],
      [a.ax + a.nx * s1, a.az + a.nz * s1]
    ];
  }

  /* Rounded-rectangle THREE.Shape in the (x,z) ground plane, centred at
     (cx,cz). Used for the 2D zone / whirlpool overlay cards. */
  function _roundedRectShape(T, cx, cz, w, h, r) {
    var hw = w / 2, hh = h / 2;
    r = Math.min(r, hw, hh);
    var s = new T.Shape();
    s.moveTo(cx - hw + r, cz - hh);
    s.lineTo(cx + hw - r, cz - hh);
    s.quadraticCurveTo(cx + hw, cz - hh, cx + hw, cz - hh + r);
    s.lineTo(cx + hw, cz + hh - r);
    s.quadraticCurveTo(cx + hw, cz + hh, cx + hw - r, cz + hh);
    s.lineTo(cx - hw + r, cz + hh);
    s.quadraticCurveTo(cx - hw, cz + hh, cx - hw, cz + hh - r);
    s.lineTo(cx - hw, cz - hh + r);
    s.quadraticCurveTo(cx - hw, cz - hh, cx - hw + r, cz - hh);
    s.closePath();
    return s;
  }

  /* Default whirlpool footprint -- ~2 m, snapped to whole blocks. */
  /* Centre of the ghost whirlpool card: just outside the midpoint of the
     pool's longest edge, pushed out by a small gap. Returns {x,z} or null. */
  function _whirlpoolGhostPos(poly) {
    if (!poly || poly.length < 3) return null;
    var cxp = 0, czp = 0;
    for (var k = 0; k < poly.length; k++) { cxp += poly[k][0]; czp += poly[k][1]; }
    cxp /= poly.length; czp /= poly.length;
    var best = -1, bi = 0;
    for (var e = 0; e < poly.length; e++) {
      var a = poly[e], b = poly[(e + 1) % poly.length];
      var len = Math.hypot(b[0] - a[0], b[1] - a[1]);
      if (len > best) { best = len; bi = e; }
    }
    var p0 = poly[bi], p1 = poly[(bi + 1) % poly.length];
    var mx = (p0[0] + p1[0]) / 2, mz = (p0[1] + p1[1]) / 2;
    var ex = p1[0] - p0[0], ez = p1[1] - p0[1];
    var el = Math.hypot(ex, ez) || 1;
    var nx = -ez / el, nz = ex / el;
    if ((mx + nx - cxp) * nx + (mz + nz - czp) * nz < 0) { nx = -nx; nz = -nz; }
    var sz = WHIRL_PLACEHOLDER_M, gap = WHIRL_GAP_M;
    /* The shaft defaults to this same wall midpoint, so the jacuzzi card would
       sit on top of it. Shift the jacuzzi sideways along the wall toward the
       top-right of the view (screen-right = +x, screen-up = -z) and push it a
       little further out, so the two footprints never overlap. Clearance uses
       the real 2 m drag-card half-size, not the placeholder. */
    var ux = ex / el, uz = ez / el;             /* along-wall unit */
    var half = 1.0;                             /* half of the 2 m jacuzzi card */
    var ss = getShaftSize();
    var lat = (ss.w / 2) + half + gap;          /* clear the shaft sideways */
    var sgn = ((ux - uz) >= 0) ? 1 : -1;        /* the up-right direction */
    var outOff = gap + half;                    /* a touch further outside the wall */
    return {
      x: mx + nx * outOff + ux * sgn * lat,
      z: mz + nz * outOff + uz * sgn * lat
    };
  }
  /* Raised-floor geometry for assigned zones. Per filled slot: a raised slab
     over the full zone quad (top at -(D - raise)), plus a HOLE in the main
     bottom slab = the zone minus a wall-block-wide lap where it borders the
     deep floor (so main + raised overlap by one block). kids = 2 courses,
     relax = 1 course. Block variants only. */
  function _zoneFloors() {
    var res = { raised: [], raisedArea: 0, riserDevA: 0, raisedVol: 0, dividerCols: 0 };
    if (!_variantUsesBlocks()) return res;
    var poly = getFootprintPolygon();
    if (!poly || poly.length < 3) return res;
    var d = getVariantDefaults(variantKey(), STATE.lvl);
    var inner = _insetPolygon(poly, _effectiveWallThick(d));
    var laid = _layoutZones();
    if (!laid.length) return res;
    var D = getCurrentDepth();
    var bm = _blockModule(), course = bm.course;
    var RAISE = { kids: 2 * course, relax: 1 * course };
    var filled = {};
    for (var i = 0; i < laid.length; i++) { if (laid[i].kind) filled[laid[i].wall + ':' + laid[i].slot] = laid[i].kind; }
    for (var j = 0; j < laid.length; j++) {
      var z = laid[j], kind = z.kind;
      if (!kind) continue;
      var q = z.quad;
      var ivx = q[3][0] - q[0][0], ivz = q[3][1] - q[0][1];
      var zlen = Math.hypot(ivx, ivz) || 1;
      var Wedge = Math.hypot(q[1][0] - q[0][0], q[1][1] - q[0][1]);
      /* slab top sits at a fixed depth below the rim: kids = under the 2nd wall
         block (-0.40 m), relax = under the 1st block (-0.20 m). The slab keeps
         the placeholder size (ends at the inner edge); the overlap will be
         formed by the bottom slab later. */
      var dft = RAISE[kind] || course;
      if (dft > D - 0.05) dft = D - 0.05;
      /* Each deck's slab thickness scales with the WATER ABOVE it (less water ->
         thinner), not the full pool depth -- so a shallow shelf gets a thin slab.
         Exposed per-deck so the build + BoQ use the real thickness. */
      var slabT = _slabThickness(dft);
      /* Kids<->Main divider: only when this kids shelf borders the MAIN pool
         directly (no zone in the next, deeper slot). Pillars sit along the
         shared edge (full arm width = Wedge) with ~0.4 m swim-through gaps. */
      var _bordersMain = (kind === 'kids') && !filled[z.wall + ':' + (z.slot + 1)];
      var _divCols = 0;
      if (_bordersMain) {
        var _colFoot = STATE.isMetric ? 0.40 : 12 * IN;
        _divCols = Math.max(1, Math.round(Wedge / (_colFoot + 0.40)));   /* pillar + ~0.4 m gap */
        res.dividerCols += _divCols;
      }
      /* Riser wall (blocks) under the zone's inner edge: from the level below
         (the deeper neighbour's slab top, or the deep floor) up to this slab's
         underside. Sits on the bottom-slab 300 mm overlap and ties into the
         side perimeter walls (it spans the full arm width). */
      var topUnder = (-dft) - slabT;
      var nb = filled[z.wall + ':' + (z.slot + 1)], belowY;
      if (nb) { var ndft = RAISE[nb] || course; if (ndft > D - 0.05) ndft = D - 0.05; belowY = -ndft; }
      else belowY = -D;
      var rh = topUnder - belowY;
      var hasRiser = rh > 0.02;
      if (hasRiser) res.riserDevA += Wedge * rh;     /* developed face area of the riser wall (run x height) */
      res.raised.push({ quad: [q[0], q[1], q[2], q[3]], topY: -dft, kind: kind, area: Wedge * zlen,
                        slabT: slabT, bordersMain: _bordersMain, dividerCols: _divCols,
                        outerAtPerimeter: (z.slot === 0) || !filled[z.wall + ':' + (z.slot - 1)],
                        riserBaseY: belowY, riserTopY: topUnder, hasRiser: hasRiser });
      res.raisedArea += Wedge * zlen;
      res.raisedVol  += Wedge * zlen * slabT;   /* deck concrete at its own thickness (for the vykaz) */
    }
    return res;
  }

  /* -- Stairs -------------------------------------------------------
     Built from the same blocks as the walls (steps + side cheeks), with a
     thin tread cap on top; the ladder is a metal accessory instead. */
  var STAIRS_CYCLE = ['none', 'ladder', 'corner1', 'corner2', 'full'];
  function _stairsTypeParams(mode) {
    /* Both corner types are 2 blocks WIDE; they differ only in tread depth
       (treadHalves = depth in half-block units, bl/2 = 250 mm / 8"):
         c1 = 1 half  (250 mm / 8",  = block width / half length)
         c2 = 2 halves (500 mm / 16", = full block length)
       full = 1 half (tread = block width). The cheek runs a running bond
       (see _cheekCourseBlocks). */
    if (mode === 'corner1') return { kind: 'steps', widthBlocks: 2, treadHalves: 1 };
    if (mode === 'corner2') return { kind: 'steps', widthBlocks: 2, treadHalves: 2 };
    if (mode === 'full')    return { kind: 'steps', widthBlocks: null, treadHalves: 1 };
    if (mode === 'ladder')  return { kind: 'ladder' };
    return { kind: 'none' };
  }
  /* Placement list for the current footprint: each long-enough edge gives
     two end-anchored slots (left/right corner); 'full' gives one per edge.
     The mirror button steps through this list (clockwise + opposite wall). */
  /* Vertex convexity (true = convex) using the polygon winding. */
  function _polygonConvexity(poly) {
    var n = poly.length;
    var area2 = 0;
    for (var i = 0; i < n; i++) {
      var p0 = poly[i], p1 = poly[(i + 1) % n];
      area2 += p0[0] * p1[1] - p1[0] * p0[1];
    }
    var ccw = area2 > 0;
    var cx = [];
    for (var v = 0; v < n; v++) {
      var pv = poly[(v - 1 + n) % n], cv = poly[v], nv = poly[(v + 1) % n];
      var ax = cv[0] - pv[0], az = cv[1] - pv[1];
      var bx = nv[0] - cv[0], bz = nv[1] - cv[1];
      var cr = ax * bz - az * bx;
      cx[v] = ccw ? (cr >= 0) : (cr <= 0);
    }
    return cx;
  }

  /* Ray-cast point-in-polygon (XZ plane). */
  function _pointInPoly(pt, poly) {
    var x = pt[0], y = pt[1], inside = false, n = poly.length;
    for (var i = 0, j = n - 1; i < n; j = i++) {
      var xi = poly[i][0], yi = poly[i][1], xj = poly[j][0], yj = poly[j][1];
      var hit = ((yi > y) !== (yj > y)) &&
                (x < (xj - xi) * (y - yi) / ((yj - yi) || 1e-9) + xi);
      if (hit) inside = !inside;
    }
    return inside;
  }

  /* Index of the polygon edge nearest to (x,z) measured as point-to-SEGMENT
     distance (not edge-midpoint), so a fitting near the end of a long wall
     still snaps to that wall and not to the closer-midpoint perpendicular one. */
  function _nearestEdgeIndex(poly, x, z) {
    var bd = Infinity, bi = 0, nn = poly.length;
    for (var i = 0; i < nn; i++) {
      var a = poly[i], b = poly[(i + 1) % nn];
      var ex = b[0] - a[0], ez = b[1] - a[1], L2 = ex * ex + ez * ez || 1;
      var t = ((x - a[0]) * ex + (z - a[1]) * ez) / L2; if (t < 0) t = 0; else if (t > 1) t = 1;
      var cx = a[0] + ex * t, cz = a[1] + ez * t;
      var dd = (cx - x) * (cx - x) + (cz - z) * (cz - z);
      if (dd < bd) { bd = dd; bi = i; }
    }
    return bi;
  }

  /* True if the stairs of the given mode, placed at 'place', fit entirely
     inside the water (inner) polygon -- including their inward run, which
     for an L-shaped pool can otherwise cross the notch and poke outside. */
  /* Water-side polygon that stairs are placed on: the MAIN pool after the
     zones are carved out (each zone wall is pulled in to its riser by
     _waterDeepPoly). Same vertex count / edge indexing as the inner ring, and
     equal to it when there are no zones -- so zone-free behaviour is unchanged. */
  function _stairsBasePoly() {
    var poly = getFootprintPolygon();
    if (!poly || poly.length < 3) return poly || [];
    var d = getVariantDefaults(variantKey(), STATE.lvl);
    var inner = _insetPolygon(poly, _effectiveWallThick(d));
    return (typeof _waterDeepPoly === 'function') ? _waterDeepPoly(inner) : inner;
  }
  /* Edge indices carrying a zone: their carved edge is a riser (the shelf sits
     behind it at deck level, not a full-height wall), so stairs can't anchor
     there. Returns a map { edgeIndex: true }. */
  function _stairsZoneWalls() {
    var zw = {};
    try {
      var laid = _layoutZones();
      for (var i = 0; i < laid.length; i++) { if (laid[i].kind) zw[laid[i].wall] = true; }
    } catch (_) {}
    return zw;
  }
  /* Deck (walkable top) level of the carved edge 'edge': 0 for a real wall, or
     the innermost zone shelf's top (a negative Y) when 'edge' is a zone wall --
     so a stair there starts from the shelf deck, not the rim. */
  function _stairsDeckY(edge) {
    try {
      var laid = _layoutZones(), best = null;
      for (var i = 0; i < laid.length; i++) {
        var z = laid[i];
        if (z.kind && z.wall === edge) {
          var reach = z.geom ? (z.geom.start + z.geom.depth) : 0;
          if (!best || reach > best.reach) best = { reach: reach, kind: z.kind };
        }
      }
      if (!best) return 0;
      var course = _blockModule().course, RAISE = { kids: 2 * course, relax: 1 * course };
      var D = getCurrentDepth(), dft = RAISE[best.kind] || course;
      if (dft > D - 0.05) dft = D - 0.05;
      return -dft;
    } catch (_) { return 0; }
  }
  /* Vertical run available to a stair on 'edge': full depth on a real wall, or
     depth-below-the-shelf on a zone riser (deck Y is <= 0). */
  function _stairsEffectiveDepth(edge) {
    return getCurrentDepth() + _stairsDeckY(edge);
  }

  /* Point->segment distance in the ground plane. */
  function _segDistXZ(px, pz, ax, az, bx, bz) {
    var vx = bx - ax, vz = bz - az, wx = px - ax, wz = pz - az;
    var L2 = vx * vx + vz * vz, tt = L2 > 0 ? (wx * vx + wz * vz) / L2 : 0;
    tt = tt < 0 ? 0 : tt > 1 ? 1 : tt;
    return Math.hypot(px - (ax + vx * tt), pz - (az + vz * tt));
  }
  /* Y at which the perimeter wall bottoms out at ground point (px,pz). The
     blocks notch the wall around the WHOLE zone (cap edge + both side returns
     at the corners), so a point standing behind a zone -- within ~wallT of that
     zone's cap (q0-q1) or a side return (q0-q3 / q1-q2); the riser q3-q2 faces
     the deep pool and is excluded -- has wall only ABOVE the shelf, bottoming at
     that shelf's mesh plane. Otherwise the wall runs to the deep floor -D. Used
     by BOTH the reinforcement view and the rebar BoQ so they always agree. */
  function _wallBottomYAt(px, pz, D, wallT, raised) {
    /* A wall bar is shortened only where the shelf actually backs onto the main
       perimeter wall -- i.e. behind the zone CAP (q0-q1, the zone edge lying
       along the wall). The side returns (q0-q3, q1-q2) run INTO the pool as
       interior dividers; for a corner zone a side return lies parallel to the
       perpendicular main wall, which _build3D still builds at FULL depth -- so
       checking the returns wrongly trimmed that wall's corner bars to the shelf
       plane (vertical rebar appeared to be missing there). Cap-only keeps the
       rebar consistent with the real wall geometry. */
    var COVT = wallT * 0.5 + 0.10, best = null, bd = COVT;
    for (var zi = 0; zi < raised.length; zi++) {
      var z = raised[zi], q = z.quad; if (!q || q.length < 4) continue;
      var d = _segDistXZ(px, pz, q[0][0], q[0][1], q[1][0], q[1][1]);   /* cap (along the main wall) */
      if (d < bd) { bd = d; best = z; }
    }
    if (best) return ((best.slabT || 0) > 0.15 + 1e-6) ? (best.topY - 0.04) : (best.topY - 0.02);
    return -D;
  }

  function _stairsPlacementFits(place, mode) {
    var p = _stairsTypeParams(mode);
    if (p.kind === 'ladder') return true;
    if (p.kind !== 'steps') return false;
    /* Stairs sit on the MAIN pool with zones carved out: use the carved water
       polygon, so a wall next to a zone is shortened to its main-pool frontage
       and the shelf is excluded. Equals the plain inner ring with no zones. */
    var inner = _stairsBasePoly();
    if (!inner || inner.length < 3) return false;
    var n = inner.length;
    if (place.edge >= n) return false;
    var A = inner[place.edge], B = inner[(place.edge + 1) % n];
    var ex = B[0] - A[0], ez = B[1] - A[1];
    var L = Math.hypot(ex, ez);
    if (L < 0.05) return false;
    var ux = ex / L, uz = ez / L;
    var area2 = 0;
    for (var ai = 0; ai < n; ai++) { var q0 = inner[ai], q1 = inner[(ai + 1) % n]; area2 += q0[0] * q1[1] - q1[0] * q0[1]; }
    var ccw = area2 > 0;
    var wx = ccw ? -uz : uz, wz = ccw ? ux : -ux;
    var Ox, Oz, axx, axz;
    if (!place.atEnd) { Ox = A[0]; Oz = A[1]; axx = ux;  axz = uz; }
    else              { Ox = B[0]; Oz = B[1]; axx = -ux; axz = -uz; }
    var mod = _blockModule();
    var bl = mod.len, bh = mod.course, bw = mod.width;
    var widthBlocks = (mode === 'full') ? Math.max(1, Math.round(L / bl)) : p.widthBlocks;
    var stairW = (mode === 'full') ? L : widthBlocks * bl;
    var treadDepth = (p.treadHalves || 2) * (bl / 2);
    var stepCount = Math.max(1, Math.floor(_stairsEffectiveDepth(place.edge) / bh) - 1);
    var inwardMax = stepCount * treadDepth;
    function L2W(al, inw) { return [Ox + axx * al + wx * inw, Oz + axz * al + wz * inw]; }
    /* Sample only the footprint that actually sits in the water: along the
       edge from the corner (0) to the stair width, and inward from the wall
       to the deepest step. (Earlier code sampled al=-bw/2, i.e. *behind* the
       corner -- always outside the polygon -- so every corner placement was
       wrongly rejected.) */
    var aLo = 0.05, aHi = stairW - 0.05;
    if (aHi < aLo) { aHi = aLo; }
    var NA = 8, NI = 10;
    for (var ia = 0; ia <= NA; ia++) {
      var al = aLo + (aHi - aLo) * (ia / NA);
      for (var ii = 0; ii <= NI; ii++) {
        var inw = 0.05 + (inwardMax - 0.05) * (ii / NI);
        if (!_pointInPoly(L2W(al, inw), inner)) return false;
      }
    }
    return true;
  }

  function getStairsPlacements() {
    var poly = getFootprintPolygon();
    var n = poly ? poly.length : 0;
    if (n < 3) return [];
    var mode = STATE.stairsMode;
    var p = _stairsTypeParams(mode);
    var bl = _blockModule().len;
    /* Stairs must not be longer than the wall they sit on: a corner type
       needs widthBlocks whole blocks within the edge; full needs >=1.5. */
    var minLen = (mode === 'full') ? bl * 1.5
               : (p.widthBlocks ? p.widthBlocks * bl : bl * 2);
    var convex = _polygonConvexity(poly);
    var zoneWalls = _stairsZoneWalls();
    var out = [];
    for (var i = 0; i < n; i++) {
      /* A zone wall's carved edge is a riser; stairs may sit there descending
         from the shelf deck -- but only if there's enough run below the shelf. */
      if (zoneWalls[i] && _stairsEffectiveDepth(i) < bl) continue;
      var a = poly[i], b = poly[(i + 1) % n];
      var len = Math.hypot(b[0] - a[0], b[1] - a[1]);
      if (len < minLen) continue;               /* stairs would be longer than the wall */
      if (mode === 'full') {
        /* Full-width stairs span the whole edge -- skip the edge if either
           of its endpoints is a concave (inner) corner. */
        if (convex[i] && convex[(i + 1) % n] &&
            _stairsPlacementFits({ edge: i, atEnd: false }, mode)) {
          out.push({ edge: i, atEnd: false });
        }
        continue;
      }
      /* Corner stairs anchor at a convex corner AND must fit inside the
         water polygon (their inward run must not cross the L-notch). */
      var c0 = { edge: i, atEnd: false }, c1 = { edge: i, atEnd: true };
      if (convex[i] && _stairsPlacementFits(c0, mode)) out.push(c0);
      if (convex[(i + 1) % n] && _stairsPlacementFits(c1, mode)) out.push(c1);
    }
    return out;
  }
  function getStairsMode() { return STATE.stairsMode || 'none'; }
  function getCurrentStairsPlacement() {
    var list = getStairsPlacements();
    if (!list.length) return null;
    var idx = ((STATE.stairsSlot % list.length) + list.length) % list.length;
    return list[idx];
  }
  function cycleStairsType() {
    var cur = STATE.stairsMode || 'none';
    var idx = STAIRS_CYCLE.indexOf(cur);
    STATE.stairsMode = STAIRS_CYCLE[(idx + 1) % STAIRS_CYCLE.length];
    STATE.stairsSlot = 0;
    refreshUI();
    _forceRender3DFlush(2);
  }
  function cycleStairsPlacement() {
    var list = getStairsPlacements();
    if (!list.length) return;
    STATE.stairsSlot = (STATE.stairsSlot + 1) % list.length;
    refreshUI();
    _forceRender3DFlush(2);
  }
  /* Blocks the current stairs add: full blocks (risers + cheeks) and half
     blocks (the running-bond starter on every other cheek course). Mirrors
     the renderer exactly so the BoQ matches what is drawn. */
  function _stairsBlockTally() {
    var z = { full: 0, half: 0 };
    var mode = getStairsMode();
    var p = _stairsTypeParams(mode);
    if (p.kind !== 'steps') return z;
    var place = getCurrentStairsPlacement();
    if (!place) return z;
    var mod = _blockModule();
    var bl = mod.len, rise = mod.course, bw = mod.width;
    var D = getCurrentDepth();
    var stepCount = Math.max(1, Math.floor(_stairsEffectiveDepth(place.edge) / rise) - 1);
    var treadDepth = (p.treadHalves || 2) * (bl / 2);
    var poly = _stairsBasePoly(), n = poly.length;          /* carved main pool -- matches the rendered stair width near zones */
    var a = poly[place.edge], b = poly[(place.edge + 1) % n];
    var Lp = Math.hypot(b[0] - a[0], b[1] - a[1]);
    var widthBlocks = (mode === 'full') ? Math.max(1, Math.round(Lp / bl)) : p.widthBlocks;
    var stairW = (mode === 'full') ? Lp : widthBlocks * bl;
    var riserCount = Math.max(1, Math.round(stairW / bl));
    for (var i = 0; i < stepCount; i++) {
      var kFromTop = stepCount - i;
      if (mode === 'full') {
        z.full += riserCount;                       /* riser only, no cheeks */
      } else {
        var course = _stairCourse(kFromTop, treadDepth, bl, bw, stairW, widthBlocks);
        var parts = course.riser.concat(course.cheek);   /* riser + ONE cheek */
        for (var bi = 0; bi < parts.length; bi++) { if (parts[bi].half) z.half++; else z.full++; }
      }
    }
    return z;
  }
  function _stairsBlockCount() { return _stairsBlockTally().full; }
  function _stairsHalfBlockCount() { return _stairsBlockTally().half; }

  /* Poured concrete volume of the stairs (the solid stepped mass that the
     block facing contains). Approximated as the stepped wedge over the stair
     footprint -- a small, deterministic over-estimate (no rebar deduction). */
  function _stairsConcreteVol() {
    var mode = getStairsMode();
    var p = _stairsTypeParams(mode);
    if (p.kind !== 'steps') return 0;
    var place = getCurrentStairsPlacement();
    if (!place) return 0;
    var mod = _blockModule();
    var bl = mod.len, rise = mod.course;
    var D = getCurrentDepth();
    var stepCount = Math.max(1, Math.floor(_stairsEffectiveDepth(place.edge) / rise) - 1);
    var treadDepth = (p.treadHalves || 2) * (bl / 2);
    var poly = _stairsBasePoly(), n = poly.length;          /* carved main pool -- matches the rendered stair width near zones */
    var a = poly[place.edge], b = poly[(place.edge + 1) % n];
    var Lp = Math.hypot(b[0] - a[0], b[1] - a[1]);
    var widthBlocks = (mode === 'full') ? Math.max(1, Math.round(Lp / bl)) : p.widthBlocks;
    var stairW = (mode === 'full') ? Lp : widthBlocks * bl;
    /* sum (slice footprint x height-to-floor) = stairW.treadDepth.rise.sum(i+1). */
    return stairW * treadDepth * rise * (stepCount * (stepCount + 1) / 2);
  }

  /* Blocks of one cheek course laid as a running bond along the depth.
     Two cases by step depth:
     * half-step (c1, tread = bl/2): consecutive steps already offset by half
       a block, so the bond is natural -- even half-unit lengths are all full
       blocks, odd lengths get ONE half block at the WALL (never two shorts).
     * full-step (c2, tread = bl): consecutive steps would align, so the
       offset is forced -- odd courses (from top) are all full, even courses
       are half . fullx(n-1) . half. Returns [{c, len, half}] (c = centre
       offset from the wall along the depth). */
  function _cheekCourseBlocks(cheekLen, kFromTop, bl, treadDepth) {
    var out = [];
    var halfStep = treadDepth < bl * 0.75;
    if (halfStep) {
      var m = Math.max(1, Math.round(cheekLen / (bl / 2)));   /* length in half-units */
      if (m % 2 === 0) {
        for (var j = 0; j < m / 2; j++) out.push({ c: (j + 0.5) * bl, len: bl, half: false });
      } else {
        out.push({ c: bl / 4, len: bl / 2, half: true });      /* single half at wall */
        for (var j2 = 0; j2 < (m - 1) / 2; j2++) out.push({ c: bl / 2 + (j2 + 0.5) * bl, len: bl, half: false });
      }
    } else {
      var k = Math.max(1, Math.round(cheekLen / bl));
      if (k % 2 === 1) {
        for (var j3 = 0; j3 < k; j3++) out.push({ c: (j3 + 0.5) * bl, len: bl, half: false });
      } else {
        /* even course: a FULL block forms the nosing corner (the visible tread
           edge -- stronger bond there); the closure HALF is moved one block in,
           and a half sits at the (hidden) wall end. Short k=2 course is laid as
           two full blocks to avoid two short blocks next to each other. */
        if (k - 1 >= 2) {
          out.push({ c: bl / 4, len: bl / 2, half: true });                          /* wall half  */
          for (var j4 = 0; j4 < k - 2; j4++) out.push({ c: bl / 2 + (j4 + 0.5) * bl, len: bl, half: false });
          out.push({ c: cheekLen - bl - bl / 4, len: bl / 2, half: true });          /* closure half, just inside the nosing */
        } else {
          out.push({ c: bl / 2, len: bl, half: false });                             /* k=2: full at wall */
        }
        out.push({ c: cheekLen - bl / 2, len: bl, half: false });                    /* FULL nosing block */
      }
    }
    return out;
  }

  /* One step's masonry, both the side cheek (along the depth) and the riser
     (along the width), laid as an interlocking CORNER bond at the outer-front
     corner -- exactly like a wall corner. Counting steps from the TOP (k=1):
       * odd  k -> the CHEEK owns the corner: cheek runs full to the front; the
                  riser stops a half-block short of the outer corner.
       * even k -> the RISER owns the corner: riser runs out to the outer corner
                  (with a half-block offset at the wall); the cheek stops a
                  half-block short of the front.
     There is ONE cheek, on the open (outer) side; the other side and the back
     sit against the pool walls. Half blocks (250 / "K") give the running-bond
     offset and the corner closure. c (cheek) = depth offset from the wall;
     c (riser) = width offset from the wall side. Returns {cheek, riser}. */
  function _stairCourse(k, treadDepth, bl, bw, stairW, widthBlocks) {
    var halfLen = bl / 2;
    var cheekLen = k * treadDepth;
    var cheekOwns = (k % 2 === 1);
    var cheek = [], riser = [], j;
    var fullStep = treadDepth >= bl * 0.75;            /* c2 = full block tread */
    if (fullStep) {
      if (cheekOwns) {                                  /* cheek runs full to the front */
        for (j = 0; j < k; j++) cheek.push({ c: (j + 0.5) * bl, len: bl, half: false });
      } else {                                          /* cheek: K at wall, stops halfLen short of front */
        cheek.push({ c: halfLen / 2, len: halfLen, half: true });
        for (j = 0; j < k - 1; j++) cheek.push({ c: halfLen + (j + 0.5) * bl, len: bl, half: false });
      }
      if (!cheekOwns) {                                 /* riser owns the corner: K at wall + fulls to outer corner */
        riser.push({ c: halfLen / 2, len: halfLen, half: true });
        for (j = 0; j < widthBlocks; j++) riser.push({ c: halfLen + (j + 0.5) * bl, len: bl, half: false });
      } else {                                          /* riser yields: fulls covering the interior width */
        for (j = 0; j < widthBlocks; j++) riser.push({ c: (j + 0.5) * bl, len: bl, half: false });
      }
    } else {
      /* c1 (half-block-deep tread): the cheek already offsets naturally; lay
         its half-step running bond, riser stays full blocks across the width. */
      var m = Math.max(1, Math.round(cheekLen / halfLen));
      if (m % 2 === 0) {
        for (j = 0; j < m / 2; j++) cheek.push({ c: (j + 0.5) * bl, len: bl, half: false });
      } else {
        cheek.push({ c: halfLen / 2, len: halfLen, half: true });
        for (j = 0; j < (m - 1) / 2; j++) cheek.push({ c: halfLen + (j + 0.5) * bl, len: bl, half: false });
      }
      for (j = 0; j < widthBlocks; j++) riser.push({ c: (j + 0.5) * bl, len: bl, half: false });
    }
    return { cheek: cheek, riser: riser };
  }

  function getVariantDefaults(variantKey, lvl) {
    var base = VARIANT_DEFAULTS[variantKey];
    if (!base) return {};
    var merged = {};
    for (var k in base) if (base.hasOwnProperty(k)) merged[k] = base[k];
    var ov = VARIANT_LVL_OVERRIDES[variantKey] && VARIANT_LVL_OVERRIDES[variantKey][lvl];
    if (ov) {
      for (var k2 in ov) if (ov.hasOwnProperty(k2)) merged[k2] = ov[k2];
    }
    return merged;
  }

  /* Depth range for the current variant (pool basin depth). Minimum height is
     ONE row (1 course) for every variant -- concrete 0.20 m / 8", EPS 0.25 m /
     16", gunite uses the concrete course as its floor. */
  function getCurrentDepthRange() {
    var d = getVariantDefaults(variantKey(), STATE.lvl);
    return { min: _facingModule().course, max: d.depthMaxM, def: d.depthM };
  }

  /* Current basin depth -- STATE.depth clamped to range if set, else the
     variant default. Block variants snap the depth to whole courses
     (block height), since the wall is built course by course. */
  function getCurrentDepth() {
    var r = getCurrentDepthRange();
    var ov = STATE.depth;
    var d = (ov == null) ? r.def : Math.max(r.min, Math.min(r.max, ov));
    if (_variantUsesBlocks()) {
      var c = _facingModule().course;
      d = Math.round(d / c) * c;
      if (d < c) d = c;                      /* at least 1 row */
      if (d > r.max) d = Math.floor(r.max / c) * c;
    }
    return d;
  }

  function setPoolDepth(d) {
    if (d == null) { STATE.depth = null; }
    else {
      var r = getCurrentDepthRange();
      STATE.depth = Math.max(r.min, Math.min(r.max, d));
    }
    refreshUI();
    if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
  }

  /* Back-compat aliases -- several generic managers (info bar, section
     cut, base dimensions) historically called getCurrentHeight(). For a
     pool the "height" of the built element IS the basin depth. */
  function getCurrentHeight() { return getCurrentDepth(); }

  function _dbg(msg) {
    if (global.Configurator && global.Configurator.log && global.Configurator.log.log) {
      global.Configurator.log.log('[base-lib] ' + msg);
    }
  }

  function snap(v) {
    /* Block variants (concrete / EPS) step the footprint by WHOLE blocks
       (0.50 m / 16") so walls are built from whole units -- as before. Gunite
       (and free-form shapes) use a fine grid (5 cm / 2") since sprayed concrete
       has no module. */
    if (_variantUsesBlocks()) {
      var b = _blockModule().len;
      return Math.round(v / b) * b;
    }
    var s = STATE.isMetric ? SNAP_M : (2 * 0.0254);
    return Math.round(v / s) * s;
  }

  function clamp(v, lo, hi) {
    return Math.max(lo, Math.min(hi, v));
  }

  function fmtLen(meters, opts) {
    opts = opts || {};
    var precision = (opts.precision == null) ? 2 : opts.precision;
    if (STATE.isMetric) {
      return meters.toFixed(precision);
    }
    /* Imperial: linear m->ft (x3.28084), area m^2->ft^2 (x10.7639). */
    var factor = opts.area ? 10.7639 : 3.28084;
    return (meters * factor).toFixed(precision);
  }
  /* Area unit label (m^2 / ft^2). */
  function areaUnitLabel() { return STATE.isMetric ? 'm\u00b2' : 'ft\u00b2'; }
  /* Volume unit label (m^3 / ft^3). */
  function volUnitLabel() { return STATE.isMetric ? 'm\u00b3' : 'ft\u00b3'; }

  /* Dimension callout (koty) -- technical, whole-grid numbers, complete with
     unit. Metric: millimetres with a thin space separator ("3 700 mm").
     Imperial: architectural feet-inches ("12'-6"") -- the 2" grid keeps inches
     whole, so no fractions. */
  function fmtDim(meters) {
    if (STATE.isMetric) {
      var mm = Math.round(meters * 1000);
      return mm.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' mm';
    }
    var totalIn = Math.round(meters / 0.0254);    /* nearest whole inch (grid is 2") */
    var ft = Math.floor(totalIn / 12);
    var inch = totalIn - ft * 12;
    return ft + "'-" + inch + '"';
  }

  function getFootprintPolygon() {
    var poly = STATE.polygon;
    if (!poly || !poly.length) return [];
    var out = new Array(poly.length);
    for (var i = 0; i < poly.length; i++) {
      out[i] = [poly[i][0], poly[i][1]];
    }
    return out;
  }

  function getBBox() {
    var poly = STATE.polygon;
    if (!poly || !poly.length) return { L: 0, W: 0 };
    var xMin =  Infinity, xMax = -Infinity;
    var zMin =  Infinity, zMax = -Infinity;
    for (var i = 0; i < poly.length; i++) {
      var x = poly[i][0], z = poly[i][1];
      if (x < xMin) xMin = x;
      if (x > xMax) xMax = x;
      if (z < zMin) zMin = z;
      if (z > zMax) zMax = z;
    }
    return { L: xMax - xMin, W: zMax - zMin };
  }

  function computeArea() {
    var poly = getFootprintPolygon();
    var a = 0;
    for (var i = 0; i < poly.length; i++) {
      var j = (i + 1) % poly.length;
      a += poly[i][0] * poly[j][1];
      a -= poly[j][0] * poly[i][1];
    }
    return Math.abs(a) / 2;
  }

  function computePerimeter() {
    var poly = getFootprintPolygon();
    var p = 0;
    for (var i = 0; i < poly.length; i++) {
      var j = (i + 1) % poly.length;
      var dx = poly[j][0] - poly[i][0];
      var dy = poly[j][1] - poly[i][1];
      p += Math.sqrt(dx*dx + dy*dy);
    }
    return p;
  }

  function _pointInPolygonOrBoundary(x, z, poly) {
    var n = poly.length;
    var EPS = 0.001;
    for (var i = 0; i < n; i++) {
      var a = poly[i], b = poly[(i + 1) % n];
      var dx = b[0] - a[0], dz = b[1] - a[1];
      var lenSq = dx * dx + dz * dz;
      if (lenSq < 1e-9) continue;
      var t = ((x - a[0]) * dx + (z - a[1]) * dz) / lenSq;
      var tc = t < 0 ? 0 : (t > 1 ? 1 : t);
      var px = a[0] + tc * dx;
      var pz = a[1] + tc * dz;
      if (Math.hypot(x - px, z - pz) < EPS) return true;
    }
    var inside = false;
    for (var i = 0, j = n - 1; i < n; j = i++) {
      var xi = poly[i][0], zi = poly[i][1];
      var xj = poly[j][0], zj = poly[j][1];
      if ((zi > z) !== (zj > z) &&
          x < (xj - xi) * (z - zi) / (zj - zi) + xi) {
        inside = !inside;
      }
    }
    return inside;
  }

  /* Canonical variant keys, indexed by STATE.variant - 1.
     Order matches POOL_VARIANT_COUNT enum + Shopify variant order. */
  var POOL_VARIANT_KEYS = ['concrete_block', 'gunite'];
  function variantKey() {
    var base = POOL_VARIANT_KEYS[STATE.variant - 1] || 'concrete_block';
    /* The block variant carries a concrete/eps material toggle; gunite ignores it. */
    if (base === 'concrete_block' && STATE.wallMaterial === 'eps') return 'eps_block';
    return base;
  }

  /* -- Water-edge system (skimmer | overflow) ------------------------- */
  var EDGE_TYPES = ['skimmer', 'overflow', 'infinite'];
  function getEdgeType() { return EDGE_TYPES.indexOf(STATE.edgeType) >= 0 ? STATE.edgeType : 'skimmer'; }
  function setEdgeType(t) {
    var v = EDGE_TYPES.indexOf(t) >= 0 ? t : 'skimmer';
    if (getEdgeType() === v) return;
    STATE.edgeType = v;
    if (v === 'infinite' && (!Array.isArray(STATE.infiniteEdges) || !STATE.infiniteEdges.length)) {
      STATE.infiniteEdges = [_longestEdgeIndex()];   /* default: longest edge */
    }
    _syncEdgeTypeDisplay();
    refreshUI();
    if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
  }
  function toggleEdgeType() {
    var i = EDGE_TYPES.indexOf(getEdgeType());
    setEdgeType(EDGE_TYPES[(i + 1) % EDGE_TYPES.length]);
  }
  /* Index of the longest footprint edge (default vanishing edge). */
  function _longestEdgeIndex() {
    var poly = getFootprintPolygon(); if (!poly || poly.length < 3) return 0;
    var best = 0, bestL = -1;
    for (var i = 0; i < poly.length; i++) {
      var a = poly[i], b = poly[(i + 1) % poly.length];
      var L = Math.hypot(b[0] - a[0], b[1] - a[1]);
      if (L > bestL) { bestL = L; best = i; }
    }
    return best;
  }
  /* Vanishing-edge selection (infinite mode). */
  function getInfiniteEdges() { return Array.isArray(STATE.infiniteEdges) ? STATE.infiniteEdges.slice() : []; }
  function isInfiniteEdge(i) { return getEdgeType() === 'infinite' && getInfiniteEdges().indexOf(i) >= 0; }
  function setInfiniteEdges(list) {
    STATE.infiniteEdges = (Array.isArray(list) ? list : []).filter(function (v) { return typeof v === 'number' && v >= 0; });
    refreshUI();
    if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
  }
  function toggleInfiniteEdge(i) {
    var arr = getInfiniteEdges(), k = arr.indexOf(i);
    if (k >= 0) {
      arr.splice(k, 1);
      if (!arr.length) {                              /* keep one ON: auto-enable another edge */
        var alt = _longestEdgeIndexExcept(i);
        arr.push(alt);
      }
    } else {
      arr.push(i);
    }
    setInfiniteEdges(arr);
  }
  /* Longest footprint edge index other than 'skip' (fallback: next index). */
  function _longestEdgeIndexExcept(skip) {
    var poly = getFootprintPolygon(); if (!poly || poly.length < 3) return 0;
    var n = poly.length, best = -1, bestL = -1;
    for (var i = 0; i < n; i++) {
      if (i === skip) continue;
      var a = poly[i], b = poly[(i + 1) % n];
      var L = Math.hypot(b[0] - a[0], b[1] - a[1]);
      if (L > bestL) { bestL = L; best = i; }
    }
    return best >= 0 ? best : ((skip + 1) % n);
  }

  /* -- Pool interior surface finish ----------------------------------
     Five options cycled by the info-bar surface button. Geometry-neutral;
     only the FINISHES branch of the BoQ changes. */
  var SURFACES = ['liner', 'plaster', 'tiles', 'pebble', 'inox'];
  function getSurface() {
    return SURFACES.indexOf(STATE.surface) >= 0 ? STATE.surface : 'liner';
  }
  function setSurface(s) {
    var v = SURFACES.indexOf(s) >= 0 ? s : 'liner';
    if (getSurface() === v) return;
    STATE.surface = v;
    _syncSurfaceDisplay();
    refreshUI();
    if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
  }
  function cycleSurface() {
    var i = SURFACES.indexOf(getSurface());
    setSurface(SURFACES[(i + 1) % SURFACES.length]);
  }
  function _syncSurfaceDisplay() {
    try {
      var el = document.getElementById('cf-stat-surface-name');
      if (!el) return;
      var i18n = (global.BASE_BOOT || {}).i18n || {};
      el.textContent = i18n['pool_surface_' + getSurface()] || getSurface();
      var btn = document.getElementById('cf-btn-surface');
      if (btn) btn.setAttribute('aria-pressed', getSurface() === 'liner' ? 'false' : 'true');
    } catch (_) {}
  }

  /* -- Wall material toggle (block variant only): concrete <-> eps ------
     Geometry-neutral -- both share the same snap/course module, so the
     footprint, walls and stairs are unchanged; only the wall BoQ branch and
     the 3D wall colour switch. Hidden/ignored for gunite. */
  function getWallMaterial() { return STATE.wallMaterial === 'eps' ? 'eps' : 'concrete'; }
  function setWallMaterial(m) {
    var v = (m === 'eps') ? 'eps' : 'concrete';
    if (STATE.wallMaterial === v) return;
    STATE.wallMaterial = v;
    _syncMaterialDisplay();
    refreshUI();
    if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
  }
  function cycleWallMaterial() {
    /* Only meaningful on the block variant; no-op on gunite. */
    if (variantKey() === 'gunite') return;
    setWallMaterial(getWallMaterial() === 'concrete' ? 'eps' : 'concrete');
  }

  /* -- Technology shaft ----------------------------------------------
     Underground plastic box + lid beside the pool. Footprint grows with the
     water volume (pump + filter + dosing need more room on bigger pools). */
  function getShaftSize() {
    var g = _poolGeometry();
    var V = (g && g.waterVol) || 0;            /* m^3 water */
    /* Footprint scales with the equipment the shaft must house (pump + filter
       tank + manifold + doser + electrics); the filter tank also gets taller
       as the pool grows, so the depth steps up too. */
    var w, l, h;
    if      (V <= 30) { w = 0.80; l = 0.80; h = 1.10; }
    else if (V <= 60) { w = 1.00; l = 1.20; h = 1.20; }
    else if (V <= 100){ w = 1.20; l = 1.50; h = 1.35; }
    else              { w = 1.50; l = 1.80; h = 1.50; }
    return { w: w, l: l, h: h };               /* metres; h = underground depth */
  }

  /* Configurator-generated shaft dimensions for the quote/BoQ, since the
     master no longer pins them. Returns metres plus rounded metric (mm) and
     imperial (inch) triples [w, l, h]. */
  function getShaftDimensions() {
    var s = getShaftSize();
    var mm = function (m) { return Math.round(m * 1000 / 10) * 10; };       /* nearest 10 mm */
    var inch = function (m) { return Math.round(m * 39.3701 * 2) / 2; };    /* nearest 1/2" */
    return {
      m:        { w: s.w, l: s.l, h: s.h },
      metricMm: { w: mm(s.w), l: mm(s.l), h: mm(s.h) },
      imperialIn: { w: inch(s.w), l: inch(s.l), h: inch(s.h) }
    };
  }

  /* Default shaft centre: just outside the longest wall, offset by ~1 m. */
  function _defaultShaftPos() {
    var poly = getFootprintPolygon();
    if (!poly || poly.length < 3) return { x: 0, z: 0 };
    var n = poly.length, best = 0, bestLen = -1, bi = 0;
    for (var i = 0; i < n; i++) {
      var a = poly[i], b = poly[(i + 1) % n];
      var len = Math.hypot(b[0] - a[0], b[1] - a[1]);
      if (len > bestLen) { bestLen = len; bi = i; }
    }
    var a2 = poly[bi], b2 = poly[(bi + 1) % n];
    var mx = (a2[0] + b2[0]) / 2, mz = (a2[1] + b2[1]) / 2;
    var ex = (b2[0] - a2[0]) / bestLen, ez = (b2[1] - a2[1]) / bestLen;
    var nx = -ez, nz = ex;                      /* edge normal */
    /* push outward (away from polygon centroid) */
    var cx = 0, cz = 0;
    for (var k = 0; k < n; k++) { cx += poly[k][0]; cz += poly[k][1]; }
    cx /= n; cz /= n;
    if ((mx - cx) * nx + (mz - cz) * nz < 0) { nx = -nx; nz = -nz; }
    var sz = getShaftSize();
    var off = 1.0 + sz.l / 2;
    return { x: mx + nx * off, z: mz + nz * off };
  }

  function getShaftPos() {
    if (STATE.shaft && isFinite(STATE.shaft.x) && isFinite(STATE.shaft.z)) return STATE.shaft;
    return _defaultShaftPos();
  }
  function setShaftPos(x, z) { STATE.shaft = { x: x, z: z }; }

  /* Whirlpool / jacuzzi placeholder -- a free-floating footprint for the future
     separate configurator. It never affects the pool shape; only its position
     is stored. Default = the ghost spot beside the longest wall. */
  function getWhirlpoolPos() {
    if (STATE.whirlpool && isFinite(STATE.whirlpool.x) && isFinite(STATE.whirlpool.z)) return STATE.whirlpool;
    var g = _whirlpoolGhostPos(getFootprintPolygon());
    return g || { x: 0, z: 0 };
  }
  function setWhirlpoolPos(x, z) { STATE.whirlpool = { x: x, z: z }; }

  /* -- Overflow balance tank -----------------------------------------
     Underground surge tank that buffers the displaced water in an overflow
     pool. Sized at ~10 % of the pool water volume. Depth fixed (buried box);
     footprint square, derived from the target tank volume. Only relevant in
     overflow mode. */
  function getTankSize() {
    var g = _poolGeometry();
    var V = (g && g.waterVol) || 0;            /* m^3 pool water */
    var tankVol = Math.max(1.0, 0.10 * V);     /* 10 % of water, min 1 m^3 */
    var h = 1.20;                              /* buried box depth (m) */
    var side = Math.sqrt(tankVol / h);         /* square footprint */
    side = Math.max(0.80, Math.round(side / 0.05) * 0.05);  /* min 0.8 m, snap 50 mm */
    return { w: side, l: side, h: h };
  }

  /* Configurator-generated tank dimensions for the quote/BoQ (master no longer
     pins them). Metres + rounded metric (mm) + imperial (inch). */
  function getTankDimensions() {
    var s = getTankSize();
    var mm = function (m) { return Math.round(m * 1000 / 10) * 10; };
    var inch = function (m) { return Math.round(m * 39.3701 * 2) / 2; };
    return {
      m:        { w: s.w, l: s.l, h: s.h },
      metricMm: { w: mm(s.w), l: mm(s.l), h: mm(s.h) },
      imperialIn: { w: inch(s.w), l: inch(s.l), h: inch(s.h) }
    };
  }

  /* Default tank centre: outside the longest wall like the shaft, but shifted
     along the wall so it sits beside (not on top of) the shaft. */
  function _defaultTankPos() {
    var poly = getFootprintPolygon();
    if (!poly || poly.length < 3) return { x: 2, z: 0 };
    var n = poly.length, bestLen = -1, bi = 0;
    for (var i = 0; i < n; i++) {
      var a = poly[i], b = poly[(i + 1) % n];
      var len = Math.hypot(b[0] - a[0], b[1] - a[1]);
      if (len > bestLen) { bestLen = len; bi = i; }
    }
    var a2 = poly[bi], b2 = poly[(bi + 1) % n];
    var mx = (a2[0] + b2[0]) / 2, mz = (a2[1] + b2[1]) / 2;
    var ex = (b2[0] - a2[0]) / bestLen, ez = (b2[1] - a2[1]) / bestLen;  /* along wall */
    var nx = -ez, nz = ex;                      /* edge normal */
    var cx = 0, cz = 0;
    for (var k = 0; k < n; k++) { cx += poly[k][0]; cz += poly[k][1]; }
    cx /= n; cz /= n;
    if ((mx - cx) * nx + (mz - cz) * nz < 0) { nx = -nx; nz = -nz; }
    var ts = getTankSize(), ss = getShaftSize();
    var off = 1.0 + ts.l / 2;
    /* lateral shift beside the shaft (shaft sits at wall mid-point) */
    var shift = (ss.w / 2) + (ts.w / 2) + 0.6;
    return { x: mx + nx * off + ex * shift, z: mz + nz * off + ez * shift };
  }

  function getTankPos() {
    if (STATE.tank && isFinite(STATE.tank.x) && isFinite(STATE.tank.z)) return STATE.tank;
    return _defaultTankPos();
  }
  function setTankPos(x, z) { STATE.tank = { x: x, z: z }; }

  /* Electrical panel default: just outside the wall near the shaft, offset a
     bit so they don't overlap. */
  function _defaultPanelPos() {
    var sp = _defaultShaftPos();
    var poly = getFootprintPolygon();
    var cx = 0, cz = 0, n = poly.length;
    for (var i = 0; i < n; i++) { cx += poly[i][0]; cz += poly[i][1]; }
    cx /= n; cz /= n;
    /* push 1.2 m further out from the centroid than the shaft */
    var dx = sp.x - cx, dz = sp.z - cz, L = Math.hypot(dx, dz) || 1;
    return { x: sp.x + (dx / L) * 1.2, z: sp.z + (dz / L) * 1.2 };
  }
  function getPanelPos() {
    if (STATE.panel && isFinite(STATE.panel.x) && isFinite(STATE.panel.z)) return STATE.panel;
    return _defaultPanelPos();
  }
  function setPanelPos(x, z) { STATE.panel = { x: x, z: z }; }

  /* Wiring from the distribution box (panel). Up to two runs are emitted here,
     both routed right-angle along the perimeter offset ring (never across the
     pool footprint):
       * Cable 1 -- ALWAYS: panel -> shaft (technology feed).
       * Cable 3 -- panel -> each light's junction box (only if lights exist).
     (Cable 2, valve control, is computeValveWiring.) Returns draw segments,
     total cable length and the light-box count. */
  function computeWiring() {
    try {
      var foot = getFootprintPolygon();
      var off = _offsetPolygon(foot, -0.12, true);          /* just outside wall */
      if (!off || off.length < 3) off = foot;
      var panel = getPanelPos();
      var shaft = getShaftPos();
      var yWall = -0.10, yBox = -0.10;                      /* cable runs high on the wall */
      if (getEdgeType() === 'infinite') { yWall = -0.42; yBox = -0.42; }  /* below the gutter */
      var segs = [], cableLen = 0;
      function nearestOn(ring, x, z) {
        var bd = Infinity, bx = x, bz = z, n = ring.length;
        for (var i = 0; i < n; i++) {
          var a = ring[i], b = ring[(i + 1) % n];
          var ex=b[0]-a[0], ez=b[1]-a[1], L2=(ex*ex+ez*ez)||1e-9;
          var t=((x-a[0])*ex+(z-a[1])*ez)/L2; if(t<0)t=0;else if(t>1)t=1;
          var px=a[0]+ex*t, pz=a[1]+ez*t; var dd=(px-x)*(px-x)+(pz-z)*(pz-z);
          if(dd<bd){bd=dd;bx=px;bz=pz;}
        }
        return { x: bx, z: bz };
      }
      function push(x1,y1,z1,x2,y2,z2){
        var L = Math.hypot(x2-x1, z2-z1) + Math.abs(y2-y1);
        if (L < 0.01) return;
        segs.push({ x1:x1,y1:y1,z1:z1, x2:x2,y2:y2,z2:z2 });
        cableLen += L;
      }
      var panelOn = nearestOn(off, panel.x, panel.z);
      /* Cable 1 -- ALWAYS: distribution box -> shaft (technology), around the ring. */
      var shaftOn = nearestOn(off, shaft.x, shaft.z);
      push(panel.x, yWall, panel.z, panelOn.x, yWall, panelOn.z);
      var sp = _ringPathShorter(off, panelOn, shaftOn);
      for (var s2 = 1; s2 < sp.length; s2++) push(sp[s2-1].x, yWall, sp[s2-1].z, sp[s2].x, yWall, sp[s2].z);
      push(shaftOn.x, yWall, shaftOn.z, shaft.x, yWall, shaft.z);
      /* Cable 3 -- lights -> distribution box (only if lights). The run travels
         the perimeter on the OUTSIDE ring, drops a riser BEHIND the wall, and
         enters the light niche from the back (a short through-wall stub at the
         fixture's depth) -- like a real conduit, not down the wet inner face.
         Riser + stub length are counted. */
      var li = getLightPositions();
      var yLight = _lightY(getCurrentDepth());
      for (var k = 0; k < li.length; k++) {
        var on = nearestOn(off, li[k].x, li[k].z);                  /* behind-wall point nearest the light */
        var path = _ringPathShorter(off, on, panelOn);              /* perimeter run, outside the wall */
        for (var i = 1; i < path.length; i++) push(path[i-1].x, yWall, path[i-1].z, path[i].x, yWall, path[i].z);
        push(panelOn.x, yWall, panelOn.z, panel.x, yWall, panel.z); /* into the distribution box */
        push(on.x, yWall, on.z, on.x, yLight, on.z);                /* riser down behind the wall */
        push(on.x, yLight, on.z, li[k].x, yLight, li[k].z);         /* through the wall into the niche */
      }
      return { segs: segs, cableLen: cableLen, boxes: li.length };
    } catch (_) { return { segs: [], cableLen: 0, boxes: 0 }; }
  }

  /* Drain-valve control wiring (both edge systems) -- CABLE 2 from the distribution
     box: a junction box at each pool-drain valve, daisy-chained along the
     perimeter ring (two arms) and fed by one cable straight from the panel.
     Never crosses the pool footprint. Returns draw segments, total cable
     length and the per-valve box points. */
  function computeValveWiring(valvePts) {
    try {
      if (!valvePts || !valvePts.length) return { segs: [], cableLen: 0, valveBoxes: 0, commonBox: 0, boxPts: [], commonPt: null };
      var foot = getFootprintPolygon();
      var off = _offsetPolygon(foot, -0.12, true);
      if (!off || off.length < 3) off = foot;
      var panel = getPanelPos();
      var shaft = getShaftPos();
      /* Separate cable run, 5 cm BELOW the light cable (lights run at -0.10),
         and routed independently (never through the light junction boxes). */
      var yWall = -0.15, yBox = -0.15;
      if (getEdgeType() === 'infinite') { yWall = -0.42; yBox = -0.42; }  /* below the gutter */
      /* Valve sits on the drain riser; its cable rises from there to the box.
         The riser meets the suction trunk, which is deeper in infinite mode, so
         match that depth (= where the purple valve mesh actually sits). */
      var D = getCurrentDepth();
      var segs = [], cableLen = 0;
      function nearestOn(ring, x, z) {
        var bd = Infinity, bx = x, bz = z, n = ring.length;
        for (var i = 0; i < n; i++) {
          var a = ring[i], b = ring[(i + 1) % n];
          var ex=b[0]-a[0], ez=b[1]-a[1], L2=(ex*ex+ez*ez)||1e-9;
          var t=((x-a[0])*ex+(z-a[1])*ez)/L2; if(t<0)t=0;else if(t>1)t=1;
          var px=a[0]+ex*t, pz=a[1]+ez*t; var dd=(px-x)*(px-x)+(pz-z)*(pz-z);
          if(dd<bd){bd=dd;bx=px;bz=pz;}
        }
        return { x: bx, z: bz };
      }
      function push(x1,y1,z1,x2,y2,z2){
        var L = Math.hypot(x2-x1, z2-z1) + Math.abs(y2-y1);
        if (L < 0.01) return;
        segs.push({ x1:x1,y1:y1,z1:z1, x2:x2,y2:y2,z2:z2 });
        cableLen += L;
      }
      var feedPt = nearestOn(off, panel.x, panel.z);     /* daisy chain feeds from the distribution box */
      /* Arc length of a point along the off ring (for ordering boxes). */
      function arcOn(p) {
        var n = off.length, cum = 0, best = Infinity, bs = 0;
        for (var i = 0; i < n; i++) {
          var a = off[i], b = off[(i + 1) % n];
          var ex=b[0]-a[0], ez=b[1]-a[1], L2=(ex*ex+ez*ez)||1e-9;
          var t=((p.x-a[0])*ex+(p.z-a[1])*ez)/L2; if(t<0)t=0;else if(t>1)t=1;
          var px=a[0]+ex*t, pz=a[1]+ez*t; var dd=(px-p.x)*(px-p.x)+(pz-p.z)*(pz-p.z);
          if(dd<best){best=dd; bs=cum+Math.hypot(px-a[0],pz-a[1]);}
          cum += Math.hypot(ex, ez);
        }
        return { s: bs, total: cum };
      }
      var cA = arcOn(feedPt), total = cA.total || 1, cs = cA.s;
      var boxPts = [];
      var nodes = [];
      /* Wire the ACTUAL electric valves (the purple meshes), NOT the floor
         drains. Each valve gets a junction box on the perimeter trench nearest
         IT, plus a short whip from that box down/in to the valve -- so the cable
         always terminates on a real valve, the box stays on the trench, and
         nothing is dragged around a corner or back across the water. The daisy
         chain then walks the trench through the boxes to the panel. */
      for (var k = 0; k < valvePts.length; k++) {
        var vp = valvePts[k];
        var ringPt = nearestOn(off, vp.x, vp.z);           /* box on the trench nearest THIS valve */
        boxPts.push({ x: ringPt.x, z: ringPt.z });
        var s = arcOn(ringPt).s;
        var cw = (((s - cs) % total) + total) % total;
        nodes.push({ x: ringPt.x, z: ringPt.z, cw: cw, ccw: total - cw });
        push(ringPt.x, yBox, ringPt.z, vp.x, vp.y, vp.z);  /* trench box -> the real valve */
      }
      /* Two daisy-chained arms from the common box, each walking the ring in
         one direction through its boxes in order -- so the run passes through
         each junction box as a node and never overshoots past one. */
      var armA = nodes.filter(function (q) { return q.cw <= q.ccw; }).sort(function (a, b) { return a.cw - b.cw; });
      var armB = nodes.filter(function (q) { return q.cw >  q.ccw; }).sort(function (a, b) { return a.ccw - b.ccw; });
      function chain(list) {
        var prev = feedPt;
        for (var j = 0; j < list.length; j++) {
          var path = _ringPathShorter(off, prev, { x: list[j].x, z: list[j].z });
          for (var i = 1; i < path.length; i++) push(path[i-1].x, yWall, path[i-1].z, path[i].x, yWall, path[i].z);
          prev = list[j];
        }
      }
      chain(armA); chain(armB);
      /* feed cable from the distribution box to the ring (cable 2 origin) */
      push(panel.x, yWall, panel.z, feedPt.x, yWall, feedPt.z);
      return { segs: segs, cableLen: cableLen, valveBoxes: valvePts.length, commonBox: 0, boxPts: boxPts, commonPt: null, yBox: yBox };
    } catch (_) { return { segs: [], cableLen: 0, valveBoxes: 0, commonBox: 0, boxPts: [], commonPt: null }; }
  }

  /* Main floor drains, count by surface area (VGB: >=2 once non-trivial). */
  function _drainCount(inner) {
    var A = _polyArea(inner);
    if (A <= 30) return 1;
    if (A <= 80) return 2;
    return 3;
  }
  /* Drain positions: split the floor into N bands along the longer axis and
     place each drain at the AREA CENTROID of its band (so each drain sits in
     the middle of the floor area it serves; respects L-shapes/concavity). */
  function getDrainPositions() {
    var inner = _innerRing();
    if (!inner || inner.length < 3) return [];
    /* Floor drains belong to the MAIN pool only -- never under a raised zone.
       Use the deep-water footprint (each zone arm's cap shifted in to its riser),
       so both the COUNT (by area) and the sampled positions ignore the benches. */
    var mainPoly = (typeof _waterDeepPoly === 'function') ? _waterDeepPoly(inner) : inner;
    if (!mainPoly || mainPoly.length < 3) mainPoly = inner;
    var n = _drainCount(mainPoly);
    var bb = _ringBBox(mainPoly);
    var w = bb.maxX - bb.minX, l = bb.maxZ - bb.minZ;
    var alongZ = (l >= w);                       /* split along the longer axis */
    var lo = alongZ ? bb.minZ : bb.minX;
    var hi = alongZ ? bb.maxZ : bb.maxX;
    var bandW = (hi - lo) / n || 1;
    /* sample grid over the bounding box; keep points inside the pool */
    var nx = 32, nz = 32;
    var stepX = (w || 1) / nx, stepZ = (l || 1) / nz;
    var acc = [], gAcc = { sx: 0, sz: 0, c: 0 };
    for (var i = 0; i < n; i++) acc.push({ sx: 0, sz: 0, c: 0 });
    for (var gx = bb.minX; gx <= bb.maxX + 1e-9; gx += stepX) {
      for (var gz = bb.minZ; gz <= bb.maxZ + 1e-9; gz += stepZ) {
        if (!_pointInPoly([gx, gz], mainPoly)) continue;
        var coord = alongZ ? gz : gx;
        var band = Math.floor((coord - lo) / bandW);
        if (band < 0) band = 0; else if (band > n - 1) band = n - 1;
        acc[band].sx += gx; acc[band].sz += gz; acc[band].c++;
        gAcc.sx += gx; gAcc.sz += gz; gAcc.c++;
      }
    }
    var gcx = gAcc.c ? gAcc.sx / gAcc.c : (bb.minX + bb.maxX) / 2;
    var gcz = gAcc.c ? gAcc.sz / gAcc.c : (bb.minZ + bb.maxZ) / 2;
    var out = [];
    for (i = 0; i < n; i++) {
      if (!acc[i].c) continue;
      var px = acc[i].sx / acc[i].c, pz = acc[i].sz / acc[i].c;
      /* if the band centroid lands outside (concave shape), pull it toward the
         global centroid until it's inside the pool */
      if (!_pointInPoly([px, pz], mainPoly)) {
        for (var t = 0.1; t <= 1.0; t += 0.1) {
          var qx = px + (gcx - px) * t, qz = pz + (gcz - pz) * t;
          if (_pointInPoly([qx, qz], mainPoly)) { px = qx; pz = qz; break; }
        }
      }
      out.push({ x: px, z: pz });
    }
    return out;
  }
  function _ringBBox(ring) {
    var minX = Infinity, maxX = -Infinity, minZ = Infinity, maxZ = -Infinity;
    for (var i = 0; i < ring.length; i++) {
      var p = ring[i];
      if (p[0] < minX) minX = p[0]; if (p[0] > maxX) maxX = p[0];
      if (p[1] < minZ) minZ = p[1]; if (p[1] > maxZ) maxZ = p[1];
    }
    return { minX: minX, maxX: maxX, minZ: minZ, maxZ: maxZ };
  }

  /* Overflow gutter collection points ("sberna mista"): evenly spaced around
     the gutter (outer footprint edge), ~1 per 3 m of perimeter, min 4. Only
     meaningful in overflow mode; gravity pipes lead from these to the tank. */
  function _overflowCollectorCount() {
    var foot = getFootprintPolygon();
    if (!foot || foot.length < 3) return 0;
    return Math.max(4, Math.round(_polyPerim(foot) / 3));
  }
  function getOverflowCollectorPositions() {
    if (getEdgeType() !== 'overflow') return [];
    var foot = getFootprintPolygon();
    if (!foot || foot.length < 3) return [];
    return _spaceAlongRing(foot, _overflowCollectorCount()).map(function (p) {
      return { x: p.x, z: p.z };
    });
  }

  /* Coping edge tiles (skimmer edge). One deterministic layout shared by the
     BoQ and the 2D/3D drawing, so the drawn pieces == the counted pieces (and
     each placement can later map to an asset-drawer item). Straight tiles
     (600 mm / 24") run along each footprint edge; each corner gets one corner
     piece, classified OUTER (convex) or INNER (concave). Returns world-space
     placements: { straight:[{cx,cz,ang,len,w}], outer:[{cx,cz,ang,w}],
     inner:[{cx,cz,ang,w}] }. */
  function _copingTiles(widthM, baseRing) {
    var out = { straight: [], outer: [], inner: [] };
    var poly = baseRing || _innerRing();                /* lay tiles at the inner (water) edge */
    if (!poly || poly.length < 3) return out;
    var d = getVariantDefaults(variantKey(), STATE.lvl);
    var cw = widthM || d.copingWidthM || 0.30;          /* tile width (across the edge) */
    var tileLen = STATE.isMetric ? 0.60 : (24 * IN);    /* tile length (along the edge) */
    var joint = 0.008;                                  /* visible joint gap */
    var n = poly.length;
    /* winding + centroid (outward direction) */
    var area2 = 0, cx0 = 0, cz0 = 0;
    for (var i = 0; i < n; i++) {
      var p0 = poly[i], p1 = poly[(i + 1) % n];
      area2 += p0[0] * p1[1] - p1[0] * p0[1];
      cx0 += poly[i][0]; cz0 += poly[i][1];
    }
    var ccw = area2 > 0; cx0 /= n; cz0 /= n;
    function unit(ax, az) { var L = Math.hypot(ax, az) || 1; return [ax / L, az / L]; }
    /* per-vertex convexity (outer/convex vs inner/concave) */
    var convexAt = [];
    for (i = 0; i < n; i++) {
      var Pv = poly[i], Pvp = poly[(i - 1 + n) % n], Pvn = poly[(i + 1) % n];
      var uvp = unit(Pv[0] - Pvp[0], Pv[1] - Pvp[1]);
      var uvn = unit(Pvn[0] - Pv[0], Pvn[1] - Pv[1]);
      convexAt[i] = ((uvp[0] * uvn[1] - uvp[1] * uvn[0]) > 0) === ccw;
    }
    var cornerReturn0 = STATE.isMetric ? 0.10 : (4 * IN);  /* outer L return ~ 10 cm */
    function gapAt(vi) { return convexAt[vi] ? cornerReturn0 : (cw + cornerReturn0); }
    /* Infinity (vanishing) edges carry NO coping: the tiles are hidden on those
       edges, the corner tiles at their corners are removed, and the adjacent
       straight tiles extend into the corner. */
    var _infMode = getEdgeType() === 'infinite';
    var _infSet = _infMode ? getInfiniteEdges() : [];
    function isInfEdge(k) { k = ((k % n) + n) % n; return _infMode && _infSet.indexOf(k) >= 0; }
    function isInfCorner(v) { v = ((v % n) + n) % n; return _infMode && (isInfEdge(v - 1) || isInfEdge(v)); }
    /* straight tiles per edge */
    for (i = 0; i < n; i++) {
      if (isInfEdge(i)) continue;                        /* no coping on infinity edges */
      var A = poly[i], B = poly[(i + 1) % n];
      var ex = B[0] - A[0], ez = B[1] - A[1], len = Math.hypot(ex, ez);
      if (len < 1e-6) continue;
      var u = [ex / len, ez / len];
      /* outward normal from winding (robust for concave shapes): CCW -> interior
         on the left, so outward is to the right of the edge direction. */
      var nx = ccw ? u[1] : -u[1];
      var nz = ccw ? -u[0] : u[0];
      var ang = Math.atan2(u[1], u[0]);
      function layTile(d0, L) {                          /* d0 = start dist from A, L = length */
        if (L < 0.03) return;                            /* skip slivers < 3 cm */
        var dPos = d0 + L / 2;
        var px = A[0] + u[0] * dPos + nx * (cw / 2);
        var pz = A[1] + u[1] * dPos + nz * (cw / 2);
        out.straight.push({ cx: px, cz: pz, ang: ang, len: L, w: cw });
      }
      var aInf = isInfCorner(i), bInf = isInfCorner((i + 1) % n);
      /* At an infinity corner the corner tile is gone and the straight tiles run
         right into the corner. They extend PAST the inner vertex out to the
         OUTER (footprint) corner, where the gutter connects (negative gap). */
      var footP = _infMode ? getFootprintPolygon() : null;
      function outerExt(vIdx, fromA) {
        if (!footP || footP.length !== n) return 0;        /* fall back to the vertex */
        var F = footP[vIdx];
        var tF = (F[0] - A[0]) * u[0] + (F[1] - A[1]) * u[1]; /* footprint corner pos along the edge */
        return fromA ? Math.min(0, tF) : Math.min(0, len - tF);
      }
      var gapStart = aInf ? outerExt(i, true)             : gapAt(i);            /* gap at vertex A */
      var gapEnd   = bInf ? outerExt((i + 1) % n, false)  : gapAt((i + 1) % n);  /* gap at vertex B */
      var run = len - gapStart - gapEnd;                  /* available run for tiles + cut */
      if (run >= 0.06) {
        var unitL = tileLen + joint;
        var nFull = Math.floor((run + joint) / unitL);
        if (nFull < 1) {
          /* edge too short for a full tile -- one cut piece spans the run */
          layTile(gapStart, run);
        } else {
          var used = nFull * tileLen + (nFull - 1) * joint;
          var cutLen = run - used - joint;                /* the single dorez */
          /* Full tiles start FROM the infinity corner; the dorez sits on the
             OTHER end. Default packs from A (cut at far/B end). If only the B
             end is the infinity corner, pack from B (cut at A). Both/neither ->
             default. */
          if (bInf && !aInf) {
            layTile(gapStart, cutLen);                    /* dorez at the A (non-infinity) end */
            var baseB = gapStart + cutLen + joint;
            for (var tb = 0; tb < nFull; tb++) layTile(baseB + tb * unitL, tileLen);
          } else {
            for (var t = 0; t < nFull; t++) layTile(gapStart + t * unitL, tileLen);
            layTile(gapStart + used + joint, cutLen);     /* dorez at the far (B) end */
          }
        }
      }
    }
    /* corner pieces -- one L per vertex (two arms hugging the corner), OUTER
       (convex) or INNER (concave). Each record carries the vertex, the two
       edge directions and their outward normals so the builder can draw two
       arm boxes (length cw, width cw) forming the L. */
    for (i = 0; i < n; i++) {
      if (isInfCorner(i)) continue;                      /* no corner tile next to an infinity edge */
      var P = poly[i], Pp = poly[(i - 1 + n) % n], Pn = poly[(i + 1) % n];
      var up = unit(P[0] - Pp[0], P[1] - Pp[1]);        /* incoming dir (-> P) */
      var un = unit(Pn[0] - P[0], Pn[1] - P[1]);        /* outgoing dir (P ->) */
      var cross = up[0] * un[1] - up[1] * un[0];
      var convex = convexAt[i];
      function outN(dx, dz) {
        /* outward normal from winding, consistent with the straight-tile normals */
        return ccw ? [dz, -dx] : [-dz, dx];
      }
      var nIn = outN(up[0], up[1]), nOut = outN(un[0], un[1]);
      var rec = {
        vx: P[0], vz: P[1],
        uIn: up, uOut: un, nIn: nIn, nOut: nOut, w: cw, convex: convex
      };
      if (convex) out.outer.push(rec); else out.inner.push(rec);
    }
    return out;
  }

  /* -- Piping (US trunk-and-branch, right-angle routing) ---------------
     Two trunks run to the shaft:
       * suction  = skimmers (surface) + main drains (floor)
       * pressure = return jets
     Each fitting drops a short 11/2" branch onto its trunk; the trunk runs at
     the larger diameter chosen from the required flow. Routes are right-angle
     (Manhattan) so the metreage matches real trenching. Returns line segments
     (for drawing) and aggregated quantities (for the BoQ), all in metres;
     the BoQ converts to feet. One 90 deg elbow per direction change. */
  function _requiredGPM() {
    var g = _poolGeometry();
    var V = (g && g.waterVol) || 0;            /* m^3 */
    var gal = V * 264.172;                      /* US gallons */
    var turnoverMin = 360;                      /* 6 h turnover */
    return gal / turnoverMin;                   /* GPM */
  }
  /* 3D segment helper: store full 3D endpoints + diameter + kind. */
  function _seg3(x1, y1, z1, x2, y2, z2, dia, kind, circuit) {
    return { x1: x1, y1: y1, z1: z1, x2: x2, y2: y2, z2: z2, dia: dia, kind: kind, circuit: circuit || 'suction' };
  }
  /* Diameter outer radius (m) for offset/draw. */
  var _DIA_OD = { d15: 0.048, d20: 0.060, d25: 0.073, d40: 0.110 };

  /* Walk a closed ring from start param to a target point, the SHORTER way.
     ring: array of [x,z]; returns ordered [x,z] points from p0 to p1 along the
     ring (inclusive of intermediate vertices). */
  function _ringPathShorter(ring, p0, p1) {
    var n = ring.length;
    /* project p0/p1 to ring: find edge + cumulative distance */
    function proj(p) {
      var bd = Infinity, be = 0, bx = p.x, bz = p.z, bcum = 0, cum = 0;
      for (var i = 0; i < n; i++) {
        var a = ring[i], b = ring[(i + 1) % n];
        var ex = b[0] - a[0], ez = b[1] - a[1], L2 = (ex * ex + ez * ez) || 1e-9;
        var t = ((p.x - a[0]) * ex + (p.z - a[1]) * ez) / L2;
        if (t < 0) t = 0; else if (t > 1) t = 1;
        var px = a[0] + ex * t, pz = a[1] + ez * t;
        var d = (px - p.x) * (px - p.x) + (pz - p.z) * (pz - p.z);
        if (d < bd) { bd = d; be = i; bx = px; bz = pz; bcum = cum + Math.hypot(px - a[0], pz - a[1]); }
        cum += Math.hypot(ex, ez);
      }
      return { edge: be, x: bx, z: bz, cum: bcum, total: cum };
    }
    var P = proj(p0), Q = proj(p1), total = P.total;
    /* build CW path from P.cum to Q.cum and CCW; pick shorter */
    function build(forward) {
      var pts = [{ x: P.x, z: P.z }];
      var guard = 0;
      if (forward) {
        /* toward increasing vertex index; stop at Q's near vertex (don't run on
           to the corner past Q and back). */
        var vi = (P.edge + 1) % n;
        while (guard++ < n + 1) {
          if (vi === (Q.edge + 1) % n) break;       /* same-edge: go straight to Q */
          pts.push({ x: ring[vi][0], z: ring[vi][1] });
          if (vi === Q.edge) break;                 /* reached Q's edge */
          vi = (vi + 1) % n;
        }
      } else {
        /* toward decreasing vertex index; stop at Q's far-side vertex. */
        var vj = P.edge;
        while (guard++ < n + 1) {
          pts.push({ x: ring[vj][0], z: ring[vj][1] });
          if (vj === (Q.edge + 1) % n) break;
          vj = (vj - 1 + n) % n;
        }
      }
      pts.push({ x: Q.x, z: Q.z });
      var L = 0;
      for (var k = 1; k < pts.length; k++) L += Math.hypot(pts[k].x - pts[k - 1].x, pts[k].z - pts[k - 1].z);
      return { pts: pts, L: L };
    }
    var f = build(true), b = build(false);
    return (f.L <= b.L) ? f.pts : b.pts;
  }

  function computePiping() {
    try {
      var inner = _innerRing();
      if (!inner || inner.length < 3) return null;
      var d = getVariantDefaults(variantKey(), STATE.lvl);
      var wallT = _effectiveWallThick(d);
      var D = getCurrentDepth();
      var foot = getFootprintPolygon();            /* outer wall face */
      var shaft = getShaftPos();
      var gpm = _requiredGPM();
      var trunkKey = _trunkDiaKey(gpm);
      var branchKey = 'd15';

      /* Perimeter run rings, offset OUTSIDE the wall by ~2xD of the pipe. */
      var offS = _offsetPolygon(foot, -(2 * _DIA_OD[trunkKey]), true);   /* outside */
      if (!offS || offS.length < 3) offS = foot;

      /* Depths (Y, world): grade = 0, up is +Y. */
      var ySkim = -(d.freeboardM || 0.15);          /* skimmer at water line */
      var slabTop = -D;                             /* basin floor */
      var yDrainPipe = slabTop - 0.05;              /* drain pipe inside the slab */
      var yShaftIn = -0.30;                         /* enters the shaft near top */

      var agg = {};
      function add(dia, field, v) { (agg[dia] = agg[dia] || { pipe: 0, elbow90: 0, tee: 0, reducer: 0 })[field] += v; }
      var segs = [];
      var teePts = [];                              /* tee junctions (green) */
      var elbowPts = [];                            /* elbow points (green) */
      var valvePts = [];                            /* electric flow valves (purple) */
      var _circuit = 'suction';
      function pushSeg(x1,y1,z1,x2,y2,z2,dia,kind){
        var L = Math.hypot(x2-x1, z2-z1) + Math.abs(y2-y1);
        if (L < 0.01) return;
        segs.push(_seg3(x1,y1,z1,x2,y2,z2,dia,kind,_circuit));
        add(dia, 'pipe', L);
      }
      function elbowAt(x, y, z) { elbowPts.push({ x: x, y: y, z: z }); }

      /* nearest point on a ring to a world point */
      function nearestOn(ring, x, z) {
        var bd = Infinity, bx = x, bz = z, n = ring.length;
        for (var i = 0; i < n; i++) {
          var a = ring[i], b = ring[(i + 1) % n];
          var ex = b[0]-a[0], ez = b[1]-a[1], L2=(ex*ex+ez*ez)||1e-9;
          var t = ((x-a[0])*ex+(z-a[1])*ez)/L2; if(t<0)t=0;else if(t>1)t=1;
          var px=a[0]+ex*t, pz=a[1]+ez*t; var dd=(px-x)*(px-x)+(pz-z)*(pz-z);
          if(dd<bd){bd=dd;bx=px;bz=pz;}
        }
        return { x: bx, z: bz };
      }

      var shaftOnRing = nearestOn(offS, shaft.x, shaft.z);

      /* Tee orientation: trunk tangent at the ring point + branch direction
         (from the ring point toward the fitting). */
      function _teeInfo(on, p) {
        var n = offS.length, bi = 0, bd = Infinity;
        for (var i = 0; i < n; i++) {
          var a = offS[i], b = offS[(i + 1) % n];
          var ex=b[0]-a[0], ez=b[1]-a[1], L2=(ex*ex+ez*ez)||1e-9;
          var t=((on.x-a[0])*ex+(on.z-a[1])*ez)/L2; if(t<0)t=0;else if(t>1)t=1;
          var px=a[0]+ex*t, pz=a[1]+ez*t; var dd=(px-on.x)*(px-on.x)+(pz-on.z)*(pz-on.z);
          if(dd<bd){bd=dd;bi=i;}
        }
        var A=offS[bi], B=offS[(bi+1)%n], L=Math.hypot(B[0]-A[0],B[1]-A[1])||1;
        var tx=(B[0]-A[0])/L, tz=(B[1]-A[1])/L;          /* trunk tangent */
        var bx=p.x-on.x, bz=p.z-on.z, bl=Math.hypot(bx,bz)||1;
        return { x:on.x, z:on.z, tx:tx, tz:tz, bx:bx/bl, bz:bz/bl };
      }

      /* Arc-length parameter of a point projected onto the perimeter ring. */
      function ringParam(pt) {
        var n = offS.length, cum = 0, best = Infinity, bs = 0;
        for (var i = 0; i < n; i++) {
          var a = offS[i], b = offS[(i + 1) % n];
          var ex=b[0]-a[0], ez=b[1]-a[1], L2=(ex*ex+ez*ez)||1e-9;
          var t=((pt.x-a[0])*ex+(pt.z-a[1])*ez)/L2; if(t<0)t=0;else if(t>1)t=1;
          var px=a[0]+ex*t, pz=a[1]+ez*t; var dd=(px-pt.x)*(px-pt.x)+(pz-pt.z)*(pz-pt.z);
          if(dd<best){best=dd; bs=cum+Math.hypot(px-a[0],pz-a[1]);}
          cum += Math.hypot(ex, ez);
        }
        return { s: bs, total: cum };
      }
      var ringTotal = ringParam(shaftOnRing).total || _polyPerim(offS) || 1;
      var s0 = ringParam(shaftOnRing).s;

      /* Cumulative arc length to each ring vertex (for direction-correct legs). */
      var vparam = [];
      (function () {
        var cum = 0;
        for (var i = 0; i < offS.length; i++) {
          vparam[i] = cum;
          var a = offS[i], b = offS[(i + 1) % offS.length];
          cum += Math.hypot(b[0] - a[0], b[1] - a[1]);
        }
      })();
      /* Forward (CW) distance from the shaft to a given arc-length s. */
      function fwdOf(s) { return (((s - s0) % ringTotal) + ringTotal) % ringTotal; }
      /* A trunk leg from prevPt -> curPt walking the ring in the ARM direction
         (forward = increasing CW distance; backward = the other way). Returns
         the point list including the ring vertices that fall between them, so
         the trunk never short-cuts across the far side. */
      function dirLeg(prevPt, curPt, forward) {
        var kp = fwdOf(ringParam(prevPt).s), kc = fwdOf(ringParam(curPt).s);
        var pts = [{ x: prevPt.x, z: prevPt.z }];
        var mids = [];
        for (var i = 0; i < offS.length; i++) {
          var vf = vparam[i] === undefined ? 0 : fwdOf(vparam[i]);
          var inBetween;
          if (forward) {
            /* vertices with CW distance strictly between kp and kc (forward) */
            if (kc >= kp) inBetween = (vf > kp + 1e-6 && vf < kc - 1e-6);
            else          inBetween = (vf > kp + 1e-6 || vf < kc - 1e-6); /* wrap */
          } else {
            /* backward: between kc and kp going the other way */
            if (kp >= kc) inBetween = (vf > kc + 1e-6 && vf < kp - 1e-6);
            else          inBetween = (vf > kc + 1e-6 || vf < kp - 1e-6);
          }
          if (inBetween) mids.push({ x: offS[i][0], z: offS[i][1], k: vf });
        }
        /* order the intermediate vertices along the travel direction */
        mids.sort(function (a, b) {
          var da = forward ? ((a.k - kp + ringTotal) % ringTotal) : ((kp - a.k + ringTotal) % ringTotal);
          var db = forward ? ((b.k - kp + ringTotal) % ringTotal) : ((kp - b.k + ringTotal) % ringTotal);
          return da - db;
        });
        for (var m = 0; m < mids.length; m++) pts.push({ x: mids[m].x, z: mids[m].z });
        pts.push({ x: curPt.x, z: curPt.z });
        return pts;
      }

      /* Branch stub from a fitting down to the trunk at its ring point. */
      /* Branch stub from a fitting down to its circuit trunk at yP. Adds the
         outlet elbow (into the pool / drain) and the top elbow; the bottom
         junction (tee or dead-end elbow) is handled by the caller. */
      function branchStub(it, yP) {
        if (it.kind === 'drain') {
          elbowAt(it.p.x, yDrainPipe, it.p.z); add(branchKey, 'elbow90', 1);   /* drain -> slab */
          pushSeg(it.p.x, yDrainPipe, it.p.z, it.on.x, yDrainPipe, it.on.z, branchKey, 'slab');
          elbowAt(it.on.x, yDrainPipe, it.on.z); add(branchKey, 'elbow90', 1); /* slab -> riser */
          pushSeg(it.on.x, yDrainPipe, it.on.z, it.on.x, yP, it.on.z, branchKey, 'riser');
          /* Electric flow valve (DN50) on the vertical drain connection -- same
             as the overflow drains, so skimmer pools get drain valves too. */
          valvePts.push({ x: it.on.x, y: (yDrainPipe + yP) / 2, z: it.on.z });
        } else {
          elbowAt(it.p.x, it.y, it.p.z); add(branchKey, 'elbow90', 1);          /* outlet into pool */
          pushSeg(it.p.x, it.y, it.p.z, it.on.x, it.y, it.on.z, branchKey, 'stub');
          elbowAt(it.on.x, it.y, it.on.z); add(branchKey, 'elbow90', 1);        /* stub -> riser */
          pushSeg(it.on.x, it.y, it.on.z, it.on.x, yP, it.on.z, branchKey, 'riser');
        }
      }

      /* Build one trunk arm at depth yP: shaft -> fitting[0] -> ... -> dead-end.
         Tee at each pass-through junction; the final fitting is a dead-end
         ELBOW. The last leg (one fitting) drops to branch diameter, preceded
         by a trunk REDUCER at the second-to-last. */
      function buildArm(arm, forward, yP, sink) {
        if (!arm.length) return;
        var prev = shaftOnRing;
        for (var j = 0; j < arm.length; j++) {
          var it = arm[j];
          var isLast = (j === arm.length - 1);
          var legDia = (isLast && arm.length >= 2) ? branchKey : trunkKey;
          var path = dirLeg(prev, it.on, forward);
          for (var i = 1; i < path.length; i++) {
            pushSeg(path[i-1].x, yP, path[i-1].z, path[i].x, yP, path[i].z, legDia, 'perimeter');
            if (sink) sink.push({ ax: path[i-1].x, az: path[i-1].z, bx: path[i].x, bz: path[i].z });
            if (i < path.length - 1) { add(legDia, 'elbow90', 1); elbowAt(path[i].x, yP, path[i].z); } /* ring corner */
          }
          branchStub(it, yP);
          if (isLast) {
            add(legDia, 'elbow90', 1); elbowAt(it.on.x, yP, it.on.z);   /* dead-end elbow */
            if (legDia !== branchKey) add(trunkKey, 'reducer', 1);
          } else {
            add(trunkKey, 'tee', 1);
            var ti = _teeInfo(it.on, it.p); ti.y = yP; teePts.push(ti);
            if (branchKey !== trunkKey) add(trunkKey, 'reducer', 1);    /* branch outlet reducer */
            if (j === arm.length - 2 && branchKey !== trunkKey) add(trunkKey, 'reducer', 1);
          }
          prev = it.on;
        }
      }

      /* Nearest point on a list of XZ segments (the real trunk). */
      function nearestOnSegs(list, x, z) {
        var bd = Infinity, bx = x, bz = z;
        for (var i = 0; i < list.length; i++) {
          var sg = list[i];
          var ex = sg.bx - sg.ax, ez = sg.bz - sg.az, L2 = (ex*ex+ez*ez) || 1e-9;
          var t = ((x-sg.ax)*ex + (z-sg.az)*ez)/L2; if(t<0)t=0;else if(t>1)t=1;
          var px = sg.ax+ex*t, pz = sg.az+ez*t; var dd = (px-x)*(px-x)+(pz-z)*(pz-z);
          if (dd < bd) { bd = dd; bx = px; bz = pz; }
        }
        return { x: bx, z: bz };
      }

      /* Build a whole circuit (its own two arms from the shaft + drain taps). */
      function buildCircuit(wall, drains, yP, circuit) {
        _circuit = circuit;
        var its = [], i;
        for (i = 0; i < wall.length; i++) {
          var w = wall[i];
          w.on = nearestOn(offS, w.p.x, w.p.z);
          var cw = (((ringParam(w.on).s - s0) % ringTotal) + ringTotal) % ringTotal;
          w.cw = cw; w.ccw = ringTotal - cw; its.push(w);
        }
        var armA = its.filter(function (q) { return q.cw <= q.ccw; }).sort(function (a, b) { return a.cw - b.cw; });
        var armB = its.filter(function (q) { return q.cw >  q.ccw; }).sort(function (a, b) { return a.ccw - b.ccw; });
        /* shaft riser + supply split */
        pushSeg(shaft.x, yShaftIn, shaft.z, shaftOnRing.x, yP, shaftOnRing.z, trunkKey, 'riser');
        add(trunkKey, 'elbow90', 1); elbowAt(shaftOnRing.x, yP, shaftOnRing.z);
        if (armA.length && armB.length) {
          add(trunkKey, 'tee', 1);
          var ts = _teeInfo(shaftOnRing, { x: shaft.x, z: shaft.z }); ts.y = yP; teePts.push(ts);
        } else { add(trunkKey, 'elbow90', 1); }
        var trunkXZ = [];
        buildArm(armA, true, yP, trunkXZ);
        buildArm(armB, false, yP, trunkXZ);
        /* Drains tap the trunk. In INFINITE mode the trunk only runs along the
           gutter edges, so a straight branch to the nearest trunk point would
           cut diagonally across open ground. Instead drop each drain
           PERPENDICULAR to its nearest wall, then run along the perimeter
           trench (elbows at corners) to the trunk tap -- sharing the trench, as
           it would actually be dug. Skimmer/overflow keep the original direct
           stub (their trunk already hugs every wall). */
        var _alongWall = (getEdgeType() === 'infinite');
        for (i = 0; i < drains.length; i++) {
          var d = drains[i];
          var tap = trunkXZ.length ? nearestOnSegs(trunkXZ, d.x, d.z)
                                   : nearestOn(offS, d.x, d.z);
          if (_alongWall && trunkXZ.length) {
            var near = nearestOn(offS, d.x, d.z);          /* perpendicular to nearest wall */
            elbowAt(d.x, yDrainPipe, d.z); add(branchKey, 'elbow90', 1);
            pushSeg(d.x, yDrainPipe, d.z, near.x, yDrainPipe, near.z, branchKey, 'slab');
            elbowAt(near.x, yDrainPipe, near.z); add(branchKey, 'elbow90', 1);
            pushSeg(near.x, yDrainPipe, near.z, near.x, yP, near.z, branchKey, 'riser');
            valvePts.push({ x: near.x, y: (yDrainPipe + yP) / 2, z: near.z });   /* valve at the wall */
            var dpath = _ringPathShorter(offS, near, tap);  /* run along the trench (no corner overshoot) */
            for (var pj = 1; pj < dpath.length; pj++) {
              pushSeg(dpath[pj-1].x, yP, dpath[pj-1].z, dpath[pj].x, yP, dpath[pj].z, branchKey, 'perimeter');
              if (pj < dpath.length - 1) { add(branchKey, 'elbow90', 1); elbowAt(dpath[pj].x, yP, dpath[pj].z); }
            }
            add(trunkKey, 'tee', 1);
            var td2 = _teeInfo(tap, near); td2.y = yP; teePts.push(td2);
            if (branchKey !== trunkKey) add(trunkKey, 'reducer', 1);
          } else {
            var dpt = { p: d, y: yDrainPipe, kind: 'drain' };
            dpt.on = tap;
            branchStub(dpt, yP);
            add(trunkKey, 'tee', 1);
            var td = _teeInfo(dpt.on, dpt.p); td.y = yP; teePts.push(td);
            if (branchKey !== trunkKey) add(trunkKey, 'reducer', 1);
          }
        }
      }

      /* -- Overflow-only branches (kept completely separate from the skimmer
         suction circuit above) -----------------------------------------
         * Gutter collection points -> TANK by gravity (RED, DN110 main with
           DN75 gutter drops; one tee + 110->75 reducer per collector).
         * Main floor drains -> SHAFT (pump) on their own RED branch. */
      function _arcOn(p) {
        var n = offS.length, cum = 0, best = Infinity, bs = 0;
        for (var i = 0; i < n; i++) {
          var a = offS[i], b = offS[(i + 1) % n];
          var ex = b[0]-a[0], ez = b[1]-a[1], L2 = (ex*ex+ez*ez)||1e-9;
          var t = ((p.x-a[0])*ex+(p.z-a[1])*ez)/L2; if (t<0)t=0; else if (t>1)t=1;
          var px = a[0]+ex*t, pz = a[1]+ez*t; var dd = (px-p.x)*(px-p.x)+(pz-p.z)*(pz-p.z);
          if (dd < best) { best = dd; bs = cum + Math.hypot(px-a[0], pz-a[1]); }
          cum += Math.hypot(ex, ez);
        }
        return { s: bs, total: cum };
      }

      function buildOverflowToTank(yP) {
        _circuit = 'suction';                         /* red */
        var tank = getTankPos();
        var cols = getOverflowCollectorPositions();
        if (!cols.length) return;
        var tankOn = nearestOn(offS, tank.x, tank.z);
        var pts = cols.map(function (c) { return { p: c, on: nearestOn(offS, c.x, c.z) }; });
        var tA = _arcOn(tankOn), total = tA.total || 1, ts = tA.s;
        pts.forEach(function (o) { var s = _arcOn(o.on).s; o.cw = (((s - ts) % total) + total) % total; o.ccw = total - o.cw; });
        var armA = pts.filter(function (o) { return o.cw <= o.ccw; }).sort(function (a, b) { return a.cw - b.cw; });
        var armB = pts.filter(function (o) { return o.cw >  o.ccw; }).sort(function (a, b) { return a.ccw - b.ccw; });

        /* Main from the ring point nearest the tank, into the tank. */
        pushSeg(tankOn.x, yP, tankOn.z, tank.x, yP, tank.z, 'd40', 'perimeter');
        add('d40', 'elbow90', 1); elbowAt(tank.x, yP, tank.z);
        if (armA.length && armB.length) {
          add('d40', 'tee', 1);
          var tt = _teeInfo(tankOn, { x: tank.x, z: tank.z }); tt.y = yP; teePts.push(tt);
        } else { add('d40', 'elbow90', 1); elbowAt(tankOn.x, yP, tankOn.z); }

        var yGut = -0.12;                              /* gutter outlet just below coping */
        function arm(list) {
          var prev = tankOn;
          for (var j = 0; j < list.length; j++) {
            var o = list[j], isLast = (j === list.length - 1);
            var path = _ringPathShorter(offS, prev, o.on);
            for (var i = 1; i < path.length; i++) {
              pushSeg(path[i-1].x, yP, path[i-1].z, path[i].x, yP, path[i].z, 'd40', 'perimeter');
              if (i < path.length - 1) { add('d40', 'elbow90', 1); elbowAt(path[i].x, yP, path[i].z); }
            }
            /* gutter drop: DN75 from the gutter down to the DN110 main */
            elbowAt(o.p.x, yGut, o.p.z); add('d25', 'elbow90', 1);
            pushSeg(o.p.x, yGut, o.p.z, o.on.x, yGut, o.on.z, 'd25', 'stub');
            elbowAt(o.on.x, yGut, o.on.z); add('d25', 'elbow90', 1);
            pushSeg(o.on.x, yGut, o.on.z, o.on.x, yP, o.on.z, 'd25', 'riser');
            if (isLast) {
              add('d40', 'elbow90', 1); elbowAt(o.on.x, yP, o.on.z);   /* dead-end */
              add('d40', 'reducer', 1);                                 /* 110->75 */
            } else {
              add('d40', 'tee', 1);
              var ti = _teeInfo(o.on, o.p); ti.y = yP; teePts.push(ti);
              add('d40', 'reducer', 1);                                 /* 110->75 branch */
            }
            prev = o.on;
          }
        }
        arm(armA); arm(armB);
      }

      /* Infinity: gutter pickups -> balance tank by gravity, mirroring the
         overflow gutter->tank line. Each infinity-gutter pickup (one per run /
         loop, at the gutter floor) drops to trunk depth, runs along the
         perimeter trench to the ring point nearest the tank, and a single main
         feeds into the tank. */
      function buildInfinityGutterToTank(yP) {
        _circuit = 'suction';                         /* red gravity line */
        var tank = getTankPos();
        var gps = (typeof gutterSuctionPickups === 'function') ? gutterSuctionPickups() : [];
        if (!gps.length) return;
        var tankOn = nearestOn(offS, tank.x, tank.z);
        /* main from the ring point nearest the tank into the tank */
        pushSeg(tankOn.x, yP, tankOn.z, tank.x, yP, tank.z, 'd40', 'perimeter');
        add('d40', 'elbow90', 1); elbowAt(tank.x, yP, tank.z);
        for (var gi = 0; gi < gps.length; gi++) {
          var g = gps[gi];
          var on = nearestOn(offS, g.p.x, g.p.z);
          /* gutter-floor pickup -> perpendicular stub to its ring point */
          elbowAt(g.p.x, g.y, g.p.z); add('d25', 'elbow90', 1);
          pushSeg(g.p.x, g.y, g.p.z, on.x, g.y, on.z, 'd25', 'stub');
          /* riser from the gutter floor down to trunk depth */
          elbowAt(on.x, g.y, on.z); add('d25', 'elbow90', 1);
          pushSeg(on.x, g.y, on.z, on.x, yP, on.z, 'd40', 'riser');
          add('d40', 'reducer', 1);                   /* 75 -> 110 */
          /* along the perimeter trench to the tank tap */
          var gpath = _ringPathShorter(offS, on, tankOn);
          for (var gk = 1; gk < gpath.length; gk++) {
            pushSeg(gpath[gk-1].x, yP, gpath[gk-1].z, gpath[gk].x, yP, gpath[gk].z, 'd40', 'perimeter');
            if (gk < gpath.length - 1) { add('d40', 'elbow90', 1); elbowAt(gpath[gk].x, yP, gpath[gk].z); }
          }
          if (gps.length > 1) {
            add('d40', 'tee', 1);
            var gti = _teeInfo(tankOn, on); gti.y = yP; teePts.push(gti);
          } else {
            add('d40', 'elbow90', 1); elbowAt(tankOn.x, yP, tankOn.z);
          }
        }
      }

      /* Floor drains -> BALANCE TANK (gravity). Same routing as the shaft
         version, but every drain ends in the tank, so ALL pool outflow
         (gutter + floor drains) collects in the tank -- not split between tank
         and shaft. */
      function buildDrainsToTank(yP) {
        _circuit = 'suction';                          /* red */
        var drs = getDrainPositions();
        if (!drs.length) return;
        var tank = getTankPos();
        var tankOn = nearestOn(offS, tank.x, tank.z);
        /* main: ring tap nearest the tank -> into the tank */
        pushSeg(tankOn.x, yP, tankOn.z, tank.x, yP, tank.z, trunkKey, 'perimeter');
        add(trunkKey, 'elbow90', 1); elbowAt(tank.x, yP, tank.z);
        add(trunkKey, 'elbow90', 1); elbowAt(tankOn.x, yP, tankOn.z);
        for (var k = 0; k < drs.length; k++) {
          var on = nearestOn(offS, drs[k].x, drs[k].z);
          elbowAt(drs[k].x, yDrainPipe, drs[k].z); add(branchKey, 'elbow90', 1);
          pushSeg(drs[k].x, yDrainPipe, drs[k].z, on.x, yDrainPipe, on.z, branchKey, 'slab');
          elbowAt(on.x, yDrainPipe, on.z); add(branchKey, 'elbow90', 1);
          pushSeg(on.x, yDrainPipe, on.z, on.x, yP, on.z, branchKey, 'riser');
          valvePts.push({ x: on.x, y: (yDrainPipe + yP) / 2, z: on.z });
          var path = _ringPathShorter(offS, on, tankOn);
          for (var i = 1; i < path.length; i++) {
            pushSeg(path[i-1].x, yP, path[i-1].z, path[i].x, yP, path[i].z, trunkKey, 'perimeter');
            if (i < path.length - 1) { add(trunkKey, 'elbow90', 1); elbowAt(path[i].x, yP, path[i].z); }
          }
          add(trunkKey, 'tee', 1);
          var ti = _teeInfo(tankOn, drs[k]); ti.y = yP; teePts.push(ti);
          if (branchKey !== trunkKey) add(trunkKey, 'reducer', 1);
        }
      }

      /* BALANCE TANK -> TECHNOLOGY SHAFT (pump suction). A single line: the
         pump in the shaft draws from the tank. This is the ONLY connection
         between the outflow side (tank) and the shaft; the shaft then feeds
         the return circuit (jets) only. */
      function buildTankToShaft(yP) {
        _circuit = 'suction';                          /* red */
        var tank = getTankPos();
        pushSeg(tank.x, yP, tank.z, shaft.x, yP, shaft.z, trunkKey, 'perimeter');
        add(trunkKey, 'elbow90', 1); elbowAt(tank.x, yP, tank.z);
        add(trunkKey, 'elbow90', 1); elbowAt(shaft.x, yP, shaft.z);
        pushSeg(shaft.x, yP, shaft.z, shaft.x, yShaftIn, shaft.z, trunkKey, 'riser');
        /* electric flow valve on the suction line into the shaft */
        valvePts.push({ x: shaft.x, y: (yP + yShaftIn) / 2, z: shaft.z });
      }

      /* Infinity: suction is collected from the BOTTOM of the gutter, at the
         gutter END nearest the shaft (a run end where the gutter meets a
         non-infinity edge; for a full loop, the corner nearest the shaft).
         Returns a single 'wall'-type pickup item, or null. */
      function gutterSuctionPickups() {
        if (getEdgeType() !== 'infinite') return [];
        var ie = getInfiniteEdges(); if (!ie || !ie.length) return [];
        var fn = foot.length, inSet = {}, e2, kk;
        for (e2 = 0; e2 < ie.length; e2++) if (ie[e2] >= 0 && ie[e2] < fn) inSet[ie[e2]] = true;
        var ar = 0; for (kk = 0; kk < fn; kk++) { var pa = foot[kk], pb = foot[(kk + 1) % fn]; ar += pa[0] * pb[1] - pb[0] * pa[1]; }
        var ccwF = ar > 0;
        var GUT_MID = 0.16, yGutFloor = -0.21;       /* channel centre offset + floor (match 3D) */
        var nInf = 0; for (kk in inSet) if (inSet[kk]) nInf++;
        if (!nInf) return [];
        var loop = (nInf === fn);
        function endPt(eIdx, atB) {
          var A = foot[eIdx], B = foot[(eIdx + 1) % fn];
          var ex = B[0] - A[0], ez = B[1] - A[1], L = Math.hypot(ex, ez) || 1;
          var ux = ex / L, uz = ez / L, nx = ccwF ? uz : -uz, nz = ccwF ? -ux : ux;
          var c = atB ? B : A, into = atB ? -1 : 1;
          return { x: c[0] + ux * into * 0.20 + nx * GUT_MID, z: c[1] + uz * into * 0.20 + nz * GUT_MID };
        }
        function nearer(cands) {                     /* candidate nearest the shaft */
          var best = null, bd = Infinity;
          for (var i = 0; i < cands.length; i++) {
            var p = cands[i], dd = (p.x - shaft.x) * (p.x - shaft.x) + (p.z - shaft.z) * (p.z - shaft.z);
            if (dd < bd) { bd = dd; best = p; }
          }
          return best;
        }
        var out = [];
        if (loop) {                                  /* one continuous loop -> single pickup */
          var all = [];
          for (e2 = 0; e2 < fn; e2++) { all.push(endPt(e2, false)); all.push(endPt(e2, true)); }
          var bp = nearer(all);
          if (bp) out.push({ p: { x: bp.x, z: bp.z }, y: yGutFloor, kind: 'wall' });
          return out;
        }
        /* group consecutive infinity edges into runs (mod n) -- one pickup per
           run, at its end nearest the shaft, so EVERY separate gutter on the
           shape is connected to the suction trunk, not just one. */
        var seen = {};
        for (var k0 = 0; k0 < fn; k0++) {
          if (!inSet[k0] || seen[k0] || inSet[(k0 - 1 + fn) % fn]) continue;   /* run starts only */
          var run = [], j = k0;
          while (inSet[j] && !seen[j]) { seen[j] = true; run.push(j); j = (j + 1) % fn; }
          var pk = nearer([ endPt(run[0], false), endPt(run[run.length - 1], true) ]);
          if (pk) out.push({ p: { x: pk.x, z: pk.z }, y: yGutFloor, kind: 'wall' });
        }
        return out;
      }

      var sk = getSkimmerPositions(), jt = getJetPositions(), dr = getDrainPositions();
      var yPerimS = -0.45;   /* suction trunk (skimmers + drains) -- deeper */
      var yPerimR = -0.32;   /* return trunk (jets) -- higher, so both are visible */
      var skItems = [], jtItems = [], q;
      for (q = 0; q < sk.length; q++) skItems.push({ p: sk[q], y: ySkim, kind: 'wall' });
      for (q = 0; q < jt.length; q++) jtItems.push({ p: jt[q], y: _jetMouthY(jt[q].x, jt[q].z),  kind: 'wall' });

      if (getEdgeType() === 'overflow') {
        /* Serial hydraulic chain: gutter + floor drains -> balance tank
           (gravity) -> technology shaft (pump suction) -> jets (return). The
           shaft connects to the outflow side ONLY through the tank. */
        buildOverflowToTank(yPerimS);   /* gutter collectors -> tank */
        buildDrainsToTank(yPerimS);     /* floor drains -> tank */
        buildTankToShaft(yPerimS);      /* tank -> shaft (pump) */
        buildCircuit(jtItems, [], yPerimR, 'return');   /* shaft -> jets */
      } else if (getEdgeType() === 'infinite') {
        /* Same serial chain as overflow: gutter pickups + floor drains ->
           balance tank -> shaft (pump) -> jets. Technology dropped below the
           gutter band. */
        yPerimS = -0.55; yPerimR = -0.45; yShaftIn = -0.42;
        buildInfinityGutterToTank(yPerimS);   /* gutter -> tank (gravity) */
        buildDrainsToTank(yPerimS);            /* floor drains -> tank */
        buildTankToShaft(yPerimS);             /* tank -> shaft (pump) */
        buildCircuit(jtItems, [], yPerimR, 'return');   /* shaft -> jets */
      } else {
        /* Skimmer: original two circuits (unchanged). */
        buildCircuit(skItems, dr, yPerimS, 'suction');
        buildCircuit(jtItems, [], yPerimR, 'return');
      }

      return { agg: agg, segs: segs, trunkKey: trunkKey, gpm: gpm,
               teePts: teePts, elbowPts: elbowPts, valvePts: valvePts,
               counts: { skimmers: sk.length, jets: jt.length, drains: dr.length,
                         collectors: getOverflowCollectorPositions().length } };
    } catch (_) { return null; }
  }

  /* -- Skimmers + return jets ----------------------------------------
     Counts driven by pool size (same rules as BoQ). Positions are placed
     evenly along the inner (water) perimeter, then cached in STATE so the
     user can drag them in 2D. Re-derived only when the count changes. */
  function _skimmerCount(inner) { return Math.max(1, Math.ceil(_polyArea(inner) / 25)); }
  function _jetCount(inner) {
    return Math.max(2, Math.round(_polyArea(inner) / 18), Math.ceil(_polyPerim(inner) / 6));
  }
  /* Evenly space n points along a closed ring; returns [{x,z,edge}]. */
  function _spaceAlongRing(ring, n) {
    var per = _polyPerim(ring);
    if (per <= 0 || n <= 0) return [];
    var step = per / n, out = [], acc = 0, placed = 0, target = step / 2;
    for (var i = 0; i < ring.length && placed < n; i++) {
      var a = ring[i], b = ring[(i + 1) % ring.length];
      var segLen = Math.hypot(b[0] - a[0], b[1] - a[1]) || 1;
      while (acc + segLen >= target && placed < n) {
        var t = (target - acc) / segLen;
        out.push({ x: a[0] + (b[0] - a[0]) * t, z: a[1] + (b[1] - a[1]) * t, edge: i });
        placed++; target += step;
      }
      acc += segLen;
    }
    return out;
  }
  /* Inner ring for an arbitrary footprint polygon. */
  function _innerRingFor(poly) {
    var d = getVariantDefaults(variantKey(), STATE.lvl);
    return _insetPolygon(poly, _effectiveWallThick(d));
  }
  /* When the pool is resized, move each fitting so it keeps the SAME edge and
     the SAME proportional position (t) along that edge. Mutates the arrays. */
  function _remapFittingsProportional(oldPoly, newPoly) {
    try {
      var oldRing = _innerRingFor(oldPoly), newRing = _innerRingFor(newPoly);
      if (!oldRing || !newRing || oldRing.length < 3 || newRing.length !== oldRing.length) return;
      function remap(arr) {
        if (!Array.isArray(arr)) return arr;
        return arr.map(function (p) {
          /* find nearest old edge + param t */
          var bi = 0, bt = 0, bd = Infinity, n = oldRing.length;
          for (var i = 0; i < n; i++) {
            var a = oldRing[i], b = oldRing[(i + 1) % n];
            var ex = b[0] - a[0], ez = b[1] - a[1], L2 = (ex * ex + ez * ez) || 1e-9;
            var t = ((p.x - a[0]) * ex + (p.z - a[1]) * ez) / L2;
            if (t < 0) t = 0; else if (t > 1) t = 1;
            var px = a[0] + ex * t, pz = a[1] + ez * t;
            var d = (px - p.x) * (px - p.x) + (pz - p.z) * (pz - p.z);
            if (d < bd) { bd = d; bi = i; bt = t; }
          }
          /* same edge index + same t on the new ring */
          var na = newRing[bi], nb = newRing[(bi + 1) % newRing.length];
          var nx = na[0] + (nb[0] - na[0]) * bt, nz = na[1] + (nb[1] - na[1]) * bt;
          var s = _clampAwayFromStairs(nx, nz, 0.10, bi);
          return { x: s.x, z: s.z };
        });
      }
      if (Array.isArray(STATE.skimmers)) STATE.skimmers = remap(STATE.skimmers);
      if (Array.isArray(STATE.jets))     STATE.jets     = remap(STATE.jets);
      if (Array.isArray(STATE.lights))   STATE.lights   = remap(STATE.lights);
    } catch (_) {}
  }

  function _innerRing() {
    var d = getVariantDefaults(variantKey(), STATE.lvl);
    return _insetPolygon(getFootprintPolygon(), _effectiveWallThick(d));
  }
  function getSkimmerPositions() {
    /* Overflow + infinity pools have no wall skimmers -- overflow spills over the
       whole perimeter into the gutter; infinity spills over the vanishing edge
       into its gutter (suction is picked up from the gutter, see computePiping).
       Return jets stay in both systems. */
    if (getEdgeType() === 'overflow' || getEdgeType() === 'infinite') { STATE.skimmers = []; return STATE.skimmers; }
    var inner = _innerRing();
    if (!inner || inner.length < 3) return [];
    var n = _skimmerCount(inner);
    if (!Array.isArray(STATE.skimmers) || STATE.skimmers.length !== n) {
      STATE.skimmers = _spaceAlongRing(inner, n).map(function (p) {
        var s = _clampAwayFromStairs(p.x, p.z, 0.10, p.edge);
        var c = _clampAwayFromCorners(s.x, s.z, 0.5);   /* same as drag-drop */
        return { x: c.x, z: c.z };
      });
    } else {
      /* Re-snap cached fittings onto the CURRENT inner edge so a 2D/3D toggle
         (or any geometry change) can't leave them floating off the wall --
         same correction the resize remap applies. Idempotent for on-edge pts. */
      STATE.skimmers = STATE.skimmers.map(function (p) {
        var c = _clampAwayFromCorners(p.x, p.z, 0.5);
        return { x: c.x, z: c.z };
      });
    }
    return STATE.skimmers;
  }
  /* Return-jet mouth height. We raised the jets to -0.10 m so they clear the
     relax/kids shelf slabs -- but that only needs to happen AT the bench. A jet
     sitting on a shelf's cap edge (over the raised slab) stays high (-0.10);
     every other jet drops back to the original deeper plane (-0.50), oriented
     down as before. Same supply manifold, just the mouth height differs. */
  var JET_Y_HIGH = -0.16, JET_Y_LOW = -0.50;
  /* True when a jet sits over/in front of a raised zone shelf: nudge the jet
     position inward (toward the pool centre) and test whether it lands on a
     shelf. Robust regardless of how the jet was spaced/clamped along the edge. */
  function _jetOnBench(px, pz) {
    try {
      var zf = _zoneFloors();
      if (!zf || !zf.raised || !zf.raised.length) return false;
      var inner = _innerRing();
      if (!inner || inner.length < 3) return false;
      var cx = 0, cz = 0;
      for (var k = 0; k < inner.length; k++) { cx += inner[k][0]; cz += inner[k][1]; }
      cx /= inner.length; cz /= inner.length;
      var dx = cx - px, dz = cz - pz, dl = Math.hypot(dx, dz) || 1; dx /= dl; dz /= dl;
      for (var d = 0.10; d <= 0.45; d += 0.15) {                /* sample a few steps inward */
        var qx = px + dx * d, qz = pz + dz * d;
        for (var i = 0; i < zf.raised.length; i++) {
          var q = zf.raised[i].quad;
          if (q && q.length >= 4 && _pointInPoly([qx, qz], q)) return true;
        }
      }
    } catch (_) {}
    return false;
  }
  function _jetMouthY(px, pz) {
    return _jetOnBench(px, pz) ? JET_Y_HIGH : JET_Y_LOW;
  }
  function getJetPositions() {
    var inner = _innerRing();
    if (!inner || inner.length < 3) return [];
    var n = _jetCount(inner);
    if (!Array.isArray(STATE.jets) || STATE.jets.length !== n) {
      STATE.jets = _spaceAlongRing(inner, n).map(function (p) {
        var s = _clampAwayFromStairs(p.x, p.z, 0.10, p.edge);
        var c = _clampAwayFromCorners(s.x, s.z, 0.5);
        return { x: c.x, z: c.z };
      });
    } else {
      STATE.jets = STATE.jets.map(function (p) {
        var c = _clampAwayFromCorners(p.x, p.z, 0.5);
        return { x: c.x, z: c.z };
      });
    }
    return STATE.jets;
  }

  /* -- Pool lights -----------------------------------------------------
     Same placement/drag model as skimmers: spaced along the inner ring,
     cached in STATE, draggable in 2D, edge-locked. Density from lightStage:
     stage s -> 1 light per (6 - s) x 5 m? No -- simple: 1 light / (5 m / s),
     i.e. stage 1 = 1 light / 5 m, stage 2 = 1 / 2.5 m, ... (denser). */
  function _lightCount(inner) {
    var s = STATE.lightStage | 0;
    if (s <= 0) return 0;
    var per = _polyPerim(inner);
    var spacing = 10.0 / s;                     /* metres between lights: stage 1 = 1/10 m */
    return Math.max(1, Math.round(per / spacing));
  }
  function getLightPositions() {
    if ((STATE.lightStage | 0) <= 0) { STATE.lights = []; return STATE.lights; }
    var inner = _innerRing();
    if (!inner || inner.length < 3) return [];
    var n = _lightCount(inner);
    if (!Array.isArray(STATE.lights) || STATE.lights.length !== n) {
      STATE.lights = _spaceAlongRing(inner, n).map(function (p) {
        var s = _clampAwayFromStairs(p.x, p.z, 0.10, p.edge);
        var c = _clampAwayFromCorners(s.x, s.z, 0.5);
        return { x: c.x, z: c.z };
      });
    } else {
      STATE.lights = STATE.lights.map(function (p) {
        var c = _clampAwayFromCorners(p.x, p.z, 0.5);
        return { x: c.x, z: c.z };
      });
    }
    return STATE.lights;
  }
  /* Vertical Y of the light by lightPos letter, given pool depth D. */
  function _lightY(D) {
    var pos = STATE.lightPos || 'A';
    if (pos === 'A') return -0.30;               /* top: ~12" below water line */
    if (pos === 'B') return -D * 0.5;            /* middle */
    return -Math.max(0.4, D - 0.35);             /* bottom: ~35 cm off floor */
  }
  /* Cycle the light stage/position: 0(off) -> 1/A -> ... -> 5/A -> 1/B ... 5/C -> 0.
     We cycle density 1..5 first, then advance the position letter. */
  function cycleLightStage() {
    var s = STATE.lightStage | 0, pos = STATE.lightPos || 'A';
    if (s === 0) { STATE.lightStage = 1; STATE.lightPos = 'A'; }
    else if (s < 5) { STATE.lightStage = s + 1; }
    else {
      /* density maxed -- advance position, reset density to 1; after C, off */
      if (pos === 'A') { STATE.lightPos = 'B'; STATE.lightStage = 1; }
      else if (pos === 'B') { STATE.lightPos = 'C'; STATE.lightStage = 1; }
      else { STATE.lightStage = 0; STATE.lightPos = 'A'; }
    }
    STATE.lights = null;                         /* re-derive count/positions */
    _updateLightButton();
    if (typeof rebuildDragHandles === 'function') { try { rebuildDragHandles(); } catch (_) {} }
    refreshUI();
  }
  function _lightLabel() {
    var s = STATE.lightStage | 0;
    if (s <= 0) return '';
    return s + '/' + (STATE.lightPos || 'A');
  }
  function _updateLightButton() {
    var btn = document.getElementById('cf-btn-lights');
    if (!btn) return;
    btn.setAttribute('aria-pressed', (STATE.lightStage | 0) > 0 ? 'true' : 'false');
    var lab = btn.querySelector('.cf-btn-lights-label');
    if (lab) lab.textContent = _lightLabel();
  }
  /* Snap a point onto the nearest point of the inner ring (the water<->coping
     boundary). Returns {x,z,edge} where edge is the ring edge index. */
  function _projectToInnerEdge(x, z) {
    var ring = _innerRing();
    if (!ring || ring.length < 2) return { x: x, z: z, edge: 0 };
    var bestX = x, bestZ = z, bestD = Infinity, bestE = 0, n = ring.length;
    for (var i = 0; i < n; i++) {
      var a = ring[i], b = ring[(i + 1) % n];
      var ex = b[0] - a[0], ez = b[1] - a[1];
      var L2 = ex * ex + ez * ez || 1e-9;
      var t = ((x - a[0]) * ex + (z - a[1]) * ez) / L2;
      if (t < 0) t = 0; else if (t > 1) t = 1;
      var px = a[0] + ex * t, pz = a[1] + ez * t;
      var d = (px - x) * (px - x) + (pz - z) * (pz - z);
      if (d < bestD) { bestD = d; bestX = px; bestZ = pz; bestE = i; }
    }
    return { x: bestX, z: bestZ, edge: bestE };
  }

  /* Keep a dragged fitting at least 10 cm away from the stairs footprint.
     Only acts when the fitting is ON the stairs edge; on any other edge it
     leaves the point untouched (so it never jumps to the opposite wall). */
  function _clampAwayFromStairs(x, z, minDist, onEdge) {
    try {
      var mode = getStairsMode();
      if (mode === 'none' || mode === 'ladder') return { x: x, z: z };
      var place = getCurrentStairsPlacement();
      if (!place) return { x: x, z: z };
      /* If we know which edge the fitting sits on and it isn't the stairs
         edge, do nothing. */
      if (typeof onEdge === 'number' && onEdge !== place.edge) return { x: x, z: z };
      var inner = _stairsBasePoly();
      if (!inner || inner.length < 3) return { x: x, z: z };
      var n = inner.length;
      var A = inner[place.edge], B = inner[(place.edge + 1) % n];
      var ex = B[0] - A[0], ez = B[1] - A[1], L = Math.hypot(ex, ez) || 1;
      var ux = ex / L, uz = ez / L;
      var rel = (x - A[0]) * ux + (z - A[1]) * uz;
      if (rel < -1e-6 || rel > L + 1e-6) return { x: x, z: z };  /* not actually on this edge */
      var mod = _blockModule(), bl = mod.len;
      var pmode = _stairsTypeParams(mode);
      var widthBlocks = (mode === 'full') ? Math.max(1, Math.round(L / bl)) : pmode.widthBlocks;
      var stairW = (mode === 'full') ? L : widthBlocks * bl;
      var a0, a1;
      if (!place.atEnd) { a0 = 0; a1 = stairW; } else { a0 = L - stairW; a1 = L; }
      if (rel >= a0 - minDist && rel <= a1 + minDist) {
        var target = (Math.abs(rel - (a0 - minDist)) < Math.abs(rel - (a1 + minDist)))
          ? (a0 - minDist) : (a1 + minDist);
        target = Math.max(0, Math.min(L, target));      /* stays on THIS edge */
        return { x: A[0] + ux * target, z: A[1] + uz * target };
      }
      return { x: x, z: z };
    } catch (_) {
      return { x: x, z: z };
    }
  }

  /* Keep a fitting at least minDist from the corners of the edge it sits on.
     Applied on drop, so it doesn't fight the drag. Returns {x,z}. */
  function _clampAwayFromCorners(x, z, minDist) {
    try {
      var ring = _innerRing();
      if (!ring || ring.length < 3) return { x: x, z: z };
      var e = _projectToInnerEdge(x, z);
      var A = ring[e.edge], B = ring[(e.edge + 1) % ring.length];
      var ex = B[0] - A[0], ez = B[1] - A[1], L = Math.hypot(ex, ez) || 1;
      var ux = ex / L, uz = ez / L;
      var rel = (e.x - A[0]) * ux + (e.z - A[1]) * uz;
      /* if the edge is shorter than 2*minDist, just centre it */
      var lo = minDist, hi = L - minDist;
      if (hi < lo) { rel = L / 2; }
      else if (rel < lo) rel = lo;
      else if (rel > hi) rel = hi;
      return { x: A[0] + ux * rel, z: A[1] + uz * rel };
    } catch (_) {
      return { x: x, z: z };
    }
  }

  function _edgeLabel() {
    var i18n = (global.BASE_BOOT || {}).i18n || {};
    var t = getEdgeType();
    if (t === 'overflow') return i18n.pool_edge_overflow || 'Overflow';
    if (t === 'infinite') return i18n.pool_edge_infinite || 'Infinity';
    return i18n.skimmer || 'Skimmer';
  }
  function _syncEdgeTypeDisplay() {
    var el = document.getElementById('cf-stat-edge-name');
    if (el) el.textContent = _edgeLabel();
    var btn = document.getElementById('cf-btn-edge');
    if (btn) btn.setAttribute('aria-pressed', getEdgeType() === 'skimmer' ? 'false' : 'true');
  }

  function _materialLabel() {
    var i18n = (global.BASE_BOOT || {}).i18n || {};
    return getWallMaterial() === 'eps'
      ? (i18n.pool_material_eps || 'EPS')
      : (i18n.concrete || 'Concrete');
  }
  /* Material toggle is only relevant for the block variant; hidden for gunite. */
  function _syncMaterialDisplay() {
    var item = document.getElementById('cf-info-material');
    var sep  = document.getElementById('cf-info-material-sep');
    var isBlock = (variantKey() !== 'gunite');
    if (item) item.style.display = isBlock ? '' : 'none';
    if (sep)  sep.style.display  = isBlock ? '' : 'none';
    var el = document.getElementById('cf-stat-material-name');
    if (el) el.textContent = _materialLabel();
    var btn = document.getElementById('cf-btn-material');
    if (btn) btn.setAttribute('aria-pressed', getWallMaterial() === 'eps' ? 'true' : 'false');
  }

  function _syncStairsDisplay() {
    var mode = getStairsMode();
    var btn = document.getElementById('cf-btn-stairs');
    if (btn) {
      btn.classList.toggle('active', mode !== 'none');
      btn.setAttribute('aria-pressed', mode !== 'none' ? 'true' : 'false');
      btn.setAttribute('data-mode', mode);
    }
    var badge = document.getElementById('cf-stairs-badge');
    if (badge) {
      var labels = { none: '', ladder: 'L', corner1: 'C1', corner2: 'C2', full: 'F' };
      badge.textContent = labels[mode] || '';
      badge.style.display = (mode === 'none') ? 'none' : 'block';
    }
    /* Mirror button only meaningful with >1 placement. */
    var mb = document.getElementById('cf-btn-stairs-mirror');
    if (mb) {
      var slots = (mode === 'none') ? 0 : getStairsPlacements().length;
      var dim = slots <= 1;
      mb.style.opacity = dim ? '0.4' : '';
      mb.style.pointerEvents = dim ? 'none' : '';
    }
  }

  /* Basin-depth slider -- lives in the #cf-info-height info column.
     Mirrors the old fence height slider but bound to STATE.depth via
     setPoolDepth(). Operates in metres internally; the info bar handles
     m / ft display. */
  var _DepthSlider = {
    init: function () {
      var slider = document.getElementById('cf-depth-slider');
      if (!slider) return;
      var self = this;
      slider.addEventListener('input', function () {
        var v = parseFloat(slider.value);
        if (!isFinite(v)) return;
        STATE.depth = v;
        self._updateFill();
        if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
        refreshInfoBar();
        _debouncedPublishBoQ();
        try { _ProjectStore && _ProjectStore.publish && _ProjectStore.publish(); } catch (e) {}
      });
      this.refresh();
    },
    refresh: function () {
      var slider = document.getElementById('cf-depth-slider');
      if (!slider) return;
      var r = getCurrentDepthRange();
      slider.min  = r.min.toFixed(2);
      slider.max  = r.max.toFixed(2);
      slider.step = (_variantUsesBlocks() ? _facingModule().course : 0.05).toFixed(4);
      slider.value = getCurrentDepth().toFixed(2);
      this._updateFill();
    },
    _updateFill: function () {
      var slider = document.getElementById('cf-depth-slider');
      if (!slider) return;
      var v  = parseFloat(slider.value);
      var lo = parseFloat(slider.min);
      var hi = parseFloat(slider.max);
      if (!isFinite(v) || !isFinite(lo) || !isFinite(hi) || hi <= lo) return;
      var pct = ((v - lo) / (hi - lo)) * 100;
      slider.style.setProperty('--cfg-fill', pct.toFixed(1) + '%');
    }
  };

  /* ==================================================================
     POOL BILL OF QUANTITIES -- three wall systems x two edge systems.

     Row shape: [code8, metricQty, imperialQty]. The budget bridge
     resolves name / unit / price from the code, so this function only
     emits codes + quantities. Imperial factors: m^3 x35.3147, m^2 x10.7639,
     m x3.28084, pcs x1.

     CODES -- cygnus-i 19.5 families. The 3-letter PREFIX is fixed; the
     5-digit SUFFIX below is a best-effort placeholder. >>> CONFIRM each
     suffix against the budget master data before go-live. <<< Known:
     FFR30001 = KARI mesh (confirmed); PFP00851 = LINER TRIM PROFILE
     (confirmed present, 85/40 mm, unit m); PFP05001 to be verified.
     ================================================================== */
  var POOL_CODES = {
    /* Earthworks */
    excavation:      'PEE00001',  /* EXCAVATION - POOL              m^3 */
    excavationShaft: 'PEE00002',  /* EXCAVATION - SHAFT             m^3 */
    backfill:        'PEB00001',  /* BACKFILL (around the walls)    m^3 */
    /* Base slab */
    gravelBed:       'PBG32601',  /* GRAVEL BASE 0/32 mm            m^3 */
    slabConcrete:    'PBW00001',  /* CONCRETE - BASE SLAB           m^3 */
    mesh:            'PBF30001',  /* REBAR MESH - BASE SLAB dia6 (3x2 m / 8x20 ft) pcs */
    mesh8:           'PBF30002',  /* REBAR MESH - BASE SLAB dia8 (3x2 m / 8x20 ft) pcs */
    /* Walls */
    wallConcrete:    'PWC00001',  /* CONCRETE - WALLS (fill/core)   m^3 */
    wallBlocks:      'PWC05001',  /* CONCRETE BLOCKS 500x250x200    pcs */
    wallBlocksEps:   'PWC05005',  /* EPS BLOCKS 1000x250x250        pcs */
    wallHalfBlocks:  'PWC05003',  /* CONCRETE BLOCKS 250x250x200    pcs */
    rebar:           'PWC00002',  /* REBAR - WALLS (dia12)            m */
    /* Finish -- liner pool buildup */
    finScreed:       'PFL00001',  /* LEVELING SCREED                m^3 */
    finGeotextile:   'PFG00001',  /* GEOTEXTILE                     m^2 */
    finLiner:        'PFP00001',  /* POOL LINER                     m^2 */
    finPlaster:      'PFP00002',  /* POOL PLASTER                   kg */
    finTiles:        'PFP00003',  /* POOL TILES                     m^2 */
    finPebble:       'PFP00004',  /* PEBBLE / AGGREGATE             kg */
    finInox:         'PFP00005',  /* INOX                           m^2 */
    finLinerTrim:    'PFP00851',  /* LINER TRIM PROFILE             m */
    finEdgeTiles:    'PFP05001',  /* EDGE TILES (coping)            pcs */
    finEdgeTilesCorner: 'PFP05002', /* EDGE TILES CORNER OUTER      pcs */
    finEdgeTilesCornerInner: 'PFP05003', /* EDGE TILES CORNER INNER pcs */
    finDimpledFoil:  'PFN00001',  /* DIMPLED FOIL (drainage, outside walls) m^2 */
    /* Overflow edge -- tiled (shaped weir lip + slot grate + channel + corners) */
    overflowEdge:      'PFP00006',  /* OVERFLOW EDGE TILE             m */
    overflowGrate:     'PFP00007',  /* OVERFLOW GRATE TILE            m */
    overflowChannel:   'PFP00008',  /* OVERFLOW CHANNEL TILE          m */
    overflowCornerInt: 'PFP00009',  /* OVERFLOW CORNER INTERNAL       pcs */
    overflowCornerExt: 'PFP00010',  /* OVERFLOW CORNER EXTERNAL       pcs */
    /* Cove -- floor-to-wall fillet (tiled pools) */
    coveTile:          'PFP00011',  /* COVE TILE                      m */
    coveCornerInt:     'PFP00012',  /* COVE CORNER INTERNAL           pcs */
    coveCornerExt:     'PFP00013',  /* COVE CORNER EXTERNAL           pcs */
    /* Bullnose coping -- skimmer / non-overflow edge */
    bullnoseEdge:      'PFP00014',  /* BULLNOSE EDGE TILE             m */
    bullnoseCornerInt: 'PFP00015',  /* BULLNOSE CORNER INTERNAL       pcs */
    bullnoseCornerExt: 'PFP00016',  /* BULLNOSE CORNER EXTERNAL       pcs */
    /* Consumables -- FASTENERS & CONSUMABLES / CONSUMABLE MATERIALS */
    wpMembrane:      'FEC00025',  /* WATERPROOFING MEMBRANE 2K      kg */
    tyingWire:       'FEC00026',  /* TYING WIRE                     kg */
    wpTape:          'FEC00027',  /* WATERPROOFING TAPE             m  */
    wpAdmixture:     'FEC00028',  /* WATERPROOFING ADMIXTURE        kg */
    poolRender:      'FEC00029',  /* POOL RENDER                    kg */
    formOil:         'FEC00030',  /* FORM RELEASE OIL               L  */
    /* Edge system + accessories */
    accOverflowGutter: 'PPO03001', /* OVERFLOW GUTTER               m */
    accOverflowGutterEdge: 'PPO03002', /* OVERFLOW GUTTER EDGE (corner) pcs */
    accOverflowGrate:  'PPO02501', /* OVERFLOW GRATES               m */
    accOverflowGrateEdge: 'PPO02502', /* OVERFLOW GRATES EDGE (corner) pcs */
    accOverflowOutlet: 'PPO02503', /* OVERFLOW GUTTER OUTLET (DN50) pcs */
    accSteelOverflowProfile: 'PPO02504', /* STEEL OVERFLOW PROFILE   m */
    accBalanceTank:    'PPB15001', /* BALANCE TANK                  pcs */
    accFlowValve:      'PPE00503', /* ELECTRIC FLOW VALVE (drain, DN50) pcs */
    accSkimmer:        'PPS00001', /* SKIMMER                       pcs */
    poolLight:         'PPL00001', /* UNDERWATER LED LIGHT          pcs */
    /* DRAINS -- prefab drainage channels. Channels counted by run length
       (m / ft); corner units by piece. Slot channel = overflow edge,
       U-channel = infinity catch trough. */
    drainSlotChannel:  'SMW00001', /* SLOT CHANNEL                  m   */
    drainSlotCorner:   'SMW00002', /* SLOT CHANNEL CORNER           pcs */
    drainUChannel:     'SMW00003', /* U-CHANNEL                     m   */
    drainUCorner:      'SMW00004', /* U-CHANNEL CORNER              pcs */
    accReturnJet:      'PPP00002', /* RECIRCULATION JET             pcs */
    accFloorDrain:     'PPP00001', /* POOL DRAIN                    pcs */
    accPump:           'PPP00003', /* PUMP                          pcs */
    accFilter:         'PPF00001', /* FILTER SET                    pcs */
    accDoser:          'PPA00001', /* CHLORINE AND PH DOSER         pcs */
    accTechShaft:      'PPT10001', /* TECHNOLOGY SHAFT              pcs */
    accWaterLevel:     'PPW00001', /* WATER LEVEL SENSOR            pcs */
    accSensorWires:    'PPW00002', /* SENSOR WIRES                  m */
    /* Lighting electrical */
    elJunctionBox:     'EEJ00001', /* JUNCTION BOX (one per light)  pcs */
    elCable:           'EEE00001', /* ELECTRIC CABLE (box->panel)    m */
    elPanel:           'EED04001', /* WALL-MOUNTED DISTRIBUTION CABINET pcs */
    elRcd:             'EER00001'  /* RESIDUAL CURRENT DEVICE 30 mA pcs */
  };

  /* Piping codes by nominal diameter (Sch 40 PVC, US sizes).
     d15 = 11/2" (~50 mm), d20 = 2" (~63 mm), d25 = 21/2" (~75 mm).
     pipe = linear ft, elbow90/elbow30/tee/valve = pcs. */
  var PIPE_CODES = {
    d15: { pipe: 'PPP00501', elbow90: 'PPE00502', elbow30: 'PPE00501', tee: 'PPT00501', valve: 'PPP00502', reducerTo15: null,        reducer2015: null },
    d20: { pipe: 'PPE00634', elbow90: 'PPE00632', elbow30: 'PPE00631', tee: 'PPE00633', valve: 'PPP00632', reducerTo15: 'PPE06350', reducer2015: 'PPE06350' },
    d25: { pipe: 'PPE00754', elbow90: 'PPE00752', elbow30: 'PPE00751', tee: 'PPE00753', valve: 'PPP00752', reducerTo15: 'PPE07550', reducer2015: 'PPE07563' },
    d40: { pipe: 'PPE01004', elbow90: 'PPE01002', elbow30: 'PPE01001', tee: 'PPE01003', valve: null,        reducerTo15: 'PPE10075', reducer2015: 'PPE10075' }
  };
  /* Reducer codes:
       PPE06350 = 63->50 (2"->11/2")
       PPE07563 = 75->63 (21/2"->2")
       PPE07550 = 75->50 (21/2"->11/2")
     reducerTo15 = trunk diameter reduced down to a 50 mm (d15) branch. */
  /* Choose the trunk (main line) diameter from required flow. Flow ~ water
     volume / turnover; sized at <=6 ft/s: 11/2"->38 GPM, 2"->63, 21/2"->90 GPM. */
  function _trunkDiaKey(gpm) {
    if (gpm <= 38) return 'd15';
    if (gpm <= 63) return 'd20';
    return 'd25';
  }

  /* Generic polygon area (shoelace) and perimeter for an arbitrary ring. */
  function _polyArea(poly) {
    if (!poly || poly.length < 3) return 0;
    var a = 0;
    for (var i = 0; i < poly.length; i++) {
      var j = (i + 1) % poly.length;
      a += poly[i][0] * poly[j][1];
      a -= poly[j][0] * poly[i][1];
    }
    return Math.abs(a) / 2;
  }
  function _polyPerim(poly) {
    if (!poly || poly.length < 2) return 0;
    var p = 0;
    for (var i = 0; i < poly.length; i++) {
      var j = (i + 1) % poly.length;
      var dx = poly[j][0] - poly[i][0];
      var dy = poly[j][1] - poly[i][1];
      p += Math.sqrt(dx*dx + dy*dy);
    }
    return p;
  }
  /* Offset a closed polygon by |dist| metres, winding-agnostic, using a
     TRUE parallel-edge (miter) offset so each edge moves exactly 'dist'
     (a plain bisector move under-offsets corners). outward=false shrinks
     the ring, outward=true grows it; the correct sign is chosen by area
     so CW or CCW user-drawn polygons both behave. */
  function _offsetPolygon(poly, dist, outward) {
    var n = poly.length;
    function build(sgn) {
      var out = [];
      for (var i = 0; i < n; i++) {
        var prev = poly[(i - 1 + n) % n];
        var curr = poly[i];
        var next = poly[(i + 1) % n];
        var e1x = curr[0] - prev[0], e1z = curr[1] - prev[1];
        var e2x = next[0] - curr[0], e2z = next[1] - curr[1];
        var l1 = Math.sqrt(e1x*e1x + e1z*e1z) || 1;
        var l2 = Math.sqrt(e2x*e2x + e2z*e2z) || 1;
        /* Left normals of each edge. */
        var n1x = -e1z / l1, n1z = e1x / l1;
        var n2x = -e2z / l2, n2z = e2x / l2;
        var bx = n1x + n2x, bz = n1z + n2z;
        var blen = Math.sqrt(bx*bx + bz*bz);
        if (blen < 1e-6) {
          /* Straight / degenerate -- offset along the single normal. */
          out.push([curr[0] + sgn * dist * n1x, curr[1] + sgn * dist * n1z]);
          continue;
        }
        /* Miter scale = dist / sin(half-angle); sin(half) = blen/2. */
        var scale = (2 * dist) / (blen * blen);
        out.push([curr[0] + sgn * bx * scale, curr[1] + sgn * bz * scale]);
      }
      return out;
    }
    var pos = build(1), neg = build(-1);
    var aPos = _polyArea(pos), aNeg = _polyArea(neg);
    if (outward) return aPos >= aNeg ? pos : neg;
    return aPos <= aNeg ? pos : neg;
  }
  /* Back-compat inward inset (positive dist = inward, negative = outward). */
  function _insetPolygon(poly, inset) {
    return _offsetPolygon(poly, Math.abs(inset), inset < 0);
  }

  /* All shared pool quantities derived from the footprint + depth. */
  /* Slab thickness grows with basin depth (over-dimensioned by ~50 mm vs the
     minimum; no rebar yet). */
  function _slabThickness(D) {
    if (D <= 0.5) return 0.15;   /* shallow shelf -- little water load above */
    if (D <= 1.2) return 0.20;
    if (D <= 1.8) return 0.25;
    return 0.30;
  }
  /* Clip an axis-segment (ax,az)->(bx,bz) to a (possibly concave) polygon.
     Returns inside sub-segments as [ax,az,bx,bz]. Handles the L-notch. */
  /* Clip a segment to the polygon, then remove the parts that fall inside any
     hole -- so the reinforcement grid is cut around the zone cut-outs. */
  function _clipSegToPolyMinusHoles(ax, az, bx, bz, poly, holes) {
    var inPoly = _clipSegToPoly(ax, az, bx, bz, poly);
    if (!holes || !holes.length) return inPoly;
    var out = [];
    for (var i = 0; i < inPoly.length; i++) {
      var pieces = [inPoly[i]];
      for (var h = 0; h < holes.length; h++) {
        var next = [];
        for (var p = 0; p < pieces.length; p++) {
          var sg = pieces[p];
          var hin = _clipSegToPoly(sg[0], sg[1], sg[2], sg[3], holes[h]);
          var rem = _subtractSegParts(sg, hin);
          for (var q = 0; q < rem.length; q++) next.push(rem[q]);
        }
        pieces = next;
      }
      for (var k = 0; k < pieces.length; k++) out.push(pieces[k]);
    }
    return out;
  }
  /* Subtract sub-segments 'parts' from segment 'seg' (all collinear), returning
     the remaining sub-segments. */
  function _subtractSegParts(seg, parts) {
    var ax = seg[0], az = seg[1], bx = seg[2], bz = seg[3];
    var dx = bx - ax, dz = bz - az, len2 = dx * dx + dz * dz;
    if (len2 < 1e-12) return [];
    function tOf(x, z) { return ((x - ax) * dx + (z - az) * dz) / len2; }
    var cuts = [];
    for (var i = 0; i < parts.length; i++) {
      var t0 = tOf(parts[i][0], parts[i][1]), t1 = tOf(parts[i][2], parts[i][3]);
      if (t0 > t1) { var tmp = t0; t0 = t1; t1 = tmp; }
      cuts.push([Math.max(0, t0), Math.min(1, t1)]);
    }
    cuts.sort(function (a, b) { return a[0] - b[0]; });
    var res = [], cur = 0;
    for (var j = 0; j < cuts.length; j++) {
      if (cuts[j][1] <= cur + 1e-9) continue;
      if (cuts[j][0] > cur + 1e-6) res.push([cur, cuts[j][0]]);
      if (cuts[j][1] > cur) cur = cuts[j][1];
    }
    if (cur < 1 - 1e-6) res.push([cur, 1]);
    var outp = [];
    for (var k = 0; k < res.length; k++) {
      if (res[k][1] - res[k][0] < 1e-4) continue;
      outp.push([ax + dx * res[k][0], az + dz * res[k][0], ax + dx * res[k][1], az + dz * res[k][1]]);
    }
    return outp;
  }

  function _clipSegToPoly(ax, az, bx, bz, poly) {
    var out = [], dx = bx - ax, dz = bz - az, n = poly.length;
    var ts = [0, 1];
    for (var i = 0, j = n - 1; i < n; j = i++) {
      var x1 = poly[j][0], z1 = poly[j][1], ex = poly[i][0] - x1, ez = poly[i][1] - z1;
      var den = dx * ez - dz * ex;
      if (Math.abs(den) < 1e-12) continue;
      var t = ((x1 - ax) * ez - (z1 - az) * ex) / den;
      var s = ((x1 - ax) * dz - (z1 - az) * dx) / den;
      if (t > 1e-9 && t < 1 - 1e-9 && s >= -1e-9 && s <= 1 + 1e-9) ts.push(t);
    }
    ts.sort(function (a, b) { return a - b; });
    for (var k = 0; k < ts.length - 1; k++) {
      var t0 = ts[k], t1 = ts[k + 1];
      if (t1 - t0 < 1e-6) continue;
      var tm = (t0 + t1) / 2;
      if (_pointInPoly([ax + dx * tm, az + dz * tm], poly)) {
        out.push([ax + dx * t0, az + dz * t0, ax + dx * t1, az + dz * t1]);
      }
    }
    return out;
  }

  /* KARI welded-wire mesh sheet: 3x2 m metric / 8x20 ft imperial. */
  var MESH_SHEET_L = 3.0, MESH_SHEET_W = 2.0;
  var MESH_LAP = 0.25;                         /* sheet overlap (m) */

  /* KARI takeoff counted PER PLATE (the base slab + each raised zone shelf),
     as whole sheets with offcut reuse (plate area / usable sheet area, so the
     edge offcuts fill in rather than wasting a bounding box). Diameter & layer
     count follow the plate thickness: a thin plate (<=0.15 m) gets ONE layer of
     dia6 (PBF30001); a thicker plate gets TWO layers of dia8 (PBF30002).
     Sheet size is unit-aware: 3x2 m metric, 8x20 ft imperial. Returns a map
     { code: pieces }. */
  function _meshTakeoff() {
    var out = {};
    var poly = getFootprintPolygon();
    if (!poly || poly.length < 3) return out;
    var d = getVariantDefaults(variantKey(), STATE.lvl);
    var D = getCurrentDepth();
    var dims = STATE.isMetric
      ? { L: MESH_SHEET_L, W: MESH_SHEET_W, lap: MESH_LAP }
      : { L: 20 * FT, W: 8 * FT, lap: 0.5 * FT };          /* 8x20 ft sheet, 6" lap */
    var usable = Math.max(0.5, (dims.L - dims.lap) * (dims.W - dims.lap));
    function add(t, area) {
      if (!(area > 0.01)) return;
      var thin = (t <= 0.15 + 1e-6);
      var code = thin ? POOL_CODES.mesh : POOL_CODES.mesh8;
      var layers = thin ? 1 : 2;
      out[code] = (out[code] || 0) + Math.max(1, Math.ceil(area / usable)) * layers;
    }
    var slabPoly = _offsetPolygon(poly, (d.slabOverhangM || 0), true);
    var zf = _zoneFloors();
    add(_slabThickness(D), Math.max(0, _polyArea(slabPoly) - (zf.raisedArea || 0)));   /* base slab = footprint minus the raised shelves (the real deep slab) */
    for (var i = 0; i < zf.raised.length; i++) add(zf.raised[i].slabT, zf.raised[i].area);   /* each shelf plate */
    return out;
  }

  /* -- dia12 rebar (FFM00006) -- total length in metres ------------------
     Block system only (cavities + courses). Three contributions:
       * vertical bars in the block cavities (~every 250 mm) with an L-bend
         into the slab to lap with the KARI mesh,
       * one longitudinal bar in EVERY block course (~every 200 mm) around
         the wall perimeter (the "vyrez" channel),
       * the same scheme on the stairs (vertical + one bar per step).
     1 bar/cavity normally; 2 bars/cavity for pools that are BOTH deep and
     large. Reported as a single length row. */
  function _rebarTally() {
    if (!_variantUsesBlocks()) return 0;
    var g   = _poolGeometry();
    var mod = _blockModule();
    var bl = mod.len, course = mod.course;        /* 0.50 m long, 0.20 m course */
    var D  = g.D;
    if (!isFinite(D) || D <= 0 || !isFinite(g.Pmid) || g.Pmid <= 0) return 0;

    var BAR  = 0.012;                              /* dia12 */
    var LAP  = 40 * BAR;                           /* 0.48 m lap / development (40d) */
    var BEND = 0.20;                               /* horizontal leg of the L into the slab */
    var TOP  = 0.10;                               /* top allowance to the bond-beam course */
    var CAV  = bl / 2;                             /* 2 cavities per block -> ~0.25 m pitch */

    var poly = getFootprintPolygon();

    /* Walls: vertical L-bars in the cavities + a longitudinal bar per course,
       in TWO mats (one screen near each face) -- fixed, not parametric. Sampled
       along the wall centreline with the SAME per-point rule as the view: a bar
       behind a zone (cap or either side return) stops at the shelf mesh plane,
       so the wall is trimmed around the WHOLE zone, not just its own edge. The
       wall below a shelf is the riser, counted separately as riserLen. */
    var MATS = 2;
    var wallT = g.wallT, raised = (g.zoneFloors && g.zoneFloors.raised) || [];
    var midRing = _insetPolygon(poly, wallT / 2);
    var STEPb = CAV;                                  /* one vertical per cavity */
    var wallVert = 0, wallHoriz = 0, nCoursesMax = 0;
    for (var we = 0; we < midRing.length; we++) {
      var wa = midRing[we], wb = midRing[(we + 1) % midRing.length];
      var wlen = Math.hypot(wb[0] - wa[0], wb[1] - wa[1]);
      if (wlen < 0.05) continue;
      var wux = (wb[0] - wa[0]) / wlen, wuz = (wb[1] - wa[1]) / wlen;
      for (var ws = 0; ws < wlen - 1e-6; ws += STEPb) {
        var seg = Math.min(STEPb, wlen - ws);
        var smx = wa[0] + wux * (ws + seg / 2), smz = wa[1] + wuz * (ws + seg / 2);
        var wbot = _wallBottomYAt(smx, smz, D, wallT, raised);   /* shelf mesh plane behind a zone, else -D */
        var wh = -wbot;                              /* wall height at this point */
        wallVert  += MATS * (wh + BEND + TOP);                          /* one cavity bar, both mats */
        var wnc = Math.max(1, Math.round(wh / course));
        wallHoriz += wnc * MATS * seg;                                  /* course bars over this sub-segment */
        if (wnc > nCoursesMax) nCoursesMax = wnc;
      }
    }
    wallHoriz += nCoursesMax * MATS * LAP;           /* one perimeter lap per (deepest) course */

    /* Stairs rebar: vertical dowels in the BLOCKS only (riser across the
       width + one cheek per step), each running slab->step-top plus an L-foot.
       Matches the reinforcement view. KARI on the tread is counted as mesh. */
    var stairLen = 0;
    var mode = getStairsMode();
    var p = _stairsTypeParams(mode);
    var place = getCurrentStairsPlacement();
    if (p.kind === 'steps' && place) {
      var rise = course;
      var stepCount  = Math.max(1, Math.floor(_stairsEffectiveDepth(place.edge) / rise) - 1);
      var a = poly[place.edge], b = poly[(place.edge + 1) % poly.length];
      var Lp = Math.hypot(b[0] - a[0], b[1] - a[1]);
      var widthBlocks = (mode === 'full') ? Math.max(1, Math.round(Lp / bl)) : p.widthBlocks;
      var stairW = (mode === 'full') ? Lp : widthBlocks * bl;
      var nAcross = Math.max(1, Math.round(stairW / 0.25));   /* dowels per riser row */
      var stairVert = 0;
      for (var st = 1; st <= stepCount; st++) {
        var hTop = st * rise;                          /* slab->top of step st */
        stairVert += (nAcross + 1) * (hTop + BEND);    /* riser row + 1 cheek, each +bend */
      }
      stairLen = stairVert;
    }

    /* Zone riser walls (blocks under the shelves): vertical bars in the
       cavities + one longitudinal bar per course, along each shelf's inner
       (main-pool-facing) edge. Matches the reinforcement view. */
    var riserLen = 0;
    var zf = _zoneFloors();
    for (var zi = 0; zi < zf.raised.length; zi++) {
      var z = zf.raised[zi];
      if (!z.hasRiser || !z.quad || z.quad.length < 4) continue;
      var rw = Math.hypot(z.quad[2][0] - z.quad[3][0], z.quad[2][1] - z.quad[3][1]);   /* riser width */
      var rh = z.riserTopY - z.riserBaseY;                                             /* riser height */
      if (rw < 0.05 || rh < 0.05) continue;
      var rVert = Math.max(1, Math.round(rw / CAV)) * MATS * (rh + BEND);
      var rHoriz = Math.max(1, Math.round(rh / course)) * MATS * (rw + LAP);
      riserLen += rVert + rHoriz;
    }

    /* Kids<->Main divider pillars: 4 corner dowels per pillar, deck->rim + L-foot.
       Matches the reinforcement view (3c). */
    var colLen = 0;
    for (var ci2 = 0; ci2 < zf.raised.length; ci2++) {
      var cz2 = zf.raised[ci2];
      if (!cz2.bordersMain || (cz2.dividerCols | 0) < 1) continue;
      var pillH = (-0.03) - (cz2.topY - 0.02);          /* deck mesh -> just under tile ~ dft */
      if (pillH < 0.05) continue;
      colLen += (cz2.dividerCols | 0) * 4 * (pillH + BEND);
    }

    /* Slab-to-slab Z-ties at steps between adjacent zone decks (kids<->relax):
       per tie = bottom leg + step + top leg. Matches the view (3d). */
    var zlinkLen = 0;
    var laidT = (typeof _layoutZones === 'function') ? _layoutZones() : [];
    var RAISEt = { kids: 2 * course, relax: 1 * course };
    var deckYt = function (k) { var v = RAISEt[k] || course; if (v > D - 0.05) v = D - 0.05; return -v; };
    var keyT = {};
    for (var kti = 0; kti < laidT.length; kti++) { if (laidT[kti].kind) keyT[laidT[kti].wall + ':' + laidT[kti].slot] = laidT[kti]; }
    for (var kti2 = 0; kti2 < laidT.length; kti2++) {
      var zaT = laidT[kti2]; if (!zaT.kind) continue;
      var zbT = keyT[zaT.wall + ':' + (zaT.slot + 1)]; if (!zbT || !zbT.kind) continue;
      var yaT = deckYt(zaT.kind), ybT = deckYt(zbT.kind);
      if (Math.abs(yaT - ybT) < 0.05) continue;
      var qaT = zaT.quad; if (!qaT || qaT.length < 4) continue;
      var jLT = Math.hypot(qaT[2][0] - qaT[3][0], qaT[2][1] - qaT[3][1]);
      var nZT = Math.max(1, Math.round(jLT / 0.25));
      zlinkLen += nZT * (2 * BEND + Math.abs(yaT - ybT));
    }

    return wallVert + wallHoriz + stairLen + riserLen + colLen + zlinkLen;
  }

  function _poolGeometry() {
    var poly  = getFootprintPolygon();
    var d     = getVariantDefaults(variantKey(), STATE.lvl);
    var D     = getCurrentDepth();
    var wallT = _effectiveWallThick(d), slabT = _slabThickness(D), gravT = d.bedGravelM;

    var inner = _insetPolygon(poly, wallT);                 /* water edge */
    var pit   = _insetPolygon(poly, -d.excavOversizeM);     /* excavation edge */
    var slabPoly  = _offsetPolygon(poly, (d.slabOverhangM || 0), true);       /* slab overhang past the wall */
    var gravelPoly = _offsetPolygon(poly, (d.bedGravelOverhangM || 0), true); /* gravel base footprint */

    var Aout = _polyArea(poly),  Pout = _polyPerim(poly);
    var Ain  = _polyArea(inner), Pin  = _polyPerim(inner);
    var Apit = _polyArea(pit);
    var Aslab = _polyArea(slabPoly), Pslab = _polyPerim(slabPoly);
    var Agravel = _polyArea(gravelPoly);
    var Pmid = (Pout + Pin) / 2;                             /* wall centreline */
    var excavD = D + slabT + gravT;

    /* Infinity edges carry finished surface BEYOND the basin, clad in the pool
       surface because the water sheets over / sits in them:
         * venec/wall top                ~ wallT
         * gutter inner-wall weir top     0.06  (INNER_T)
         * inner-wall spill face          0.26  (WEIR_TOP-yFloor)
         * channel floor                  0.20  (GUT_W-INNER_T)
         * outer-wall CHANNEL face        0.18  (GUT_OUTER_TOP-yFloor)
       The whole channel INTERIOR is finished; only the outer wall's EXTERIOR
       face stays concrete. Counted into wettedA. (Concrete substrates are still
       counted separately: venec via copingLen, gutter via the concrete rows.) */
    var infFinishA = 0;
    if (getEdgeType() === 'infinite') {
      var _ie = getInfiniteEdges() || [], _fn = poly.length, _il = 0;
      for (var _k = 0; _k < _ie.length; _k++) {
        var _e = _ie[_k]; if (_e < 0 || _e >= _fn) continue;
        var _a = poly[_e], _b = poly[(_e + 1) % _fn];
        _il += Math.hypot(_b[0] - _a[0], _b[1] - _a[1]);
      }
      infFinishA = _il * (Math.max(0, wallT - 0.005) + 0.06 + 0.26 + 0.20 + 0.18);
    }

    var _zf = _zoneFloors();

    /* Developed wall area and solid-equivalent wall volume, summed PER EDGE so
       a wall next to a zone counts only ABOVE the shelf (full depth elsewhere);
       the wall BELOW the shelf is the zone riser, added separately. This makes
       the block count AND the block fill shrink with zones instead of counting
       the full-depth perimeter on top of the risers (double counting). */
    var _midRing = _insetPolygon(poly, wallT / 2);
    var wallDevA = 0, wallConcVol = 0;
    for (var _we = 0; _we < _midRing.length; _we++) {
      var _ma = _midRing[_we], _mb = _midRing[(_we + 1) % _midRing.length];
      var _ml = Math.hypot(_mb[0] - _ma[0], _mb[1] - _ma[1]);
      if (_ml < 1e-3) continue;
      var _dy = (typeof _stairsDeckY === 'function') ? _stairsDeckY(_we) : 0;
      var _wh = (_dy < -1e-6) ? (-_dy) : D;        /* zone edge -> above-shelf height; else full depth */
      wallDevA    += _ml * _wh;
      wallConcVol += _ml * wallT * _wh;
    }
    /* Riser walls (blocks under the shelves) are filled too, so their solid
       volume joins the wall fill (the riser BLOCK count is added in the BoQ). */
    wallConcVol += (_zf.riserDevA || 0) * wallT;

    return {
      d: d, D: D, wallT: wallT, slabT: slabT, gravT: gravT,
      Aout: Aout, Pout: Pout, Ain: Ain, Pin: Pin, Apit: Apit, Pmid: Pmid,
      excavVol:   Apit * excavD,                  /* m^3 */
      pitFloorA:  Apit,                           /* m^2 */
      gravelVol:  Agravel * gravT,                /* m^3 (gravel base footprint) */
      slabVol:    Math.max(0, Aslab - (_zf.raisedArea || 0)) * slabT + (_zf.raisedVol || 0),   /* m^3: main deep slab at full-depth thickness + every raised deck at ITS OWN water-above thickness */
      slabFormA:  Pslab * slabT,                  /* m^2 */
      wallFootA:  Math.max(0, Aout - Ain),        /* m^2 (wall cross-section footprint) */
      wallConcVol:wallConcVol,                     /* m^3 solid-equivalent (perimeter shortened at zones + risers) */
      wallDevA:   wallDevA,                         /* m^2 developed wall area (shortened at zones) */
      wettedA:    Ain + Pin * D + infFinishA + (_zf.riserDevA || 0),  /* m^2 finish (floor+decks net = Ain, + walls + riser faces + infinity spill) */
      copingLen:  Pout,                            /* m */
      meshA:      Aslab + Pmid * D,               /* m^2 slab (incl. overhang) + walls */
      zoneFloors: _zf,                            /* raised zone slabs + main-slab holes */
      waterVol:   _waterVolume()   /* pool-v9 from the water's solid: deep + shelves + treads, less the pillars (was Ain x depth less the shelves, the stairs not off) */    /* m^3: gross to the edge-type water line, less shelf/pillar displacement */
    };
  }

  /* m -> ft, m^2 -> ft^2, m^3 -> ft^3, pcs -> pcs */
  var _FT  = 3.28084, _FT2 = 10.7639, _LBS = 2.20462;
  var _YD3 = 1.30795;   /* 1 m^3 = 1.30795 yd^3 (cubic yards) */
  var _GAL = 0.264172;  /* 1 L = 0.264172 US gal */
  function _rowM (code, q) { return [code, q, q * _FT];  }
  function _rowM2(code, q) { return [code, q, q * _FT2]; }
  function _rowYd3(code, q) { return [code, q, q * _YD3]; }
  function _rowKg(code, q) { return [code, q, q * _LBS]; }
  function _rowPc(code, q) { return [code, q, q];        }
  function _rowL (code, q) { return [code, q, q * _GAL]; }

  /* -- Model-truth block takeoff ------------------------------------------
     _takeoffActive flips _buildBlockWalls into count-only mode: it builds the
     full transform list (the real placement geometry) then tallies its length
     and returns BEFORE creating any mesh. _wallBlockTakeoff runs the SAME
     orchestration the 3D renderer uses (_layWallBlocks) regardless of the
     active 2D/3D view, so the BoQ block count always equals the laid model. */
  var _takeoffActive = false, _takeoffBlocks = 0;
  function _wallBlockTakeoff() {
    try {
      if (!_variantUsesBlocks()) return null;
      var BR = global.BaseRenderer;
      if (!BR || typeof BR._layWallBlocks !== 'function') return null;
      var poly = getFootprintPolygon();
      if (!poly || !poly.length) return null;
      var D = getCurrentDepth();
      var d = getVariantDefaults(variantKey(), STATE.lvl);
      var wallT = _effectiveWallThick(d);
      var inner = _insetPolygon(poly, wallT);
      _takeoffActive = true; _takeoffBlocks = 0;
      BR._layWallBlocks(poly, inner, D, wallT, null);
      _takeoffActive = false;
      return _takeoffBlocks;
    } catch (e) { _takeoffActive = false; return null; }
  }

  function computeBoQ() {
    var poly = getFootprintPolygon();
    if (!poly || poly.length < 3) return [];
    var C = POOL_CODES;
    var g = _poolGeometry();
    var vk = variantKey();
    var edge = getEdgeType();
    var rows = [];

    /* -- Earthworks -------------------------------------------- */
    rows.push(_rowYd3(C.excavation, g.excavVol));
    /* Shaft pit (oversized ~0.2 m each side). */
    var ssz = getShaftSize();
    var shaftExcav = (ssz.w + 0.4) * (ssz.l + 0.4) * (ssz.h + 0.2);
    rows.push(_rowYd3(C.excavationShaft, shaftExcav));
    /* Backfill = the dig minus the pool footprint column (the ring around the
       walls that gets filled back). */
    var backfill = Math.max(0, g.excavVol * (1 - (g.Apit ? g.Aout / g.Apit : 1)));
    rows.push(_rowYd3(C.backfill, backfill));

    /* -- Base: gravel bed + base-slab concrete ------------------- */
    /* All gravel beds together: base footprint + the bed under each zone shelf
       (same thickness as the base). */
    /* All gravel beds together: the base bed is now cut out under each zone,
       but each zone's own bed (under its deck) replaces exactly that area, so
       the base footprint volume already equals the full total. */
    var _zfBoq = g.zoneFloors || null;
    rows.push(_rowYd3(C.gravelBed,    g.gravelVol));
    /* All slabs together (one item): base slab (cut under zones) + stairs fill
       + the raised zone decks. The cut and the decks cancel, so this equals the
       full-footprint slab + stairs. */
    rows.push(_rowYd3(C.slabConcrete, g.slabVol + _stairsConcreteVol()));

    /* -- Walls -- quantity meaning depends on the wall system. Stairs are
         always built from concrete blocks (PWC05001), regardless of the wall
         material, so their block counts are reported separately for EPS. -- */
    if (vk === 'concrete_block') {
      var faceM = 0.50 * 0.20;            /* metric block face 500x200 */
      var faceI = (16 * IN) * (8 * IN);   /* imperial block face 16x8"  */
      var stairsKs = _stairsBlockCount();
      var zRiserA = (_zfBoq && _zfBoq.riserDevA) ? _zfBoq.riserDevA : 0;
      /* Wall + riser blocks counted from the ACTUAL laid model (view-independent
         takeoff of the same placement the renderer uses). Stairs are laid by a
         separate builder, so their blocks are always added on top. The analytic
         area formula stays as the fallback when the takeoff can't run. The other
         unit's column is scaled from the model count by the block-face ratio
         (the non-active unit is never physically laid, so can't be counted). */
      var _mw = _wallBlockTakeoff();
      var ksM, pcsI;
      if (_mw != null && _mw > 0) {
        var _fA = STATE.isMetric ? faceM : faceI, _fO = STATE.isMetric ? faceI : faceM;
        var _act = _mw + stairsKs, _oth = Math.ceil(_mw * _fA / _fO) + stairsKs;
        ksM  = STATE.isMetric ? _act : _oth;
        pcsI = STATE.isMetric ? _oth : _act;
      } else {
        ksM  = Math.ceil(g.wallDevA / faceM) + stairsKs + (zRiserA > 0 ? Math.ceil(zRiserA / faceM) : 0);
        pcsI = Math.ceil(g.wallDevA / faceI) + stairsKs + (zRiserA > 0 ? Math.ceil(zRiserA / faceI) : 0);
      }
      rows.push([C.wallBlocks, ksM, pcsI]);
      var halfKs = _stairsHalfBlockCount();
      if (halfKs > 0) rows.push([C.wallHalfBlocks, halfKs, halfKs]);
      /* Concrete poured into the hollow blocks -- void fraction is product-
         specific: EU lost-formwork ~0.55, US hollow CMU (ASTM C90) ~0.50. */
      var _fillFrac = STATE.isMetric ? 0.55 : 0.50;
      rows.push(_rowYd3(C.wallConcrete, g.wallConcVol * _fillFrac));
    } else if (vk === 'eps_block') {
      /* EPS lost-formwork blocks for the walls (face 1000x250 / 48x16"). */
      var faceEpsM = 1.00 * 0.25;
      var faceEpsI = (48 * IN) * (16 * IN);
      var wallEpsM = Math.ceil(g.wallDevA / faceEpsM);
      var wallEpsI = Math.ceil(g.wallDevA / faceEpsI);
      /* Zone-shelf risers -- EPS forms cut down to the 200 mm zone course.
         metric:   the 250 mm form yields ONE 200 mm-tall piece (50 mm offcut),
                   so a whole block covers only 1.00 x 0.20 m of riser face.
         imperial: the 16" form is cut horizontally into two 8" (~200 mm) halves
                   and BOTH are used, so a whole block covers the full 48"x16"
                   face (no waste). Either way the vykaz stays whole pieces. */
      var zRiserAe = (_zfBoq && _zfBoq.riserDevA) ? _zfBoq.riserDevA : 0;
      if (zRiserAe > 0) {
        wallEpsM += Math.ceil(zRiserAe / (1.00 * 0.20));
        wallEpsI += Math.ceil(zRiserAe / faceEpsI);
      }
      rows.push([C.wallBlocksEps, wallEpsM, wallEpsI]);
      /* Stairs are still concrete blocks. */
      var sKs = _stairsBlockCount();
      if (sKs > 0) rows.push([C.wallBlocks, sKs, sKs]);
      var sHalf = _stairsHalfBlockCount();
      if (sHalf > 0) rows.push([C.wallHalfBlocks, sHalf, sHalf]);
      /* Solid concrete core poured into the EPS forms (full core thickness).
         Reuse the zone-aware solid wall volume and rescale from full block
         width to the core thickness, so shelves/risers match the concrete
         branch instead of counting full perimeter x full depth. */
      var core = (g.d.coreThickM || 0.20);
      rows.push(_rowYd3(C.wallConcrete, g.wallConcVol * (core / g.wallT)));
    } else { /* gunite */
      rows.push(_rowYd3(C.wallConcrete, g.wallConcVol));
    }

    /* -- Reinforcement: KARI mesh per plate (base slab + each shelf) + wall rebar -- */
    var _mt = _meshTakeoff();
    if (_mt[C.mesh]  > 0) rows.push(_rowPc(C.mesh,  _mt[C.mesh]));    /* dia6 -- thin plates, 1 layer */
    if (_mt[C.mesh8] > 0) rows.push(_rowPc(C.mesh8, _mt[C.mesh8]));   /* dia8 -- thick plates, 2 layers */
    var rebarLen = _rebarTally();
    if (rebarLen > 0) rows.push(_rowM(C.rebar, rebarLen));

    /* -- Structure consumables -- scale with poured concrete volume and the
       reinforced (wetted) area. Zone-aware: the geometry totals already sum
       every zone (kids / relax / main), so no per-zone breakdown is needed. -- */
    var TYING_WIRE_KG_M2 = 0.04;   /* annealed tie wire ~ 40 g per m^2 of tied mesh */
    var OIL_L_M2         = 0.03;   /* form release oil ~ 0.03 L per m^2 of formwork face */
    var _formworkA   = g.Pmid * g.D;  /* developed wall-face area (ring beam / cast formwork); tune OIL_L_M2 for EPS-block walls */
    rows.push(_rowKg(C.tyingWire,   g.wettedA   * TYING_WIRE_KG_M2));
    /* Waterproofing admixture intentionally NOT in BoQ -- for US ready-mix it is part of the supplier's watertight pool mix (4500 psi, W2, w/c <= 0.45), not a separate line. */
    rows.push(_rowL (C.formOil,     _formworkA  * OIL_L_M2));

    /* -- Interior surface finish over the wetted basin (dno + steny) --
       Driven by STATE.surface. Quantities are the wetted area scaled by a
       per-material waste/overlap factor (real consumption, not the net
       geometric area): membranes/fabrics are laid with overlaps, tiles and
       sheets have cutting waste, sprayed/plastered finishes have spillage.
       KG finishes also carry their kg/m^2 consumption rate. */
    var PLASTER_KG_M2 = 20;   /* white plaster ~ 20 kg/m^2 (~10 mm coat) */
    var PEBBLE_KG_M2  = 28;   /* pebble / aggregate ~ 28 kg/m^2 (~12-15 mm) */
    var W_LINER   = 1.10;     /* welded membrane: ~10 % seam overlap + offcuts */
    var W_FLEECE  = 1.10;     /* geotextile: ~10 % overlaps */
    var W_SCREED  = 1.05;     /* leveling screed: ~5 % spillage */
    var SCREED_T  = 0.03;     /* leveling screed thickness 30 mm (volume = area x T) */
    var W_TRIM    = 1.05;     /* edge trim profile: corner offcuts */
    var W_TILES   = 1.10;     /* tiles: ~10 % cutting waste */
    var W_INOX    = 1.05;     /* stainless panels: ~5 % weld overlap + offcuts */
    var W_PLASTER = 1.05;     /* plaster: ~5 % spillage (on top of kg/m^2) */
    var W_PEBBLE  = 1.05;     /* pebble: ~5 % spillage (on top of kg/m^2) */
    var surf = getSurface();
    if (surf === 'plaster') {
      rows.push(_rowKg(C.finPlaster, g.wettedA * PLASTER_KG_M2 * W_PLASTER));
    } else if (surf === 'tiles') {
      rows.push(_rowM2(C.finTiles, g.wettedA * W_TILES));
    } else if (surf === 'pebble') {
      rows.push(_rowKg(C.finPebble, g.wettedA * PEBBLE_KG_M2 * W_PEBBLE));
    } else if (surf === 'inox') {
      rows.push(_rowM2(C.finInox, g.wettedA * W_INOX));
    } else {
      /* liner buildup: leveling screed + protective fleece + membrane + trim */
      rows.push(_rowYd3(C.finScreed,     g.wettedA * SCREED_T * W_SCREED));
      rows.push(_rowM2(C.finGeotextile, g.wettedA * W_FLEECE));
      rows.push(_rowM2(C.finLiner,      g.wettedA * W_LINER));
      rows.push(_rowM (C.finLinerTrim,  g.copingLen * W_TRIM));
    }

    /* -- Waterproofing + levelling render -- cementitious tiled finishes only.
       Liner and inox carry their own watertight barrier, so they are excluded.
       Quantities scale with the wetted basin area and the floor-to-wall
       perimeter (both already zone-aware via the geometry). -- */
    if (surf === 'plaster' || surf === 'tiles' || surf === 'pebble') {
      var MEMBRANE_KG_M2 = 3.5;   /* 2K cementitious ~ 1.5 kg/m^2 per coat x 2 coats + waste */
      var W_TAPE         = 1.25;  /* floor-wall perimeter + vertical corners & penetration patches */
      rows.push(_rowKg(C.wpMembrane, g.wettedA * MEMBRANE_KG_M2));
      rows.push(_rowM (C.wpTape,     g.Pin * W_TAPE));
      if (surf === 'tiles') {
        /* Levelling render only under TILES (tiles need a flat substrate).
           Plaster and pebble are applied directly as thick self-finishing
           coats, so they do their own levelling -- no separate render. */
        var RENDER_KG_M2 = 6;     /* thin levelling/scratch coat ~ 2 kg/m^2 per mm x ~3 mm */
        rows.push(_rowKg(C.poolRender, g.wettedA * RENDER_KG_M2));
      }
    }
    /* Edge / coping tiles -- counted in PIECES from the shared layout (so the
       BoQ matches what's drawn). Corners split OUTER (convex) / INNER
       (concave). Overflow edge uses the gutter + grates instead. */
    /* Top edge coping -- skimmer / non-overflow uses BULLNOSE (rounded edge tile
       by the running metre + large corner pieces). Overflow is tiled over the
       gutter instead (handled in the edge-system branch below). */
    if (getEdgeType() !== 'overflow') {
      var ct = _copingTiles();
      var _bullLen = 0;
      for (var _bi = 0; _bi < ct.straight.length; _bi++) _bullLen += ct.straight[_bi].len || 0;
      if (_bullLen > 0)     rows.push(_rowM (C.bullnoseEdge,      _round2(_bullLen)));
      if (ct.outer.length)  rows.push(_rowPc(C.bullnoseCornerExt, ct.outer.length));
      if (ct.inner.length)  rows.push(_rowPc(C.bullnoseCornerInt, ct.inner.length));
    }
    /* COVE -- curved floor-to-wall fillet tiles. Tiled pools only (plaster &
       pebble form their own cove in the finish coat). Length = inner floor
       perimeter; corners as large pieces. */
    if (surf === 'tiles') {
      var ctv = _copingTiles();
      rows.push(_rowM(C.coveTile, _round2(g.Pin)));
      if (ctv.outer.length) rows.push(_rowPc(C.coveCornerExt, ctv.outer.length));
      if (ctv.inner.length) rows.push(_rowPc(C.coveCornerInt, ctv.inner.length));
    }
    rows.push(_rowM2(C.finDimpledFoil, g.Pmid * g.D));  /* drainage foil outside walls -- outer face is full depth even at zones */

    /* -- Edge system + hydraulics ------------------------------
       Counts are simple sizing rules -- refined later against the model /
       recommended construction. */
    if (edge === 'overflow') {
      rows.push(_rowM (C.accOverflowGutter, g.Pout));        /* perimeter gutter (channel) */
      var corners = (getFootprintPolygon() || []).length;
      /* Slot cover. Tiled finishes are tiled OVER the gutter: shaped weir lip +
         slot grate + channel lining (each runs the outer perimeter) + large
         corner pieces. Liner / inox use the steel slot profile instead -- the
         two are mutually exclusive (no double cover). */
      if (surf === 'plaster' || surf === 'tiles' || surf === 'pebble') {
        var ctOf = _copingTiles();
        rows.push(_rowM (C.overflowEdge,    g.Pout));         /* weir-lip tile (water side) */
        rows.push(_rowM (C.overflowGrate,   g.Pout));         /* slot cover tile (deck side) */
        rows.push(_rowM (C.overflowChannel, g.Pout));         /* channel trough lining */
        if (ctOf.outer.length) rows.push(_rowPc(C.overflowCornerExt, ctOf.outer.length));
        if (ctOf.inner.length) rows.push(_rowPc(C.overflowCornerInt, ctOf.inner.length));
      } else {
        rows.push(_rowM (C.accSteelOverflowProfile, g.Pout)); /* steel slot profile (covers the gutter, instead of a grate) */
      }
      /* Gutter corner pieces: one moulded edge unit per polygon corner. */
      if (corners > 0) rows.push(_rowPc(C.accOverflowGutterEdge, corners));
      /* Gutter outlets ("sberna mista"): one DN50 outlet per collection point. */
      var outlets = getOverflowCollectorPositions().length;
      if (outlets > 0) rows.push(_rowPc(C.accOverflowOutlet, outlets));
      rows.push(_rowPc(C.accBalanceTank,    1));             /* surge / balance tank */
      /* DRAINS: slot channel around the whole perimeter (length) + one corner
         unit per polygon corner. */
      rows.push(_rowM (C.drainSlotChannel, g.Pout));
      if (corners > 0) rows.push(_rowPc(C.drainSlotCorner, corners));
    } else if (edge === 'infinite') {
      /* DRAINS: U-channel catch trough only along the infinity edges (length),
         + one corner unit per direction change between two infinity edges.
         (No skimmers in infinite -- the surface is collected by the gutter.) */
      var _poly = getFootprintPolygon() || [], _np = _poly.length;
      var _ie = getInfiniteEdges() || [], _isInf = {};
      for (var _q = 0; _q < _ie.length; _q++) _isInf[_ie[_q]] = true;
      var _infLen = 0, _infCorners = 0;
      for (var _e2 = 0; _e2 < _np; _e2++) {
        if (!_isInf[_e2]) continue;
        var _a2 = _poly[_e2], _b2 = _poly[(_e2 + 1) % _np];
        _infLen += Math.hypot(_b2[0] - _a2[0], _b2[1] - _a2[1]);
        if (_isInf[(_e2 + 1) % _np]) _infCorners++;           /* corner where two infinity edges meet */
      }
      if (_infLen > 0) {
        rows.push(_rowM (C.drainUChannel, _infLen));
        if (_infCorners > 0) rows.push(_rowPc(C.drainUCorner, _infCorners));
        /* Same principle as overflow: the gutter feeds a retention/surge tank.
           Count one gutter outlet per gutter run (= per suction pickup) + one
           balance tank. A run = a maximal block of consecutive infinity edges;
           an all-infinity loop is a single run. */
        var _runs = 0;
        for (var _e3 = 0; _e3 < _np; _e3++) {
          if (_isInf[_e3] && !_isInf[(_e3 - 1 + _np) % _np]) _runs++;
        }
        if (_runs === 0) _runs = 1;                            /* closed loop = one run */
        rows.push(_rowPc(C.accOverflowOutlet, _runs));         /* gutter outlet(s) to tank (DN50) */
        rows.push(_rowPc(C.accBalanceTank,    1));             /* retention / surge tank */
      }
    } else {
      var skimmers = Math.max(1, Math.ceil(g.Ain / 25));     /* ~1 skimmer / 25 m^2 */
      rows.push(_rowPc(C.accSkimmer, skimmers));
    }

    /* Electric flow valve on each pool-drain connection -- both edge systems
       (drains, and therefore their valves, exist for skimmer and overflow). */
    var _drainPoly = (typeof _waterDeepPoly === 'function') ? _waterDeepPoly(_innerRing()) : _innerRing();   /* drains belong to the MAIN pool only -- zones excluded from both count and placement */
    var dvalves = _drainCount(_drainPoly);
    if (dvalves > 0) rows.push(_rowPc(C.accFlowValve, dvalves));

    var jets   = Math.max(2, Math.round(g.Ain / 18), Math.ceil(g.Pin / 6)); /* return jets (matches 3D) */
    var drains = _drainCount(_drainPoly);                    /* main floor drains by area (1/2/3) -- zones excluded */
    rows.push(_rowPc(C.accReturnJet,  jets));
    rows.push(_rowPc(C.accFloorDrain, drains));

    /* Piping -- trunk-and-branch, per diameter (linear ft + fittings pcs). */
    var pip = computePiping();
    if (pip && pip.agg) {
      for (var dk in pip.agg) {
        if (!pip.agg.hasOwnProperty(dk)) continue;
        var a = pip.agg[dk], codes = PIPE_CODES[dk];
        if (!codes) continue;
        if (a.pipe    > 0) rows.push(_rowM (codes.pipe, _round2(a.pipe)));     /* m -> ft */
        if (a.elbow90 > 0) rows.push(_rowPc(codes.elbow90, Math.round(a.elbow90)));
        if (a.tee     > 0) rows.push(_rowPc(codes.tee, Math.round(a.tee)));
        if (a.reducer > 0 && codes.reducerTo15) rows.push(_rowPc(codes.reducerTo15, Math.round(a.reducer)));
      }
      /* One shut-off valve per trunk (suction + pressure) at the shaft. */
      rows.push(_rowPc(PIPE_CODES[pip.trunkKey].valve, 2));
    }

    /* Shared technology set (one each by default). */
    rows.push(_rowPc(C.accPump,       1));
    rows.push(_rowPc(C.accFilter,     1));
    rows.push(_rowPc(C.accDoser,      1));
    rows.push(_rowPc(C.accTechShaft,  1));
    rows.push(_rowPc(C.accWaterLevel, 1));
    /* Sensor wires: run from the water-level sensor to the shaft/panel. */
    var sp = getShaftPos();
    var cx = 0, cz = 0;
    for (var ci = 0; ci < poly.length; ci++) { cx += poly[ci][0]; cz += poly[ci][1]; }
    cx /= poly.length; cz /= poly.length;
    var sensorWire = Math.hypot(sp.x - cx, sp.z - cz) + g.D + 2;
    rows.push(_rowM(C.accSensorWires, _round2(sensorWire)));

    /* Underwater LED lights -- one fixture per placed light position
       (driven by lightStage; 0 when lighting is off -> no row). */
    var _lights = (typeof getLightPositions === 'function') ? getLightPositions().length : 0;
    if (_lights > 0) rows.push(_rowPc(C.poolLight, _lights));

    /* Pool electrical: junction box per light + per drain valve (overflow),
       a common valve box, cable runs to the wall-mounted panel, the panel
       itself, and a 30 mA RCD (pool safety). */
    var wire = computeWiring();
    var vwire = computeValveWiring(pip.valvePts);
    var jboxes  = (wire.boxes || 0) + (vwire.valveBoxes || 0) + (vwire.commonBox || 0);
    var cableLn = (wire.cableLen || 0) + (vwire.cableLen || 0);
    if (jboxes > 0) {
      rows.push(_rowPc(C.elJunctionBox, jboxes));
      rows.push(_rowM (C.elCable, _round2(cableLn)));        /* m -> ft */
      rows.push(_rowPc(C.elPanel, 1));
      rows.push(_rowPc(C.elRcd,   1));
    }

    /* Kids<->Main divider: 2 blocks per pillar (PWC05004) + 1 tile each (SFF00002). */
    var _divCols = (_zfBoq && _zfBoq.dividerCols) ? (_zfBoq.dividerCols | 0) : 0;
    if (_divCols > 0) {
      rows.push(_rowPc('PWC05004', 2 * _divCols));
      rows.push(_rowPc('SFF00002', _divCols));
    }

    return rows;
  }

  var _publishTimer = null;
  /* Round a quantity to 2 decimals, keeping it a Number (so the budget
     can still sum/format it). Avoids long floating-point tails like
     3530.5591999999997 reaching the BoQ display. */
  function _round2(v) {
    if (typeof v !== 'number' || !isFinite(v)) return v;
    return Math.round(v * 100) / 100;
  }

  function publishBoQToBudget() {
    var rows = computeBoQ();
    /* Generic ConfiguratorBoQ contract -- header row + spacer, then
       [code, metricQty, imperialQty] rows (same shape as fence/rack). */
    var variantData = [['id', 'metric', 'imperial'], ['', '', '']];
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      variantData.push([r[0], _round2(r[1]).toFixed(3), _round2(r[2]).toFixed(3)]);
    }
    var BOQ_COVERAGE = {};
    BOQ_COVERAGE[POOL_CODES.tyingWire]   = { sellUnit: 'm', perUnit: 0.015757 };
    global.ConfiguratorBoQ = {
      source: 'pool',
      variantData: variantData,
      coverage: BOQ_COVERAGE,
      /* Configurator-generated dimensions for items the master no longer
         pins (shaft now; balance tank later). Keyed by code; the budget can
         read these to fill the dimension columns. */
      dimensions: (function () {
        var sd = getShaftDimensions();
        var dims = {};
        dims[POOL_CODES.accTechShaft] = {
          metricMm: [sd.metricMm.w, sd.metricMm.l, sd.metricMm.h],
          imperialIn: [sd.imperialIn.w, sd.imperialIn.l, sd.imperialIn.h]
        };
        /* Balance tank dims (overflow only) -- generated from 10 % water volume. */
        if (getEdgeType() === 'overflow') {
          var td = getTankDimensions();
          dims[POOL_CODES.accBalanceTank] = {
            metricMm: [td.metricMm.w, td.metricMm.l, td.metricMm.h],
            imperialIn: [td.imperialIn.w, td.imperialIn.l, td.imperialIn.h]
          };
        }
        return dims;
      })()
    };
    global._poolVariantData = variantData;
    if (typeof global.loadVariantCSV === 'function') {
      try { global.loadVariantCSV('synthetic://pool'); } catch (e) {}
    }
  }

  function _debouncedPublishBoQ() {
    if (_publishTimer) clearTimeout(_publishTimer);
    _publishTimer = setTimeout(publishBoQToBudget, 400);
  }

  function getCountLabel() {
    var boot = global.BASE_BOOT || {};
    var i18n = boot.i18n || {};
    return i18n.volume || 'Volume';
  }

  /* Concrete-block count for the active unit (block variants only). Uses
     the wall developed area and the current block face (metric 500x200,
     imperial 16x8"), matching the PWC05001 BoQ row. */
  /* Total blocks for the bottom banner: wall blocks (sized by the material's
     facing module -- EPS 1000x250, concrete 500x200) plus the stair blocks
     (always concrete). Matches the BoQ: for EPS this sums the EPS wall blocks
     and the concrete stair blocks together; for concrete, all concrete. */
  function getBlockCount() {
    if (!_variantUsesBlocks()) return 0;
    var st = _stairsBlockTally();              /* stair blocks (laid separately), incl. halves */
    /* Wall + riser blocks from the ACTUAL laid model -- the SAME view-independent
       takeoff the drawer BoQ uses -- so the bottom banner tracks the model and the
       priced BoQ in lock-step. Analytic wall-area formula stays as the fallback. */
    var _mw = _wallBlockTakeoff();
    var wallPlusRiser;
    if (_mw != null && _mw > 0) {
      wallPlusRiser = _mw;                       /* incl. zone risers (laid via bands) */
    } else {
      var g = _poolGeometry();
      var mod = _facingModule();
      var face = mod.len * mod.course;
      var wall = (face > 0) ? Math.ceil(g.wallDevA / face) : 0;
      var zf = g.zoneFloors || null;
      var zRiserA = (zf && zf.riserDevA) ? zf.riserDevA : 0;
      var zKs = (zRiserA > 0 && face > 0) ? Math.ceil(zRiserA / face) : 0;
      wallPlusRiser = wall + zKs;
    }
    return wallPlusRiser + st.full + st.half;
  }

  /* Water displaced by zone benches: over each bench the water is only 'dft'
     deep instead of the full depth, so it loses footprint x (D - dft) m^3. */
  /* Water surface Y by edge type: overflow brims at the rim (0), infinite sits
     a touch above in the venec/gutter (+0.05), skimmer runs a freeboard below
     the coping (-freeboardM). Single source for the volume formulas + the 3D
     build so the reported volume tracks the visible water line. */
  function _waterSurfaceY() {
    var d = getVariantDefaults(variantKey(), STATE.lvl);
    var et = getEdgeType();
    return (et === 'overflow') ? 0.0 : (et === 'infinite') ? 0.05 : -((d && d.freeboardM) || 0.15);
  }
  function _zoneWaterDisplacement(D) {
    if (!_variantUsesBlocks()) return 0;
    var laid = _layoutZones();
    var bc = _blockModule().course, RAISE = { kids: 2 * bc, relax: 1 * bc }, sum = 0;
    for (var i = 0; i < laid.length; i++) {
      var z = laid[i]; if (!z.kind) continue;
      var dft = RAISE[z.kind] || bc; if (dft > D - 0.05) dft = D - 0.05;
      sum += Math.abs(_polyArea(z.quad)) * Math.max(0, D - dft);
    }
    /* Kids<->Main divider pillars stand in the shallow water above the kids
       shelf, so they displace water too: footprint x submerged height
       (~ kids depth less the ~0.10 freeboard, matching the gross formula). */
    var zf = _zoneFloors();
    if (zf && zf.dividerCols) {
      var colFoot = STATE.isMetric ? 0.40 : 12 * IN;
      var kidsDft = Math.min(2 * bc, D - 0.05);
      sum += zf.dividerCols * colFoot * colFoot * Math.max(0, kidsDft - 0.10);
    }
    return sum;
  }

  /* pool-v9 THE STAIRS OUT OF THE WATER: their block footprint (the steps + the open-side cheek, from the wall in to the lowest
     riser) notched out of the deep-water outline 'basePoly' (the carved main pool the stairs anchor on, same edge indexing), and one
     tread quad a step (from its riser back to the next one up) whose water runs from the tread top to the surface -- mirrors
     _buildStairs. { deep, treads: [{ quad, yZone }] }; unchanged when there are no block stairs. */
  function _stairsWaterCut(basePoly, yTop) {
    var out = { deep: basePoly, treads: [] };
    try {
      var mode = getStairsMode(), p = _stairsTypeParams(mode);
      if (p.kind !== 'steps' || !basePoly || basePoly.length < 3) return out;
      var place = getCurrentStairsPlacement();
      if (!place || !_stairsPlacementFits(place, mode)) return out;
      var n = basePoly.length, e = place.edge, A = basePoly[e], B = basePoly[(e + 1) % n];
      var ex = B[0] - A[0], ez = B[1] - A[1], L = Math.hypot(ex, ez), i;
      if (L < 0.05) return out;
      var ux = ex / L, uz = ez / L, a2 = 0;
      for (i = 0; i < n; i++) { var q0 = basePoly[i], q1 = basePoly[(i + 1) % n]; a2 += q0[0] * q1[1] - q1[0] * q0[1]; }
      var wx = (a2 > 0) ? -uz : uz, wz = (a2 > 0) ? ux : -ux;
      var mod = _blockModule(), bl = mod.len, rise = mod.course, bw = mod.width, D = getCurrentDepth();
      var widthBlocks = (mode === 'full') ? Math.max(1, Math.round(L / bl)) : p.widthBlocks;
      var stairW = (mode === 'full') ? L : widthBlocks * bl, Wst = Math.min(L, stairW + ((mode === 'full') ? 0 : bw));
      var tread = (p.treadHalves || 2) * (bl / 2), nSt = Math.max(1, Math.floor(_stairsEffectiveDepth(e) / rise) - 1), Din = nSt * tread;
      var Ox = place.atEnd ? B[0] : A[0], Oz = place.atEnd ? B[1] : A[1], axx = place.atEnd ? -ux : ux, axz = place.atEnd ? -uz : uz;
      var W = function (al, inw) { return [Ox + axx * al + wx * inw, Oz + axz * al + wz * inw]; };
      var onSeg = function (P, S0, S1) {   /* P on segment S0-S1 (the corner's neighbour wall: the notch side runs along it) */
        var vx = S1[0] - S0[0], vz = S1[1] - S0[1], l2 = vx * vx + vz * vz; if (l2 < 1e-8) return false;
        var t = ((P[0] - S0[0]) * vx + (P[1] - S0[1]) * vz) / l2; if (t < -1e-6 || t > 1 + 1e-6) return false;
        return Math.hypot(S0[0] + vx * t - P[0], S0[1] + vz * t - P[1]) < 2e-3;
      };
      var res = [];
      for (i = 0; i < n; i++) {
        var Pi = basePoly[i];
        if (i === e) {
          if (!place.atEnd) {
            if (!onSeg(W(0, Din), basePoly[(e - 1 + n) % n], A)) res.push(A);
            res.push(W(0, Din), W(Wst, Din), W(Wst, 0));
          } else {
            res.push(A, W(Wst, 0), W(Wst, Din), W(0, Din));
          }
          continue;
        }
        if (i === (e + 1) % n && place.atEnd && onSeg(W(0, Din), B, basePoly[(e + 2) % n])) continue;   /* B: its side runs along the next wall */
        res.push(Pi);
      }
      var dd = [];   /* no two points the same */
      for (i = 0; i < res.length; i++) { var pr = dd.length ? dd[dd.length - 1] : null; if (!pr || Math.hypot(pr[0] - res[i][0], pr[1] - res[i][1]) > 1e-4) dd.push(res[i]); }
      if (dd.length > 2 && Math.hypot(dd[0][0] - dd[dd.length - 1][0], dd[0][1] - dd[dd.length - 1][1]) < 1e-4) dd.pop();
      /* no point in line with its neighbours: the full-width stairs end on the next wall and the corner
         behind them was left as a spike (the outline ran out to it and back), the body then not closed
         and the cut skipped the whole water */
      for (var spk = true, guard = 0; spk && dd.length > 3 && guard++ < 64;) {
        spk = false;
        for (i = 0; i < dd.length; i++) {
          var sp = dd[(i - 1 + dd.length) % dd.length], sc = dd[i], sn = dd[(i + 1) % dd.length];
          if (Math.abs((sc[0] - sp[0]) * (sn[1] - sc[1]) - (sc[1] - sp[1]) * (sn[0] - sc[0])) < 1e-6) { dd.splice(i, 1); spk = true; break; }
        }
      }
      if (dd.length >= 3) out.deep = dd;
      out.edge = e; out.wst = Wst;   /* the wall the stairs stand on and their width along it (the lining behind them is dry) */
      for (i = 0; i < nSt; i++) {
        var yS = -D + (i + 1) * rise, in0 = (nSt - i - 1) * tread, in1 = (nSt - i) * tread;
        if (yTop != null && yS > yTop - 0.005) continue;   /* a tread over the surface: no water on it */
        out.treads.push({ quad: [W(0, in0), W(Wst, in0), W(Wst, in1), W(0, in1)], yZone: yS });
      }
    } catch (eS) { _dbg('[water] stairs cut THREW ' + ((eS && eS.message) || eS)); }
    return out;
  }
  /* pool-v9 THE WATER'S VOLUME from its solid -- the same blocks the section tool fills: the deep block (the main pool, zones and
     stairs carved out) from the floor finish's top, each zone's shelf and each stair tread from its own top, all to the surface;
     less the kids' divider pillars standing in it and the 20 mm interior finish on the deep walls (the infinity edge's water is
     already drawn to the finish's face). Not taken off: the finish on the walls above a shelf, behind and over the stairs' top
     step (a few litres). */
  var POOL_FIN_T = 0.02;   /* the interior finish (floor + wall lining), as the build draws it */
  function _waterVolume() {
    var poly = getFootprintPolygon();
    if (!poly || poly.length < 3) return 0.1;
    var d = getVariantDefaults(variantKey(), STATE.lvl), D = getCurrentDepth(), sY = _waterSurfaceY(), i;
    var inner = _insetPolygon(poly, _effectiveWallThick(d));
    var inf = (getEdgeType() === 'infinite');
    var wPoly = inf ? _insetPolygon(inner, POOL_FIN_T) : inner;   /* as the build's _wPoly */
    var deep = (typeof _waterDeepPoly === 'function') ? _waterDeepPoly(wPoly) : wPoly;
    var yF = -D + POOL_FIN_T;                                       /* the floor finish's top */
    var sc = _stairsWaterCut(deep, sY), V = Math.abs(_polyArea(sc.deep)) * Math.max(0.05, sY - yF);
    var zf = _zoneFloors();
    for (i = 0; i < zf.raised.length; i++) V += Math.abs(_polyArea(zf.raised[i].quad)) * Math.max(0, sY - zf.raised[i].topY);
    for (i = 0; i < sc.treads.length; i++) V += Math.abs(_polyArea(sc.treads[i].quad)) * Math.max(0, sY - sc.treads[i].yZone);
    if (zf.dividerCols) {
      var colFoot = STATE.isMetric ? 0.40 : 12 * IN, kidsDft = Math.min(2 * _blockModule().course, D - 0.05);
      V -= zf.dividerCols * colFoot * colFoot * Math.max(0, kidsDft - 0.10);
    }
    if (!inf && deep && deep.length >= 3) {
      /* the deep walls' lining: full height, a riser line only up to its shelf (the build's _riserTop) */
      var rTop = {};
      try {
        var lz = _layoutZones(), bc = _blockModule().course, RZ = { kids: 2 * bc, relax: 1 * bc }, reach = {};
        for (i = 0; i < lz.length; i++) {
          var z = lz[i]; if (!z.kind || !z.geom || !z.geom.arm) continue;
          var zw = z.geom.arm.wall, zs = z.geom.start + z.geom.depth, zd = RZ[z.kind] || bc; if (zd > D - 0.05) zd = D - 0.05;
          if (!(zw in reach) || zs > reach[zw]) { reach[zw] = zs; rTop[zw] = -zd; }
        }
      } catch (eR) {}
      for (i = 0; i < deep.length; i++) {
        var a0 = deep[i], a1 = deep[(i + 1) % deep.length], eL = Math.hypot(a1[0] - a0[0], a1[1] - a0[1]);
        if (sc.edge === i && sc.wst) eL = Math.max(0, eL - sc.wst);
        var wTop = (i in rTop) ? Math.min(rTop[i], sY) : sY;
        V -= eL * POOL_FIN_T * Math.max(0, wTop - yF);
      }
    }
    return Math.max(0.1, V);
  }

  function refreshInfoBar() {
    var area  = computeArea();
    var depth = getCurrentDepth();
    var volM3 = _round2(_waterVolume());   /* pool-v9 from the water's solid (was the footprint area x depth) */

    function setTxt(id, v) {
      var el = document.getElementById(id);
      if (el) el.textContent = v;
    }
    /* Values -- area to 1 decimal, depth, volume to whole units. */
    setTxt('cf-stat-area',  fmtLen(area, { area: true, precision: 1 }));
    setTxt('cf-stat-height', fmtDim(depth));
    setTxt('cf-stat-count', STATE.isMetric ? volM3.toFixed(0) : (volM3 * 35.3147).toFixed(0));

    /* Unit labels -- switch m/m^2/m^3 <-> ft/ft^2/ft^3 on units toggle. */
    setTxt('cf-stat-area-unit',   areaUnitLabel());
    setTxt('cf-stat-height-unit', '');  /* unit folded into fmtDim (mm / ft-in) */
    setTxt('cf-stat-count-unit',  volUnitLabel());

    /* BLOCKS slot (replaces the old perimeter slot). Shows the concrete
       block count for masonry variants; hidden for gunite. The value is
       blurred for visitors who haven't purchased (sensitive BoQ data). */
    var blkItem = document.getElementById('cf-info-blocks');
    var blkSep  = document.getElementById('cf-info-blocks-sep');
    if (_variantUsesBlocks()) {
      setTxt('cf-stat-blocks', String(getBlockCount()));
      if (blkItem) blkItem.style.display = '';
      if (blkSep)  blkSep.style.display = '';
      var blkVal = document.getElementById('cf-stat-blocks');
      /* pool-v7-buyer: the block count opens for a buyer of the pool (hasOwnership = a paid order; hasPurchased = any order of it, or an admin) -- blurred like the prices until then (Marek: rozmazane ceny bez koupi v poradku) */
      var owns = !!((global.BASE_BOOT || {}).hasOwnership) || !!((global.LEVA_PRODUCT || {}).hasPurchased === true);
      if (blkVal) blkVal.classList.toggle('cf-stat-locked', !owns);
    } else {
      if (blkItem) blkItem.style.display = 'none';
      if (blkSep)  blkSep.style.display = 'none';
    }

    /* Depth occupies the old fence "height" info slot -- keep it visible
       and keep the depth slider in sync with the current range/value. */
    var hItem = document.getElementById('cf-info-height');
    if (hItem) hItem.style.display = '';
    if (_DepthSlider && _DepthSlider.refresh) _DepthSlider.refresh();

    /* Hide fence-only info slots (style + spacing). */
    var styleItem = document.getElementById('cf-info-style');
    if (styleItem) styleItem.style.display = 'none';
    var spSep = document.getElementById('cf-stat-spacing-sep');
    if (spSep) spSep.style.display = 'none';
    var spItem = document.getElementById('cf-stat-spacing-item');
    if (spItem) spItem.style.display = 'none';

    /* Edge-type name (skimmer / overflow). */
    _syncEdgeTypeDisplay();
    _syncStairsDisplay();
    _syncMaterialDisplay();
    _syncSurfaceDisplay();

    /* Count slot -> basin volume. */
    var cLabel = document.getElementById('cf-stat-count-label');
    if (cLabel) cLabel.textContent = getCountLabel();
    var cItem = document.getElementById('cf-stat-count-item');
    if (cItem) cItem.style.visibility = 'visible';
    var cSep = document.getElementById('cf-stat-count-item-sep');
    if (cSep) cSep.style.display = '';
  }

  function refreshUI(skipPublish) {
    refreshInfoBar();
    if (global.BaseRenderer && typeof global.BaseRenderer.build === 'function') {
      global.BaseRenderer.build();
    }
    if (typeof _applyAssemblyStep === 'function') _applyAssemblyStep();
    /* If the fitting count changed (pool resized -> more/fewer skimmers/jets),
       the handle set is stale -- rebuild it so every fitting has a handle. */
    try {
      if (!_anyHandleDragging) {
        var poly = getFootprintPolygon();
        var want = (poly ? poly.length * 2 : 0) + 1            /* corners + edges + shaft */
          + getSkimmerPositions().length + getJetPositions().length + getLightPositions().length + 1 /* panel */;
        if (want !== _handleEls.length) rebuildDragHandles();
      }
    } catch (_) {}
    positionDragHandles();
    if (_VisualizationManager && _VisualizationManager.refreshDimensions) _VisualizationManager.refreshDimensions();
    if (!skipPublish) _debouncedPublishBoQ();
    if (_ProjectStore && _ProjectStore._initialized) _ProjectStore.publish();
  }

  var _UndoHistory = {
    _stack: [],
    _MAX:   50,

    push: function () {
      var snap = {
        polygon: JSON.parse(JSON.stringify(STATE.polygon)),
        variant: STATE.variant
      };
      this._stack.push(snap);
      if (this._stack.length > this._MAX) this._stack.shift();
      this._updateButton();
    },

    pop: function () {
      if (!this._stack.length) return null;
      var snap = this._stack.pop();
      this._updateButton();
      return snap;
    },

    canUndo: function () {
      return this._stack.length > 0;
    },

    /* When the stack is empty the Undo button morphs into a "Restart"
       (reset-to-defaults) control. This holds true both right after a
       page refresh (stack starts empty) and after the user has popped
       every step in their session -- a single, consistent behaviour. */
    isResetMode: function () {
      return this._stack.length === 0;
    },

    pushIfChanged: function (prevPolygon, prevVariant) {
      var sameVariant = (prevVariant === STATE.variant);
      var samePoly = JSON.stringify(prevPolygon) === JSON.stringify(STATE.polygon);
      if (sameVariant && samePoly) return;
      var snap = {
        polygon: JSON.parse(JSON.stringify(prevPolygon)),
        variant: prevVariant
      };
      this._stack.push(snap);
      if (this._stack.length > this._MAX) this._stack.shift();
      this._updateButton();
    },

    clear: function () {
      this._stack = [];
      this._updateButton();
    },

    _updateButton: function () {
      var btn = document.getElementById('cf-btn-undo');
      if (!btn) return;
      var resetMode = this.isResetMode();
      /* Button is always enabled -- when no undo steps remain it
         morphs into a "Restart" control with a different icon. The
         theme should swap the SVG via the cf-undo-reset-mode class. */
      btn.disabled = false;
      btn.style.opacity = '';
      btn.style.cursor  = 'pointer';
      btn.title         = resetMode ? 'Reset to default' : 'Undo';
      btn.setAttribute('aria-label', resetMode ? 'Reset to default' : 'Undo');
      btn.classList.toggle('cf-undo-reset-mode', resetMode);
    }
  };

  function undo() {
    /* Empty stack -> button is in restart mode, clicking it resets the
       whole scene to defaults. Works after a page refresh too. */
    if (_UndoHistory.isResetMode()) {
      reset();
      return;
    }
    var snap = _UndoHistory.pop();
    if (!snap) return;
    STATE.polygon = snap.polygon;
    if (typeof snap.variant === 'number') STATE.variant = snap.variant;
    if (typeof snap.lvl === 'number') STATE.lvl = snap.lvl;
    rebuildDragHandles();
    _updateLvlButton();
    selectVariant(STATE.variant, true);
    refreshUI();
  }

  function reset() {
    var prevPoly = JSON.parse(JSON.stringify(STATE.polygon));
    var prevVariant = STATE.variant;
    var prevLvl = STATE.lvl;
    var fresh = JSON.parse(JSON.stringify(DEFAULTS));
    for (var k in fresh) {
      if (fresh.hasOwnProperty(k)) STATE[k] = fresh[k];
    }
    _UndoHistory._stack.push({
      polygon: prevPoly, variant: prevVariant, lvl: prevLvl
    });
    _UndoHistory._updateButton();
    _updateLvlButton();
    /* Apply the variant first so wall thickness / inner ring are final, THEN
       clear the fitting caches so they regenerate (and snap to the edge) on the
       final geometry -- otherwise they'd be placed against an intermediate ring
       and only snap after the first wall drag. */
    selectVariant(STATE.variant);
    STATE.skimmers = null; STATE.jets = null; STATE.lights = null;
    STATE.shaft = null; STATE.panel = null; STATE.tank = null; STATE.whirlpool = null;
    rebuildDragHandles();
    refreshUI();
    /* Reframe the camera exactly like a fresh load from cache (boot calls
       the same routine) -- centre on the footprint bbox at ~60% fill. Covers
       undo's reset-mode path too, which routes through here. */
    if (global.BaseEngine && global.BaseEngine.fitCameraToFootprint) {
      global.BaseEngine.fitCameraToFootprint();
    }
  }

  function cycleLvl() {
    _UndoHistory._stack.push({
      polygon: JSON.parse(JSON.stringify(STATE.polygon)),
      variant: STATE.variant,
      lvl: STATE.lvl
    });
    _UndoHistory._updateButton();
    STATE.lvl = (STATE.lvl >= 3) ? 1 : (STATE.lvl + 1);
    _updateLvlButton();
    _showLvlAvatar();
    refreshUI();
  }

  function _showLvlAvatar() {
    var img = document.getElementById('cf-lvl-avatar');
    if (!img) return;
    var boot = global.BASE_BOOT || {};
    var url = boot.lvlAvatars && boot.lvlAvatars[STATE.lvl];
    if (!url) return;
    img.classList.remove('cf-lvl-avatar-show');
    img.style.display = 'none';
    if (img.src !== url) {
      img.src = url;
    }
    void img.offsetWidth;
    img.style.display = '';
    img.classList.add('cf-lvl-avatar-show');
  }

  function _preloadLvlAvatars() {
    var boot = global.BASE_BOOT || {};
    var avatars = boot.lvlAvatars || {};
    for (var k in avatars) {
      if (avatars.hasOwnProperty(k)) {
        var preImg = new Image();
        preImg.src = avatars[k];
      }
    }
  }

  function _updateLvlButton() {
    var btn = document.getElementById('cf-btn-lvl');
    if (!btn) return;
    btn.classList.toggle('active', STATE.lvl !== 1);
    btn.setAttribute('data-lvl', String(STATE.lvl));
    btn.setAttribute('aria-pressed', STATE.lvl !== 1 ? 'true' : 'false');
    var needle = document.getElementById('cf-lvl-needle');
    if (needle) {
      var deg = (STATE.lvl === 1) ? -60 : (STATE.lvl === 2) ? 0 : 60;
      needle.style.transform = 'rotate(' + deg + 'deg)';
    }
  }

  /* -- Assembly sequence (wood fence) -----------------------------
     17 steps (0..16). Each step from 2 onward adds one part type on
     top of the previous, building the isolated single bay from the
     ground up. The tooltip on each step shows the matching BoQ item's
     localized name (via ConfiguratorBudgetBridge.getBoqItem), falling
     back to a hardcoded English name. partType tags are set by
     _build3D_DetailBay so applyStep can toggle visibility + explode. */

  /* Replace a metric dimension token inside a name with its imperial
     equivalent, tolerant to x vs x and variable whitespace. Falls back
     to appending the imperial value if the metric token isn't found. */

  /* Replace the single "pi" placeholder in a BoQ name with the
     active-units dimension string (e.g. "WOOD SCREW pi" + "6 x 80" ->
     "WOOD SCREW 6 x 80"). If there is no pi, the name is already resolved
     and is returned unchanged. A stray pi with no dimension is stripped. */

  var _SlopeManager = {
    init: function () {
      var btn = document.getElementById('cf-btn-slope');
      if (!btn) return;
      var self = this;
      btn.addEventListener('click', function () { self.toggle(); });
      this._wireSlider();
      this._injectArrow();
      this._updateAll();
    },

    _wireSlider: function () {
      var slider = document.getElementById('cf-slope-slider');
      if (!slider) return;
      var maxV = parseInt(slider.max, 10) || 15;
      var self = this;
      var updateFill = function (val) {
        var fillPct = 100 - (val / maxV) * 100;
        slider.style.setProperty('--cfg-fill', fillPct + '%');
      };
      var onChange = function () {
        var v = parseInt(slider.value, 10) || 0;
        STATE.slopeDeg = v;
        updateFill(v);
        var lbl = document.getElementById('cf-slope-value');
        if (lbl) lbl.textContent = v + '\u00b0';
        self._updateArrow();
        if (global.BaseEngine) _rebuildGrid(global.BaseEngine);
        if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
        refreshUI();
      };
      slider.addEventListener('input',  onChange);
      slider.addEventListener('change', onChange);
      slider.value = STATE.slopeDeg;
      updateFill(STATE.slopeDeg);
      var lbl = document.getElementById('cf-slope-value');
      if (lbl) lbl.textContent = STATE.slopeDeg + '\u00b0';
    },

    _injectArrow: function () {
      if (document.getElementById('cf-slope-arrow')) return;
      var wrap = document.getElementById('cf-wrap-base');
      if (!wrap) return;
      var TT = (global.BASE_BOOT && global.BASE_BOOT.i18n) || {};
      var slopeLabel = TT.slopeArrowLabel || 'SLOPE';
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.id = 'cf-slope-arrow';
      svg.setAttribute('viewBox', '0 0 100 36');
      svg.style.cssText = [
        'position:absolute', 'left:15%', 'top:50%',
        'transform:translate(-50%, -50%)',
        'width:100px', 'height:36px',
        'pointer-events:none', 'display:none', 'z-index:9'
      ].join(';');
      svg.innerHTML = [
        '<line x1="6" y1="18" x2="86" y2="18" stroke="#D2A878" stroke-width="2.5" stroke-linecap="round"/>',
        '<polyline points="78,10 90,18 78,26" fill="none" stroke="#D2A878" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>',
        '<text x="48" y="34" text-anchor="middle" font-family="Montserrat, system-ui, sans-serif" font-size="9" font-weight="700" fill="#D2A878" id="cf-slope-arrow-label">' + slopeLabel + '</text>'
      ].join('');
      wrap.appendChild(svg);
    },

    _updateArrow: function () {
      var svg = document.getElementById('cf-slope-arrow');
      if (!svg) return;
      var visible = STATE.slopeActive && STATE.view === '2d';
      svg.style.display = visible ? 'block' : 'none';
      var lbl = document.getElementById('cf-slope-arrow-label');
      if (lbl) {
        var TT = (global.BASE_BOOT && global.BASE_BOOT.i18n) || {};
        lbl.textContent = TT.slopeArrowLabel || 'SLOPE';
      }
    },

    _updateButton: function () {
      var btn = document.getElementById('cf-btn-slope');
      if (!btn) return;
      btn.classList.toggle('active', STATE.slopeActive);
      btn.setAttribute('aria-pressed', STATE.slopeActive ? 'true' : 'false');
    },

    _updateSlider: function () {
      var wrap = document.getElementById('cf-slope-slider-wrap');
      if (!wrap) return;
      var visible = STATE.slopeActive && STATE.view === '2d' && STATE.vizStage !== 1;
      wrap.classList.toggle('cf-slope-visible', visible);
    },

    _updateAll: function () {
      this._updateButton();
      this._updateSlider();
      this._updateArrow();
    },

    toggle: function () {
      STATE.slopeActive = !STATE.slopeActive;
      if (STATE.slopeActive && STATE.view !== '2d') {
        if (global.BaseEngine && global.BaseEngine.toggleView) {
          global.BaseEngine.toggleView();
        }
      }
      this._updateAll();
      if (global.BaseEngine) _rebuildGrid(global.BaseEngine);
      if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
      refreshUI();
    }
  };

  function _updateMapLockButton() {
    var btn = document.getElementById('cf-map-lock');
    if (!btn) return;
    btn.classList.toggle('locked', !!STATE.mapLocked);
    btn.setAttribute('aria-pressed', STATE.mapLocked ? 'true' : 'false');
    btn.title = STATE.mapLocked ? 'Unlock map position' : 'Lock map position';
    var shackle = document.getElementById('cf-map-lock-shackle');
    if (shackle) {
      shackle.setAttribute('d', STATE.mapLocked
        ? 'M8 11V7a4 4 0 0 1 8 0v4'
        : 'M8 11V7a4 4 0 0 1 7-2.65');
    }
    _applyMapLockState();
  }

  function _applyMapLockState() {
    if (!_MapManager || !_MapManager.map) return;
    var m = _MapManager.map;
    var locked = !!STATE.mapLocked;
    try {
      if (locked) {
        m.dragPan.disable();
        m.scrollZoom.disable();
        m.boxZoom.disable();
        m.dragRotate.disable();
        m.doubleClickZoom.disable();
        m.touchZoomRotate.disable();
      } else {
        m.dragPan.enable();
        m.scrollZoom.enable();
        m.boxZoom.enable();
        m.dragRotate.enable();
        m.doubleClickZoom.enable();
        m.touchZoomRotate.enable();
      }
    } catch (e) {}
    var rotateInput = document.getElementById('cf-map-rotate');
    if (rotateInput) {
      rotateInput.disabled = locked;
      rotateInput.style.opacity = locked ? '0.4' : '';
      rotateInput.style.pointerEvents = locked ? 'none' : '';
    }
  }

  function _slopeRefBearing() {
    if (_MapManager && typeof _MapManager.bearing === 'number') return _MapManager.bearing;
    return 0;
  }

  function _rotatePoint(x, z, bearingDeg) {
    if (!bearingDeg) return { x: x, z: z };
    var rad = -bearingDeg * Math.PI / 180;
    var cs = Math.cos(rad), sn = Math.sin(rad);
    return { x: x * cs - z * sn, z: x * sn + z * cs };
  }

  function _slopeRefX() {
    var poly = STATE.polygon;
    if (!poly || !poly.length) return 0;
    var bearing = _slopeRefBearing();
    var xMax = -Infinity;
    for (var i = 0; i < poly.length; i++) {
      var r = _rotatePoint(poly[i][0], poly[i][1], bearing);
      if (r.x > xMax) xMax = r.x;
    }
    return xMax;
  }

  function _padSlopeExtra(padX, padZ) {
    if (!STATE.slopeActive || STATE.slopeDeg <= 0) return 0;
    var bearing = _slopeRefBearing();
    var rotated = _rotatePoint(padX, (typeof padZ === 'number' ? padZ : 0), bearing);
    var xMax = _slopeRefX();
    var rad = STATE.slopeDeg * Math.PI / 180;
    var extra = (xMax - rotated.x) * Math.tan(rad);
    return extra > 0 ? extra : 0;
  }

  /* -------------------------------------------------------------
     _forceRender3DFlush
     Chromium Android occasionally retains a stale composite layer
     for the WebGL canvas after the scene group is rebuilt -- the
     renderer paints the new frame correctly (verified via
     gl.readPixels) but the user sees a blank canvas until they
     interact with it. This shows up on multiple paths: variant
     switch, units toggle, style switch, viz mode change, etc.

     Three escalation levels:

       0 (default, "soft") -- sync render() now + a second render
         scheduled via requestAnimationFrame on the next frame.
         Cheap, invisible. Fixes most paths.

       1 ("canvas")        -- also nudges the canvas element's
         opacity to 0.999 for one animation frame and back. This
         forces the compositor to invalidate its cached layer for
         the canvas without re-creating the WebGL context, and
         without the visible 2D detour. Cost: ~one extra paint.

       2 ("roundtrip")     -- also performs a 3D -> 2D -> 3D view
         toggle. Heaviest, briefly shows the 2D scene; rebuilds
         the scene group from scratch. Reserved for paths that
         still fail at level 1.

     Callers pick the lowest level that works for their path. The
     'useRoundTrip' legacy parameter (boolean) is still accepted --
     false -> 0, true -> 2 -- for backwards compatibility.
     ------------------------------------------------------------- */
  function _forceRender3DFlush(level) {
    if (STATE.view !== '3d') return;
    var eng = global.BaseEngine;
    if (!eng) return;
    /* Coerce legacy boolean (false -> 0, true -> 2). Numbers pass through. */
    var lvl = (level === true) ? 2 : (level === false ? 0 : (level | 0));

    function _doRender() {
      try {
        if (STATE.view === '3d' && eng.renderer && eng.scene && eng.camera) {
          eng.renderer.render(eng.scene, eng.camera);
        }
      } catch (e) {}
    }

    /* Level 0 -- sync + RAF render */
    _doRender();
    if (global.requestAnimationFrame) global.requestAnimationFrame(_doRender);

    /* Level 1 -- canvas opacity nudge forces compositor reflow.
       The 0.999 -> 1 change is visually undetectable but invalidates
       the cached composite layer for the canvas. */
    if (lvl >= 1) {
      try {
        var canvas = eng.renderer && eng.renderer.domElement;
        if (canvas && global.requestAnimationFrame) {
          var prev = canvas.style.opacity;
          canvas.style.opacity = '0.999';
          global.requestAnimationFrame(function () {
            canvas.style.opacity = prev || '';
            _doRender();
          });
        }
      } catch (e) {}
    }

    /* Level 2 -- view round-trip (3D -> 2D -> 3D). Visible flicker.
       toggleView() resets vizStage to 0, so we snapshot and restore
       it -- otherwise a style switch while in section-cut / detail
       stage would silently drop the user back to the plain 3D view. */
    if (lvl >= 2 && eng.toggleView) {
      try {
        var savedStage = STATE.vizStage;
        _poolRoundTrip++;   /* pool-v9: not a real visit to the plan -- the cut stays on */
        try { eng.toggleView(); /* -> 2D */ eng.toggleView(); /* -> 3D */ } finally { _poolRoundTrip--; }
        /* toggleView resets vizStage to 0; restore it so a unit switch
           doesn't drop the user out of section-cut mode. */
        var changed = false;
        if (savedStage && savedStage !== STATE.vizStage) {
          STATE.vizStage = savedStage; changed = true;
        }
        if (changed) {
          if (_VisualizationManager && _VisualizationManager.apply) {
            _VisualizationManager.apply();
          }
          /* NOTE: we intentionally do NOT call frameCamera() here. This
             path runs on a style/unit switch while the user is already
             inside assembly view -- re-framing would snap the camera away
             from wherever they've orbited to. The camera was framed once
             on entry; a style change should leave it exactly as-is. */
        }
      } catch (e) {}
    }
  }

  function toggleUnits() {
    STATE.isMetric = !STATE.isMetric;
    /* The grid step changes with the unit (5 cm <-> 2"), so RE-MODEL rather than
       just relabel: re-snap the footprint to the new unit's grid (e.g. imperial
       3.678 m -> metric 3.70 m) and re-snap the depth to whole rows. */
    _snapPolygonToBlockGrid();
    if (STATE.depth != null) STATE.depth = getCurrentDepth();
    try { rebuildDragHandles(); } catch (e) {}
    if (global.BaseEngine) _rebuildGrid(global.BaseEngine);
    if (STATE.view === '3d' && global.BaseRenderer && global.BaseRenderer.build) {
      global.BaseRenderer.build();
    }
    refreshUI(true);
    _forceRender3DFlush(2);
    _broadcastUnitToBudget();
  }

  function _broadcastUnitToBudget() {
    var sel = document.getElementById('unitSelector');
    if (sel) {
      sel.setAttribute('data-current-unit', STATE.isMetric ? 'metric' : 'imperial');
      sel.dispatchEvent(new CustomEvent('unitChange', {
        detail: { unit: STATE.isMetric ? 'metric' : 'imperial' }, bubbles: true
      }));
    }
  }

  function _syncFromBudgetUnit() {
    var sel = document.getElementById('unitSelector');
    if (!sel) return;
    var u = sel.getAttribute('data-current-unit');
    var nextMetric = (u !== 'imperial');
    if (STATE.isMetric !== nextMetric) {
      STATE.isMetric = nextMetric;
      if (global.BaseEngine) _rebuildGrid(global.BaseEngine);
      /* Rebuild the 3D scene too: the slope-conforming grid is generated
         in build() with a metric/imperial step, so it must regenerate
         when units change (otherwise it keeps the old spacing). */
      if (STATE.view === '3d' && global.BaseRenderer && global.BaseRenderer.build) {
        global.BaseRenderer.build();
      }
      refreshUI(true);
      _forceRender3DFlush(2);
    }
  }

  /* Fence has 7 variants:
       1 = wood            (= timber pickets / privacy / split-rail)
       2 = vinyl           (= PVC privacy panels)
       3 = concrete_blocks (= split-face block posts + dwarf wall + panel)
       4 = chain_link      (= galvanised mesh on steel posts)
       5 = steel_panel     (= welded steel panel between steel posts)
       6 = gabion          (= stone-filled wire cages)
       7 = concrete_panel  (= precast concrete panels in H-posts)
     Names are US-market friendly. Order of variants matches Shopify
     product variants so _syncShopifyVariant maps variant N -> boot.variants[N-1]. */
  var POOL_VARIANT_COUNT = 2;

  function selectVariant(n, silent) {
    if (n < 1 || n > POOL_VARIANT_COUNT) return;
    if (!silent && STATE.variant !== n) {
      _UndoHistory.pushIfChanged(STATE.polygon, STATE.variant);
    }
    STATE.variant = n;
    if (_SectionCutManager && _SectionCutManager.resetManualOffset) {
      _SectionCutManager.resetManualOffset();
    }
    /* Variant change can change depth range -> drop manual override. */
    STATE.depth = null;
    /* Entering a block variant snaps the footprint to whole blocks. */
    if (_variantUsesBlocks()) {
      _snapPolygonToBlockGrid();
      try { rebuildDragHandles(); } catch (e) {}
    }
    if (_VisualizationManager && _VisualizationManager.reset) _VisualizationManager.reset();
    _syncVariantNameDisplay();
    if (!silent) _syncShopifyVariant(n);
    refreshUI();
    _forceRender3DFlush(2);
  }

  function nextVariant() {
    var n = STATE.variant + 1;
    if (n > POOL_VARIANT_COUNT) n = 1;
    selectVariant(n);
  }

  function prevVariant() {
    var n = STATE.variant - 1;
    if (n < 1) n = POOL_VARIANT_COUNT;
    selectVariant(n);
  }

  /* -------------------------------------------------------------
     Wood-fence style switcher.
     Valid: 'privacy' | 'spaced' | 'shadow_box' | 'picket'.
     Pure picket-pattern change -- rails, posts, dimensions unchanged.
     Triggers full re-render and re-publishes BoQ + ProjectStore.
     ------------------------------------------------------------- */

  /* Display labels mirror the canonical FENCE_VARIANT_KEYS order. */
  var POOL_VARIANT_FALLBACK_NAMES = ['Block Pool', 'Gunite Pool'];

  function _syncVariantNameDisplay() {
    var nameEl = document.getElementById('cf-base-variant-name');
    if (!nameEl) return;
    var boot = global.BASE_BOOT || {};
    var i18n = boot.i18n || {};
    var key = 'pool_v' + STATE.variant;
    var fallback = POOL_VARIANT_FALLBACK_NAMES[STATE.variant - 1] || 'Pool';
    nameEl.textContent = i18n[key] || fallback;
    _syncWipWatermark();
  }

  /* Variants still under development show a diagonal "UNDER DEVELOPMENT"
     watermark over the stage. Gunite is not finished yet. */
  var POOL_WIP_VARIANTS = { gunite: true };
  function _syncWipWatermark() {
    var el = document.getElementById('cf-wip-watermark');
    if (!el) return;
    el.classList.toggle('cf-wip-active', !!POOL_WIP_VARIANTS[variantKey()]);
  }

  function _syncShopifyVariant(n) {
    var boot = global.BASE_BOOT;
    if (!boot || !boot.variants || !boot.variants[n - 1]) return;
    var v = boot.variants[n - 1];
    if (!v || !v.id) return;
    try {
      var url = new URL(global.location.href);
      url.searchParams.set('variant', String(v.id));
      global.history.replaceState({}, '', url.toString());
    } catch (e) {}

    var selectors = document.querySelectorAll('select[name="id"], input[name="id"]');
    selectors.forEach(function (sel) {
      if (sel.tagName === 'SELECT') {
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].value === String(v.id)) {
            sel.selectedIndex = i;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      } else {
        sel.value = String(v.id);
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    document.dispatchEvent(new CustomEvent('base:variantChanged', {
      detail: { variant: n, shopifyVariantId: v.id }, bubbles: true
    }));
  }

  function _readShopifyVariantFromURL() {
    var boot = global.BASE_BOOT;
    if (!boot || !boot.variants) return;
    try {
      var url = new URL(global.location.href);
      var vid = url.searchParams.get('variant');
      if (!vid) return;
      for (var i = 0; i < boot.variants.length; i++) {
        if (String(boot.variants[i].id) === String(vid)) {
          STATE.variant = i + 1;
          return;
        }
      }
    } catch (e) {}
  }

  var _handleEls = [];
  var _anyHandleDragging = false;
  var _shaftDragStart = null;
  var _whirlDragStart = null;
  var _tankDragStart = null;
  var _panelDragStart = null;
  var _fittingDragStart = null;
  var _fittingsResizeStart = null;

  /* -- Zone "+" add-buttons (DOM overlay) -----------------------------
     Each zone slot gets TWO round "+" buttons (kids + relax) with native
     tooltips; the ghost whirlpool gets one. They live in the same overlay
     container as the drag handles, are a constant screen size, and are
     re-projected every frame by positionDragHandles -> _positionZoneButtons. */
  var _zoneBtnEls = [];
  var ZONE_BTN_OFF = 24;   /* screen-px offset of each 40px icon from the slot centre */
  /* Shared placeholder icon for the future shaft / jacuzzi configurator -- both
     the whirlpool (jacuzzi) ghost and the technology-shaft handle use it. */
  var _TECH_ICON_URL = 'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/technology.png?v=1780834162';
  var _JACUZZI_ICON_URL = 'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/lotus-flower.png?v=1780690650';
  /* Zone icons. kids/relax/whirlpool = product PNGs; remove = inline SVG. */
  var _ZONE_ICONS = {
    kids:      '<img src="https://cdn.shopify.com/s/files/1/0803/9815/6119/files/rubber-duck.png?v=1780690651" width="26" height="26" style="object-fit:contain;pointer-events:none" alt="">',
    relax:     '<img src="https://cdn.shopify.com/s/files/1/0803/9815/6119/files/sunbed.png?v=1780690650" width="26" height="26" style="object-fit:contain;pointer-events:none" alt="">',
    whirlpool: '<img src="' + _JACUZZI_ICON_URL + '" width="26" height="26" style="object-fit:contain;pointer-events:none" alt="">',
    remove:    '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round"><line x1="7" y1="12" x2="17" y2="12"/></svg>'
  };
  function _zoneMap() {
    if (!STATE.pool) STATE.pool = {};
    if (!STATE.pool.zones) STATE.pool.zones = {};
    return STATE.pool.zones;
  }
  function _zoneKey(wall, slot) { return wall + '_' + slot; }
  /* A zone value is either a kind string (legacy = default depth) or {k, d}
     where d is the custom depth in metres (inward extent). */
  function _zoneKindOf(v) { return (v && typeof v === 'object') ? v.k : v; }
  function _zoneDepthOf(v) { return (v && typeof v === 'object' && typeof v.d === 'number') ? v.d : null; }
  /* Sum of the (stored or default) depths of the FILLED slots before 'slot' on
     this arm = the inward start offset of 'slot'. */
  function _zoneStartOffset(zmap, arm, wall, slot) {
    var cur = 0;
    for (var s = 0; s < slot; s++) {
      var v = zmap[_zoneKey(wall, s)]; if (!_zoneKindOf(v)) break;
      var d = _zoneDepthOf(v); if (d == null) d = ZONE_LEN_M;
      if (cur + d > arm.armDepth) d = arm.armDepth - cur;
      cur += d;
    }
    return cur;
  }
  /* Lay out zones for every arm: each FILLED slot (with its custom depth) stacked
     inward, plus exactly ONE next placeholder per arm. The cap + two side edges
     follow the arm (full width); only the inner edge (depth) is user-set. */
  function _layoutZones() {
    var poly = getFootprintPolygon();
    if (!poly || poly.length < 3) return [];
    var d = getVariantDefaults(variantKey(), STATE.lvl);
    var inner = _insetPolygon(poly, _effectiveWallThick(d));
    var arms = _computeZones(inner);
    if (!arms.length) return [];
    var zmap = _zoneMap();
    var nE = inner.length;
    var out = [];
    /* Step the zone depth by whole wall blocks (the blocks actually drawn on
       the wall), so the riser falls on the same block grid as the side
       perimeter walls and can bond into them -- exactly like the footprint
       dimensions snap to whole blocks. */
    var _zbl = _facingModule().len;
    var _snapDepth = function (dpt, maxd) {
      var n = Math.round(dpt / _zbl);                 /* nearest whole block */
      if (n < 1) n = 1;
      var v = n * _zbl;
      if (v > maxd + 1e-6) v = Math.floor((maxd + 1e-6) / _zbl) * _zbl;   /* never exceed the arm */
      return v;
    };
    /* Total inward depth occupied by the PLACED zones on an arm (snapped, capped
       at the arm). Used to trim the perpendicular arm that meets it at a corner
       so two placed zones never cross. Empty placeholders contribute 0. */
    function _placedDepth(arm) {
      var cur = 0, sl = 0, g = 0;
      while (g++ < 30) {
        var vv = zmap[_zoneKey(arm.wall, sl)], kk = _zoneKindOf(vv);
        if (!kk) break;
        var zz = _zoneDepthOf(vv); if (zz == null) zz = ZONE_LEN_M;
        zz = _snapDepth(zz, arm.armDepth - cur);
        if (zz < ZONE_MIN_DEPTH || zz < _zbl - 1e-6) break;
        cur += zz; sl++;
      }
      return cur;
    }
    /* index arms by edge; precompute each arm's placed depth and its CORNER
       PRIORITY. At a shared corner the higher-priority arm keeps its FULL width
       (claims the corner); the lower-priority arm trims its width by the winner's
       depth, so the two never cross and the winner leaves no hole. Priority:
       RELAX always beats KIDS (relax stays full width -- the construction rule),
       same kind breaks by lower wall index, and any placed zone beats an empty
       placeholder (so the placeholder yields onto the free main-pool area). No
       insertion-order tracking needed. */
    function _armRank(arm) {
      var k = _zoneKindOf(zmap[_zoneKey(arm.wall, 0)]);
      return k === 'relax' ? 2 : (k === 'kids' ? 1 : 0);
    }
    var armByEdge = {}, pdepth = {}, pprio = {};
    for (var ie = 0; ie < arms.length; ie++) armByEdge[arms[ie].wall] = arms[ie];
    for (var ip = 0; ip < arms.length; ip++) {
      pdepth[arms[ip].wall] = _placedDepth(arms[ip]);
      pprio[arms[ip].wall]  = _armRank(arms[ip]) * 1000 - arms[ip].wall;
    }
    for (var a = 0; a < arms.length; a++) {
      var arm0 = arms[a];
      var adjA = armByEdge[(arm0.wall - 1 + nE) % nE];   /* arm sharing vertex A */
      var adjB = armByEdge[(arm0.wall + 1) % nE];        /* arm sharing vertex B */
      var trimA = (adjA && pdepth[adjA.wall] > 0 && pprio[adjA.wall] > pprio[arm0.wall]) ? pdepth[adjA.wall] : 0;
      var trimB = (adjB && pdepth[adjB.wall] > 0 && pprio[adjB.wall] > pprio[arm0.wall]) ? pdepth[adjB.wall] : 0;
      var capW = Math.hypot(arm0.bx - arm0.ax, arm0.bz - arm0.az) || 1;
      if (trimA + trimB >= capW - 1e-3) continue;        /* corner zones ate the wall -- nothing left */
      var ux = (arm0.bx - arm0.ax) / capW, uz = (arm0.bz - arm0.az) / capW;
      var arm = {
        wall: arm0.wall,
        ax: arm0.ax + ux * trimA, az: arm0.az + uz * trimA,
        bx: arm0.bx - ux * trimB, bz: arm0.bz - uz * trimB,
        nx: arm0.nx, nz: arm0.nz,
        anchorEnd: arm0.anchorEnd, capW: capW - trimA - trimB, armDepth: arm0.armDepth
      };
      var cursor = 0, slot = 0, guard = 0;
      while (guard++ < 30) {
        var key = _zoneKey(arm.wall, slot), v = zmap[key], kind = _zoneKindOf(v);
        if (kind) {
          var zd = _zoneDepthOf(v); if (zd == null) zd = ZONE_LEN_M;
          var maxd = arm.armDepth - cursor;
          zd = _snapDepth(zd, maxd);                   /* snap to whole blocks */
          if (zd < ZONE_MIN_DEPTH || zd < _zbl - 1e-6) break;
          out.push({ wall: arm.wall, slot: slot, kind: kind, quad: _armZoneQuad(arm, cursor, cursor + zd),
                     geom: { arm: arm, start: cursor, depth: zd } });
          cursor += zd; slot++;
          continue;
        }
        var rem = arm.armDepth - cursor;
        if (rem < ZONE_LEN_M - 1e-6) break;                 /* not enough for a new zone */
        var pd = _snapDepth(Math.min(ZONE_LEN_M, rem), rem);
        out.push({ wall: arm.wall, slot: slot, kind: null, quad: _armZoneQuad(arm, cursor, cursor + pd),
                   geom: { arm: arm, start: cursor, depth: pd } });
        break;                                              /* one placeholder per arm */
      }
    }
    return out;
  }
  /* Inner water polygon with each zone arm's cap edge moved INWARD by that
     arm's filled shelf depth, so the deep-water block excludes the shelf
     columns (water never sits in the slab/earth under a bench). Zones span the
     full arm width, so this is a clean edge shift on a simple polygon -- robust,
     unlike a boundary-touching hole. Returns 'inner' unchanged when no zones. */
  function _waterDeepPoly(inner) {
    if (!inner || inner.length < 3) return inner;
    /* Carve every bench out of the deep outline by moving its cap edge inward to
       the riser. Delegates to _poolDeepFoot, whose inward direction is derived
       from the polygon winding (robust on every arm). The previous local version
       used each zone's arm.nx/nz, which was mis-oriented on some arms, so the
       deep-floor FINISH (and wall shell) bled UNDER the bench there -- that thin
       opaque strip, seen through the water, was the "plane under the zone" that
       appeared only toward one side. _poolDeepFoot is the same function the base
       slab uses (which never showed the bleed), so finish, slab and water now
       agree. */
    return _poolDeepFoot(inner);
  }
  /* -- Concrete-plate footprints (single source of truth) -------------------
     Both the 3D concrete (_build3D) and the reinforcement mesh (_buildReinforcement)
     lay their geometry into the SAME plates, so they must use the SAME polygons.
     _poolDeepFoot: the base/deep slab footprint -- every bench cap edge moved inward
     by its shelf depth (the riser becomes a real perimeter edge). Self-contained:
     it derives the per-edge setback from _layoutZones() itself.
     _poolBenchFoot: a raised deck footprint -- grows outward by 'ov' on the cap and
     the two sides, the riser edge (toward the main pool) stays put. */
  function _poolDeepFoot(base) {
    if (!base || base.length < 3) return base;
    var _benFoot = [];
    try {
      var _lzS = _layoutZones(), _bfMax = {};
      for (var _bk = 0; _bk < _lzS.length; _bk++) {
        var _bzz = _lzS[_bk];
        if (!_bzz.kind || !_bzz.geom || !_bzz.geom.arm) continue;
        var _be2 = _bzz.geom.arm.wall, _bs2 = (_bzz.geom.start || 0) + (_bzz.geom.depth || ZONE_LEN_M);
        if (!(_be2 in _bfMax) || _bs2 > _bfMax[_be2]) _bfMax[_be2] = _bs2;
      }
      var _bfKeys = Object.keys(_bfMax);
      for (var _bk2 = 0; _bk2 < _bfKeys.length; _bk2++) _benFoot.push({ e: +_bfKeys[_bk2], s: _bfMax[_bfKeys[_bk2]] });
    } catch (_bf) { _benFoot = []; }
    var out = base.map(function (p) { return [p[0], p[1]]; });
    var nn = base.length;
    var a2 = 0; for (var _a = 0; _a < nn; _a++) { var _q0 = base[_a], _q1 = base[(_a + 1) % nn]; a2 += _q0[0] * _q1[1] - _q1[0] * _q0[1]; }
    var ccw = a2 > 0;
    for (var _k = 0; _k < _benFoot.length; _k++) {
      var e = _benFoot[_k].e, w = (e + 1) % nn, s = _benFoot[_k].s;
      var ax = base[w][0] - base[e][0], az = base[w][1] - base[e][1], aL = Math.hypot(ax, az) || 1;
      var inx = ccw ? -(az / aL) : (az / aL), inz = ccw ? (ax / aL) : -(ax / aL);
      out[e] = [base[e][0] + inx * s, base[e][1] + inz * s];
      out[w] = [base[w][0] + inx * s, base[w][1] + inz * s];
    }
    return out;
  }
  function _poolBenchFoot(q, ov, growOuter) {
    if (growOuter === undefined) growOuter = true;
    var ux = q[3][0] - q[0][0], uz = q[3][1] - q[0][1], uL = Math.hypot(ux, uz) || 1; ux /= uL; uz /= uL;
    var vx = q[1][0] - q[0][0], vz = q[1][1] - q[0][1], vL = Math.hypot(vx, vz) || 1; vx /= vL; vz /= vL;
    var oo = growOuter ? ov : 0;
    return [
      [q[0][0] - ux * oo - vx * ov, q[0][1] - uz * oo - vz * ov],
      [q[1][0] - ux * oo + vx * ov, q[1][1] - uz * oo + vz * ov],
      [q[2][0]             + vx * ov, q[2][1]             + vz * ov],
      [q[3][0]             - vx * ov, q[3][1]             - vz * ov]
    ];
  }
  /* Build the pool water as ONE watertight solid (no extrude, no touching second
     body -> no seam/plane). Top = the full footprint at the surface; bottom is the
     DEEP floor over the main pool and RAISED to each zone's floor over the zones,
     joined by a vertical step (riser). Faces are wound so their normals point OUT
     of the water; the material is FrontSide so the downward-facing bottom caps are
     culled when seen from above the water. 'foot' = water outline, 'deep' = main
     pool outline (zone caps pulled in to the riser), 'zones' = [{quad, yZone}]. */
  function _buildSteppedWaterMesh(foot, deep, zones, yTop, yDeep, mat, byWinding) {
    var T = global.THREE;
    if (!T || !foot || foot.length < 3) return null;
    var P = [];
    function emit(ax, ay, az, bx, by, bz, cx, cy, cz, nx, ny, nz) {
      /* push triangle a,b,c, flipped if its normal opposes the wanted (nx,ny,nz) */
      var ux = bx - ax, uy = by - ay, uz = bz - az;
      var vx = cx - ax, vy = cy - ay, vz = cz - az;
      var gx = uy * vz - uz * vy, gy = uz * vx - ux * vz, gz = ux * vy - uy * vx;
      if (gx * nx + gy * ny + gz * nz >= 0) P.push(ax, ay, az, bx, by, bz, cx, cy, cz);
      else                                  P.push(ax, ay, az, cx, cy, cz, bx, by, bz);
    }
    function centroid(poly) { var x = 0, z = 0, n = poly.length; for (var i = 0; i < n; i++) { x += poly[i][0]; z += poly[i][1]; } return [x / n, z / n]; }
    function cap(poly, y, ny, dropInZone) {
      if (!poly || poly.length < 3) return;
      var v = [], i;
      for (i = 0; i < poly.length; i++) v.push(new T.Vector2(poly[i][0], poly[i][1]));
      var geo; try { geo = new T.ShapeGeometry(new T.Shape(v)); } catch (e) { geo = null; }
      if (!geo) return;
      var pa = geo.attributes.position.array;
      var idx = geo.index ? geo.index.array : null;
      var nT = idx ? idx.length : (pa.length / 3);
      for (i = 0; i < nT; i += 3) {
        var a = idx ? idx[i] : i, b = idx ? idx[i + 1] : i + 1, c = idx ? idx[i + 2] : i + 2;
        var ax = pa[a * 3], az = pa[a * 3 + 1], bx = pa[b * 3], bz = pa[b * 3 + 1], cx = pa[c * 3], cz = pa[c * 3 + 1];
        if (dropInZone && inAnyZone((ax + bx + cx) / 3, (az + bz + cz) / 3) !== null) continue;   /* never floor a shelf */
        emit(ax, y, az, bx, y, bz, cx, y, cz, 0, ny, 0);
      }
    }
    function quad(p0, y0a, y0b, p1, y1a, y1b, nx, nz) {
      /* vertical-ish quad: p0@[y0a..y0b], p1@[y1a..y1b]; outward normal (nx,0,nz) */
      emit(p0[0], y0a, p0[1], p1[0], y1a, p1[1], p1[0], y1b, p1[1], nx, 0, nz);
      emit(p0[0], y0a, p0[1], p1[0], y1b, p1[1], p0[0], y0b, p0[1], nx, 0, nz);
    }
    function inAnyZone(px, pz) {
      for (var z = 0; z < zones.length; z++) {
        var q = zones[z].quad, inside = false, j = q.length - 1;
        for (var k = 0; k < q.length; k++) {
          if (((q[k][1] > pz) !== (q[j][1] > pz)) &&
              (px < (q[j][0] - q[k][0]) * (pz - q[k][1]) / (q[j][1] - q[k][1]) + q[k][0])) inside = !inside;
          j = k;
        }
        if (inside) return zones[z].yZone;
      }
      return null;
    }
    function walls(poly, yT, yB) {
      if (!poly || poly.length < 3) return;
      var c = centroid(poly), nn = poly.length;
      /* pool-v9: the hidden solid (byWinding) takes "outward" from the
         polygon's winding, not from its centroid -- the centroid test turns
         the stairs' notch faces inward on a non-convex outline, the body is
         then not closed one way round and the section tool skips it (no blue
         on a vertical cut). The visible water keeps the old test. */
      var sA = 0, e0;
      if (byWinding) { for (e0 = 0; e0 < nn; e0++) { var p0 = poly[e0], p1 = poly[(e0 + 1) % nn]; sA += p0[0] * p1[1] - p1[0] * p0[1]; } }
      for (var e = 0; e < nn; e++) {
        var a = poly[e], b = poly[(e + 1) % nn];
        var ex = b[0] - a[0], ez = b[1] - a[1], eL = Math.hypot(ex, ez) || 1;
        var nx = ez / eL, nz = -ex / eL;
        var mx = (a[0] + b[0]) / 2, mz = (a[1] + b[1]) / 2;
        if (byWinding) { if (sA < 0) { nx = -nx; nz = -nz; } }
        else if ((mx - c[0]) * nx + (mz - c[1]) * nz < 0) { nx = -nx; nz = -nz; }   /* outward */
        quad(a, yT, yB, b, yT, yB, nx, nz);
      }
    }
    /* Build the water as SEPARATE closed extrusions, each merged into one geometry.
       Each prism is watertight ON ITS OWN, so it is robust even if the deep
       outline and the bench quads do not align to the millimetre (the one-hull
       version mixed the two and left gaps/strays UNDER the pool whenever they
       disagreed). Touching faces at a riser merely coincide -- an accepted thin
       seam on the bench face -- never a stray solid under the basin.
         * DEEP part -> footprint with benches carved out ('deep'), surface->deep floor;
         * each SHELF -> its quad, surface->shelf floor. */
    var deepPoly = (zones.length && deep && deep.length >= 3) ? deep : foot;
    cap(deepPoly, yTop, +1);
    cap(deepPoly, yDeep, -1);
    walls(deepPoly, yTop, yDeep);
    for (var ci = 0; ci < zones.length; ci++) {
      var q = zones[ci].quad, yz = zones[ci].yZone;
      if (!q || q.length < 3) continue;
      cap(q, yTop, +1);
      cap(q, yz, -1);
      walls(q, yTop, yz);
    }
    var g = new T.BufferGeometry();
    g.setAttribute('position', new T.BufferAttribute(new Float32Array(P), 3));
    g.computeVertexNormals();
    return new T.Mesh(g, mat);
  }
  /* Slots to DISPLAY: every FILLED zone (so it can be removed) plus exactly ONE
     empty "next" placeholder per arm -- the first unfilled slot from the arm end.
     Deeper empty slots stay hidden until the one in front is filled, so each arm
     shows a single add-placeholder at a time (revealed progressively). */
  function _displayZones() {
    var laid = _layoutZones();
    if (!laid.length) return laid;
    /* Hide the empty add-placeholder (its red overlay AND its +/- icons) on any
       arm whose corner-neighbour (wall +/-1) already carries a zone -- placing
       perpendicular zones crosses their risers at the shared corner. Placed
       zones are always kept; stacking on the same wall and opposite walls stay
       available. Single source of truth for both the 2D overlay and the DOM
       buttons (both read _displayZones). */
    var poly = getFootprintPolygon();
    var nE = (poly && poly.length) || 0;
    if (!nE) return laid;
    var placedWalls = {};
    for (var i = 0; i < laid.length; i++) if (laid[i].kind) placedWalls[laid[i].wall] = true;
    var out = [];
    for (var j = 0; j < laid.length; j++) {
      var z = laid[j];
      if (z.kind) { out.push(z); continue; }                       /* placed -- always keep */
      if (placedWalls[(z.wall - 1 + nE) % nE] || placedWalls[(z.wall + 1) % nE]) continue;  /* corner-blocked */
      out.push(z);
    }
    return out;
  }
  function _zoneButtonAnchors() {
    var out = [];
    if (STATE.view !== '2d' || !_variantUsesBlocks()) return out;
    var poly = getFootprintPolygon();
    if (!poly || poly.length < 3) return out;
    var dz = _displayZones();
    for (var i = 0; i < dz.length; i++) {
      var q = dz[i].quad;
      var cx = (q[0][0] + q[2][0]) / 2, cz = (q[0][1] + q[2][1]) / 2;
      var ex = q[1][0] - q[0][0], ez = q[1][1] - q[0][1];          /* edge axis (width) */
      var dvx = q[3][0] - q[0][0], dvz = q[3][1] - q[0][1];        /* depth axis */
      var Wedge = Math.hypot(ex, ez) || 1, zlen = Math.hypot(dvx, dvz) || 1;
      var ux = ex / Wedge, uz = ez / Wedge, nx = dvx / zlen, nz = dvz / zlen;
      var wl = dz[i].wall, sl = dz[i].slot;
      if (dz[i].kind) {
        out.push({ ax: cx, az: cz, ux: ux, uz: uz, nx: nx, nz: nz, Wedge: Wedge, zlen: zlen, sign: 0, kind: 'remove', title: 'Remove zone', wall: wl, slot: sl });
        var g = dz[i].geom;
        if (g) {
          var rx = (q[2][0] + q[3][0]) / 2, rz = (q[2][1] + q[3][1]) / 2;   /* inner-edge midpoint */
          out.push({ ax: rx, az: rz, ux: ux, uz: uz, nx: nx, nz: nz, Wedge: Wedge, zlen: zlen, sign: 0, kind: 'resize', title: 'Resize zone depth', wall: wl, slot: sl, geom: g });
        }
      } else {
        out.push({ ax: cx, az: cz, ux: ux, uz: uz, nx: nx, nz: nz, Wedge: Wedge, zlen: zlen, sign: -1, kind: 'kids',  title: 'Kids zone',  wall: wl, slot: sl });
        out.push({ ax: cx, az: cz, ux: ux, uz: uz, nx: nx, nz: nz, Wedge: Wedge, zlen: zlen, sign:  1, kind: 'relax', title: 'Relax zone', wall: wl, slot: sl });
      }
    }
    /* Whirlpool / jacuzzi is now a free-floating draggable handle (like the
       shaft), not a zone button -- see _buildHandleDefs. */
    return out;
  }
  function _refreshZones() {
    if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
    rebuildDragHandles();   /* refresh +/- buttons regardless of what build() does */
    try { refreshInfoBar(); } catch (_) {}   /* recompute banner VOLUME (zones displace water) */
    try { publishBoQToBudget(); } catch (_) {}  /* zones change blocks / concrete / rebar / mesh-surface -> republish the priced BoQ NOW so the TOTAL updates immediately */
  }
  /* brief label flash near a world point -- touch-friendly feedback on insert */
  function _flashZoneLabel(text, ax, az) {
    var container = document.getElementById('cf-base-handles');
    if (!container) return;
    var el = document.createElement('div');
    el.textContent = text;
    var s = el.style;
    s.position = 'absolute'; s.padding = '4px 10px'; s.borderRadius = '6px';
    s.background = 'rgba(20,20,20,.82)'; s.color = '#fff';
    s.font = '700 13px/1 sans-serif'; s.letterSpacing = '.04em';
    s.whiteSpace = 'nowrap'; s.pointerEvents = 'none'; s.zIndex = '41';
    s.transform = 'translate(-50%,-50%)';
    s.transition = 'opacity .3s ease, top .3s ease';
    s.opacity = '0';
    var sc = _worldToScreen(ax, az);
    var top0 = sc ? sc.top : 60;
    s.left = (sc ? sc.left : 0) + 'px';
    s.top = top0 + 'px';
    container.appendChild(el);
    setTimeout(function () { s.opacity = '1'; s.top = (top0 - 16) + 'px'; }, 16);
    setTimeout(function () { s.opacity = '0'; }, 720);
    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 1080);
  }
  function _onZonePlusClick(a) {
    if (a.kind === 'remove') {
      delete _zoneMap()[_zoneKey(a.wall, a.slot)];
      _dbg('zone removed: wall' + a.wall + ' slot' + a.slot);
      _refreshZones();
      return;
    }
    _zoneMap()[_zoneKey(a.wall, a.slot)] = { k: a.kind };
    _flashZoneLabel(a.kind === 'kids' ? 'KIDS ZONE' : 'Relax zone', a.ax, a.az);
    _dbg('zone set: ' + a.kind + ' wall' + a.wall + ' slot' + a.slot);
    _refreshZones();
  }
  function _zoneBtnKey(o) {
    return (o.kind || '') + '|' + (o.wall == null ? '_' : o.wall) + '|' + (o.slot == null ? '_' : o.slot) + '|' + (o.sign || 0);
  }
  function _buildZoneButtons(container) {
    _zoneBtnEls = [];
    if (!container) return;
    var anchors = _zoneButtonAnchors();
    var COLORS = {
      kids: 'rgba(255,140,66,.92)', relax: 'rgba(110,201,110,.92)',
      whirlpool: 'rgba(232,232,232,.95)', remove: 'rgba(40,40,40,.85)'
    };
    for (var i = 0; i < anchors.length; i++) {
      (function (a) {
        if (a.kind === 'resize') {
          var rel = document.createElement('div');
          rel.className = 'cf-zone-resize';
          rel.title = a.title;
          rel.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#2f6fb0" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 7L5 12l4 5M15 7l4 5-4 5"/></svg>';
          var rs = rel.style;
          rs.position = 'absolute'; rs.width = '24px'; rs.height = '24px'; rs.borderRadius = '6px';
          rs.display = 'flex'; rs.alignItems = 'center'; rs.justifyContent = 'center';
          rs.background = '#fff'; rs.border = '2px solid #2f6fb0'; rs.boxShadow = '0 1px 3px rgba(0,0,0,.4)';
          rs.cursor = 'move'; rs.zIndex = '34'; rs.touchAction = 'none';
          rs.pointerEvents = 'auto'; rs.userSelect = 'none';
          _attachZoneResizeDrag(rel, a);
          container.appendChild(rel);
          _zoneBtnEls.push({ el: rel, ax: a.ax, az: a.az, sign: 0, ux: a.ux, uz: a.uz, nx: a.nx, nz: a.nz, Wedge: a.Wedge, zlen: a.zlen, kind: 'resize', wall: a.wall, slot: a.slot, geom: a.geom, hw: 12, hh: 12 });
          return;
        }
        var el = document.createElement('div');
        el.className = 'cf-zone-plus cf-zone-plus-' + a.kind;
        el.title = a.title;
        el.innerHTML = _ZONE_ICONS[a.kind] || '';
        var s = el.style;
        s.position = 'absolute'; s.width = '40px'; s.height = '40px'; s.borderRadius = '50%';
        s.display = 'flex'; s.alignItems = 'center'; s.justifyContent = 'center';
        s.background = COLORS[a.kind] || COLORS.kids;
        s.border = '2px solid #fff'; s.boxShadow = '0 1px 3px rgba(0,0,0,.4)';
        s.cursor = 'pointer'; s.zIndex = '32'; s.touchAction = 'manipulation';
        s.pointerEvents = 'auto'; s.userSelect = 'none';
        el.addEventListener('click', function (ev) { ev.stopPropagation(); _onZonePlusClick(a); });
        container.appendChild(el);
        _zoneBtnEls.push({ el: el, ax: a.ax, az: a.az, sign: a.sign || 0, ux: a.ux, uz: a.uz, nx: a.nx, nz: a.nz, Wedge: a.Wedge, zlen: a.zlen, kind: a.kind, wall: a.wall, slot: a.slot, hw: 20, hh: 20 });
      })(anchors[i]);
    }
  }
  /* Drag the inner edge of a placed zone to set its DEPTH (inward extent); the
     cap and two side edges follow the arm. Clamped [ZONE_MIN_DEPTH, arm room]. */
  function _attachZoneResizeDrag(el, a) {
    var dragging = false, startWorld = null, startD = 0, nx = 0, nz = 0;
    var g = a.geom, arm = g.arm, key = _zoneKey(a.wall, a.slot);
    /* sum of depths of FILLED slots after this one (so they keep fitting) */
    function succDepth() {
      var zmap = _zoneMap(), sum = 0;
      for (var s = a.slot + 1; s < a.slot + 30; s++) {
        var v = zmap[_zoneKey(a.wall, s)]; if (!_zoneKindOf(v)) break;
        var d = _zoneDepthOf(v); sum += (d == null ? ZONE_LEN_M : d);
      }
      return sum;
    }
    el.addEventListener('pointerdown', function (e) {
      if (STATE.view !== '2d') return;
      e.preventDefault(); e.stopPropagation();
      dragging = true; _anyHandleDragging = true;
      try { el.setPointerCapture(e.pointerId); } catch (_) {}
      var eng = global.BaseEngine; if (eng && eng.controls) eng.controls.enabled = false;
      startWorld = _screenToWorld(e.clientX, e.clientY);
      nx = arm.nx; nz = arm.nz;
      var v = _zoneMap()[key]; startD = _zoneDepthOf(v); if (startD == null) startD = ZONE_LEN_M;
    });
    el.addEventListener('pointermove', function (e) {
      if (!dragging || !startWorld) return;
      if (STATE.view !== '2d') { dragging = false; return; }
      var p = _screenToWorld(e.clientX, e.clientY); if (!p) return;
      var along = (p.x - startWorld.x) * nx + (p.z - startWorld.z) * nz;   /* inward = deeper */
      var start = _zoneStartOffset(_zoneMap(), arm, a.wall, a.slot);
      var maxD = arm.armDepth - start - succDepth();
      var dd = startD + along;
      if (dd > maxD) dd = maxD; if (dd < ZONE_MIN_DEPTH) dd = ZONE_MIN_DEPTH;
      var cur = _zoneMap()[key], kind = _zoneKindOf(cur) || 'kids';
      _zoneMap()[key] = { k: kind, d: dd };
      if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
      positionDragHandles();
      try { refreshInfoBar(); } catch (_) {}
      _debouncedPublishBoQ();   /* resizing the zone changes slab / rebar / mesh / surface / blocks -> reprice while dragging */
    });
    function endDrag(e) {
      if (!dragging) return;
      dragging = false; _anyHandleDragging = false;
      try { if (e) el.releasePointerCapture(e.pointerId); } catch (_) {}
      var eng = global.BaseEngine; if (eng && eng.controls) eng.controls.enabled = true;
      try { rebuildDragHandles(); } catch (_) {}
      try { refreshInfoBar(); } catch (_) {}
      try { publishBoQToBudget(); } catch (_) {}   /* final reprice on release -- flush the priced BoQ + TOTAL now */
      if (_ProjectStore && _ProjectStore._initialized) _ProjectStore.publish();
    }
    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointercancel', endDrag);
  }
  function _positionZoneButtons() {
    if (STATE.view !== '2d') {
      for (var i = 0; i < _zoneBtnEls.length; i++) _zoneBtnEls[i].el.style.display = 'none';
      return;
    }
    /* refresh anchors from the CURRENT geometry so icons track a live dimension
       drag in real time; rebuild the DOM only if the set of zones changed. */
    var container = document.getElementById('cf-base-handles');
    var fresh = _zoneButtonAnchors(), fmap = {};
    for (var f = 0; f < fresh.length; f++) fmap[_zoneBtnKey(fresh[f])] = fresh[f];
    var sameSet = (_zoneBtnEls.length === fresh.length);
    if (sameSet) { for (var m = 0; m < _zoneBtnEls.length; m++) { if (!fmap[_zoneBtnKey(_zoneBtnEls[m])]) { sameSet = false; break; } } }
    if (!sameSet && container && !_anyHandleDragging) {
      for (var d = 0; d < _zoneBtnEls.length; d++) { var de = _zoneBtnEls[d].el; if (de && de.parentNode) de.parentNode.removeChild(de); }
      _buildZoneButtons(container);
    }
    for (var u = 0; u < _zoneBtnEls.length; u++) {
      var bu = _zoneBtnEls[u], fa = fmap[_zoneBtnKey(bu)];
      if (fa) { bu.ax = fa.ax; bu.az = fa.az; bu.ux = fa.ux; bu.uz = fa.uz; bu.nx = fa.nx; bu.nz = fa.nz; bu.Wedge = fa.Wedge; bu.zlen = fa.zlen; }
    }
    if (!_zoneBtnEls.length) return;
    var EPS = 0.1, ICON_MIN = 44, PAIR_LONG_MIN = 92;   /* px the slot must span to show the 40px icon(s) */
    for (var j = 0; j < _zoneBtnEls.length; j++) {
      var b = _zoneBtnEls[j];
      var sC = _worldToScreen(b.ax, b.az);
      if (!sC) { b.el.style.display = 'none'; continue; }
      var sE = _worldToScreen(b.ax + b.ux * EPS, b.az + b.uz * EPS);
      var sN = _worldToScreen(b.ax + b.nx * EPS, b.az + b.nz * EPS);
      var evx = (sE.left - sC.left) / EPS, evy = (sE.top - sC.top) / EPS;
      var nvx = (sN.left - sC.left) / EPS, nvy = (sN.top - sC.top) / EPS;
      var eLen = Math.hypot(evx, evy) || 1, nLen = Math.hypot(nvx, nvy) || 1;
      var wS = eLen * b.Wedge, hS = nLen * b.zlen;
      var longS = Math.max(wS, hS), shortS = Math.min(wS, hS);
      if (b.kind !== 'resize' && (shortS < ICON_MIN || longS < (b.sign ? PAIR_LONG_MIN : ICON_MIN))) {
        b.el.style.display = 'none'; continue;
      }
      var dx = 0, dy = 0;
      if (b.sign) {
        var vx, vy, L;
        if (hS > wS) { vx = nvx; vy = nvy; L = nLen; }
        else { vx = evx; vy = evy; L = eLen; }
        dx = b.sign * ZONE_BTN_OFF * vx / L;
        dy = b.sign * ZONE_BTN_OFF * vy / L;
      }
      var chw = (b.hw == null ? 20 : b.hw), chh = (b.hh == null ? 20 : b.hh);
      b.el.style.left = (sC.left + dx - chw) + 'px';
      b.el.style.top  = (sC.top  + dy - chh) + 'px';
      if (b.kind === 'resize') b.el.style.transform = 'rotate(' + Math.atan2(nvy, nvx) + 'rad)';
      b.el.style.display = 'flex';
    }
  }

  function rebuildDragHandles() {
    var container = document.getElementById('cf-base-handles');
    if (!container) return;
    container.innerHTML = '';
    _handleEls = [];

    var poly = getFootprintPolygon();
    var defs = _buildHandleDefs(poly);

    for (var i = 0; i < defs.length; i++) {
      var def = defs[i];
      var el = document.createElement('div');
      el.className = 'cf-base-handle cf-base-handle-' + def.type;
      el.setAttribute('data-handle-index', String(i));
      if (def.type === 'shaft') {
        el.title = 'Technology shaft';
        el.style.position = 'absolute';
        el.style.boxSizing = 'border-box';
        el.style.width = '36px';
        el.style.height = '36px';
        el.style.background = 'transparent';
        el.style.border = 'none';
        el.style.borderRadius = '0';
        el.style.boxShadow = 'none';
        el.style.outline = 'none';
        el.style.transform = 'none';
        el.style.margin = '0';
        el.style.padding = '0';
        el.style.cursor = 'grab';
        el.style.zIndex = '32';
        el.style.touchAction = 'none';
        el.style.pointerEvents = 'auto';
        el.style.userSelect = 'none';
        el.innerHTML = '<img src="' + _TECH_ICON_URL + '" style="width:100%;height:100%;object-fit:contain;object-position:center;display:block;pointer-events:none" alt="">';
      } else if (def.type === 'whirlpool') {
        el.title = 'Jacuzzi (placeholder)';
        el.style.position = 'absolute';
        el.style.boxSizing = 'border-box';
        el.style.width = '36px';
        el.style.height = '36px';
        el.style.background = 'transparent';
        el.style.border = 'none';
        el.style.borderRadius = '0';
        el.style.boxShadow = 'none';
        el.style.outline = 'none';
        el.style.transform = 'none';
        el.style.margin = '0';
        el.style.padding = '0';
        el.style.cursor = 'grab';
        el.style.zIndex = '32';
        el.style.touchAction = 'none';
        el.style.pointerEvents = 'auto';
        el.style.userSelect = 'none';
        el.innerHTML = '<img src="' + _JACUZZI_ICON_URL + '" style="width:100%;height:100%;object-fit:contain;object-position:center;display:block;pointer-events:none" alt="">';
      } else if (def.type === 'tank') {
        el.title = 'Overflow balance tank \u2014 drag to move';
        el.style.position = 'absolute';
        el.style.width = '16px';
        el.style.height = '16px';
        el.style.borderRadius = '3px';
        el.style.background = '#2f6fb0';      /* water-tank blue */
        el.style.border = '2px solid #fff';
        el.style.boxShadow = '0 1px 3px rgba(0,0,0,.4)';
        el.style.cursor = 'grab';
        el.style.zIndex = '30';
        el.style.touchAction = 'none';
        el.style.pointerEvents = 'auto';
      } else if (def.type === 'panel') {
        el.title = 'Electrical panel \u2014 drag to move';
        el.style.position = 'absolute';
        el.style.width = '14px';
        el.style.height = '14px';
        el.style.borderRadius = '3px';
        el.style.background = '#f2f2f2';      /* white cabinet */
        el.style.border = '2px solid #555';
        el.style.boxShadow = '0 1px 3px rgba(0,0,0,.4)';
        el.style.cursor = 'grab';
        el.style.zIndex = '30';
        el.style.touchAction = 'none';
        el.style.pointerEvents = 'auto';
      } else if (def.type === 'skimmer' || def.type === 'jet') {
        el.title = (def.type === 'skimmer' ? 'Skimmer' : 'Return jet') + ' \u2014 drag to move';
        el.style.position = 'absolute';
        if (def.type === 'skimmer') {
          el.style.width = '30px';   /* 6:1 */
          el.style.height = '5px';
        } else {
          el.style.width = '10px';   /* 2:1 */
          el.style.height = '5px';
        }
        el.style.background = (def.type === 'jet') ? '#000000' : '#ffffff';
        el.style.border = 'none';
        el.style.boxShadow = '0 0 0 1px rgba(0,0,0,.25)';
        el.style.cursor = 'grab';
        el.style.zIndex = '30';
        el.style.touchAction = 'none';
        el.style.pointerEvents = 'auto';
      } else if (def.type === 'light') {
        el.title = 'Pool light \u2014 drag to move';
        el.style.position = 'absolute';
        el.style.width = '12px';
        el.style.height = '12px';
        el.style.borderRadius = '50%';
        el.style.background = '#ffd11a';      /* yellow */
        el.style.border = 'none';
        el.style.boxShadow = '0 0 4px 1px rgba(255,200,20,.8)';
        el.style.cursor = 'grab';
        el.style.zIndex = '30';
        el.style.touchAction = 'none';
        el.style.pointerEvents = 'auto';
      } else if (def.type === 'corner') {
        /* Corner size handles -- LEVA olive, ~60% size. Edge (mid-wall) handles
           keep their original light-brown CSS styling. positionDragHandles
           offsets left/top by -6 (for the default ~12px handle); we add a
           margin to re-centre the smaller dot on the corner. */
        el.style.background = '#5A6B47';
        el.style.borderColor = '#5A6B47';
        el.style.width = '10px';
        el.style.height = '10px';
        el.style.boxSizing = 'border-box';
        el.style.marginLeft = '2px';
        el.style.marginTop = '2px';
      }
      el.style.display = 'none';
      container.appendChild(el);
      _attachHandleDrag(el, def);
      _handleEls.push({ el: el, def: def });
    }
    _buildZoneButtons(container);
    positionDragHandles();
  }

  function _buildHandleDefs(poly) {
    var defs = [];
    var n = poly ? poly.length : 0;
    for (var i = 0; i < n; i++) {
      defs.push({ type: 'corner', vertexIndex: i });
    }
    for (var i = 0; i < n; i++) {
      defs.push({ type: 'edge', edgeIndex: i });
    }
    defs.push({ type: 'shaft' });          /* draggable technology-shaft handle */
    defs.push({ type: 'whirlpool' });      /* draggable jacuzzi placeholder (independent of pool shape) */
    defs.push({ type: 'panel' });          /* draggable electrical-panel handle */
    if (getEdgeType() === 'overflow' || getEdgeType() === 'infinite') {
      defs.push({ type: 'tank' });         /* balance/retention tank (overflow + infinite) */
    }
    var sk = getSkimmerPositions();
    for (var si = 0; si < sk.length; si++) defs.push({ type: 'skimmer', idx: si });
    var jt = getJetPositions();
    for (var ji = 0; ji < jt.length; ji++) defs.push({ type: 'jet', idx: ji });
    var li = getLightPositions();
    for (var lk = 0; lk < li.length; lk++) defs.push({ type: 'light', idx: lk });
    return defs;
  }

  function _clampCoord(v) {
    if (v >  MAX_COORD) return  MAX_COORD;
    if (v < -MAX_COORD) return -MAX_COORD;
    return v;
  }

  function _worldToScreen(x, z) {
    var eng = global.BaseEngine;
    if (!eng || !eng.camera || !eng.renderer) return null;
    var T = global.THREE;
    if (!T) return null;
    var v = new T.Vector3(x, 0, z);
    v.project(eng.camera);
    var canvasRect = eng.renderer.domElement.getBoundingClientRect();
    var parent = document.getElementById('cf-wrap-base');
    var parentRect = parent ? parent.getBoundingClientRect() : { left: 0, top: 0 };
    return {
      left: (canvasRect.left - parentRect.left) + ((v.x + 1) / 2) * canvasRect.width,
      top:  (canvasRect.top  - parentRect.top)  + ((1 - (v.y + 1) / 2)) * canvasRect.height,
      depth: v.z
    };
  }

  function _screenToWorld(clientX, clientY) {
    var eng = global.BaseEngine;
    if (!eng || !eng.camera || !eng.renderer) return null;
    var T = global.THREE;
    if (!T) return null;
    var rect = eng.renderer.domElement.getBoundingClientRect();
    var ndc = new T.Vector2(
      ((clientX - rect.left) / rect.width)  * 2 - 1,
      -((clientY - rect.top)  / rect.height) * 2 + 1
    );
    var ray = new T.Raycaster();
    ray.setFromCamera(ndc, eng.camera);
    var plane = new T.Plane(new T.Vector3(0, 1, 0), 0);
    var p = new T.Vector3();
    ray.ray.intersectPlane(plane, p);
    return p ? { x: p.x, z: p.z } : null;
  }

  function positionDragHandles() {
    _InfinityEdgeLines.update();                       /* self-hides outside 2D + infinite */
    _positionZoneButtons();                            /* self-hides outside 2D */
    if (STATE.view !== '2d') {
      for (var i = 0; i < _handleEls.length; i++) {
        _handleEls[i].el.style.display = 'none';
      }
      return;
    }
    var poly = getFootprintPolygon();
    var n = poly.length;
    for (var i = 0; i < _handleEls.length; i++) {
      var h = _handleEls[i];
      var def = h.def;
      var wx = 0, wz = 0;
      if (def.type === 'corner') {
        wx = poly[def.vertexIndex][0];
        wz = poly[def.vertexIndex][1];
      } else if (def.type === 'edge') {
        var a = poly[def.edgeIndex];
        var b = poly[(def.edgeIndex + 1) % n];
        wx = (a[0] + b[0]) / 2;
        wz = (a[1] + b[1]) / 2;
      } else if (def.type === 'shaft') {
        try { var sp = getShaftPos(); wx = sp.x; wz = sp.z; } catch (_) { continue; }
      } else if (def.type === 'whirlpool') {
        try { var wpp = getWhirlpoolPos(); wx = wpp.x; wz = wpp.z; } catch (_) { continue; }
      } else if (def.type === 'tank') {
        var _tet = getEdgeType();
        if (_tet !== 'overflow' && _tet !== 'infinite') { h.el.style.display = 'none'; continue; }
        try { var tp = getTankPos(); wx = tp.x; wz = tp.z; } catch (_) { continue; }
      } else if (def.type === 'panel') {
        try { var pp = getPanelPos(); wx = pp.x; wz = pp.z; } catch (_) { continue; }
      } else if (def.type === 'skimmer') {
        try { var sks = getSkimmerPositions(); if (!sks[def.idx]) { h.el.style.display = 'none'; continue; } wx = sks[def.idx].x; wz = sks[def.idx].z; } catch (_) { h.el.style.display = 'none'; continue; }
      } else if (def.type === 'jet') {
        try { var jts = getJetPositions(); if (!jts[def.idx]) { h.el.style.display = 'none'; continue; } wx = jts[def.idx].x; wz = jts[def.idx].z; } catch (_) { h.el.style.display = 'none'; continue; }
      } else if (def.type === 'light') {
        try { var lts = getLightPositions(); if (!lts[def.idx]) { h.el.style.display = 'none'; continue; } wx = lts[def.idx].x; wz = lts[def.idx].z; } catch (_) { h.el.style.display = 'none'; continue; }
      }
      var s = _worldToScreen(wx, wz);
      if (!s) continue;
      h.el.style.left = (s.left - 6) + 'px';
      h.el.style.top  = (s.top  - 6) + 'px';
      /* Orient skimmer/jet handles so their long side runs along the nearest
         inner wall -- compute the edge angle in SCREEN space. */
      if (def.type === 'skimmer' || def.type === 'jet') {
        try {
          /* Re-centre by the handle's real size (the -6 default is for ~12px
             square corner handles) and rotate along the nearest wall. */
          var hw = (def.type === 'skimmer') ? 30 : 10, hh = 5;
          h.el.style.left = (s.left - hw / 2) + 'px';
          h.el.style.top  = (s.top  - hh / 2) + 'px';
          var ring = _innerRing();
          if (ring && ring.length >= 2) {
            var pe = _projectToInnerEdge(wx, wz).edge;   /* same edge the snap uses */
            var A = ring[pe], B = ring[(pe + 1) % ring.length];
            var sa = _worldToScreen(A[0], A[1]), sb = _worldToScreen(B[0], B[1]);
            if (sa && sb) {
              var ang = Math.atan2(sb.top - sa.top, sb.left - sa.left) * 180 / Math.PI;
              h.el.style.transformOrigin = 'center center';
              h.el.style.transform = 'rotate(' + ang + 'deg)';
            }
          }
        } catch (_) {}
      } else if (def.type === 'light') {
        h.el.style.left = (s.left - 6) + 'px';   /* 12px round, centre on point */
        h.el.style.top  = (s.top  - 6) + 'px';
      } else if (def.type === 'shaft' || def.type === 'whirlpool') {
        /* Scale the 36px icon to fit its shape when zoomed out (so it does not
           overflow) but NEVER hide it -- the shaft/whirlpool must stay
           drag-and-drop at ANY zoom. Floor keeps the handle grabbable on touch. */
        var _hScale = 1;
        try {
          var _fsz = (def.type === 'shaft') ? getShaftSize() : { w: 2.0, l: 2.0 };
          var _hw2 = _fsz.w / 2, _hl2 = _fsz.l / 2;
          var _p0 = _worldToScreen(wx - _hw2, wz - _hl2);
          var _p1 = _worldToScreen(wx + _hw2, wz - _hl2);
          var _p3 = _worldToScreen(wx - _hw2, wz + _hl2);
          if (_p0 && _p1 && _p3) {
            var _swid = Math.hypot(_p1.left - _p0.left, _p1.top - _p0.top);
            var _shei = Math.hypot(_p3.left - _p0.left, _p3.top - _p0.top);
            var _minSide = Math.min(_swid, _shei);
            if (_minSide < 72) _hScale = Math.max(0.5, _minSide / 72);
          }
        } catch (_zoErr) {}
        h.el.style.transformOrigin = 'center center';
        h.el.style.transform = (_hScale !== 1) ? ('scale(' + _hScale.toFixed(3) + ')') : 'none';
        h.el.style.left = (s.left - 18) + 'px';        /* 36px element -> half = 18 */
        h.el.style.top  = (s.top  - 18) + 'px';
      }
      h.el.style.display = 'block';
    }
  }

  /* -- Infinity edge selector (2D only) ------------------------------
     A faint line offset just outside each footprint edge. Tap it to toggle
     that edge between vanishing/overflow (ON, full) and skimmer (OFF, faded).
     Only shown in 2D + infinite mode; never rendered in 3D. */
  var _InfinityEdgeLines = {
    els: [],
    LINE_H: 6,
    OFFSET: 0.75,                                  /* world metres outside the edge (marker, not the actual placement) */
    END_GAP: 0.45,                                 /* world metres trimmed at each corner, so markers don't touch */
    _ensure: function (n) {
      var parent = document.getElementById('cf-wrap-base');
      if (!parent) return;
      while (this.els.length < n) {
        var d = document.createElement('div');
        d.className = 'cf-infinity-edge';
        var self = this, idx = this.els.length;
        d.addEventListener('pointerdown', function (e) { e.preventDefault(); e.stopPropagation(); });
        d.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var ei = this._edgeIndex;
          if (typeof ei === 'number') toggleInfiniteEdge(ei);
        });
        parent.appendChild(d);
        this.els.push({ el: d });
      }
      while (this.els.length > n) {
        var x = this.els.pop();
        if (x.el.parentNode) x.el.parentNode.removeChild(x.el);
      }
    },
    update: function () {
      var show = (STATE.view === '2d' && getEdgeType() === 'infinite');
      var poly = getFootprintPolygon();
      if (!show || !poly || poly.length < 3) {
        for (var k = 0; k < this.els.length; k++) this.els[k].el.style.display = 'none';
        return;
      }
      var n = poly.length;
      this._ensure(n);
      if (this.els.length < n) return;                 /* container not ready yet */
      var area = 0, i;
      for (i = 0; i < n; i++) { var a0 = poly[i], b0 = poly[(i + 1) % n]; area += a0[0] * b0[1] - b0[0] * a0[1]; }
      var ccw = area > 0;
      var onEdges = getInfiniteEdges();
      for (i = 0; i < n; i++) {
        var o = this.els[i]; if (!o) continue; o.el._edgeIndex = i;
        var A = poly[i], B = poly[(i + 1) % n];
        var dx = B[0] - A[0], dz = B[1] - A[1], L = Math.hypot(dx, dz) || 1;
        var ux = dx / L, uz = dz / L;
        var nx = ccw ? uz : -uz, nz = ccw ? -ux : ux;   /* outward normal */
        /* trim the marker in from both corners so adjacent edge markers have a
           clear gap between them; skip very short edges */
        var gap = Math.min(this.END_GAP, L * 0.35);
        var A2x = A[0] + ux * gap, A2z = A[1] + uz * gap;
        var B2x = B[0] - ux * gap, B2z = B[1] - uz * gap;
        var sa = _worldToScreen(A2x + nx * this.OFFSET, A2z + nz * this.OFFSET);
        var sb = _worldToScreen(B2x + nx * this.OFFSET, B2z + nz * this.OFFSET);
        if (!sa || !sb) { o.el.style.display = 'none'; continue; }
        var px = sb.left - sa.left, py = sb.top - sa.top;
        var len = Math.hypot(px, py), ang = Math.atan2(py, px) * 180 / Math.PI;
        var on = onEdges.indexOf(i) >= 0;
        o.el.style.display = 'block';
        o.el.style.left = sa.left + 'px';
        o.el.style.top  = (sa.top - this.LINE_H / 2) + 'px';
        o.el.style.width = len + 'px';
        o.el.style.transformOrigin = '0 50%';
        o.el.style.transform = 'rotate(' + ang + 'deg)';
        o.el.classList.toggle('cf-infinity-on', on);
        o.el.classList.toggle('cf-infinity-off', !on);
      }
    }
  };

  /* Open a storefront product page in the correct locale. Prefers Shopify's
     localized root (e.g. /en-gb/), else derives a locale prefix from the
     current path, else falls back to the plain /products/ path. Opens a new
     tab so the configurator's work isn't lost. */
  function _openProductPage(handle) {
    var url = '/products/' + handle;
    try {
      if (global.Shopify && Shopify.routes && Shopify.routes.root_url) {
        url = Shopify.routes.root_url.replace(/\/+$/, '') + '/products/' + handle;
      } else {
        var m = (global.location && global.location.pathname || '').match(/^(\/[a-z]{2}(?:-[a-z0-9]{2,})?)\/products(?:\/|$)/i);
        if (m) url = m[1] + '/products/' + handle;
      }
    } catch (_) {}
    try { global.open(url, '_blank'); } catch (_) { try { global.location.href = url; } catch (__) {} }
  }

  function _attachHandleDrag(el, def) {
    var dragging = false;
    var startWorld = null;
    var startState = null;
    var startPoly = null;
    var downX = 0, downY = 0, moved = false;   /* tap (no drag) detection */

    el.addEventListener('pointerdown', function (e) {
      if (STATE.view !== '2d') return;
      e.preventDefault();
      dragging = true;
      _anyHandleDragging = true;
      downX = e.clientX; downY = e.clientY; moved = false;
      try { el.setPointerCapture(e.pointerId); } catch (_) {}
      el.style.cursor = 'grabbing';
      var eng = global.BaseEngine;
      if (eng && eng.controls) eng.controls.enabled = false;
      startWorld = _screenToWorld(e.clientX, e.clientY);
      startState = JSON.parse(JSON.stringify(STATE.polygon));
      startPoly = getFootprintPolygon();
      _shaftDragStart = (def.type === 'shaft') ? getShaftPos() : null;
      _whirlDragStart = (def.type === 'whirlpool') ? getWhirlpoolPos() : null;
      _tankDragStart  = (def.type === 'tank')  ? getTankPos()  : null;
      _panelDragStart = (def.type === 'panel') ? getPanelPos() : null;
      _fittingDragStart = null;
      if (def.type === 'skimmer') { var sks = getSkimmerPositions(); if (sks[def.idx]) _fittingDragStart = { x: sks[def.idx].x, z: sks[def.idx].z }; }
      if (def.type === 'jet')     { var jts = getJetPositions();     if (jts[def.idx]) _fittingDragStart = { x: jts[def.idx].x, z: jts[def.idx].z }; }
      if (def.type === 'light')   { var lts = getLightPositions();   if (lts[def.idx]) _fittingDragStart = { x: lts[def.idx].x, z: lts[def.idx].z }; }
      /* Baseline for proportional remap during a resize (corner/edge) drag. */
      if (def.type === 'corner' || def.type === 'edge') {
        _fittingsResizeStart = {
          poly: JSON.parse(JSON.stringify(getFootprintPolygon())),
          skimmers: Array.isArray(STATE.skimmers) ? JSON.parse(JSON.stringify(STATE.skimmers)) : null,
          jets:     Array.isArray(STATE.jets)     ? JSON.parse(JSON.stringify(STATE.jets))     : null,
          lights:   Array.isArray(STATE.lights)   ? JSON.parse(JSON.stringify(STATE.lights))   : null
        };
      } else {
        _fittingsResizeStart = null;
      }
    });

    el.addEventListener('pointermove', function (e) {
      if (!dragging || !startWorld) return;
      if (STATE.view !== '2d') { dragging = false; return; }
      var p = _screenToWorld(e.clientX, e.clientY);
      if (!p) return;
      if (Math.abs(e.clientX - downX) > 4 || Math.abs(e.clientY - downY) > 4) moved = true;
      var dx = p.x - startWorld.x;
      var dz = p.z - startWorld.z;
      _applyHandleDelta(def, dx, dz, startState);
      if (def.type === 'shaft' || def.type === 'whirlpool' || def.type === 'tank' || def.type === 'panel' || def.type === 'skimmer' || def.type === 'jet' || def.type === 'light') {
        /* Light path: just rebuild the scene and reposition handles -- no
           dimension labels / BoQ publish on every move. */
        if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
        positionDragHandles();
      } else {
        /* Resize drag: remap fittings proportionally from the drag-start
           baseline to the current polygon (same edge, same t). */
        if (_fittingsResizeStart) {
          if (_fittingsResizeStart.skimmers) STATE.skimmers = JSON.parse(JSON.stringify(_fittingsResizeStart.skimmers));
          if (_fittingsResizeStart.jets)     STATE.jets     = JSON.parse(JSON.stringify(_fittingsResizeStart.jets));
          if (_fittingsResizeStart.lights)   STATE.lights   = JSON.parse(JSON.stringify(_fittingsResizeStart.lights));
          _remapFittingsProportional(_fittingsResizeStart.poly, getFootprintPolygon());
          try {
            var nowInner = _innerRing();
            if (nowInner && nowInner.length >= 3) {
              var ns = _skimmerCount(nowInner), nj = _jetCount(nowInner), nl = _lightCount(nowInner);
              if (Array.isArray(STATE.skimmers) && STATE.skimmers.length > ns) STATE.skimmers = STATE.skimmers.slice(0, ns);
              if (Array.isArray(STATE.jets)     && STATE.jets.length     > nj) STATE.jets     = STATE.jets.slice(0, nj);
              if (Array.isArray(STATE.lights)   && STATE.lights.length   > nl) STATE.lights   = STATE.lights.slice(0, nl);
            }
          } catch (_) {}
        }
        refreshUI();
        var nowPoly = getFootprintPolygon();
        _showEdgeDimensionLabels(_changingEdges(nowPoly, startPoly));
      }
    });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      _anyHandleDragging = false;
      try { if (e) el.releasePointerCapture(e.pointerId); } catch (_) {}
      var eng = global.BaseEngine;
      if (eng && eng.controls) eng.controls.enabled = true;
      _hideAllEdgeLabels();
      if (startState) _UndoHistory.pushIfChanged(startState, STATE.variant);
      startState = null;
      _fittingsResizeStart = null;
      if (def.type === 'skimmer' || def.type === 'jet' || def.type === 'light') {
        /* On drop: keep >=0.5 m from the corners of the edge. */
        var arr = (def.type === 'skimmer') ? STATE.skimmers : (def.type === 'jet') ? STATE.jets : STATE.lights;
        if (arr && arr[def.idx]) {
          var c = _clampAwayFromCorners(arr[def.idx].x, arr[def.idx].z, 0.5);
          arr[def.idx].x = c.x; arr[def.idx].z = c.z;
        }
        el.style.cursor = 'grab';
        refreshUI();
        if (_ProjectStore && _ProjectStore._initialized) _ProjectStore.publish();
      } else if (def.type === 'shaft' || def.type === 'whirlpool' || def.type === 'tank' || def.type === 'panel') {
        el.style.cursor = 'grab';
        if (_ProjectStore && _ProjectStore._initialized) _ProjectStore.publish();
      } else {
        /* Resize drop: corner-clamp every fitting, then rebuild handles. */
        try {
          if (Array.isArray(STATE.skimmers)) STATE.skimmers = STATE.skimmers.map(function (p) { return _clampAwayFromCorners(p.x, p.z, 0.5); });
          if (Array.isArray(STATE.jets))     STATE.jets     = STATE.jets.map(function (p) { return _clampAwayFromCorners(p.x, p.z, 0.5); });
        } catch (_) {}
        try { rebuildDragHandles(); } catch (_) {}
        refreshUI();
      }
      /* A tap (no real drag) opens that placeholder's product page in the
         correct locale; dragging still just moves the object. */
      if (!moved && def.type === 'shaft')     _openProductPage('shaft');
      if (!moved && def.type === 'whirlpool') _openProductPage('jacuzzi');
    }
    el.addEventListener('pointerup',     endDrag);
    el.addEventListener('pointercancel', endDrag);
    el._forceEndDrag = function () {
      if (!dragging) return;
      dragging = false;
      _anyHandleDragging = false;
      var eng = global.BaseEngine;
      if (eng && eng.controls) eng.controls.enabled = true;
      _hideAllEdgeLabels();
      if (startState) _UndoHistory.pushIfChanged(startState, STATE.variant);
      startState = null;
    };
  }

  function _resetAllHandleDrags() {
    for (var i = 0; i < _handleEls.length; i++) {
      var hel = _handleEls[i] && _handleEls[i].el;
      if (hel && hel._forceEndDrag) hel._forceEndDrag();
    }
    var widget = document.getElementById('cf-budget-widget');
    if (widget && widget._forceEndDrag) widget._forceEndDrag();
  }

  function _changingEdges(currentPoly, startPoly) {
    if (!currentPoly || !startPoly) return [];
    if (currentPoly.length !== startPoly.length) return [];
    var changed = [];
    var n = currentPoly.length;
    for (var i = 0; i < n; i++) {
      var ca = currentPoly[i], cb = currentPoly[(i + 1) % n];
      var sa = startPoly[i],   sb = startPoly[(i + 1) % n];
      var clen = Math.hypot(cb[0] - ca[0], cb[1] - ca[1]);
      var slen = Math.hypot(sb[0] - sa[0], sb[1] - sa[1]);
      if (Math.abs(clen - slen) > 0.0001) changed.push(i);
    }
    return changed;
  }

  function _applyHandleDelta(def, dx, dz, s0) {
    var poly = STATE.polygon;
    if (!poly || !poly.length) return;
    var n = s0.length;
    if (def.type === 'corner') {
      var i = def.vertexIndex;
      if (i < 0 || i >= n) return;
      var nx = snap(s0[i][0] + dx);
      var nz = snap(s0[i][1] + dz);
      poly[i][0] = _clampCoord(nx);
      poly[i][1] = _clampCoord(nz);
    } else if (def.type === 'edge') {
      var ei = def.edgeIndex;
      if (ei < 0 || ei >= n) return;
      var a = s0[ei];
      var b = s0[(ei + 1) % n];
      var edx = b[0] - a[0], edz = b[1] - a[1];
      var len = Math.hypot(edx, edz);
      if (len < 1e-6) return;
      var nrmX = -edz / len, nrmZ = edx / len;
      /* Snap the DRAG DISTANCE along the edge normal (not the absolute x/z of
         each endpoint). Both endpoints then move by the same vector, so the
         edge stays parallel and the shared corners never drift along the edge
         (which previously skewed the neighbouring edges when the start coords
         were off the snap grid). */
      var proj = snap(dx * nrmX + dz * nrmZ);
      poly[ei][0] = _clampCoord(a[0] + proj * nrmX);
      poly[ei][1] = _clampCoord(a[1] + proj * nrmZ);
      poly[(ei + 1) % n][0] = _clampCoord(b[0] + proj * nrmX);
      poly[(ei + 1) % n][1] = _clampCoord(b[1] + proj * nrmZ);
    } else if (def.type === 'shaft') {
      var st = _shaftDragStart || getShaftPos();
      setShaftPos(_clampCoord(snap(st.x + dx)), _clampCoord(snap(st.z + dz)));
    } else if (def.type === 'whirlpool') {
      var wst = _whirlDragStart || getWhirlpoolPos();
      setWhirlpoolPos(_clampCoord(snap(wst.x + dx)), _clampCoord(snap(wst.z + dz)));
    } else if (def.type === 'tank') {
      var tst = _tankDragStart || getTankPos();
      setTankPos(_clampCoord(snap(tst.x + dx)), _clampCoord(snap(tst.z + dz)));
    } else if (def.type === 'panel') {
      var pst = _panelDragStart || getPanelPos();
      setPanelPos(_clampCoord(snap(pst.x + dx)), _clampCoord(snap(pst.z + dz)));
    } else if (def.type === 'skimmer' || def.type === 'jet' || def.type === 'light') {
      var fs = _fittingDragStart;
      if (!fs) return;
      var rawX = _clampCoord(fs.x + dx), rawZ = _clampCoord(fs.z + dz);
      var locked = _projectToInnerEdge(rawX, rawZ);        /* snap to water<->coping edge */
      var safe = _clampAwayFromStairs(locked.x, locked.z, 0.10, locked.edge); /* clear stairs on that edge only */
      var arr = (def.type === 'skimmer') ? STATE.skimmers : (def.type === 'jet') ? STATE.jets : STATE.lights;
      if (arr && arr[def.idx]) { arr[def.idx].x = safe.x; arr[def.idx].z = safe.z; }
    }
  }

  var _edgeLabels = [];
  var _edgeLabelCssInjected = false;

  function _injectEdgeLabelCSS() {
    if (_edgeLabelCssInjected) return;
    _edgeLabelCssInjected = true;
    var css = '#cf-wrap-base .cf-base-dim-label {' +
              '  position: absolute; z-index: 12;' +
              '  background: rgba(20,20,20,0.92); color: #fff;' +
              '  font: 700 11px/1.2 Montserrat, -apple-system, sans-serif;' +
              '  padding: 4px 8px; border-radius: 6px;' +
              '  letter-spacing: 0.02em; white-space: nowrap;' +
              '  pointer-events: none;' +
              '  transform: translate(-50%, -50%);' +
              '  box-shadow: 0 2px 6px rgba(0,0,0,0.25);' +
              '}';
    var style = document.createElement('style');
    style.id = 'cf-base-dim-label-css';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  function _ensureEdgeLabelPool(n) {
    _injectEdgeLabelCSS();
    var parent = document.getElementById('cf-wrap-base');
    if (!parent) return;
    while (_edgeLabels.length < n) {
      var el = document.createElement('div');
      el.className = 'cf-base-dim-label';
      el.style.display = 'none';
      parent.appendChild(el);
      _edgeLabels.push(el);
    }
  }

  function _hideAllEdgeLabels() {
    for (var i = 0; i < _edgeLabels.length; i++) {
      _edgeLabels[i].style.display = 'none';
    }
  }

  function _showEdgeDimensionLabels(activeEdgeIndices) {
    var poly = getFootprintPolygon();
    if (!poly || !poly.length) { _hideAllEdgeLabels(); return; }
    var n = poly.length;
    _ensureEdgeLabelPool(n);

    for (var i = 0; i < n; i++) {
      var label = _edgeLabels[i];
      if (activeEdgeIndices.indexOf(i) === -1) {
        label.style.display = 'none';
        continue;
      }
      var a = poly[i];
      var b = poly[(i + 1) % n];
      var mx = (a[0] + b[0]) / 2;
      var mz = (a[1] + b[1]) / 2;
      var dx = b[0] - a[0];
      var dz = b[1] - a[1];
      var lenWorld = Math.sqrt(dx * dx + dz * dz);
      label.textContent = fmtDim(lenWorld);

      var ms = _worldToScreen(mx, mz);
      if (!ms) { label.style.display = 'none'; continue; }

      var nlen = Math.sqrt(dx * dx + dz * dz);
      var nxW, nzW;
      if (nlen < 1e-6) {
        nxW = 0; nzW = -1;
      } else {
        nxW = -dz / nlen;
        nzW =  dx / nlen;
      }
      var probe = 0.02;
      if (_pointInPolygonOrBoundary(mx + nxW * probe, mz + nzW * probe, poly)) {
        nxW = -nxW; nzW = -nzW;
      }
      var probeS = _worldToScreen(mx + nxW * probe, mz + nzW * probe);
      var sx, sy, slen;
      if (probeS) {
        sx = probeS.left - ms.left;
        sy = probeS.top  - ms.top;
        slen = Math.sqrt(sx * sx + sy * sy);
        if (slen < 0.001) { sx = 0; sy = -1; slen = 1; }
      } else {
        sx = 0; sy = -1; slen = 1;
      }
      var off = 26;
      var lx = ms.left + (sx / slen) * off;
      var ly = ms.top  + (sy / slen) * off;

      label.style.display = 'block';
      label.style.left = lx + 'px';
      label.style.top  = ly + 'px';
    }
  }

  function _startBudgetWidgetSync() {
    var dstTotal    = document.getElementById('cf-bw-total');
    var dstMaterial = document.getElementById('cf-bw-material');
    var dstExec     = document.getElementById('cf-bw-execution');
    var dstTime     = document.getElementById('cf-bw-time');
    var dstCapacity = document.getElementById('cf-bw-capacity');

    function refresh() {
      var srcTotal    = document.querySelector('[data-budget-total-cost]');
      var srcMaterial = document.querySelector('[data-budget-total-material]');
      var srcExec     = document.querySelector('[data-budget-total-execution]');
      var srcTime     = document.querySelector('[data-budget-total-time]');

      var totalText    = (srcTotal    && srcTotal.textContent)    ? srcTotal.textContent.trim()    : '';
      var materialText = (srcMaterial && srcMaterial.textContent) ? srcMaterial.textContent.trim() : '';
      var execText     = (srcExec     && srcExec.textContent)     ? srcExec.textContent.trim()     : '';
      var timeText     = (srcTime     && srcTime.textContent)     ? srcTime.textContent.trim()     : '';

      var needFallback = (!totalText || totalText === '\u2014' || !materialText || materialText === '\u2014');
      if (needFallback) {
        var matVal  = (typeof global.lastMaterialsTotal === 'number') ? global.lastMaterialsTotal : null;
        var execVal = (typeof global.lastDeliveryTotal  === 'number') ? global.lastDeliveryTotal  : null;
        if (matVal !== null || execVal !== null) {
          var fmt = (typeof global.formatPrice === 'function')
            ? global.formatPrice
            : function (n) { return '$' + Math.round(n || 0); };
          var m = matVal  || 0;
          var e = execVal || 0;
          if (!totalText    || totalText    === '\u2014') totalText    = fmt(m + e);
          if (!materialText || materialText === '\u2014') materialText = fmt(m);
          if (!execText     || execText     === '\u2014') execText     = fmt(e);
        }
      }

      if (dstTotal    && totalText)    dstTotal.textContent    = totalText;
      if (dstMaterial && materialText) dstMaterial.textContent = materialText;
      if (dstExec     && execText)     dstExec.textContent     = execText;
      if (dstTime     && timeText)     dstTime.textContent     = timeText;

      if (dstCapacity) {
        var rows = computeBoQ();
        var excM = 0, excY = 0;
        for (var i = 0; i < rows.length; i++) {
          var rc = rows[i] && rows[i][0];
          if (rc === 'PEE00001' || rc === 'PEE00002') {   /* pool + shaft dig */
            excM += rows[i][1] || 0;                        /* metric m^3           */
            excY += rows[i][2] || 0;                        /* imperial yd^3 already */
          }
        }
        dstCapacity.textContent = STATE.isMetric
          ? excM.toFixed(1) + ' m\u00b3'
          : excY.toFixed(1) + ' yd\u00b3';
      }
    }
    refresh();
    setInterval(refresh, 500);

    setTimeout(function () {
      if (typeof global.updateTotal !== 'function') return;
      var srcTotal = document.querySelector('[data-budget-total-cost]');
      var t = (srcTotal && srcTotal.textContent) ? srcTotal.textContent.trim() : '';
      var stillEmpty = (t === '' || t === '\u2014' || typeof global.lastMaterialsTotal !== 'number');
      if (!stillEmpty) return;
      try { global.updateTotal(); } catch (err) {}
    }, 2500);
  }

  function _initBudgetWidgetDrag() {
    var widget = document.getElementById('cf-budget-widget');
    var toggle = document.getElementById('cf-budget-widget-toggle');
    if (!widget) return;
    if (toggle) {
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var collapsed = widget.getAttribute('data-collapsed') === 'true';
        widget.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
      });
      toggle.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
    }

    var dragging = false, startX = 0, startY = 0, startLeft = 0, startTop = 0;
    widget.addEventListener('pointerdown', function (e) {
      if (e.target.closest('#cf-budget-widget-toggle')) return;
      dragging = true;
      startX = e.clientX; startY = e.clientY;
      var r = widget.getBoundingClientRect();
      var pr = (widget.offsetParent || document.body).getBoundingClientRect();
      startLeft = r.left - pr.left;
      startTop  = r.top  - pr.top;
      try { widget.setPointerCapture(e.pointerId); } catch (_) {}
    });
    widget.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      var parent = widget.offsetParent || document.body;
      var pr = parent.getBoundingClientRect();
      var nx = Math.max(0, Math.min(pr.width  - widget.offsetWidth,  startLeft + dx));
      var ny = Math.max(0, Math.min(pr.height - widget.offsetHeight, startTop  + dy));
      widget.style.left = nx + 'px';
      widget.style.top  = ny + 'px';
      widget.style.right = 'auto';
    });
    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      try { if (e) widget.releasePointerCapture(e.pointerId); } catch (_) {}
    }
    widget.addEventListener('pointerup',     endDrag);
    widget.addEventListener('pointercancel', endDrag);
    widget._forceEndDrag = function () { dragging = false; };
  }

  function share() {
    if (global.ConfiguratorShare && typeof global.ConfiguratorShare.open === 'function') {
      try { global.ConfiguratorShare.open(); return; }
      catch (err) { _dbg('ConfiguratorShare.open threw: ' + (err && err.message ? err.message : err)); }
    }
    var TT = (global.BASE_BOOT && global.BASE_BOOT.i18n) || {};
    var txt = TT.shareFallbackText || 'Foundation configuration from LEVA';
    var title = TT.shareFallbackTitle || 'Configuration';
    if (navigator.share) {
      navigator.share({ title: title, text: txt }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(txt);
      alert(TT.shareCopied || 'Copied to clipboard');
    }
  }

  function openBudgetDrawer() {
    /* Any user-initiated open of the drawer counts as "engaged"
       and disables the onboarding nudge for this product. The
       30-day throttle is also written so we don't pop it again
       if they refresh. */
    try {
      var BOOT = global.BASE_BOOT || {};
      global.__cfBudgetUserTouched = true;
      if (BOOT.productId) {
        localStorage.setItem('cf-budget-touched-' + BOOT.productId, String(Date.now()));
      }
      _onboardMarkSeen();
    } catch (_) {}
    if (typeof global.openShareBudgetDrawer === 'function') {
      global.openShareBudgetDrawer('data');
    } else if (typeof global.openRefreshDrawer === 'function') {
      global.openRefreshDrawer();
    } else {
      _dbg('no budget drawer opener on window');
    }
  }

  function toggleView() {
    if (global.BaseEngine && typeof global.BaseEngine.toggleView === 'function') {
      global.BaseEngine.toggleView();
      /* After landing back in 3D (user clicked 2D->3D), Chromium can
         hold a stale composite layer just like on variant/unit/style
         switches. _forceRender3DFlush early-exits when STATE.view is
         not '3d', so calling it unconditionally is safe -- the 3D->2D
         direction is a no-op. */
      _forceRender3DFlush(2);
    }
  }

  /* PDF is the primary deliverable. Until the central BoQ data has loaded
     (names + prices), an export would be incomplete -- so the button stays
     visually disabled (greyed, non-clickable). Once data is ready it is
     promoted to the single RED primary action (white icon) so it stands out. */
  var PDF_BTN_RED = '#D8232A';   /* LEVA red */

  function _initPdfButtonState() {
    var btn = document.getElementById('cf-btn-pdf');
    if (!btn) return;

    if (!document.getElementById('cf-pdf-btn-style')) {
      var st = document.createElement('style');
      st.id = 'cf-pdf-btn-style';
      st.textContent =
        '#cf-btn-pdf.cf-pdf-loading{opacity:.4;pointer-events:none;cursor:default;filter:grayscale(1);}' +
        '#cf-btn-pdf.cf-pdf-ready{background:' + PDF_BTN_RED + ' !important;border-color:' + PDF_BTN_RED + ' !important;color:#fff !important;}' +
        /* White icon regardless of how it is rendered (inline SVG,
           <img>, or a CSS mask / background-image child). */
        '#cf-btn-pdf.cf-pdf-ready > *{filter:brightness(0) invert(1) !important;}';
      document.head.appendChild(st);
    }

    var bridge = global.ConfiguratorBudgetBridge || null;
    function isReady() {
      return !(bridge && typeof bridge.isReady === 'function') || bridge.isReady();
    }
    function promote() {
      btn.classList.remove('cf-pdf-loading');
      btn.classList.add('cf-pdf-ready');
    }

    if (isReady()) { promote(); return; }

    btn.classList.add('cf-pdf-loading');
    if (bridge && typeof bridge.onReady === 'function') {
      try { bridge.onReady(promote); } catch (e) {}
    }
    var waited = 0;
    var iv = setInterval(function () {
      if (isReady()) { clearInterval(iv); promote(); }
      else if ((waited += 300) >= 30000) { clearInterval(iv); promote(); }  /* fail-open after 30 s */
    }, 300);
  }

  function wireSidebar() {
    var on = function (id, fn) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('click', fn);
    };
    on('cf-btn-view',     toggleView);
    on('cf-btn-undo',     undo);
    on('cf-btn-lvl',      cycleLvl);
    _SlopeManager.init();
    on('cf-btn-unit',     toggleUnits);
    on('cf-btn-budget',   openBudgetDrawer);
    on('cf-btn-share',    share);
    on('cf-btn-pdf',      function () { _openPdfSocialModal(); });
    on('cf-btn-ar',       function () { _openArModal(); });

    var prevBtn = document.getElementById('cf-base-variant-prev');
    var nextBtn = document.getElementById('cf-base-variant-next');
    if (prevBtn) prevBtn.addEventListener('click', prevVariant);
    if (nextBtn) nextBtn.addEventListener('click', nextVariant);

    _syncVariantNameDisplay();
    _syncEdgeTypeDisplay();
    _syncMaterialDisplay();
    _syncSurfaceDisplay();
    _DepthSlider.init();
    on('cf-btn-edge', toggleEdgeType);
    on('cf-btn-material', cycleWallMaterial);
    on('cf-btn-surface', cycleSurface);
    on('cf-btn-stairs', cycleStairsType);
    on('cf-btn-stairs-mirror', cycleStairsPlacement);
    _initPdfButtonState();

    var opacitySlider = document.getElementById('cf-2d-opacity-slider');
    if (opacitySlider) {
      opacitySlider.addEventListener('input', function (e) {
        var sv = parseInt(e.target.value, 10);
        STATE.opacity2D = (100 - sv) / 100;
        if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
      });
    }

    _startBudgetWidgetSync();
    _initBudgetWidgetDrag();
    _init2DZoom();
    _init2DMapPan();
    _bindIconTooltips();
    _VisualizationManager.init();
    _poolCutBind();   /* pool-v8 */
    _CornerInserter.init();
    _SectionDragManager.init();
    _UndoHistory._updateButton();
    _updateLvlButton();
    _preloadLvlAvatars();

    var _bridgeRetry = 0;
    var _bridgeTimer = setInterval(function () {
      _bridgeRetry++;
      var bridge = global.ConfiguratorBudgetBridge;
      if (bridge && bridge.isReady && bridge.isReady()) {
        refreshUI();
        clearInterval(_bridgeTimer);
      } else if (_bridgeRetry > 150) {
        clearInterval(_bridgeTimer);
      }
    }, 200);

    global.addEventListener('prices-updated', function () {
      refreshUI();
    });

    global.addEventListener('unitChange', _syncFromBudgetUnit);
    setTimeout(_syncFromBudgetUnit, 50);
  }

  var _CORE_CSS_INJECTED = false;
  function _injectCoreCSS() {
    if (_CORE_CSS_INJECTED) return;
    if (document.getElementById('cf-core-css-inline')) { _CORE_CSS_INJECTED = true; return; }
    var css = [
      ':root { --cfg-color-primary: #D2A878; }',
      '.cfg-slider-vert-wrap {',
      '  display: inline-flex; flex-direction: column; align-items: center;',
      '  background: transparent; padding: 0; user-select: none;',
      '}',
      '.cfg-slider-vert {',
      '  -webkit-appearance: none; appearance: none;',
      '  width: 4px; height: 130px;',
      '  background: linear-gradient(to top,',
      '    var(--cfg-color-primary, #D2A878) 0%,',
      '    var(--cfg-color-primary, #D2A878) var(--cfg-fill, 50%),',
      '    #e0e0e0 var(--cfg-fill, 50%),',
      '    #e0e0e0 100%);',
      '  border-radius: 10px; outline: none; cursor: pointer; touch-action: none;',
      '  writing-mode: tb-lr; -webkit-writing-mode: vertical-lr;',
      '}',
      '.cfg-slider-vert::-webkit-slider-thumb {',
      '  -webkit-appearance: none; appearance: none;',
      '  width: 12px; height: 12px;',
      '  background: var(--cfg-color-primary, #D2A878);',
      '  border: none; border-radius: 50%; cursor: pointer;',
      '  box-shadow: 0 2px 6px rgba(0,0,0,0.20);',
      '}',
      '.cfg-slider-vert::-moz-range-thumb {',
      '  width: 12px; height: 12px;',
      '  background: var(--cfg-color-primary, #D2A878);',
      '  border: none; border-radius: 50%; cursor: pointer;',
      '  box-shadow: 0 2px 6px rgba(0,0,0,0.20);',
      '}',
      '.cf-dim-chip {',
      '  position: absolute; transform: translate(-50%, -50%);',
      '  background: #ffffff; border-radius: 8px; padding: 6px 10px;',
      '  font-family: Montserrat, system-ui, sans-serif;',
      '  font-size: 12px; font-weight: 700; color: #1a1a1a;',
      '  box-shadow: 0 2px 8px rgba(0,0,0,0.12);',
      '  display: inline-flex; align-items: center; gap: 6px;',
      '  white-space: nowrap; pointer-events: none; touch-action: none;',
      '  user-select: none; z-index: 8;',
      '}'
    ].join('\n');
    var s = document.createElement('style');
    s.id = 'cf-core-css-inline';
    s.textContent = css;
    document.head.appendChild(s);
    _CORE_CSS_INJECTED = true;
  }

  /* ---------------------------------------------------------------
     SectionCutManager
     Provides assembly step 2 = vertical section cut through the
     3D scene. The cutting plane is computed deterministically per
     variant + polygon so the result is identical for every user.

     Pipeline:
       1. compute()  -- find a cut plane (THREE.Plane) per variant
       2. apply()    -- set material.clippingPlanes on every mesh
                       in the scene group (called from BaseRenderer)
       3. addCaps()  -- overlay opaque cap meshes so the cut surface
                       reads as solid instead of hollow
       4. clear()    -- remove clipping + caps for all other steps

     Plane orientation: perpendicular to the LONGER polygon edge --
     that maximises the amount of material visible in the slice.
     Position: passes through the polygon centroid for slab / strip
     variants; for piers / precast / screws it snaps onto the
     element nearest the centroid so the cut actually intersects
     something instead of slicing between objects.
     --------------------------------------------------------------- */
  var _SectionCutManager = {
    _capsGroup: null,
    _outlineGroup: null,
    _activePlane: null,
    _activeOffset: 0,
    /* When the user drags the section plane we store the chosen coord
       here; subsequent refreshes use it instead of auto-positioning.
       Reset to null on variant / polygon change so the auto-pick
       behaviour returns for a fresh scene. */
    _manualOffset: null,
    _dragRange: null,    /* {min,max} along the cut axis, for clamping */

    /* Compute a THREE.Plane that slices the scene vertically through
       a sensible spot. Returns null if THREE isn't ready yet (caller
       must noop). */
    compute: function (poly, variantKey, eng) {
      var T = global.THREE;
      if (!T || !poly || poly.length < 3) return null;

      /* 1. find polygon bbox + centroid */
      var xs = poly.map(function (p) { return p[0]; });
      var zs = poly.map(function (p) { return p[1]; });
      var xMin = Math.min.apply(null, xs), xMax = Math.max.apply(null, xs);
      var zMin = Math.min.apply(null, zs), zMax = Math.max.apply(null, zs);
      var cx = (xMin + xMax) / 2;
      var cz = (zMin + zMax) / 2;
      var bbL = xMax - xMin;
      var bbW = zMax - zMin;

      /* 2. pick orientation -- cut perpendicular to the longer edge.
         If the polygon is wider than it is deep we cut along the X
         axis (plane normal = +Z), otherwise along Z (normal = +X). */
      var cutAlongX = (bbL >= bbW);
      var normal = cutAlongX
        ? new T.Vector3(0, 0, 1)
        : new T.Vector3(1, 0, 0);

      /* 3. position the plane. For uniform variants (slab / strip)
         the centroid is fine. For discrete elements (piers, precast,
         screws) the plane must pass THROUGH one of them or the cut
         will land in empty space and show nothing useful. */
      var planeCoord = cutAlongX ? cz : cx;

      var elementPositions = this._findElementPositions(variantKey, eng);
      if (elementPositions && elementPositions.length) {
        var best = null, bestDist = Infinity;
        for (var i = 0; i < elementPositions.length; i++) {
          var p = elementPositions[i];
          var d = cutAlongX
            ? Math.abs(p.z - cz)
            : Math.abs(p.x - cx);
          if (d < bestDist) { bestDist = d; best = p; }
        }
        if (best) planeCoord = cutAlongX ? best.z : best.x;
      }

      /* Record the draggable range along the cut axis (polygon bbox
         plus a small margin) so the drag handler can clamp. */
      this._dragRange = cutAlongX
        ? { min: zMin, max: zMax }
        : { min: xMin, max: xMax };

      /* If the user has dragged the plane, honour their chosen coord
         (clamped to the polygon) instead of the auto-picked element. */
      if (typeof this._manualOffset === 'number' && isFinite(this._manualOffset)) {
        var lo = this._dragRange.min, hi = this._dragRange.max;
        planeCoord = Math.max(lo, Math.min(hi, this._manualOffset));
      }

      /* THREE.Plane equation: n.x + constant = 0
         Fragments are clipped where n.x + constant < 0. We want to
         hide the NEAR half of the model (the half closest to the
         default camera angle), so the cut surface ends up facing
         the user without them having to orbit. Practically that
         means picking a normal that points TOWARDS the visible
         half, then making the plane sit at planeCoord. */
      var plane = new T.Plane(normal.clone().negate(), planeCoord);
      this._activePlane = plane;
      this._activeOffset = planeCoord;
      this._activeCutAlongX = cutAlongX;
      return plane;
    },

    /* Pull world positions of discrete elements out of the scene
       graph, so the section-cut plane can auto-snap to pass THROUGH a
       post rather than landing in an empty bay. For fences the natural
       target is the posts (all variants tag them). */
    _findElementPositions: function (variantKey, eng) {
      if (!eng || !eng.sceneGroup) return [];
      var POST_TYPES = {
        'fence-post-wood': true, 'fence-post': true, 'fence-post-vinyl': true,
        'fence-post-cp': true, 'fence-post-chain': true, 'fence-post-steel': true,
        'gabion-post': true
      };
      var hits = [];
      eng.sceneGroup.traverse(function (node) {
        if (!node || !node.userData) return;
        if (POST_TYPES[node.userData.assetType]) {
          var pos = new global.THREE.Vector3();
          node.getWorldPosition(pos);
          hits.push(pos);
        }
      });
      return hits;
    },

    /* Walk the scene group and attach our plane to every material
       so the GPU clips fragments on the far side of it. We also
       enable per-material 'clipShadows: false' because the scene's
       shadows look weird when the casting mesh is half-clipped.
       Returns the number of materials touched (handy for logging). */
    apply: function (plane) {
      var eng = global.BaseEngine;
      if (!eng || !eng.sceneGroup || !plane) return 0;
      var n = 0;
      eng.sceneGroup.traverse(function (node) {
        /* Hide excavation wireframes while the section cut is active --
           the clipped gold line-boxes read as visual noise across the
           cut face, and the concrete/gravel footing caps already show
           what's below grade. They're restored in clear(). */
        if (node.userData && node.userData.assetType === 'excavation-box') {
          node.visible = false;
          return;
        }
        if (!node.material) return;
        var mats = Array.isArray(node.material) ? node.material : [node.material];
        for (var i = 0; i < mats.length; i++) {
          var m = mats[i];
          if (!m) continue;
          m.clippingPlanes = [plane];
          m.clipShadows = false;
          m.needsUpdate = true;
          n++;
        }
      });
      return n;
    },

    /* Remove any active clipping + cap geometry. Called when the
       user leaves step 2 of the assembly cycle. */
    clear: function () {
      var eng = global.BaseEngine;
      if (eng && eng.sceneGroup) {
        eng.sceneGroup.traverse(function (node) {
          /* Restore excavation wireframes hidden by apply(). */
          if (node.userData && node.userData.assetType === 'excavation-box') {
            node.visible = true;
          }
          if (!node.material) return;
          var mats = Array.isArray(node.material) ? node.material : [node.material];
          for (var i = 0; i < mats.length; i++) {
            if (mats[i]) {
              mats[i].clippingPlanes = null;
              mats[i].needsUpdate = true;
            }
          }
        });
      }
      this._removeCapsGroup();
      this._activePlane = null;
    },

    _removeCapsGroup: function () {
      var eng = global.BaseEngine;
      if (!eng || !eng.sceneGroup) return;
      if (this._capsGroup) {
        eng.sceneGroup.remove(this._capsGroup);
        this._disposeGroup(this._capsGroup);
        this._capsGroup = null;
      }
      if (this._outlineGroup) {
        eng.sceneGroup.remove(this._outlineGroup);
        this._disposeGroup(this._outlineGroup);
        this._outlineGroup = null;
      }
    },

    _disposeGroup: function (group) {
      group.traverse(function (n) {
        if (n.geometry) n.geometry.dispose();
        if (n.material) {
          var ms = Array.isArray(n.material) ? n.material : [n.material];
          ms.forEach(function (m) { m && m.dispose && m.dispose(); });
        }
      });
    },

    /* Add a thin highlighted line along the cut so the user can see
       exactly where the slice plane sits in 3D -- without this it
       reads as just "half the model deleted". */
    addOutline: function (plane, poly, eng) {
      var T = global.THREE;
      if (!T || !plane || !poly || !eng) return;
      var grp = new T.Group();
      grp.userData.assetType = 'section-cut-aux';

      var cutAlongX = this._activeCutAlongX;
      var coord = this._activeOffset;
      var heightTop = 0.6;
      var heightBot = -2.0;

      var xs = poly.map(function (p) { return p[0]; });
      var zs = poly.map(function (p) { return p[1]; });
      var xMin = Math.min.apply(null, xs), xMax = Math.max.apply(null, xs);
      var zMin = Math.min.apply(null, zs), zMax = Math.max.apply(null, zs);

      var a, b;
      if (cutAlongX) {
        a = new T.Vector3(xMin - 0.5, heightBot, coord);
        b = new T.Vector3(xMax + 0.5, heightBot, coord);
      } else {
        a = new T.Vector3(coord, heightBot, zMin - 0.5);
        b = new T.Vector3(coord, heightBot, zMax + 0.5);
      }
      var top = a.clone(); top.y = heightTop;
      var top2 = b.clone(); top2.y = heightTop;

      var lineGeo = new T.BufferGeometry().setFromPoints([a, b, top2, top, a]);
      var lineMat = new T.LineBasicMaterial({ color: 0xd2a878, linewidth: 2 });
      grp.add(new T.Line(lineGeo, lineMat));

      eng.sceneGroup.add(grp);
      this._outlineGroup = grp;
    },

    /* Stencil-buffer cap fill -- turns the "thin-shell hole" effect
       into a proper solid cross-section.

       Per-material variant: we don't paint every cut surface the
       same neutral grey. Instead we group the solid meshes by their
       source material and run an independent stencil pass per
       group, then draw a coloured cap using that material's own
       diffuse colour. The result: gravel reads brown, concrete
       reads grey, precast block reads its own tone -- same as the
       3D bodies they belong to.

       Rebar / wire mesh is rendered as line geometry, so the cap
       trick doesn't apply directly; we still want their cross-
       section to show up as small filled circles inside the slab
       cap. We do that as a second pass that ignores the stencil
       and uses additive blending so the rebar lines pop on top of
       the concrete cap.

       Algorithm per material group:
         1. clear stencil to 0
         2. render BACK faces of every mesh in the group with the
            cut clipping plane, INCREMENTing the stencil counter
         3. render FRONT faces DECREMENTing
            -> counter != 0 exactly where the cut is inside any mesh
              from this material group
         4. draw a big quad on the cut plane in the material's own
            colour, gated by 'stencilFunc: NotEqual, ref: 0'
            and CLEARING the stencil back to 0 with 'Zero' ops so
            the next material group starts from a clean slate

       Each pass is given its own renderOrder block (group N uses
       10*N+0 / +1 / +2) so Three.js processes them in the right
       sequence. */
    addCaps: function (plane, poly, eng) {
      var T = global.THREE;
      if (!T || !plane || !poly || !eng) return;

      var grp = new T.Group();
      grp.userData.assetType = 'section-cut-aux';

      /* Asset types that read as solid bodies -> get the per-material
         coloured cap. Wireframe assets (mesh / rebar) get a
         separate overlay pass below. */
      var SOLID_TYPES = {
        /* Fence solid components -- capped so the section cut shows a
           clean coloured cross-section through posts, rails, pickets,
           brackets and footings rather than the raw clipped shell. */
        'fence-post-wood':         true,
        'fence-rail-wood':         true,
        'fence-picket-wood':       true,
        'fence-cap-wood':          true,
        'fence-bracket':           true,
        'fence-footing-concrete':  true,
        'fence-footing-gravel':    true,
        'fence-post':              true,
        'fence-post-cap':          true,
        'fence-panel':             true,
        'fence-post-vinyl':        true,
        'fence-panel-vinyl':       true,
        'fence-post-cp':           true,
        'fence-panel-cp':          true,
        'fence-dwarf-wall':        true,
        'fence-post-chain':        true,
        'fence-post-steel':        true,
        'fence-panel-steel':       true,
        'gabion-fill':             true,
        'gabion-post':             true,
        'anchor':                  true
      };
      /* Wireframe / line assets -- drawn over the cap as accent lines
         so the user can still see the rebar grid intersecting the
         slab cross-section. */
      var WIRE_TYPES = {
        'mesh':  true,
        'rebar': true
      };

      /* Bucket meshes by their material UUID. Meshes that share the
         same material end up in the same group, so a single
         coloured cap covers everything that visually belongs
         together (e.g. all concrete pours).

         We darken the cap colour to 70% because the cap is drawn
         with MeshBasicMaterial (unlit), while the source meshes use
         MeshStandardMaterial which is attenuated by scene lighting.
         Cloning the raw colour straight across makes the caps look
         noticeably brighter than the surrounding 3D -- multiplying
         by 0.7 brings them roughly in line with how the rest of the
         lit geometry reads on screen. */
      var CAP_BRIGHTNESS = 0.7;
      var groups = {};
      eng.sceneGroup.traverse(function (node) {
        if (!node.isMesh || !node.geometry || !node.material) return;
        if (node.userData && node.userData.assetType === 'section-cut-aux') return;
        var t = (node.userData && node.userData.assetType)
              || (node.parent && node.parent.userData && node.parent.userData.assetType);
        if (!t || !SOLID_TYPES[t]) return;
        var mats = Array.isArray(node.material) ? node.material : [node.material];
        for (var mi = 0; mi < mats.length; mi++) {
          var m = mats[mi];
          if (!m || !m.color) continue;
          var key = m.uuid;
          if (!groups[key]) {
            var capColor = m.color.clone().multiplyScalar(CAP_BRIGHTNESS);
            groups[key] = { color: capColor, meshes: [], typeHint: t };
          }
          groups[key].meshes.push({ node: node, materialIndex: mi });
        }
      });

      var groupKeys = Object.keys(groups);
      _dbg('[section-cut] addCaps: ' + groupKeys.length + ' material groups');

      var xs = poly.map(function (p) { return p[0]; });
      var zs = poly.map(function (p) { return p[1]; });
      var xMin = Math.min.apply(null, xs), xMax = Math.max.apply(null, xs);
      var zMin = Math.min.apply(null, zs), zMax = Math.max.apply(null, zs);
      var capH = 4.0;
      var capW = (this._activeCutAlongX ? (xMax - xMin) : (zMax - zMin)) + 4;
      var capCenterX = this._activeCutAlongX ? (xMin + xMax) / 2 : this._activeOffset;
      var capCenterZ = this._activeCutAlongX ? this._activeOffset : (zMin + zMax) / 2;
      var capY = capH / 2 - 2.5;
      var self = this;

      function makeStencilMat(faceSide, op, refClear) {
        return new T.MeshBasicMaterial({
          side: faceSide,
          clippingPlanes: [plane],
          colorWrite: false,
          depthWrite: false,
          depthTest: true,
          stencilWrite: true,
          stencilFunc: T.AlwaysStencilFunc,
          stencilRef: 0,
          stencilMask: 0xff,
          stencilFail: T.KeepStencilOp,
          stencilZFail: op,
          stencilZPass: op
        });
      }

      function buildCapMesh(color, renderOrder) {
        /* The cap material uses NotEqual / Zero so the same pass
           both draws the colour AND resets the stencil to 0 -- that
           way the next material group's stencil pass starts clean
           without needing an explicit clear. */
        var capMat = new T.MeshBasicMaterial({
          color: color,
          side: T.DoubleSide,
          clippingPlanes: null,
          stencilWrite: true,
          stencilRef: 0,
          stencilMask: 0xff,
          stencilFunc: T.NotEqualStencilFunc,
          stencilFail: T.ZeroStencilOp,
          stencilZFail: T.ZeroStencilOp,
          stencilZPass: T.ZeroStencilOp
        });
        var capGeo = new T.PlaneGeometry(capW, capH);
        var cap = new T.Mesh(capGeo, capMat);
        cap.renderOrder = renderOrder;
        if (self._activeCutAlongX) {
          cap.position.set(capCenterX, capY, self._activeOffset);
        } else {
          cap.rotation.y = Math.PI / 2;
          cap.position.set(self._activeOffset, capY, capCenterZ);
        }
        return cap;
      }

      /* Each group gets its own renderOrder window so the stencil
         passes for group N+1 don't fight with the cap from group N.
         We leave plenty of room (10 slots per group) for the line
         overlay below. */
      for (var gi = 0; gi < groupKeys.length; gi++) {
        var g = groups[groupKeys[gi]];
        var base = 10 + gi * 10;
        var matBack  = makeStencilMat(T.BackSide,  T.IncrementWrapStencilOp);
        var matFront = makeStencilMat(T.FrontSide, T.DecrementWrapStencilOp);
        for (var i = 0; i < g.meshes.length; i++) {
          var entry = g.meshes[i];
          var src = entry.node;
          src.updateMatrixWorld(true);
          var geom = src.geometry.clone();
          geom.applyMatrix4(src.matrixWorld);
          var mB = new T.Mesh(geom, matBack);
          var mF = new T.Mesh(geom, matFront);
          mB.renderOrder = base;
          mF.renderOrder = base + 1;
          grp.add(mB);
          grp.add(mF);
        }
        var cap = buildCapMesh(g.color, base + 2);
        grp.add(cap);
      }

      /* Wire-frame overlay pass -- rebar / kari mesh lines that
         actually cross the cut plane render on top of whatever cap
         sits behind them. We just clone the line geometry, give it
         a clipping plane (so we only see the half-cut side), and
         draw it with a high render order. No stencil needed; lines
         have no interior to fill. */
      var wireOverlayCount = 0;
      eng.sceneGroup.traverse(function (node) {
        if (node.userData && node.userData.assetType === 'section-cut-aux') return;
        if (!(node.isLine || node.isLineSegments)) return;
        var t = (node.userData && node.userData.assetType)
              || (node.parent && node.parent.userData && node.parent.userData.assetType);
        if (!t || !WIRE_TYPES[t]) return;
        if (!node.material || !node.geometry) return;
        wireOverlayCount++;
      });
      _dbg('[section-cut] addCaps: ' + wireOverlayCount + ' wire overlays already clipped via main pass');
      /* Note: line meshes inherit the main clipping pipeline (we
         call apply() on every material in the scene), so the rebar
         already auto-clips. We don't duplicate them here -- that
         would draw them twice and make the lines look bold. */

      eng.sceneGroup.add(grp);
      if (this._capsGroup) {
        eng.sceneGroup.remove(this._capsGroup);
        this._disposeGroup(this._capsGroup);
      }
      this._capsGroup = grp;
    },

    /* Re-run the whole pipeline for the current state. Called from
       BaseRenderer after every build so the cut survives variant /
       level / polygon edits. Heavily logged so a console session
       can trace exactly why the cut didn't appear. */
    refresh: function () {
      var eng = global.BaseEngine;
      _dbg('[section-cut] refresh: vizStage=' + STATE.vizStage + ' view=' + STATE.view + ' eng=' + !!eng);
      if (!eng) return;
      var inSection = (STATE.vizStage === 2 && STATE.view === '3d');
      if (!inSection) {
        _dbg('[section-cut] refresh: not in section-cut mode, clearing');
        this.clear();
        return;
      }
      var poly = getFootprintPolygon();
      if (!poly || poly.length < 3) {
        _dbg('[section-cut] refresh: invalid polygon, clearing');
        this.clear();
        return;
      }
      var vk = variantKey();
      _dbg('[section-cut] refresh: computing plane for variant=' + vk + ' polyN=' + poly.length);
      var plane = this.compute(poly, vk, eng);
      if (!plane) {
        _dbg('[section-cut] refresh: compute returned null, clearing');
        this.clear();
        return;
      }
      _dbg('[section-cut] refresh: plane normal=' + JSON.stringify(plane.normal) + ' constant=' + plane.constant + ' offset=' + this._activeOffset + ' cutAlongX=' + this._activeCutAlongX);
      /* Drop any caps/outline from a previous refresh before building
         new ones. Without this, dragging the section plane (which calls
         refresh on every pointermove) stacks a fresh caps + outline
         group each frame, leaving a growing pile of clipped wireframes
         in the scene. */
      this._removeCapsGroup();
      var matCount = this.apply(plane);
      _dbg('[section-cut] refresh: applied clipping to ' + matCount + ' materials');
      this.addCaps(plane, poly, eng);
      this.addOutline(plane, poly, eng);
      _dbg('[section-cut] refresh: caps + outline added');
    },

    /* Returns true when section-cut mode is active (3D + vizStage 2),
       so the canvas drag handler knows whether to grab pointer events. */
    isActive: function () {
      return STATE.vizStage === 2 && STATE.view === '3d';
    },

    /* True when the section plane cuts along the X axis (normal = +/-Z),
       i.e. the user drags front-to-back (changes z); false = drags
       left-to-right (changes x). */
    isCutAlongX: function () {
      return !!this._activeCutAlongX;
    },

    /* Drag entry points. setManualOffset records the user's chosen
       coordinate along the cut axis and re-runs the clip/cap pass.
       resetManualOffset returns to automatic element-snapping. */
    setManualOffset: function (coord) {
      this._manualOffset = coord;
      this.refresh();
    },
    resetManualOffset: function () {
      this._manualOffset = null;
    },
    getActiveOffset: function () {
      return this._activeOffset;
    },
    getDragRange: function () {
      return this._dragRange;
    }
  };

  /* Drag-to-move the 3D section plane. Active only while section-cut
     mode is on (3D + vizStage 2). A horizontal pointer drag on the
     canvas slides the cutting plane along its axis; OrbitControls are
     suspended for the duration so the camera doesn't spin instead. */
  var _SectionDragManager = {
    _dragging: false,
    _startClient: null,
    _startOffset: 0,
    _bound: false,

    init: function () {
      if (this._bound) return;
      var eng = global.BaseEngine;
      if (!eng || !eng.renderer || !eng.renderer.domElement) return;
      var el = eng.renderer.domElement;
      var self = this;

      el.addEventListener('pointerdown', function (e) {
        if (!_SectionCutManager.isActive()) return;
        self._dragging = true;
        self._startClient = { x: e.clientX, y: e.clientY };
        self._startOffset = _SectionCutManager.getActiveOffset();
        if (eng.controls) eng.controls.enabled = false;
        try { el.setPointerCapture(e.pointerId); } catch (_) {}
        e.preventDefault();
      });

      el.addEventListener('pointermove', function (e) {
        if (!self._dragging) return;
        if (!_SectionCutManager.isActive()) { self._endDrag(e); return; }
        /* Map screen-space drag to a world delta on the ground plane,
           then take the component along the cut axis. Using the ground
           plane projection keeps the plane following the cursor at any
           zoom / orbit angle. */
        var pStart = _screenToWorld(self._startClient.x, self._startClient.y);
        var pNow   = _screenToWorld(e.clientX, e.clientY);
        if (!pStart || !pNow) return;
        var delta = _SectionCutManager.isCutAlongX()
          ? (pNow.z - pStart.z)
          : (pNow.x - pStart.x);
        _SectionCutManager.setManualOffset(self._startOffset + delta);
        e.preventDefault();
      });

      var endFn = function (e) { self._endDrag(e); };
      el.addEventListener('pointerup',     endFn);
      el.addEventListener('pointercancel', endFn);
      this._bound = true;
    },

    _endDrag: function (e) {
      if (!this._dragging) return;
      this._dragging = false;
      var eng = global.BaseEngine;
      if (eng) {
        if (eng.controls) eng.controls.enabled = true;
        if (e && eng.renderer && eng.renderer.domElement) {
          try { eng.renderer.domElement.releasePointerCapture(e.pointerId); } catch (_) {}
        }
      }
    }
  };

  var _BaseDimensions = {
    svgEl: null,
    chipLayer: null,
    chipEls: [],
    SVG_NS: 'http://www.w3.org/2000/svg',

    init: function () {
      var root = document.getElementById('cf-wrap-base');
      if (!root) return;
      if (!this.svgEl) {
        var svg = document.createElementNS(this.SVG_NS, 'svg');
        svg.id = 'cf-base-dims-svg';
        svg.style.cssText = [
          'position:absolute', 'top:0', 'left:0',
          'width:100%', 'height:100%',
          'pointer-events:none', 'display:none', 'z-index:6'
        ].join(';');
        root.appendChild(svg);
        this.svgEl = svg;
        var self = this;
        global.addEventListener('resize', function () { self.refresh(); });
      }
      if (!this.chipLayer) {
        var existing = document.getElementById('cf-base-dim-chips');
        if (existing) {
          this.chipLayer = existing;
        } else {
          var layer = document.createElement('div');
          layer.id = 'cf-base-dim-chips';
          layer.style.cssText = [
            'position:absolute', 'top:0', 'left:0',
            'width:100%', 'height:100%',
            'pointer-events:none', 'z-index:7'
          ].join(';');
          root.appendChild(layer);
          this.chipLayer = layer;
        }
      }
    },

    _clearChips: function () {
      for (var i = 0; i < this.chipEls.length; i++) {
        if (this.chipEls[i] && this.chipEls[i].parentNode) {
          this.chipEls[i].parentNode.removeChild(this.chipEls[i]);
        }
      }
      this.chipEls = [];
    },

    hide: function () {
      this.init();
      if (this.svgEl) { this.svgEl.style.display = 'none'; this.svgEl.innerHTML = ''; }
      if (this.chipLayer) this.chipLayer.style.display = 'none';
      this._clearChips();
    },

    refresh: function () {
      this.init();
      if (!this.svgEl) return;
      var show = (STATE.view === '2d' && STATE.vizStage === 1);
      if (!show) { this.hide(); return; }

      this.svgEl.style.display = '';
      this.svgEl.innerHTML = '';
      this.chipLayer.style.display = '';
      this._clearChips();

      var eng = global.BaseEngine;
      if (!eng || !eng.cameraOrtho || !eng.renderer) return;
      var canvas = eng.renderer.domElement;
      var rect = canvas.getBoundingClientRect();
      var w = rect.width, h = rect.height;
      if (w < 10 || h < 10) return;
      this.svgEl.setAttribute('viewBox', '0 0 ' + w + ' ' + h);

      var T = global.THREE;
      var cam = eng.cameraOrtho;
      var poly = getFootprintPolygon();
      if (!poly || poly.length < 2) return;

      function proj(x, z) {
        var v = new T.Vector3(x, 0, z).project(cam);
        return {
          x: (v.x * 0.5 + 0.5) * w,
          y: (1 - (v.y * 0.5 + 0.5)) * h
        };
      }

      var cx = 0, cz = 0;
      for (var i = 0; i < poly.length; i++) { cx += poly[i][0]; cz += poly[i][1]; }
      cx /= poly.length; cz /= poly.length;

      var GRAY = '#888', DARK = '#1a1a1a';
      var DIM_OFFSET = 46;
      var EXT_GAP = 4, EXT_OVER = 6, ARROW = 6;
      var unit = STATE.isMetric ? 'm' : 'ft';

      for (var i = 0; i < poly.length; i++) {
        var a = poly[i];
        var b = poly[(i + 1) % poly.length];
        var lenM = Math.hypot(b[0] - a[0], b[1] - a[1]);
        if (lenM < 0.05) continue;

        var lenDisp = STATE.isMetric ? lenM : (lenM * 3.28084);
        var label = fmtDim(lenM);   /* same ft-inch / mm format as the drag labels */

        var pA = proj(a[0], a[1]);
        var pB = proj(b[0], b[1]);
        var mid = proj((a[0] + b[0]) / 2, (a[1] + b[1]) / 2);
        var cs  = proj(cx, cz);

        var ex = pB.x - pA.x, ey = pB.y - pA.y;
        var elen = Math.hypot(ex, ey);
        if (elen < 1) continue;

        var nxs = -ey / elen, nys = ex / elen;
        var dot = (mid.x - cs.x) * nxs + (mid.y - cs.y) * nys;
        if (dot < 0) { nxs = -nxs; nys = -nys; }

        var oxA = pA.x + nxs * DIM_OFFSET;
        var oyA = pA.y + nys * DIM_OFFSET;
        var oxB = pB.x + nxs * DIM_OFFSET;
        var oyB = pB.y + nys * DIM_OFFSET;

        var exAx = pA.x + nxs * EXT_GAP;
        var exAy = pA.y + nys * EXT_GAP;
        var exAend_x = pA.x + nxs * (DIM_OFFSET + EXT_OVER);
        var exAend_y = pA.y + nys * (DIM_OFFSET + EXT_OVER);

        var exBx = pB.x + nxs * EXT_GAP;
        var exBy = pB.y + nys * EXT_GAP;
        var exBend_x = pB.x + nxs * (DIM_OFFSET + EXT_OVER);
        var exBend_y = pB.y + nys * (DIM_OFFSET + EXT_OVER);

        this._addLine(exAx, exAy, exAend_x, exAend_y, GRAY, 0.4);
        this._addLine(exBx, exBy, exBend_x, exBend_y, GRAY, 0.4);
        this._addLine(oxA, oyA, oxB, oyB, DARK, 0.5);

        var tx = -ex / elen, ty = -ey / elen;
        this._addLine(oxA, oyA, oxA + tx * ARROW + nxs * (ARROW * 0.5), oyA + ty * ARROW + nys * (ARROW * 0.5), DARK, 0.5);
        this._addLine(oxA, oyA, oxA + tx * ARROW - nxs * (ARROW * 0.5), oyA + ty * ARROW - nys * (ARROW * 0.5), DARK, 0.5);
        this._addLine(oxB, oyB, oxB - tx * ARROW + nxs * (ARROW * 0.5), oyB - ty * ARROW + nys * (ARROW * 0.5), DARK, 0.5);
        this._addLine(oxB, oyB, oxB - tx * ARROW - nxs * (ARROW * 0.5), oyB - ty * ARROW - nys * (ARROW * 0.5), DARK, 0.5);

        var chipX = (oxA + oxB) / 2 + nxs * 14;
        var chipY = (oyA + oyB) / 2 + nys * 14;
        this._addChip(chipX, chipY, label);
      }
    },

    _addLine: function (x1, y1, x2, y2, color, width) {
      var line = document.createElementNS(this.SVG_NS, 'line');
      line.setAttribute('x1', x1); line.setAttribute('y1', y1);
      line.setAttribute('x2', x2); line.setAttribute('y2', y2);
      line.setAttribute('stroke', color);
      line.setAttribute('stroke-width', width);
      line.setAttribute('stroke-linecap', 'round');
      this.svgEl.appendChild(line);
    },

    _addChip: function (x, y, text) {
      var chip = document.createElement('div');
      chip.className = 'cf-dim-chip cf-dim-chip--label-only';
      chip.style.left = x + 'px';
      chip.style.top  = y + 'px';
      chip.textContent = text;
      this.chipLayer.appendChild(chip);
      this.chipEls.push(chip);
    }
  };

  /* pool-v8 THE SECTION CUT IS THE KIT'S (the shelters' way): ConfiguratorUI.cutPlanes cuts whatever is in the stage group with the
     materials' clipping planes and caps it with a stencil; this file says only where the stage is, which button is its own, how to
     write a length and how to switch the orbit controls off while the arrow is dragged */
  var _poolCut = null;
  var _poolRoundTrip = 0;   /* pool-v9: >0 while _forceRender3DFlush runs its 3D-2D-3D round trip */
  function _poolCutInit() {
    var U = global.ConfiguratorUI;
    if (_poolCut) return _poolCut;
    if (!U || typeof U.cutPlanes !== 'function') return null;
    _poolCut = U.cutPlanes({
      stage:     function () { return global.BaseEngine; },
      rootId:    'cf-wrap-base',
      buttonId:  'cf-btn-cut',
      unitBtnId: 'cf-btn-unit',
      fmtLen:    function (m) { return (typeof U.fmtDim === 'function') ? U.fmtDim(m, !!STATE.isMetric) : (Math.round(m * 100) / 100) + ' m'; },
      log:       function (t) { _dbg('[cut] ' + t); },
      controls:  function () { return global.BaseEngine ? global.BaseEngine.controls : null; },
      view:      function () { return STATE.view; }
    });
    return _poolCut;
  }
  function _poolCutOff(why) { try { if (_poolCut && _poolCut.on()) { _poolCut.toggle(); _dbg('[cut] section off -- ' + why); } } catch (e) {} _poolCutLines(); }
  /* the kit clips the meshes only; the blocks' edge lines stood whole on the cut-away side -- they take the same plane here (the kit
     keeps one plane object and moves it, so a line once given it follows the drag), every 400 ms while the cut is on (a rebuild's new
     lines), and lose it when the cut goes off */
  var _poolCutLineT = 0;
  function _poolCutLines() {
    var E = global.BaseEngine;
    if (!E || !E.group || !E.renderer) return;
    var pl = (_poolCut && _poolCut.on()) ? (E.renderer.__sectionPlanes || []) : [], want = pl.length ? pl : null;
    E.group.traverse(function (n) {
      if (!(n.isLineSegments || n.isLine) || !n.material) return;
      (Array.isArray(n.material) ? n.material : [n.material]).forEach(function (m) {
        if (!m) return;
        var cur = m.clippingPlanes, same = (!cur || !cur.length) ? !want : (want && cur.length === want.length && cur[0] === want[0]);
        if (!same) { m.clippingPlanes = want; m.needsUpdate = true; }
      });
    });
    if (want && !_poolCutLineT) _poolCutLineT = setInterval(_poolCutLines, 400);
    else if (!want && _poolCutLineT) { clearInterval(_poolCutLineT); _poolCutLineT = 0; }
  }
  function _poolCutBind() {
    var b = document.getElementById('cf-btn-cut');
    if (!b) return;
    b.addEventListener('click', function () {
      if (STATE.view === '2d' && global.BaseEngine && global.BaseEngine.toggleView) global.BaseEngine.toggleView();   /* the section is a 3D view */
      if (STATE.vizStage === 2) { STATE.vizStage = 0; if (_VisualizationManager.apply) _VisualizationManager.apply(); }
      var t = _poolCutInit();
      if (!t) { _dbg('[cut] ConfiguratorUI.cutPlanes missing'); return; }
      t.toggle();
      _poolCutLines();
      _dbg('[cut] section ' + (t.on() ? 'ON ' + JSON.stringify(t.state()) : 'off'));
    });
  }

  var _VisualizationManager = {
    DISABLED: false,

    init: function () {
      _injectCoreCSS();
      var btn = document.getElementById('cf-btn-viz');
      if (this.DISABLED) {
        if (btn) btn.style.display = 'none';
        STATE.vizStage = 0;
        var wrap = document.getElementById('cf-2d-opacity-slider-wrap');
        if (wrap) wrap.classList.remove('cf-2d-visible');
        return;
      }
      STATE.vizStage = 0;
      if (!btn) return;
      var self = this;
      btn.addEventListener('click', function () { self.cycle(); });
      this._wireSlider();
      this.apply();
    },

    _wireSlider: function () {
      var slider = document.getElementById('cf-2d-opacity-slider');
      if (!slider) return;
      var maxV = parseInt(slider.max, 10) || 100;
      var self = this;
      var updateFill = function (pct) {
        var fillPct = 100 - (pct / maxV) * 100;
        slider.style.setProperty('--cfg-fill', fillPct + '%');
      };
      var onChange = function () {
        var sv = parseInt(slider.value, 10) || 0;
        STATE.opacity2D = (100 - sv) / 100;
        updateFill(sv);
        self._applyOpacityToMaterials();
      };
      slider.addEventListener('input',  onChange);
      slider.addEventListener('change', onChange);
      var initSliderVal = Math.round((1 - STATE.opacity2D) * 100);
      slider.value = initSliderVal;
      updateFill(initSliderVal);
    },

    cycle: function () {
      if (this.DISABLED) return;
      /* Stage values: 1 = dim/stage view (2D + PDF plan), 2 = section cut,
         3 = reinforcement (rebar), 4 = technology (pipes + MEP). Cycle order:
           3D: off -> 3 reinforcement -> 2 section cut -> 4 technology
           2D: off -> 3 reinforcement -> 1 dimensioned plan
         Section cut + technology are 3D-only. */
      var order = (STATE.view === '3d') ? [0, 3, 4] : [0, 3, 1];   /* pool-v8 the cut on its own rail button (was [0, 3, 2, 4]) */
      var i = order.indexOf(STATE.vizStage);
      if (i < 0) i = 0;
      STATE.vizStage = order[(i + 1) % order.length];
      _dbg('[viz-cycle] vizStage=' + STATE.vizStage + ' view=' + STATE.view);
      this.apply();
    },

    reset: function () {
      STATE.vizStage = 0;
      if (this.DISABLED) return;
      this.apply();
    },

    apply: function () {
      if (this.DISABLED) return;
      this._applyOpacityToMaterials();
      if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
      this._updateButton();
      this._updateSliderVisibility();
      this._updateStageOverlays();
      this._updateTechLegend();
      if (_SlopeManager && _SlopeManager._updateSlider) _SlopeManager._updateSlider();
      _BaseDimensions.refresh();
      /* Trigger the section-cut pipeline whenever the stage state
         changes. The refresh function itself handles the early
         return when the stage isn't 2. */
      if (_SectionCutManager) _SectionCutManager.refresh();
    },

    refreshDimensions: function () {
      if (this.DISABLED) return;
      _BaseDimensions.refresh();
    },

    _applyOpacityToMaterials: function () {
      var eng = global.BaseEngine;
      if (!eng || !eng.sceneGroup) return;
      /* Stage 1 = faded materials so dimensions + overlays read on
         top. Stage 2 (section cut) wants FULL opacity so the cut
         surface looks solid -- fading would defeat the point. */
      var in2DStage = (STATE.view === '2d' && STATE.vizStage === 1);
      var in3DStage = (STATE.view === '3d' && STATE.vizStage === 1);
      var inTech    = (STATE.view === '3d' && STATE.vizStage === 4);
      /* Assets kept fully opaque (and structure ghosted) in the technology
         stage -- pipes, fittings, valves, cables, boxes and the discrete
         components (skimmers, jets, lights, shaft, tank, panel, drains). */
      var TECH_SET = {
        'pool-pipe-3d': 1, 'pool-elbow-3d': 1, 'pool-tee-3d': 1, 'pool-valve-3d': 1,
        'pool-cable-3d': 1, 'pool-valve-cable-3d': 1, 'valve-junction-box': 1, 'valve-common-box': 1,
        'skimmer': 1, 'jet': 1, 'pool-light': 1, 'shaft': 1, 'tank': 1,
        'electrical-panel': 1, 'drain': 1
      };
      eng.sceneGroup.traverse(function (node) {
        var drawable = node.material && (node.isMesh || node.isLine);
        if (!drawable) return;
        var ud = (node.parent && node.parent.userData) || node.userData || {};
        var at = ud.assetType || (node.userData && node.userData.assetType) || '';
        if (node.userData && node.userData.assetType === 'water-solid') return;   /* pool-v9 the hidden water body keeps its own (opaque, no colour) */
        var isTech = !!TECH_SET[at];

        function setOp(op) {
          var m = node.material, list = Array.isArray(m) ? m : [m];
          for (var i = 0; i < list.length; i++) {
            list[i].transparent = op < 0.999;
            list[i].opacity = op;
            list[i].depthWrite = (op > 0.99);
            list[i].needsUpdate = true;
          }
        }

        /* Technology stage: only the MEP stays solid; everything structural is
           a faint ghost. Block edge-lines (drawn per block) are the densest
           layer, so they go nearly invisible; block fills + water get the
           lowest fills. All structural values are <=15% -- a real ghost. */
        if (inTech) {
          var top;
          if (isTech)                              top = 1.0;
          else if (node.isLine)                    top = 0.04;   /* block edge web -- nearly gone */
          else if (at === 'water')                 top = 0.05;
          else if (at === 'pool-wall-blocks' ||
                   at === 'pool-stairs-blocks')    top = 0.07;   /* block fill -- barely there */
          else                                     top = 0.10;   /* other structure ghost */
          setOp(top);
          return;
        }

        /* Every other stage: meshes only -- lines keep their authored look. */
        if (!node.isMesh) return;

        var isMeshWire  = (at === 'mesh');
        var isRebar     = (at === 'rebar');
        var isStairFill = (at === 'pool-stairs-fill');
        var isWater     = (at === 'water');
        var isGround    = (at === 'ground');
        /* Water keeps its own fixed translucency so the basin floor + stairs
           always read through it. */
        if (isWater) { setOp(0.25); return; }
        var op;
        if (isMeshWire || isRebar || isStairFill || isGround) op = 1.0;
        else if (in3DStage || in2DStage)                      op = STATE.opacity2D;
        else                                                  op = 1.0;
        setOp(op);
      });
    },

    _updateButton: function () {
      var btn = document.getElementById('cf-btn-viz');
      if (!btn) return;
      var stage = STATE.vizStage;
      btn.classList.toggle('active', stage !== 0);
      btn.setAttribute('data-stage', String(stage));
      btn.setAttribute('aria-pressed', stage !== 0 ? 'true' : 'false');
      var lbl = document.getElementById('cf-stat-viz') || btn.querySelector('.cf-viz-label');
      if (lbl) {
        /* Label by position in the cycle order, so the reinforcement view
           (value 3) reads as the first stage:
             3D order [0,3,2,4] -> "1/3 reinf, 2/3 cut, 3/3 technology"
             2D order [0,3,1]   -> "1/2 reinf, 2/2 plan" */
        var order = (STATE.view === '3d') ? [0, 3, 4] : [0, 3, 1];   /* pool-v8 */
        var pos = order.indexOf(stage);
        lbl.textContent = (stage === 0 || pos <= 0) ? 'off' : (pos + '/' + (order.length - 1));
      }
    },

    _updateSliderVisibility: function () {
      var wrap = document.getElementById('cf-2d-opacity-slider-wrap');
      if (!wrap) return;
      var visible = (STATE.vizStage === 1);
      wrap.classList.toggle('cf-2d-visible', visible);
    },

    _updateStageOverlays: function () {
      var wrap = document.getElementById('cf-wrap-base');
      if (!wrap) return;
      var inStageView = (STATE.vizStage === 1);
      wrap.classList.toggle('cf-stage-view', inStageView);
      if (inStageView) {
        if (_MapManager && _MapManager.map && _MapManager.map.dragPan) _MapManager.map.dragPan.disable();
      } else {
        if (_MapManager && _MapManager.map && _MapManager.map.dragPan && STATE.view === '2d') _MapManager.map.dragPan.enable();
      }
    },

    /* Colour legend for the technology stage (3D + vizStage 4). Built lazily
       as a DOM overlay inside the configurator wrap; hidden in every other
       stage. Colours match the pipe / cable materials in _build3DPipes /
       _build3DElectrical. */
    _updateTechLegend: function () {
      var wrap = document.getElementById('cf-wrap-base');
      if (!wrap) return;
      var show = (STATE.view === '3d' && STATE.vizStage === 4);
      var el = document.getElementById('cf-tech-legend');
      if (!show) { if (el) el.style.display = 'none'; return; }
      if (!el) {
        var T = (global.BASE_BOOT && global.BASE_BOOT.i18n) || {};
        function row(color, label) {
          return '<div style="display:flex;align-items:center;gap:7px;margin:2px 0;">' +
                 '<span style="width:14px;height:4px;border-radius:2px;background:' + color + ';display:inline-block;"></span>' +
                 '<span>' + label + '</span></div>';
        }
        el = document.createElement('div');
        el.id = 'cf-tech-legend';
        el.style.cssText = 'position:absolute;left:12px;top:64px;z-index:30;' +
          'background:rgba(255,255,255,0.92);border:1px solid rgba(0,0,0,0.10);' +
          'border-radius:10px;padding:8px 10px;font:600 11px/1.35 system-ui,sans-serif;' +
          'color:#1A1C1D;pointer-events:none;box-shadow:0 2px 8px rgba(0,0,0,0.12);';
        el.innerHTML =
          '<div style="font-weight:800;text-transform:uppercase;letter-spacing:.4px;margin-bottom:4px;">' +
            (T.tech_legend_title || 'Technology') + '</div>' +
          row('#d1504f', T.tech_legend_suction || 'Suction / drain') +
          row('#4f7fd1', T.tech_legend_return  || 'Return') +
          row('#16c60c', T.tech_legend_tee     || 'Fittings') +
          row('#111111', T.tech_legend_cable   || 'Cable');
        wrap.appendChild(el);
      }
      el.style.display = 'block';
    }
  };

  /* Camera framing for the detail bay (vizStage 3). Frames the
     isolated single-bay assembly that _build3D_DetailBay drew around
     the origin, and restores the previous camera/target when leaving
     the stage so the user lands back where they were. */

  function _snapToNearestPolygonEdge(x, z) {
    var poly = STATE.polygon;
    if (!poly || poly.length < 2) return null;
    var n = poly.length;
    var best = null;
    for (var i = 0; i < n; i++) {
      var a = poly[i];
      var b = poly[(i + 1) % n];
      var ax = a[0], az = a[1];
      var bx = b[0], bz = b[1];
      var ex = bx - ax, ez = bz - az;
      var lenSq = ex * ex + ez * ez;
      if (lenSq < 1e-6) continue;
      var t = ((x - ax) * ex + (z - az) * ez) / lenSq;
      if (t < 0) t = 0;
      if (t > 1) t = 1;
      var px = ax + t * ex;
      var pz = az + t * ez;
      var d = Math.hypot(x - px, z - pz);
      if (!best || d < best.dist) {
        best = { edgeIdx: i, tFrac: t, x: px, z: pz, dist: d };
      }
    }
    return best;
  }

  function _insertCornerOnEdge(edgeIdx, tFrac) {
    var poly = STATE.polygon;
    if (!poly || poly.length < 3) return false;
    var n = poly.length;
    if (edgeIdx < 0 || edgeIdx >= n) return false;

    var a = poly[edgeIdx];
    var b = poly[(edgeIdx + 1) % n];
    var ax = a[0], az = a[1];
    var bx = b[0], bz = b[1];

    var px = ax + tFrac * (bx - ax);
    var pz = az + tFrac * (bz - az);

    var distA = Math.hypot(px - ax, pz - az);
    var distB = Math.hypot(px - bx, pz - bz);

    var sharedIdx, sharedV, otherEndOnE, adjOtherIdx;
    if (distA <= distB) {
      sharedIdx     = edgeIdx;
      sharedV       = a;
      otherEndOnE   = b;
      adjOtherIdx   = (edgeIdx - 1 + n) % n;
    } else {
      sharedIdx     = (edgeIdx + 1) % n;
      sharedV       = b;
      otherEndOnE   = a;
      adjOtherIdx   = (edgeIdx + 2) % n;
    }
    var adjOther = poly[adjOtherIdx];

    var lenE   = Math.hypot(otherEndOnE[0] - sharedV[0], otherEndOnE[1] - sharedV[1]);
    var lenAdj = Math.hypot(adjOther[0]    - sharedV[0], adjOther[1]    - sharedV[1]);
    if (lenE < 0.2 || lenAdj < 0.2) return false;

    var d = Math.min(distA, distB);
    d = Math.min(d, lenE * 0.49, lenAdj * 0.49);
    if (d < 0.15) return false;

    var v1x = snap(sharedV[0] + (d / lenE)   * (otherEndOnE[0] - sharedV[0]));
    var v1z = snap(sharedV[1] + (d / lenE)   * (otherEndOnE[1] - sharedV[1]));
    var v2x = snap(sharedV[0] + (d / lenAdj) * (adjOther[0]    - sharedV[0]));
    var v2z = snap(sharedV[1] + (d / lenAdj) * (adjOther[1]    - sharedV[1]));
    var v3x = snap(v1x + v2x - sharedV[0]);
    var v3z = snap(v1z + v2z - sharedV[1]);

    var v1 = [_clampCoord(v1x), _clampCoord(v1z)];
    var v2 = [_clampCoord(v2x), _clampCoord(v2z)];
    var v3 = [_clampCoord(v3x), _clampCoord(v3z)];

    if (distA <= distB) {
      poly.splice(sharedIdx, 1, v2, v3, v1);
    } else {
      poly.splice(sharedIdx, 1, v1, v3, v2);
    }
    return true;
  }

  var _CornerInserter = {
    pendingPlacement: false,
    _setPending: function (on) {
      this.pendingPlacement = !!on;
      var canvas = document.getElementById('cf-canvas-base');
      if (canvas) canvas.style.cursor = on ? 'crosshair' : '';
      var btn = document.getElementById('cf-btn-insert-corner');
      if (btn) {
        btn.classList.toggle('active', !!on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    },
    init: function () {
      var self = this;
      var btn = document.getElementById('cf-btn-insert-corner');
      if (btn) {
        btn.addEventListener('click', function () {
          if (STATE.view !== '2d') return;
          self._setPending(!self.pendingPlacement);
        });
      }
      var canvas = document.getElementById('cf-canvas-base');
      if (canvas) {
        canvas.addEventListener('click', function (e) {
          if (!self.pendingPlacement) return;
          if (STATE.view !== '2d') { self._setPending(false); return; }
          var p = _screenToWorld(e.clientX, e.clientY);
          if (!p) return;
          var snapped = _snapToNearestPolygonEdge(p.x, p.z);
          if (!snapped) return;
          var prevPoly = JSON.parse(JSON.stringify(STATE.polygon));
          var ok = _insertCornerOnEdge(snapped.edgeIdx, snapped.tFrac);
          self._setPending(false);
          if (!ok) return;
          _UndoHistory.pushIfChanged(prevPoly, STATE.variant);
          rebuildDragHandles();
          if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
          refreshUI();
        });
      }
    }
  };

  var _AssetDrawer = {
    _ready: false,
    _raycaster: null,
    _mouse: null,
    _selectedMesh: null,
    _origMaterial: null,

    _HIGHLIGHT_HEX: 0xff8c42,

    _findBoQRow: function (boqCode) {
      var rows = computeBoQ();
      for (var i = 0; i < rows.length; i++) {
        var r = rows[i];
        if (Array.isArray(r) && r[0] === boqCode) {
          return { code: r[0], qty: r[1] || 0, qtyAlt: r[2] || 0 };
        }
        if (r && r.code === boqCode) return r;
      }
      return null;
    },

    _buildInstance: function (mesh) {
      if (!mesh || !mesh.userData || !mesh.userData.boqCode) return null;
      var ud = mesh.userData;
      var bridge = global.ConfiguratorBudgetBridge || null;

      var boqItem = (bridge && bridge.getBoqItem) ? bridge.getBoqItem(ud.boqCode) : null;
      var name     = (boqItem && boqItem.name)     || ud.boqCode;
      var category = (boqItem && boqItem.category) || ud.category || ud.assetType;
      var unit     = boqItem
        ? (STATE.isMetric ? boqItem.unitMetric : boqItem.unitImperial)
        : null;
      if (!unit) unit = STATE.isMetric ? 'pcs' : 'pcs';

      var userPrice = (bridge && bridge.getUserPrice) ? bridge.getUserPrice(ud.boqCode) : null;
      var product = userPrice ? {
        title:    userPrice.title,
        url:      userPrice.url,
        image:    userPrice.image,
        source:   userPrice.source,
        price:    userPrice.price,
        currency: userPrice.currency,
        unit:     unit
      } : null;

      var row = this._findBoQRow(ud.boqCode);
      var qty = (row && typeof row.qty === 'number') ? row.qty : 0;
      var unitPrice = userPrice ? userPrice.price : 0;
      var totalPrice = qty * unitPrice;

      var pos = mesh.getWorldPosition ? mesh.getWorldPosition(new global.THREE.Vector3()) : { x: 0, y: 0, z: 0 };
      var inst = {
        id:                 ud.assetType + ':' + (ud.index != null ? ud.index : 0),
        name:               name,
        type:               name,
        boqCode:            ud.boqCode,
        category:           category,
        unit:               unit,
        projectQuantity:    qty,
        projectUnitPrice:   unitPrice,
        projectTotalPrice:  totalPrice,
        position:           { x: pos.x, y: pos.y, z: pos.z }
      };
      if (typeof ud.length === 'number') inst.length = ud.length;
      if (product) inst.product = product;
      return inst;
    },

    _i18nLabels: function () {
      var boot = global.BASE_BOOT || {};
      var i18n = boot.i18n || {};
      var ad = i18n.assetDrawer || {};
      var labels = {};
      for (var k in ad) { if (ad.hasOwnProperty(k)) labels[k] = ad[k]; }
      return labels;
    },

    _highlight: function (mesh) {
      this._clearHighlight();
      if (!mesh || !mesh.material) return;
      this._selectedMesh = mesh;
      this._origMaterial = mesh.material;
      try {
        var T = global.THREE;
        mesh.material = new T.MeshStandardMaterial({ color: this._HIGHLIGHT_HEX, roughness: 0.6, metalness: 0 });
      } catch (_) {}
    },

    _clearHighlight: function () {
      if (this._selectedMesh && this._origMaterial) {
        try { this._selectedMesh.material = this._origMaterial; } catch (_) {}
      }
      this._selectedMesh = null;
      this._origMaterial = null;
    },

    init: function () {
      if (this._ready) return;
      if (!global.ConfiguratorAssetDrawer) {
        _dbg('AssetDrawer: ConfiguratorAssetDrawer global not loaded yet');
        var self = this;
        setTimeout(function () { self.init(); }, 200);
        return;
      }
      var T = global.THREE;
      if (!T) return;
      this._raycaster = new T.Raycaster();
      this._mouse = new T.Vector2();

      var self = this;
      global.ConfiguratorAssetDrawer.init({
        registry: function (id) {
          if (!self._selectedMesh) return null;
          return self._buildInstance(self._selectedMesh);
        },
        onClose: function () { self._clearHighlight(); },
        labels: this._i18nLabels(),
        drawerScopeClass: 'base-asset-drawer'
      });

      this._bindCanvas();
      this._ready = true;
      _dbg('AssetDrawer initialised');
    },

    _bindCanvas: function () {
      var self = this;
      var eng = global.BaseEngine;
      if (!eng || !eng.renderer || !eng.renderer.domElement) {
        setTimeout(function () { self._bindCanvas(); }, 100);
        return;
      }
      var canvas = eng.renderer.domElement;
      var pressStart = { x: 0, y: 0, t: 0 };

      canvas.addEventListener('pointerdown', function (e) {
        pressStart.x = e.clientX;
        pressStart.y = e.clientY;
        pressStart.t = Date.now();
      });

      canvas.addEventListener('pointerup', function (e) {
        if (STATE.view !== '3d') return;
        if (_CornerInserter && _CornerInserter.pendingPlacement) return;
        var dx = e.clientX - pressStart.x;
        var dy = e.clientY - pressStart.y;
        var dt = Date.now() - pressStart.t;
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) return;
        if (dt > 500) return;
        self._handleCanvasClick(e);
      });
    },

    _handleCanvasClick: function (e) {
      var eng = global.BaseEngine;
      if (!eng || !eng.scene || !eng.cameraPersp || !eng.sceneGroup) return;
      var canvas = eng.renderer.domElement;
      var rect = canvas.getBoundingClientRect();
      this._mouse.x =  ((e.clientX - rect.left) / rect.width)  * 2 - 1;
      this._mouse.y = -((e.clientY - rect.top)  / rect.height) * 2 + 1;
      this._raycaster.setFromCamera(this._mouse, eng.cameraPersp);
      var hits = this._raycaster.intersectObjects(eng.sceneGroup.children, true);
      if (!hits || !hits.length) {
        if (global.ConfiguratorAssetDrawer && global.ConfiguratorAssetDrawer.isOpen && global.ConfiguratorAssetDrawer.isOpen()) {
          global.ConfiguratorAssetDrawer.close();
        }
        return;
      }
      var mesh = null;
      for (var i = 0; i < hits.length; i++) {
        var h = hits[i].object;
        if (h && h.userData && h.userData.boqCode) { mesh = h; break; }
      }
      if (!mesh) return;
      this._highlight(mesh);
      var instance = this._buildInstance(mesh);
      if (!instance) return;
      global.ConfiguratorAssetDrawer.open(instance.id);
    }
  };

  var _ProjectStore = {
    SCHEMA_VERSION:  1,
    MASTER_PAGE_URL: 'https://www.theleva.com/pages/my',
    CONFIG_KEY:      'pool',

    _projectId:   null,
    _saveTimer:   null,
    _subscribers: {},
    _initialized: false,

    init: function () {
      if (this._initialized) return;
      var boot = global.BASE_BOOT || {};
      var pid = boot.linkedMainProjectId || null;
      var activeKey = this._activeKey();
      if (!pid) {
        try { pid = localStorage.getItem(activeKey); } catch (_) {}
      }
      if (!pid) {
        pid = this._generateUuid();
        try { localStorage.setItem(activeKey, pid); } catch (_) {}
      }
      this._projectId = pid;

      var self = this;
      global.addEventListener('storage', function (e) { self._onStorageEvent(e); });
      global.addEventListener('pagehide', function () { self.publishNow(); });

      this._initialized = true;
      _dbg('ProjectStore: project=' + pid + ' customer=' + this.getCustomerId());
    },

    getProjectId:  function () { return this._projectId; },
    getCustomerId: function () {
      var boot = global.BASE_BOOT || {};
      return (boot.customerId != null) ? String(boot.customerId) : 'anon';
    },

    _activeKey: function () {
      return 'levaActiveProject:c' + this.getCustomerId();
    },
    _payloadKey: function (configKey) {
      return 'levaProject:p' + this._projectId + ':c' + this.getCustomerId() + ':' + configKey;
    },

    _generateUuid: function () {
      if (global.crypto && global.crypto.randomUUID) {
        try { return global.crypto.randomUUID(); } catch (_) {}
      }
      return 'p-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    },

    _readTotalsFromWidget: function () {
      function parseNum(id) {
        var el = document.getElementById(id);
        if (!el) return 0;
        var t = (el.textContent || '').replace(/[^0-9.,-]/g, '').replace(',', '.');
        return parseFloat(t) || 0;
      }
      return {
        materialKc:  parseNum('cf-bw-material'),
        executionKc: parseNum('cf-bw-execution'),
        totalKc:     parseNum('cf-bw-total'),
        hours:       parseNum('cf-bw-time')
      };
    },

    serialize: function () {
      var boot = global.BASE_BOOT || {};
      var poly = getFootprintPolygon();
      var bb   = getBBox();
      var area = computeArea();
      var per  = computePerimeter();
      var mapData = null;
      if (_MapManager && _MapManager.center) {
        mapData = {
          address: _MapManager.address || null,
          center:  _MapManager.center  || null,
          bearing: _MapManager.bearing || 0
        };
      }
      return {
        v:             this.SCHEMA_VERSION,
        configKey:     this.CONFIG_KEY,
        productHandle: boot.productHandle || null,
        productId:     boot.productId     || null,
        productTitle:  boot.productTitle  || null,
        variant:       STATE.variant,
        variantKey:    ['pool'][STATE.variant - 1] || 'pool',
        lvl:           STATE.lvl,
        depth:         STATE.depth,
        edgeType:      STATE.edgeType,
        infiniteEdges: Array.isArray(STATE.infiniteEdges) ? STATE.infiniteEdges.slice() : [],
        wallMaterial:  STATE.wallMaterial,
        surface:       STATE.surface,
        stairsMode:    STATE.stairsMode,
        stairsSlot:    STATE.stairsSlot,
        shaft:         STATE.shaft,
        whirlpool:     STATE.whirlpool,
        tank:          STATE.tank,
        panel:         STATE.panel,
        skimmers:      STATE.skimmers,
        jets:          STATE.jets,
        lights:        STATE.lights,
        lightStage:    STATE.lightStage,
        lightPos:      STATE.lightPos,
        slope:         { active: STATE.slopeActive, deg: STATE.slopeDeg },
        mapLocked:     STATE.mapLocked,
        units:         STATE.isMetric ? 'm' : 'ft',
        shape: {
          polygon:     poly,
          bboxL:       bb.L,
          bboxW:       bb.W,
          area:        area,
          perimeter:   per,
          cornerCount: poly.length
        },
        totals:        this._readTotalsFromWidget(),
        map:           mapData,
        updatedAt:     new Date().toISOString()
      };
    },

    publish: function () {
      var self = this;
      if (this._saveTimer) clearTimeout(this._saveTimer);
      this._saveTimer = setTimeout(function () { self.publishNow(); }, 500);
    },

    publishNow: function () {
      if (!this._initialized || !this._projectId) return;
      try {
        var payload = this.serialize();
        localStorage.setItem(this._payloadKey(this.CONFIG_KEY), JSON.stringify(payload));
      } catch (e) {
        _dbg('ProjectStore publish error: ' + (e && e.message ? e.message : e));
      }
    },

    read: function (configKey) {
      if (!this._projectId || !configKey) return null;
      try {
        var raw = localStorage.getItem(this._payloadKey(configKey));
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (!data || data.v !== this.SCHEMA_VERSION) return null;
        return data;
      } catch (e) { return null; }
    },

    list: function () {
      if (!this._projectId) return [];
      var prefix = 'levaProject:p' + this._projectId + ':c' + this.getCustomerId() + ':';
      var keys = [];
      try {
        for (var i = 0; i < localStorage.length; i++) {
          var k = localStorage.key(i);
          if (k && k.indexOf(prefix) === 0) {
            keys.push(k.substring(prefix.length));
          }
        }
      } catch (e) {}
      return keys;
    },

    clear: function () {
      if (!this._projectId) return;
      try { localStorage.removeItem(this._payloadKey(this.CONFIG_KEY)); } catch (e) {}
    },

    subscribe: function (configKey, callback) {
      if (typeof callback !== 'function') return;
      if (!this._subscribers[configKey]) this._subscribers[configKey] = [];
      this._subscribers[configKey].push(callback);
    },

    unsubscribe: function (configKey, callback) {
      var arr = this._subscribers[configKey];
      if (!arr) return;
      for (var i = arr.length - 1; i >= 0; i--) {
        if (arr[i] === callback) arr.splice(i, 1);
      }
    },

    _onStorageEvent: function (e) {
      if (!this._projectId || !e || !e.key) return;
      var prefix = 'levaProject:p' + this._projectId + ':c' + this.getCustomerId() + ':';
      if (e.key.indexOf(prefix) !== 0) return;
      var configKey = e.key.substring(prefix.length);
      if (configKey === this.CONFIG_KEY) return;
      var arr = this._subscribers[configKey];
      if (!arr || !arr.length) return;
      var data = null;
      try { if (e.newValue) data = JSON.parse(e.newValue); } catch (_) {}
      for (var i = 0; i < arr.length; i++) {
        try { arr[i](data); } catch (_) {}
      }
    }
  };

  function _restoreFromProjectStore() {
    return _applyConfigPayload(_ProjectStore.read(_ProjectStore.CONFIG_KEY));
  }
  /* Restore STATE from a serialized payload object (ProjectStore.serialize
     shape). Shared by the localStorage restore and the cloud applyConfigId(). */
  function _applyConfigPayload(data) {
    if (!data) return false;
    var sh = data.shape || {};
    if (Array.isArray(sh.polygon) && sh.polygon.length >= 3) {
      var newPoly = [];
      for (var i = 0; i < sh.polygon.length; i++) {
        var p = sh.polygon[i];
        if (Array.isArray(p) && p.length === 2 && typeof p[0] === 'number' && typeof p[1] === 'number') {
          newPoly.push([_clampCoord(p[0]), _clampCoord(p[1])]);
        }
      }
      if (newPoly.length >= 3) STATE.polygon = newPoly;
    }
    if (typeof data.variant === 'number' && data.variant >= 1 && data.variant <= 5) {
      STATE.variant = data.variant;
    }
    if (typeof data.lvl === 'number' && data.lvl >= 1 && data.lvl <= 3) {
      STATE.lvl = data.lvl;
    }
    if (typeof data.depth === 'number' && isFinite(data.depth)) {
      STATE.depth = data.depth;
    } else if (data.depth === null) {
      STATE.depth = null;
    }
    if (data.edgeType === 'overflow' || data.edgeType === 'skimmer' || data.edgeType === 'infinite') {
      STATE.edgeType = data.edgeType;
    }
    if (Array.isArray(data.infiniteEdges)) {
      STATE.infiniteEdges = data.infiniteEdges.filter(function (v) { return typeof v === 'number' && v >= 0; });
    }
    if (data.wallMaterial === 'eps' || data.wallMaterial === 'concrete') {
      STATE.wallMaterial = data.wallMaterial;
    }
    if (typeof data.surface === 'string' && SURFACES.indexOf(data.surface) >= 0) {
      STATE.surface = data.surface;
    }
    if (typeof data.stairsMode === 'string' && STAIRS_CYCLE.indexOf(data.stairsMode) >= 0) {
      STATE.stairsMode = data.stairsMode;
    }
    if (typeof data.stairsSlot === 'number' && data.stairsSlot >= 0) {
      STATE.stairsSlot = data.stairsSlot | 0;
    }
    if (data.shaft && isFinite(data.shaft.x) && isFinite(data.shaft.z)) {
      STATE.shaft = { x: data.shaft.x, z: data.shaft.z };
    }
    if (data.whirlpool && isFinite(data.whirlpool.x) && isFinite(data.whirlpool.z)) {
      STATE.whirlpool = { x: data.whirlpool.x, z: data.whirlpool.z };
    }
    if (data.tank && isFinite(data.tank.x) && isFinite(data.tank.z)) {
      STATE.tank = { x: data.tank.x, z: data.tank.z };
    }
    if (data.panel && isFinite(data.panel.x) && isFinite(data.panel.z)) {
      STATE.panel = { x: data.panel.x, z: data.panel.z };
    }
    if (Array.isArray(data.skimmers)) STATE.skimmers = data.skimmers.filter(function (p) { return p && isFinite(p.x) && isFinite(p.z); });
    if (Array.isArray(data.jets))     STATE.jets     = data.jets.filter(function (p) { return p && isFinite(p.x) && isFinite(p.z); });
    if (Array.isArray(data.lights))   STATE.lights   = data.lights.filter(function (p) { return p && isFinite(p.x) && isFinite(p.z); });
    if (typeof data.lightStage === 'number') STATE.lightStage = Math.max(0, Math.min(5, data.lightStage | 0));
    if (data.lightPos === 'A' || data.lightPos === 'B' || data.lightPos === 'C') STATE.lightPos = data.lightPos;
    if (data.slope && typeof data.slope.deg === 'number') {
      STATE.slopeDeg = Math.max(0, Math.min(15, data.slope.deg | 0));
      STATE.slopeActive = !!data.slope.active;
    }
    if (data.units === 'ft') STATE.isMetric = false;
    if (data.units === 'm')  STATE.isMetric = true;
    STATE.mapLocked = !!data.mapLocked;
    if (data.map && Array.isArray(data.map.center) && data.map.center.length === 2) {
      _pendingMapRestore = {
        center:  data.map.center,
        address: data.map.address || '',
        bearing: typeof data.map.bearing === 'number' ? data.map.bearing : 0
      };
    }
    _dbg('config payload applied');
    return true;
  }

  var _pendingMapRestore = null;

  /* ------------------------------------------------------------------ *
   * Cloud config sharing (Firestore 'leva_configs')                    *
   * Enables shareable ?cfg= links and the budget strip's               *
   * applyConfigId(id) / shareConfig() for pool configs -- same contract *
   * as the BBQ configurator. Payload = _ProjectStore.serialize().      *
   * ------------------------------------------------------------------ */
  var _CFG_FS = { projectId: 'leva-791c5', apiKey: 'AIzaSyBoS6u5DLBF7ZYnB6egP9uvKLJ4lFHkNtI', col: 'leva_configs' };
  function _cfgNewId() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 8); }
  function _cfgUrl(id) { return location.origin + location.pathname + '?cfg=' + id; }
  function _cfgRestBase() {
    return 'https://firestore.googleapis.com/v1/projects/' + _CFG_FS.projectId +
           '/databases/(default)/documents/' + _CFG_FS.col;
  }
  function _cfgSaveDirect(payloadObj) {
    var id = _cfgNewId();
    var payloadStr = JSON.stringify(payloadObj);
    try {
      if (global.db && global.db.collection) {
        return global.db.collection(_CFG_FS.col).doc(id)
          .set({ type: 'pool', ts: Date.now(), payload: payloadStr })
          .then(function () { return { id: id, url: _cfgUrl(id) }; });
      }
    } catch (e) { _dbg('cfg SDK save threw: ' + (e && e.message)); }
    var body = { fields: {
      type:    { stringValue: 'pool' },
      ts:      { integerValue: String(Date.now()) },
      payload: { stringValue: payloadStr }
    } };
    return fetch(_cfgRestBase() + '?documentId=' + id + '&key=' + _CFG_FS.apiKey, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    }).then(function (rsp) {
      if (!rsp.ok) throw new Error('cfg save HTTP ' + rsp.status);
      return { id: id, url: _cfgUrl(id) };
    });
  }
  function _cfgLoadDirect(id) {
    try {
      if (global.db && global.db.collection) {
        return global.db.collection(_CFG_FS.col).doc(id).get().then(function (snap) {
          return (snap && snap.exists) ? snap.data() : null;
        });
      }
    } catch (e) { _dbg('cfg SDK load threw: ' + (e && e.message)); }
    return fetch(_cfgRestBase() + '/' + encodeURIComponent(id) + '?key=' + _CFG_FS.apiKey).then(function (rsp) {
      if (!rsp.ok) return null;
      return rsp.json().then(function (j) {
        var f = (j && j.fields) || {};
        return { type: f.type && f.type.stringValue, payload: f.payload && f.payload.stringValue };
      });
    });
  }
  function _cfgExtractPayload(doc) {
    if (!doc) return null;
    var p = doc.payload;
    if (p && typeof p === 'object' && p.pool) p = p.pool;   /* LevaConfig multi-aspect */
    if (typeof p === 'string') { try { p = JSON.parse(p); } catch (e) { return null; } }
    return (p && typeof p === 'object') ? p : null;
  }

  /* Save the current config -> returns { id, url }, and drops ?cfg= in the URL. */
  function shareConfig() {
    return _cfgSaveDirect(_ProjectStore.serialize()).then(function (r) {
      if (r && r.url) { try { history.replaceState(null, '', r.url); } catch (e) {} }
      _dbg('shareConfig: saved id=' + (r && r.id));
      return r;
    });
  }

  /* Load a saved config by id and apply it in place (no reload). */
  function applyConfigId(id) {
    if (!id) return Promise.resolve(false);
    return _cfgLoadDirect(id).then(function (doc) {
      var payload = _cfgExtractPayload(doc);
      if (!payload) { _dbg('applyConfigId: doc ' + id + ' not found/unreadable'); return false; }
      _applyConfigPayload(payload);
      try { _syncVariantNameDisplay(); } catch (e) {}
      try { _syncShopifyVariant(STATE.variant); } catch (e) {}
      try { refreshUI(); } catch (e) {}
      try { _forceRender3DFlush(2); } catch (e) {}
      try { if (_ProjectStore && _ProjectStore._initialized) _ProjectStore.publish(); } catch (e) {}
      _dbg('applyConfigId: applied ' + id);
      return true;
    }).catch(function (e) { _dbg('applyConfigId failed: ' + (e && e.message)); return false; });
  }

  /* Boot-time apply of a ?cfg= link (lowest priority -- called after the
     localStorage restore so a shared link wins when present). */
  function _cfgBootApply() {
    var m = /[?&]cfg=([^&]+)/.exec(location.search);
    if (!m) return;
    applyConfigId(decodeURIComponent(m[1]));
  }

  function _applyPendingMapRestore() {
    if (!_pendingMapRestore) return;
    if (!global.mapboxgl || !_MapManager || !_MapManager._loadMap) {
      setTimeout(_applyPendingMapRestore, 200);
      return;
    }
    var data = _pendingMapRestore;
    _pendingMapRestore = null;
    if (typeof data.bearing === 'number') _MapManager.bearing = data.bearing;
    try {
      _MapManager._loadMap(data.center, data.address);
      try { _MapManager.persist(); } catch (ep) {}
      _dbg('Map restored from storage: ' + JSON.stringify(data.center));
    } catch (e) {
      _dbg('Map restore failed: ' + e.message);
    }
  }

  function _init2DZoom() {
    function getCanvas() {
      return global.BaseEngine && global.BaseEngine.renderer && global.BaseEngine.renderer.domElement;
    }
    function getOrtho() {
      return global.BaseEngine && global.BaseEngine.cameraOrtho;
    }
    function render() {
      var eng = global.BaseEngine;
      if (eng && eng.renderer && eng.camera) eng.renderer.render(eng.scene, eng.camera);
    }
    function applyZoom(factor) {
      var cam = getOrtho();
      if (!cam) return;
      cam.zoom = Math.max(0.2, Math.min(8, cam.zoom * factor));
      cam.updateProjectionMatrix();
      render();
      if (typeof positionDragHandles === 'function') positionDragHandles();
      if (_VisualizationManager && _VisualizationManager.refreshDimensions) _VisualizationManager.refreshDimensions();
      _orthoEventEmitter.fire();
    }

    var canvas = getCanvas();
    if (!canvas) { setTimeout(_init2DZoom, 100); return; }

    canvas.addEventListener('wheel', function (e) {
      if (STATE.view !== '2d') return;
      e.preventDefault();
      var factor = e.deltaY > 0 ? (1 / 1.1) : 1.1;
      applyZoom(factor);
    }, { passive: false });

    var pinch = { active: false, lastDist: 0 };
    canvas.addEventListener('touchstart', function (e) {
      if (STATE.view !== '2d') return;
      if (e.touches.length === 2) {
        pinch.active = true;
        pinch.lastDist = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
      }
    }, { passive: true });
    canvas.addEventListener('touchmove', function (e) {
      if (STATE.view !== '2d' || !pinch.active || e.touches.length !== 2) return;
      e.preventDefault();
      var dist = Math.hypot(
        e.touches[0].clientX - e.touches[1].clientX,
        e.touches[0].clientY - e.touches[1].clientY
      );
      if (pinch.lastDist > 0) applyZoom(dist / pinch.lastDist);
      pinch.lastDist = dist;
    }, { passive: false });
    function endPinch(e) {
      if (!e.touches || e.touches.length < 2) pinch.active = false;
    }
    canvas.addEventListener('touchend',    endPinch);
    canvas.addEventListener('touchcancel', endPinch);
  }

  function _init2DMapPan() {
    var canvas = global.BaseEngine && global.BaseEngine.renderer && global.BaseEngine.renderer.domElement;
    if (!canvas) { setTimeout(_init2DMapPan, 100); return; }
    var drag = { active: false, lastX: 0, lastY: 0, pointerId: null };

    function canPan() {
      if (STATE.view !== '2d') return false;
      if (!_MapManager || !_MapManager.map) return false;
      if (_CornerInserter && _CornerInserter.pendingPlacement) return false;
      var mapDiv = document.getElementById('cf-mapbox');
      if (!mapDiv || !mapDiv.classList.contains('cf-map-visible')) return false;
      return true;
    }

    canvas.addEventListener('pointerdown', function (e) {
      if (!canPan()) return;
      if (e.button !== 0 && e.pointerType === 'mouse') return;
      drag.active = true;
      drag.lastX = e.clientX;
      drag.lastY = e.clientY;
      drag.pointerId = e.pointerId;
      try { canvas.setPointerCapture(e.pointerId); } catch (_) {}
    });

    canvas.addEventListener('pointermove', function (e) {
      if (!drag.active || e.pointerId !== drag.pointerId) return;
      if (!canPan()) { drag.active = false; return; }
      var dx = e.clientX - drag.lastX;
      var dy = e.clientY - drag.lastY;
      drag.lastX = e.clientX;
      drag.lastY = e.clientY;
      if (_MapManager.map && (dx !== 0 || dy !== 0)) {
        _MapManager.map.panBy([-dx, -dy], { animate: false });
      }
    });

    function endDrag(e) {
      if (!drag.active) return;
      drag.active = false;
      try { if (e) canvas.releasePointerCapture(e.pointerId); } catch (_) {}
    }
    canvas.addEventListener('pointerup',     endDrag);
    canvas.addEventListener('pointercancel', endDrag);
    canvas.addEventListener('pointerleave',  endDrag);
  }

  function _injectTooltipCSS() {
    if (document.getElementById('cf-tooltip-runtime-css-base')) return;
    var css = [
      '#cf-wrap-base .cf-icon-btn { position: relative !important; overflow: visible !important; }',
      '#cf-wrap-base .cf-sidebar { overflow: visible !important; }',
      '#cf-wrap-base .cf-icon-btn::after {',
      '  content: attr(title) !important;',
      '  position: absolute !important;',
      '  right: calc(100% + 8px) !important;',
      '  top: 50% !important;',
      '  transform: translateY(-50%) !important;',
      '  background: rgba(20, 20, 20, 0.92) !important;',
      '  color: #fff !important;',
      '  padding: 6px 10px !important;',
      '  border-radius: 6px !important;',
      '  font: 600 11px/1.2 Montserrat, -apple-system, sans-serif !important;',
      '  letter-spacing: 0.02em !important;',
      '  white-space: nowrap !important;',
      '  pointer-events: none !important;',
      '  opacity: 0 !important;',
      '  transition: opacity 0.15s ease !important;',
      '  z-index: 9999 !important;',
      '  display: block !important;',
      '  visibility: visible !important;',
      '}',
      '#cf-wrap-base .cf-icon-btn:hover::after,',
      '#cf-wrap-base .cf-icon-btn:active::after,',
      '#cf-wrap-base .cf-icon-btn.show-tip::after { opacity: 1 !important; }'
    ].join('\n');
    var style = document.createElement('style');
    style.id = 'cf-tooltip-runtime-css-base';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  function _bindIconTooltips() {
    _injectTooltipCSS();
    var btns = document.querySelectorAll('#cf-wrap-base .cf-icon-btn');
    var tipTimer = null;
    btns.forEach(function (btn) {
      btn.addEventListener('touchstart', function () {
        if (tipTimer) clearTimeout(tipTimer);
        document.querySelectorAll('#cf-wrap-base .cf-icon-btn.show-tip').forEach(function (b) {
          b.classList.remove('show-tip');
        });
        btn.classList.add('show-tip');
        tipTimer = setTimeout(function () { btn.classList.remove('show-tip'); }, 1500);
      }, { passive: true });
    });
  }

  function _rebuildGrid(eng) {
    var T = global.THREE;
    if (!T || !eng || !eng.scene) return;
    if (eng._gridHelper) {
      eng.scene.remove(eng._gridHelper);
      if (eng._gridHelper.geometry) eng._gridHelper.geometry.dispose();
      if (eng._gridHelper.material) eng._gridHelper.material.dispose();
      eng._gridHelper = null;
    }
    var step = STATE.isMetric ? 1.0 : 0.3048;
    /* Fixed ~30 m grid; grows to fit a bigger pool (footprint + a small
       margin) and shrinks back to 30 m when the pool gets smaller again, so
       it never stays extremely large. */
    var BASE_SIZE = 30;
    var maxDim = 0;
    var poly = getFootprintPolygon();
    if (poly && poly.length >= 3) {
      var xmn = Infinity, xmx = -Infinity, zmn = Infinity, zmx = -Infinity;
      for (var gi = 0; gi < poly.length; gi++) {
        var gx = poly[gi][0], gz = poly[gi][1];
        if (gx < xmn) xmn = gx; if (gx > xmx) xmx = gx;
        if (gz < zmn) zmn = gz; if (gz > zmx) zmx = gz;
      }
      maxDim = Math.max(xmx - xmn, zmx - zmn);
    }
    var size = Math.max(BASE_SIZE, Math.ceil((maxDim * 1.2) / step) * step);
    var divisions = Math.round(size / step);
    eng._gridHelper = new T.GridHelper(size, divisions, 0xcccccc, 0xe5e5e5);
    /* Almost-invisible ground grid: it clutters the basic 3D view, so drop it
       to ~5 % opacity (95 % transparent). depthWrite off avoids the faint lines
       z-fighting with the pad/water under low camera angles. */
    if (eng._gridHelper.material) {
      var _gm = Array.isArray(eng._gridHelper.material) ? eng._gridHelper.material : [eng._gridHelper.material];
      for (var _gmi = 0; _gmi < _gm.length; _gmi++) {
        _gm[_gmi].transparent = true;
        _gm[_gmi].opacity = 0.05;
        _gm[_gmi].depthWrite = false;
      }
    }
    /* When slope is active, tilt the entire grid by the slope angle
       around an axis perpendicular to the bearing direction so the
       grid lines lie on the terrain plane. Intrinsic Euler 'YZX':
         1. Yaw by bearing so local +X points uphill.
         2. Tilt by slope around the new local +Z (now perpendicular
            to the uphill direction, in the horizontal plane). */
    /* When slope is active we DON'T tilt the grid. A tilted GridHelper
       rotates about its own centre (X=0), whereas the fence grade is
       referenced to xMax -- different pivots, so the two never line up
       and the grid appears to slope against the fence. Instead we leave
       the grid flat and let the terrain plane (heighted per-vertex from
       _padSlopeExtra, the same formula the fence uses) represent the
       slope as a true ground surface under the model. */
    eng._gridHelper.rotation.set(0, 0, 0);
    if (STATE.slopeActive && STATE.slopeDeg > 0) {
      /* Slope active -> hide the flat base grid entirely. The slope-
         conforming grid built in _build3D_SlopeViz (heighted per-vertex
         from the same _padSlopeExtra the fence uses) takes its place, so
         there's exactly one grid and it sits on grade under the model. */
      eng._gridHelper.visible = false;
      eng.scene.add(eng._gridHelper);
      return;
    }
    eng._gridHelper.visible = true;
    eng.scene.add(eng._gridHelper);
  }

  /* The flat base grid must be hidden whenever slope is active (the
     slope-conforming grid from _build3D_SlopeViz replaces it). Several
     call sites toggle grid visibility, so they all route through this. */
  function _applyGridVisibility(eng) {
    if (!eng || !eng._gridHelper) return;
    var slope = STATE.slopeActive && STATE.slopeDeg > 0;
    eng._gridHelper.visible = !slope;
  }

  var _orthoEventEmitter = {
    _listeners: [],
    addEventListener: function (name, cb) {
      if (name === 'change' && typeof cb === 'function') this._listeners.push(cb);
    },
    fire: function () {
      for (var i = 0; i < this._listeners.length; i++) {
        try { this._listeners[i](); } catch (e) {}
      }
    }
  };

  function _loadMapboxSDK() {
    if (global.mapboxgl) return Promise.resolve();
    if (global.__cfBaseMapSDKPromise) return global.__cfBaseMapSDKPromise;
    global.__cfBaseMapSDKPromise = new Promise(function (resolve, reject) {
      if (!document.getElementById('cf-mapbox-gl-css')) {
        var css = document.createElement('link');
        css.id = 'cf-mapbox-gl-css';
        css.rel = 'stylesheet';
        css.href = 'https://api.mapbox.com/mapbox-gl-js/v3.0.1/mapbox-gl.css';
        document.head.appendChild(css);
      }
      var existing = document.getElementById('cf-mapbox-gl-js');
      if (existing) {
        existing.addEventListener('load', function () { resolve(); });
        existing.addEventListener('error', function () { reject(new Error('Mapbox SDK load failed')); });
        return;
      }
      var script = document.createElement('script');
      script.id = 'cf-mapbox-gl-js';
      script.src = 'https://api.mapbox.com/mapbox-gl-js/v3.0.1/mapbox-gl.js';
      script.onload = function () { resolve(); };
      script.onerror = function () { reject(new Error('Mapbox SDK load failed')); };
      document.head.appendChild(script);
    });
    return global.__cfBaseMapSDKPromise;
  }

  function _injectMapCSS() {
    if (document.getElementById('cf-base-map-css')) return;
    var css = [
      '#cf-mapbox {',
      '  position: absolute !important; inset: 0;',
      '  width: 100% !important; height: 100% !important;',
      '  z-index: 0; background-color: #f5f5f5;',
      '  transition: opacity 0.35s ease; display: none;',
      '}',
      '#cf-mapbox.cf-map-visible { display: block; }',
      '#cf-wrap-base .cf-map-fade {',
      '  position: absolute; inset: 0; z-index: 1;',
      '  pointer-events: none; display: none;',
      '  background:',
      '    linear-gradient(to right,  rgba(245,245,245,1) 0%, rgba(245,245,245,0.85) 4%, rgba(245,245,245,0.50) 8%, rgba(245,245,245,0) 14%) left   / 100% 100% no-repeat,',
      '    linear-gradient(to left,   rgba(245,245,245,1) 0%, rgba(245,245,245,0.85) 4%, rgba(245,245,245,0.50) 8%, rgba(245,245,245,0) 14%) right  / 100% 100% no-repeat,',
      '    linear-gradient(to bottom, rgba(245,245,245,1) 0%, rgba(245,245,245,0.85) 4%, rgba(245,245,245,0.50) 8%, rgba(245,245,245,0) 14%) top    / 100% 100% no-repeat,',
      '    linear-gradient(to top,    rgba(245,245,245,1) 0%, rgba(245,245,245,0.85) 4%, rgba(245,245,245,0.50) 8%, rgba(245,245,245,0) 14%) bottom / 100% 100% no-repeat;',
      '}',
      '#cf-wrap-base .cf-map-fade.cf-map-visible { display: block; }',
      '#cf-mapbox .mapboxgl-ctrl-attrib, #cf-mapbox .mapboxgl-ctrl-logo { display: none !important; }',
      '#cf-wrap-base .cf-map-credit {',
      '  position: absolute; left: 10px; bottom: 10px; z-index: 150;',
      '  font: 9px/1 system-ui, sans-serif; color: rgba(0,0,0,0.5);',
      '  background: rgba(255,255,255,0.7); padding: 3px 6px; border-radius: 4px;',
      '  pointer-events: none; display: none;',
      '}',
      '#cf-wrap-base .cf-map-credit.cf-map-visible { display: block; }',
      '#cf-wrap-base.cf-has-map .cf-canvas { background-color: transparent !important; }',
      '#cf-wrap-base.cf-has-map { background: #f5f5f5; }',
      '.cf-map-modal-backdrop {',
      '  position: fixed; inset: 0; z-index: 9999;',
      '  background: rgba(0,0,0,0.45); display: none;',
      '  align-items: center; justify-content: center;',
      '}',
      '.cf-map-modal-backdrop.open { display: flex; }',
      '.cf-map-modal {',
      '  background: #fff; border-radius: 14px; box-shadow: 0 20px 60px rgba(0,0,0,0.30);',
      '  padding: 18px 18px 14px; width: min(380px, calc(100vw - 32px));',
      '  font-family: Montserrat, -apple-system, sans-serif;',
      '}',
      '.cf-map-modal h3 {',
      '  margin: 0 0 12px; font-size: 14px; font-weight: 700; color: #111;',
      '  letter-spacing: 0.02em;',
      '}',
      '.cf-map-modal-input-wrap { position: relative; }',
      '.cf-map-modal input {',
      '  width: 100%; padding: 10px 12px; border: 1px solid #e0e0e0; border-radius: 8px;',
      '  font: 13px/1.3 Montserrat, sans-serif; outline: none; box-sizing: border-box;',
      '}',
      '.cf-map-modal input:focus { border-color: #5A6B47; }',
      '.cf-map-modal-suggestions {',
      '  position: absolute; top: 100%; left: 0; right: 0; margin-top: 4px;',
      '  background: #fff; border: 1px solid #e0e0e0; border-radius: 8px;',
      '  box-shadow: 0 6px 20px rgba(0,0,0,0.10);',
      '  max-height: 220px; overflow-y: auto; display: none; z-index: 10;',
      '}',
      '.cf-map-modal-suggestions.open { display: block; }',
      '.cf-map-modal-sugg-item {',
      '  padding: 9px 12px; font: 12px/1.35 Montserrat, sans-serif; color: #333;',
      '  cursor: pointer; border-bottom: 1px solid #f0f0f0;',
      '}',
      '.cf-map-modal-sugg-item:last-child { border-bottom: none; }',
      '.cf-map-modal-sugg-item:hover { background: #f5f5f0; }',
      '.cf-map-modal-buttons { display: flex; gap: 8px; margin-top: 12px; }',
      '.cf-map-modal-btn {',
      '  flex: 1; padding: 9px 14px; border: none; border-radius: 8px;',
      '  font: 700 12px Montserrat, sans-serif; cursor: pointer;',
      '  letter-spacing: 0.02em;',
      '}',
      '.cf-map-modal-btn-cancel { background: #f0f0f0; color: #555; }',
      '.cf-map-modal-btn-cancel:hover { background: #e6e6e6; }',
      '.cf-map-modal-btn-ok { background: #5A6B47; color: #fff; }',
      '.cf-map-modal-btn-ok:hover { background: #4a5a3b; }',
      '.cf-map-modal-btn-ok:disabled { opacity: 0.4; cursor: not-allowed; }',
      '#cf-wrap-base .cf-map-controls {',
      '  position: absolute; z-index: 220;',
      '  display: none; align-items: flex-start;',
      '  pointer-events: none;',
      '}',
      '#cf-wrap-base .cf-map-controls.open { display: flex; }',
      '#cf-wrap-base .cf-map-controls > * { pointer-events: auto; }',
      '.cf-map-rotate-vert {',
      '  display: flex; flex-direction: column; align-items: center; gap: 8px;',
      '}',
      '.cf-map-rotate-slider {',
      '  -webkit-appearance: none; appearance: none;',
      '  accent-color: var(--cf-accent, #5A6B47);',
      '  writing-mode: vertical-lr; direction: rtl;',
      '  width: 4px; height: 320px;',
      '  background: linear-gradient(to top, var(--cf-accent, #5A6B47) 0%, var(--cf-accent, #5A6B47) var(--cf-fill, 0%), #e0e0e0 var(--cf-fill, 0%), #e0e0e0 100%);',
      '  border-radius: 10px; outline: none; cursor: pointer;',
      '}',
      '.cf-map-rotate-slider::-webkit-slider-thumb {',
      '  -webkit-appearance: none; appearance: none;',
      '  width: 12px; height: 12px; background: var(--cf-accent, #5A6B47);',
      '  border: none; border-radius: 50%; cursor: pointer;',
      '  box-shadow: 0 2px 6px rgba(0,0,0,0.20);',
      '}',
      '.cf-map-rotate-slider::-moz-range-thumb {',
      '  width: 12px; height: 12px; background: var(--cf-accent, #5A6B47);',
      '  border: none; border-radius: 50%; cursor: pointer;',
      '  box-shadow: 0 2px 6px rgba(0,0,0,0.20);',
      '}',
      '.cf-map-right-col { display: flex; flex-direction: column; gap: 10px; }',
      '.cf-map-style-row { display: flex; gap: 6px; align-items: center; }',
      '.cf-map-style-btn {',
      '  width: 42px; height: 32px; border: none; border-radius: 8px; cursor: pointer;',
      '  background: rgba(255,255,255,0.92); color: #333; font: 700 10px sans-serif;',
      '  box-shadow: 0 2px 6px rgba(0,0,0,0.08);',
      '  display: flex; align-items: center; justify-content: center;',
      '  transition: all 0.15s;',
      '}',
      '.cf-map-style-btn.active { background: #111; color: #fff; }',
      '.cf-map-lock-btn { color: #888; }',
      '.cf-map-lock-btn.locked { background: #c44; color: #fff; }',
      '.cf-map-lock-btn.locked svg { stroke: #fff; }',
      '#cf-wrap-base .cf-icon-btn.cf-map-btn-active { background: #5A6B47 !important; }',
      '#cf-wrap-base .cf-icon-btn.cf-map-btn-active img,',
      '#cf-wrap-base .cf-icon-btn.cf-map-btn-active svg { filter: brightness(0) invert(1) !important; }',
      '#cf-wrap-base .cf-icon-btn.cf-map-btn-active:hover { background: #5A6B47 !important; }'
    ].join('\n');
    var style = document.createElement('style');
    style.id = 'cf-base-map-css';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  function _injectMapDOM() {
    var wrap = document.getElementById('cf-wrap-base');
    if (!wrap) return;
    var canvas = document.getElementById('cf-canvas-base');

    if (!document.getElementById('cf-mapbox')) {
      var mapDiv = document.createElement('div');
      mapDiv.id = 'cf-mapbox';
      if (canvas) wrap.insertBefore(mapDiv, canvas); else wrap.appendChild(mapDiv);
    }
    if (!wrap.querySelector('.cf-map-fade')) {
      var fade = document.createElement('div');
      fade.className = 'cf-map-fade';
      if (canvas) wrap.insertBefore(fade, canvas); else wrap.appendChild(fade);
    }
    if (!document.getElementById('cf-map-credit')) {
      var credit = document.createElement('div');
      credit.id = 'cf-map-credit';
      credit.className = 'cf-map-credit';
      credit.textContent = '\u00a9 Mapbox \u00a9 OpenStreetMap';
      wrap.appendChild(credit);
    }
    if (!document.getElementById('cf-map-controls')) {
      var ctrls = document.createElement('div');
      ctrls.id = 'cf-map-controls';
      ctrls.className = 'cf-map-controls cf-map-stacked';
      ctrls.innerHTML =
        '<div class="cf-map-rotate-vert">' +
        '  <input type="range" id="cf-map-rotate" class="cf-map-rotate-slider" min="0" max="360" step="1" value="0" aria-label="Rotation">' +
        '</div>' +
        '<div class="cf-map-right-col">' +
        '  <div class="cf-map-style-row">' +
        '    <button id="cf-map-style-streets" class="cf-map-style-btn active" type="button">MAP</button>' +
        '    <button id="cf-map-style-satellite" class="cf-map-style-btn" type="button">SAT</button>' +
        '    <button id="cf-map-lock" class="cf-map-style-btn cf-map-lock-btn" type="button" title="Lock map position" aria-pressed="false">' +
        '      <svg id="cf-map-lock-icon" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '        <rect x="5" y="11" width="14" height="9" rx="2"/>' +
        '        <path d="M8 11V7a4 4 0 0 1 8 0v4" id="cf-map-lock-shackle"/>' +
        '      </svg>' +
        '    </button>' +
        '  </div>' +
        '</div>';
      wrap.appendChild(ctrls);
    }
    if (!document.getElementById('cf-map-modal-backdrop')) {
      var modal = document.createElement('div');
      modal.id = 'cf-map-modal-backdrop';
      modal.className = 'cf-map-modal-backdrop';
      modal.innerHTML =
        '<div class="cf-map-modal" role="dialog" aria-modal="true">' +
        '  <h3>Map location</h3>' +
        '  <div class="cf-map-modal-input-wrap">' +
        '    <input id="cf-map-address-input" type="text" placeholder="Address, city or place..." autocomplete="off">' +
        '    <div id="cf-map-suggestions" class="cf-map-modal-suggestions"></div>' +
        '  </div>' +
        '  <div class="cf-map-modal-buttons">' +
        '    <button id="cf-map-modal-cancel" type="button" class="cf-map-modal-btn cf-map-modal-btn-cancel">Cancel</button>' +
        '    <button id="cf-map-modal-ok" type="button" class="cf-map-modal-btn cf-map-modal-btn-ok" disabled>Load</button>' +
        '  </div>' +
        '</div>';
      document.body.appendChild(modal);
    }
    var sidebar = wrap.querySelector('.cf-sidebar');
    if (sidebar && !document.getElementById('cf-btn-map')) {
      var btn = document.createElement('button');
      btn.id = 'cf-btn-map';
      btn.className = 'cf-icon-btn';
      btn.type = 'button';
      var _mapI18n = (global.BASE_BOOT && global.BASE_BOOT.i18n) || {};
      btn.title = _mapI18n.fence_map || _mapI18n.addBackground || 'Add map background';
      btn.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6l6-2 6 2 6-2v14l-6 2-6-2-6 2z"/><path d="M9 4v16"/><path d="M15 6v16"/></svg>';
      var shareBtn = document.getElementById('cf-btn-share');
      if (shareBtn && shareBtn.parentNode === sidebar) {
        sidebar.insertBefore(btn, shareBtn.nextSibling);
      } else {
        sidebar.appendChild(btn);
      }
    }

    /* Lights button -- placed right after the stairs mirror button. Cycles
       light stages 0(off) -> 1/A ... 5/C. Shows the current stage as a label. */
    if (sidebar && !document.getElementById('cf-btn-lights')) {
      var lbtn = document.createElement('button');
      lbtn.id = 'cf-btn-lights';
      lbtn.className = 'cf-icon-btn';
      lbtn.type = 'button';
      lbtn.title = 'Pool lights';
      lbtn.style.position = 'relative';
      lbtn.innerHTML =
        '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<circle cx="12" cy="10" r="5"/>' +
        '<path d="M9 18h6M10 21h4M12 1v2M4.2 5.2l1.4 1.4M19.8 5.2l-1.4 1.4"/>' +
        '</svg>' +
        '<span class="cf-btn-lights-label" style="position:absolute;bottom:1px;right:2px;font-size:9px;font-weight:700;line-height:1;"></span>';
      var mirrorBtn = document.getElementById('cf-btn-stairs-mirror');
      if (mirrorBtn && mirrorBtn.parentNode === sidebar) {
        sidebar.insertBefore(lbtn, mirrorBtn.nextSibling);
      } else {
        sidebar.appendChild(lbtn);
      }
      lbtn.addEventListener('click', function () { cycleLightStage(); });
      _updateLightButton();
    }
  }

  var _MapManager = (function () {
    var I18N_DEFAULTS = {
      rotation:           'Rotation',
      streets:            'Roadmap',
      satellite:          'Satellite',
      addressPlaceholder: 'Address, city or place\u2026',
      load:               'Load',
      cancel:             'Cancel',
      modalTitle:         'Map location',
      addBackground:      'Add map background',
      changeLocation:     'Change map location'
    };

    var MM = {
      _deps: null,
      _i18n: I18N_DEFAULTS,
      _storageKey: null,
      MAPBOX_TOKEN: null,
      STYLE_STREETS:   'mapbox://styles/mapbox/light-v11',
      STYLE_SATELLITE: 'mapbox://styles/mapbox/satellite-streets-v12',

      map: null,
      currentStyle: 'streets',
      center: null,
      zoomLevel: null,
      bearing: 0,
      address: '',
      _geocodeAbort: null,
      _suggestionItems: [],
      _suppressStorageEvent: false,

      _bindUI: function () {
        var self = this;
        if (!global.mapboxgl) return;
        global.mapboxgl.accessToken = this.MAPBOX_TOKEN;

        var btn = document.getElementById('cf-btn-map');
        if (btn) btn.addEventListener('click', function () {
          var mapDiv = document.getElementById('cf-mapbox');
          var visible = mapDiv && mapDiv.classList.contains('cf-map-visible');
          if (self.map && visible) self._hideMap();
          else self._openModal();
        });

        var backdrop = document.getElementById('cf-map-modal-backdrop');
        var input    = document.getElementById('cf-map-address-input');
        var okBtn    = document.getElementById('cf-map-modal-ok');
        var cancelBtn= document.getElementById('cf-map-modal-cancel');
        var sugg     = document.getElementById('cf-map-suggestions');
        if (!backdrop || !input || !okBtn || !cancelBtn || !sugg) return;

        backdrop.addEventListener('click', function (e) {
          if (e.target === backdrop) self._closeModal();
        });
        cancelBtn.addEventListener('click', function () { self._closeModal(); });

        var debounceT = null;
        input.addEventListener('input', function () {
          clearTimeout(debounceT);
          var q = input.value.trim();
          if (q.length < 3) {
            sugg.classList.remove('open');
            okBtn.disabled = true;
            return;
          }
          debounceT = setTimeout(function () { self._geocode(q); }, 300);
        });

        okBtn.addEventListener('click', function () {
          var selected = null;
          for (var i = 0; i < self._suggestionItems.length; i++) {
            if (self._suggestionItems[i].selected) { selected = self._suggestionItems[i]; break; }
          }
          if (!selected) selected = self._suggestionItems[0];
          if (!selected) return;
          self._loadMap(selected.center, selected.label);
          self._closeModal();
        });

        var btnS  = document.getElementById('cf-map-style-streets');
        var btnSa = document.getElementById('cf-map-style-satellite');
        if (btnS)  btnS.addEventListener('click',  function () { self._setStyle('streets'); });
        if (btnSa) btnSa.addEventListener('click', function () { self._setStyle('satellite'); });

        var btnLock = document.getElementById('cf-map-lock');
        if (btnLock) {
          btnLock.addEventListener('click', function () {
            STATE.mapLocked = !STATE.mapLocked;
            _updateMapLockButton();
            if (_ProjectStore && _ProjectStore._initialized) _ProjectStore.publish();
          });
        }

        var rotateInput = document.getElementById('cf-map-rotate');
        if (rotateInput) {
          var updateRotateFill = function () {
            var pct = (parseFloat(rotateInput.value) / 360) * 100;
            rotateInput.style.setProperty('--cf-fill', pct + '%');
          };
          rotateInput.addEventListener('input', function () {
            var deg = parseInt(rotateInput.value, 10);
            self.bearing = deg;
            if (self.map) {
              if (self._deps.getView() === '3d') {
                self._syncMapTo3D(false);
              } else {
                self.map.setBearing(deg);
              }
            }
            updateRotateFill();
            if (STATE.slopeActive && STATE.slopeDeg > 0) {
              if (self._slopeRefreshTimer) clearTimeout(self._slopeRefreshTimer);
              self._slopeRefreshTimer = setTimeout(function () {
                self._slopeRefreshTimer = null;
                if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
                refreshUI();
              }, 1000);
            }
          });
          updateRotateFill();
        }

        this._updateSidebarButton();
      },

      _openModal: function () {
        var bd = document.getElementById('cf-map-modal-backdrop');
        var input = document.getElementById('cf-map-address-input');
        if (bd) bd.classList.add('open');
        if (input) { input.value = this.address || ''; setTimeout(function () { input.focus(); }, 50); }
      },
      _closeModal: function () {
        var bd = document.getElementById('cf-map-modal-backdrop');
        var sugg = document.getElementById('cf-map-suggestions');
        if (bd) bd.classList.remove('open');
        if (sugg) sugg.classList.remove('open');
      },

      _geocode: function (query) {
        var self = this;
        if (this._geocodeAbort) this._geocodeAbort.abort();
        this._geocodeAbort = new AbortController();
        var url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' +
                  encodeURIComponent(query) + '.json?access_token=' + this.MAPBOX_TOKEN +
                  '&autocomplete=true&limit=5&types=address,place,locality,neighborhood,region';
        fetch(url, { signal: this._geocodeAbort.signal })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var sugg = document.getElementById('cf-map-suggestions');
            var okBtn = document.getElementById('cf-map-modal-ok');
            if (!sugg || !okBtn) return;
            sugg.innerHTML = '';
            var feats = (data && data.features) || [];
            self._suggestionItems = feats.map(function (f, i) {
              return { label: f.place_name, center: f.center, selected: i === 0 };
            });
            if (!self._suggestionItems.length) {
              sugg.classList.remove('open');
              okBtn.disabled = true;
              return;
            }
            self._suggestionItems.forEach(function (s) {
              var div = document.createElement('div');
              div.className = 'cf-map-modal-sugg-item';
              div.textContent = s.label;
              div.addEventListener('click', function () {
                self._suggestionItems.forEach(function (it) { it.selected = false; });
                s.selected = true;
                var input = document.getElementById('cf-map-address-input');
                if (input) input.value = s.label;
                sugg.classList.remove('open');
                okBtn.disabled = false;
              });
              sugg.appendChild(div);
            });
            sugg.classList.add('open');
            okBtn.disabled = false;
          })
          .catch(function (e) {
            if (e && e.name !== 'AbortError') _dbg('geocode failed: ' + e.message);
          });
      },

      _computeZoomForLat: function (lat) {
        var wrap = document.getElementById('cf-wrap-base');
        if (!wrap) return 18;
        var canvasW = wrap.clientWidth;
        var cam = this._deps.orthoCamera;
        if (!cam) return 18;
        var frustumW = (cam.right - cam.left) / (cam.zoom || 1);
        var ourMpp = frustumW / canvasW;
        return Math.log2(78271.51696 * Math.cos(lat * Math.PI / 180) / ourMpp);
      },

      _loadMap: function (center, label) {
        var self = this;
        this.center = center;
        this.address = label;
        this.zoomLevel = this._computeZoomForLat(center[1]);

        var mapDiv = document.getElementById('cf-mapbox');
        var creditEl = document.getElementById('cf-map-credit');
        var wrap = document.getElementById('cf-wrap-base');
        var fade = document.querySelector('#cf-wrap-base .cf-map-fade');
        if (mapDiv) mapDiv.classList.add('cf-map-visible');
        if (creditEl) creditEl.classList.add('cf-map-visible');
        if (wrap) wrap.classList.add('cf-has-map');
        if (fade) fade.classList.add('cf-map-visible');

        /* No scene.background to clear -- Stage renders with a transparent
           clear colour, so #cf-mapbox under the canvas is visible as soon
           as the wrapper gets .cf-has-map. */

        if (this.map) {
          this.map.jumpTo({ center: center, zoom: this.zoomLevel, bearing: this.bearing });
        } else {
          this.map = new global.mapboxgl.Map({
            container: 'cf-mapbox',
            style: this.STYLE_STREETS,
            center: center,
            zoom: this.zoomLevel,
            bearing: this.bearing,
            pitch: 0,
            attributionControl: false,
            interactive: false,
            preserveDrawingBuffer: true
          });
          this.map.dragPan.disable();
          this.map.scrollZoom.disable();
          this.map.boxZoom.disable();
          this.map.dragRotate.disable();
          this.map.keyboard.disable();
          this.map.doubleClickZoom.disable();
          this.map.touchZoomRotate.disable();

          this._updateSidebarButton();

          var canvas = document.getElementById('cf-canvas-base');
          if (canvas) canvas.style.pointerEvents = 'auto';

          var syncZoom = function () {
            if (!self.map || !self.center) return;
            if (self._deps.getView() !== '2d-top') return;
            var z = self._computeZoomForLat(self.center[1]);
            if (Math.abs(z - self.zoomLevel) > 0.005) {
              self.zoomLevel = z;
              self.map.setZoom(z);
            }
          };
          if (this._deps.orthoControls && this._deps.orthoControls.addEventListener) {
            this._deps.orthoControls.addEventListener('change', syncZoom);
          }
          window.addEventListener('resize', function () { setTimeout(syncZoom, 50); });
          setTimeout(syncZoom, 100);

          if (this._deps.controls && this._deps.controls.addEventListener) {
            var _syncPending = false;
            this._deps.controls.addEventListener('change', function () {
              if (self._deps.getView() !== '3d' || !self.map || !self.center) return;
              if (_syncPending) return;
              _syncPending = true;
              requestAnimationFrame(function () {
                _syncPending = false;
                if (self._deps.getView() === '3d' && self.map && self.center) self._syncMapTo3D(false);
              });
            });
          }

          this.map.on('style.load', function () {
            self._install3DLayers();
            if (self._deps.getView() === '3d') self._syncMapTo3D(false);
          });

          this.map.on('moveend', function () {
            if (!self.map) return;
            var c = self.map.getCenter();
            self.center = [c.lng, c.lat];
            self.zoomLevel = self.map.getZoom();
            if (self._deps.getView() !== '3d') {
              self.bearing = self.map.getBearing();
            }
            /* Persist the panned/zoomed position to the map's own storage
               (read back by loadFromStorage on reload) AND to the project
               store, so a page refresh restores where the map was moved to
               rather than re-loading the original address. */
            self.persist();
            if (_ProjectStore && _ProjectStore._initialized) _ProjectStore.publish();
          });

          _applyMapLockState();

          if (typeof ResizeObserver !== 'undefined' && mapDiv) {
            new ResizeObserver(function () {
              if (self.map) { self.map.resize(); syncZoom(); }
            }).observe(mapDiv);
          }
        }

        var ctrls = document.getElementById('cf-map-controls');
        if (ctrls) ctrls.classList.add('open');
        this._deps.onChange();
      },

      _hideMap: function () {
        var mapDiv = document.getElementById('cf-mapbox');
        var credit = document.getElementById('cf-map-credit');
        var wrap = document.getElementById('cf-wrap-base');
        var fade = document.querySelector('#cf-wrap-base .cf-map-fade');
        var ctrls = document.getElementById('cf-map-controls');
        if (mapDiv) mapDiv.classList.remove('cf-map-visible');
        if (credit) credit.classList.remove('cf-map-visible');
        if (fade)   fade.classList.remove('cf-map-visible');
        if (wrap)   wrap.classList.remove('cf-has-map');
        if (ctrls)  ctrls.classList.remove('open');
        /* Nothing to paint back: the canvas stays transparent and
           #cf-wrap-base's own #f5f5f5 shows through instead. Re-opaquing
           the scene here would permanently hide the map on the next load
           and there would be no error to find. */
      },

      _setStyle: function (s) {
        if (!this.map) return;
        this.currentStyle = s;
        var url = s === 'satellite' ? this.STYLE_SATELLITE : this.STYLE_STREETS;
        this.map.setStyle(url);
        var b1 = document.getElementById('cf-map-style-streets');
        var b2 = document.getElementById('cf-map-style-satellite');
        if (b1) b1.classList.toggle('active', s === 'streets');
        if (b2) b2.classList.toggle('active', s === 'satellite');
        this._deps.onChange();
      },

      _install3DLayers: function () {
        if (!this.map) return;
        var m = this.map;
        try {
          if (!m.getLayer('cf-sky')) {
            m.addLayer({
              id: 'cf-sky', type: 'sky',
              paint: { 'sky-type': 'atmosphere', 'sky-atmosphere-sun-intensity': 5 }
            });
          }
        } catch (e) {}
        try {
          if (!m.getLayer('cf-3d-buildings') && m.getSource('composite')) {
            m.addLayer({
              id: 'cf-3d-buildings',
              source: 'composite',
              'source-layer': 'building',
              filter: ['==', 'extrude', 'true'],
              type: 'fill-extrusion',
              minzoom: 14,
              paint: {
                'fill-extrusion-color': '#d6cfc2',
                'fill-extrusion-height': ['get', 'height'],
                'fill-extrusion-base': ['get', 'min_height'],
                'fill-extrusion-opacity': 0.85
              }
            });
          }
        } catch (e) {}
        this._set3DLayerVisibility(this._deps.getView() === '3d');
      },

      _computeMapStateFor3D: function () {
        if (!this._deps.camera || !this._deps.controls || !this.center) return null;
        var target = this._deps.controls.target;
        var pos = this._deps.camera.position;
        var offX = pos.x - target.x;
        var offY = pos.y - target.y;
        var offZ = pos.z - target.z;
        var horiz = Math.sqrt(offX*offX + offZ*offZ);
        var dist = Math.sqrt(horiz*horiz + offY*offY);
        if (dist < 0.01) return null;
        var elev = Math.atan2(offY, horiz);
        var pitch = Math.max(0, Math.min(85, 90 - elev * 180 / Math.PI));
        var sceneBearingDeg = Math.atan2(-offX, offZ) * 180 / Math.PI;
        var bearing = (this.bearing || 0) + sceneBearingDeg;
        var wrap = document.getElementById('cf-wrap-base');
        var canvasH = wrap ? wrap.clientHeight : 600;
        var fovRad = this._deps.camera.fov * Math.PI / 180;
        var heightAtTarget = 2 * dist * Math.tan(fovRad / 2);
        var mpp = heightAtTarget / canvasH;
        var lat = this.center[1];
        var zoom = Math.log2(78271.51696 * Math.cos(lat * Math.PI / 180) / mpp);
        return { pitch: pitch, bearing: bearing, zoom: zoom };
      },

      _syncMapTo3D: function (animate) {
        if (!this.map || !this.center) return;
        var s = this._computeMapStateFor3D();
        if (!s) return;
        if (animate) this.map.easeTo({ pitch: s.pitch, bearing: s.bearing, zoom: s.zoom, duration: 400 });
        else         this.map.jumpTo({ pitch: s.pitch, bearing: s.bearing, zoom: s.zoom });
      },

      _syncMapTo2D: function (animate) {
        if (!this.map || !this.center) return;
        var z = this._computeZoomForLat(this.center[1]);
        this.zoomLevel = z;
        if (animate) this.map.easeTo({ pitch: 0, bearing: this.bearing || 0, zoom: z, duration: 400 });
        else         this.map.jumpTo({ pitch: 0, bearing: this.bearing || 0, zoom: z });
      },

      _set3DLayerVisibility: function (visible) {
        if (!this.map) return;
        var v = visible ? 'visible' : 'none';
        var ids = ['cf-3d-buildings', 'cf-sky'];
        for (var i = 0; i < ids.length; i++) {
          try {
            if (this.map.getLayer(ids[i])) this.map.setLayoutProperty(ids[i], 'visibility', v);
          } catch (e) {}
        }
      },

      _updateSidebarButton: function () {
        var btn = document.getElementById('cf-btn-map');
        if (!btn) return;
        if (this.map) {
          btn.classList.add('cf-map-btn-active');
          btn.title = this._i18n.changeLocation;
        } else {
          btn.classList.remove('cf-map-btn-active');
          btn.title = this._i18n.addBackground;
        }
      },

      serialize: function () {
        if (!this.map || !this.center) return null;
        return {
          center: this.center,
          bearing: this.bearing || 0,
          style: this.currentStyle,
          address: this.address
        };
      },
      restore: function (data) {
        if (!data || !data.center) return;
        this.bearing = data.bearing || 0;
        var rotateInput = document.getElementById('cf-map-rotate');
        if (rotateInput) {
          rotateInput.value = Math.round(this.bearing);
          rotateInput.style.setProperty('--cf-fill', (this.bearing / 360 * 100) + '%');
        }
        this._loadMap(data.center, data.address || '');
        if (data.style === 'satellite') this._setStyle('satellite');
      },

      persist: function () {
        if (!this._storageKey) return;
        var data = this.serialize();
        if (!data) return;
        try {
          this._suppressStorageEvent = true;
          localStorage.setItem(this._storageKey, JSON.stringify(data));
          var self = this;
          setTimeout(function () { self._suppressStorageEvent = false; }, 0);
        } catch (e) {}
      },
      loadFromStorage: function () {
        if (!this._storageKey) return false;
        try {
          var raw = localStorage.getItem(this._storageKey);
          if (!raw) return false;
          var data = JSON.parse(raw);
          this.restore(data);
          return true;
        } catch (e) { return false; }
      },

      _onStorageEvent: function (e) {
        if (this._suppressStorageEvent) return;
        if (!this._storageKey || e.key !== this._storageKey) return;
        if (!e.newValue) return;
        try {
          var data = JSON.parse(e.newValue);
          var oldCenter = this.center;
          if (!oldCenter || data.center[0] !== oldCenter[0] || data.center[1] !== oldCenter[1]) {
            this.restore(data);
          } else {
            if (typeof data.bearing === 'number') {
              this.bearing = data.bearing;
              if (this.map) this.map.setBearing(data.bearing);
              var ri = document.getElementById('cf-map-rotate');
              if (ri) {
                ri.value = Math.round(data.bearing);
                ri.style.setProperty('--cf-fill', (data.bearing / 360 * 100) + '%');
              }
            }
            if (data.style && data.style !== this.currentStyle) this._setStyle(data.style);
          }
        } catch (err) {}
      }
    };

    var _initialized = false;
    MM.init = function (opts) {
      opts = opts || {};
      var hostOnChange = opts.onChange || function () {};
      MM._deps = opts.engine ? Object.assign({}, opts.engine, {
        getView:       opts.getView       || function () { return '2d-top'; },
        getRootSize:   opts.getRootSize   || function () { return { w: window.innerWidth, h: window.innerHeight }; },
        getPadStep:    opts.getPadStep    || function () { return 2; },
        onChange:      function () { MM.persist(); hostOnChange(); },
        requestRender: opts.requestRender || function () {}
      }) : null;
      /* The host passes the full boot.i18n (snake_case Shopify keys),
         but MapManager's slots are camelCase. Bridge the relevant
         fence_map_* / map_* keys onto the expected names so the map UI
         localizes instead of falling back to English. */
      var _bi = opts.i18n || {};
      var _mapped = {
        rotation:           _bi.fence_map_rotate     || _bi.map_rotate,
        streets:            _bi.fence_map_streets     || _bi.map_streets,
        satellite:          _bi.fence_map_satellite,
        addressPlaceholder: _bi.fence_map_address_placeholder || _bi.map_address_placeholder,
        load:               _bi.fence_map_load        || _bi.map_load,
        modalTitle:         _bi.fence_map_modal_title || _bi.map_modal_title,
        addBackground:      _bi.fence_map,
        changeLocation:     _bi.fence_map_change      || _bi.map_change
      };
      Object.keys(_mapped).forEach(function (k) { if (_mapped[k] == null) delete _mapped[k]; });
      MM._i18n = Object.assign({}, I18N_DEFAULTS, _bi, _mapped);
      MM._storageKey = opts.storageKey || 'levaMap:default';
      MM.MAPBOX_TOKEN = opts.token || MM.MAPBOX_TOKEN;
      if (_initialized) return;
      _initialized = true;
      window.addEventListener('storage', function (e) { MM._onStorageEvent(e); });
      MM._bindUI();
    };

    return MM;
  })();

  function _initMap() {
    var token = (global.BASE_BOOT && global.BASE_BOOT.mapboxToken) || global.MAPBOX_TOKEN;
    if (!token) {
      _dbg('map: no MAPBOX_TOKEN \u2014 map feature disabled');
      return;
    }
    _injectMapCSS();
    _injectMapDOM();
    _loadMapboxSDK().then(function () {
      var boot = global.BASE_BOOT || {};
      var S = global.ConfiguratorStage;
      /* Stage builds the ortho camera in init(), but MapManager takes its
         _deps once and binds listeners on them immediately -- a null ortho
         here shows up much later as "the map does not stay with the model"
         and logs nothing. Force it before we hand anything over. */
      if (S && !S.orthoCam && typeof S._ensureOrtho === 'function') S._ensureOrtho();
      var storageKey = 'levaMap:p' + (boot.productId || '0') + ':c' + (boot.customerId || 'anon');
      _MapManager.init({
        token: token,
        storageKey: storageKey,
        i18n: boot.i18n || {},
        engine: {
          /* Concrete cameras and controls, never BaseEngine.camera /
             BaseEngine.controls: those are swapped on every view toggle
             now, and _deps would keep whatever happened to be current at
             boot -- which for a 2D start is the ortho pair. */
          camera:        S.persCam,
          controls:      S.persControls,
          orthoCamera:   S.orthoCam,
          orthoControls: _orthoEventEmitter
        },
        getView: function () { return STATE.view === '2d' ? '2d-top' : '3d'; },
        getRootSize: function () {
          var w = document.getElementById('cf-wrap-base');
          return { w: w ? w.clientWidth : 0, h: w ? w.clientHeight : 0 };
        },
        getPadStep: function () {
          var bb = (typeof getBBox === 'function') ? getBBox() : null;
          if (!bb) return 2;
          return Math.max(1, Math.min(20, (bb.L + bb.W) * 0.025));
        },
        onChange: function () {},
        requestRender: function () {
          var eng = global.BaseEngine;
          if (eng && eng.renderer && eng.camera) eng.renderer.render(eng.scene, eng.camera);
        }
      });
      if (_pendingMapRestore) {
        _applyPendingMapRestore();
      } else {
        _MapManager.loadFromStorage();
      }
    }).catch(function (err) {
      _dbg('map: ' + (err && err.message ? err.message : err));
    });
  }

  /* ---------------------------------------------------------------------
     VIEWPORT -- ConfiguratorStage (assets/configurator-ui.js)

     Step F1 of the configurator-ui migration. The inline engine is gone:
     Scene, both cameras, renderer, OrbitControls, lights, resize wiring and
     the animation loop now live in the shared asset. BaseEngine IS the
     Stage -- not an adapter around it -- with the pool-specific surface
     attached on top, exactly the way the container does it.

     Old member names are kept as getters so the ~200 eng.* call sites in
     this lib did not have to be touched:

       eng.sceneGroup  -> Stage.group
       eng.cameraPersp -> Stage.persCam
       eng.cameraOrtho -> Stage.orthoCam

     Getters, not copies: Stage.camera is swapped on every view toggle.

     What stays here because it is pool domain, not viewport: the polygon
     surface, world/screen projection, the grid (slope-aware), the 60%-fill
     framing, and the whole toggleView side-band (handle resets, viz
     manager, map sync, section cut).

     NOTE the scene has no background. Stage renders with a transparent
     clear colour so #cf-mapbox can show through from underneath; the
     #cf-wrap-base wrapper carries the same #f5f5f5 the old engine painted
     into the scene, so an unmapped viewport looks identical.
     --------------------------------------------------------------------- */
  global.BaseEngine = global.ConfiguratorStage || global.BaseEngine || null;

  function _defineAlias(S, name, prop) {
    try {
      Object.defineProperty(S, name, {
        configurable: true,
        get: function () { return this[prop]; }
      });
    } catch (e) { _dbg('alias ' + name + ' failed', e); }
  }

  function _attachEngineSurface(S) {
    _defineAlias(S, 'sceneGroup',  'group');
    _defineAlias(S, 'cameraPersp', 'persCam');
    _defineAlias(S, 'cameraOrtho', 'orthoCam');

    /* Persistent orthographic framing. Stage.setView('2d') recomputes the
       frustum from the group bbox and drops zoom to 1 every time it runs --
       including from its own resize handler -- which would throw away the
       framing fitCameraToFootprint() computed and the PDF export saves and
       restores by hand. We keep D and the centre here and put them back
       after Stage touches the camera. */
    S._currentOrthoD = S._currentOrthoD || 12;
    S._orthoCenter   = S._orthoCenter   || { x: 0, z: 0 };

    S._restoreOrtho = function () {
      var d = this._currentOrthoD;
      if (!d || !this.orthoCam || !this.renderer) return;
      var cv = this.renderer.domElement;
      var w = cv.clientWidth, h = cv.clientHeight;
      if (!w || !h) return;
      var a = w / h;
      var c = this._orthoCenter || { x: 0, z: 0 };
      this.orthoCam.left = -d * a; this.orthoCam.right = d * a;
      this.orthoCam.top = d; this.orthoCam.bottom = -d;
      this.orthoCam.zoom = 1;
      this.orthoCam.position.set(c.x, 30, c.z);
      this.orthoCam.up.set(0, 0, -1);
      this.orthoCam.lookAt(c.x, 0, c.z);
      this.orthoCam.updateProjectionMatrix();
      if (this.orthoControls) this.orthoControls.target.set(c.x, 0, c.z);
    };

    /* Public access to the live STATE -- exposed read-only via
       these helpers so external modules (FloorplanLib, future
       Structure configurator, dashboard view) can read & write
       the footprint without reaching into module-private vars. */
    S.getState = function () { return STATE; };
    S.getPolygon = function () {
      return STATE.polygon ? JSON.parse(JSON.stringify(STATE.polygon)) : null;
    };
    S.setPolygon = function (newPoly) {
      if (!Array.isArray(newPoly) || newPoly.length < 3) return false;
      STATE.polygon = JSON.parse(JSON.stringify(newPoly));
      try { rebuildDragHandles(); } catch (e) { _dbg('rebuildDragHandles after setPolygon failed', e); }
      if (global.BaseRenderer && global.BaseRenderer.build) {
        try { global.BaseRenderer.build(); } catch (e) { _dbg('build after setPolygon failed', e); }
      }
      if (_MapManager && _MapManager.map && _MapManager.center) {
        try {
          if (STATE.view === '2d') _MapManager._syncMapTo2D(true);
          else _MapManager._syncMapTo3D(true);
        } catch (e) {}
      }
      if (_SlopeManager && _SlopeManager._updateAll) {
        try { _SlopeManager._updateAll(); } catch (e) {}
      }
      return true;
    };

    /* Project a world-space point (XZ-plane, Y=0) to screen
       coordinates relative to #cf-wrap-base. Used by FloorplanLib
       to position HTML drag handles on top of the Three.js scene. */
    S.worldToScreen = function (x, z) { return _worldToScreen(x, z); };

    /* Inverse -- screen-space client coordinates to world XZ. Used
       by FloorplanLib while a wall handle is being dragged. */
    S.screenToWorld = function (clientX, clientY) { return _screenToWorld(clientX, clientY); };

    /* Show/hide the foundations drag handles. FloorplanLib calls
       this when entering floorplan-edit mode so the polygon and
       its corner/edge handles get out of the way of the wall
       handles. The render group itself stays -- we just toggle the
       HTML pin layer. */
    S.setFoundationsHandlesVisible = function (visible) {
      var container = document.getElementById('cf-base-handles');
      if (!container) return;
      container.style.display = visible ? '' : 'none';
    };

    /* Overrides Stage.fitCameraToFootprint(), which frames the group bbox
       as a bounding sphere. The pool frames the footprint polygon to a
       fixed fill fraction instead -- and the PDF export leans on it for a
       deterministic plan page. */
    S.fitCameraToFootprint = function () {
      var poly = getFootprintPolygon();
      if (!poly || poly.length < 2) return;
      var canvas = this.renderer && this.renderer.domElement;
      if (!canvas) return;
      var w = canvas.clientWidth, h = canvas.clientHeight;
      if (!w || !h) return;

      var xMin =  Infinity, xMax = -Infinity;
      var zMin =  Infinity, zMax = -Infinity;
      for (var i = 0; i < poly.length; i++) {
        if (poly[i][0] < xMin) xMin = poly[i][0];
        if (poly[i][0] > xMax) xMax = poly[i][0];
        if (poly[i][1] < zMin) zMin = poly[i][1];
        if (poly[i][1] > zMax) zMax = poly[i][1];
      }
      var bbL = xMax - xMin;
      var bbW = zMax - zMin;
      if (bbL < 0.5 && bbW < 0.5) return;

      var aspect = w / h;
      /* Frame so the footprint fills ~60% of the view in BOTH axes (~20%
         margin all round) -- applied to width too, so a wide/large pool no
         longer fills the whole viewport on reload. */
      var FILL = 0.60;
      var d = Math.max(bbW / (2 * FILL), bbL / (2 * aspect * FILL));
      d = Math.max(d, 3);
      this._currentOrthoD = d;

      var cx = (xMin + xMax) / 2;
      var cz = (zMin + zMax) / 2;
      this._orthoCenter = { x: cx, z: cz };
      this._restoreOrtho();

      /* Perspective distance that frames the footprint to the same ~60%. */
      var fovRad = ((this.persCam && this.persCam.fov) || 50) * Math.PI / 180;
      var halfV = Math.tan(fovRad / 2);
      var distV = (bbW / 2) / (FILL * halfV);
      var distH = (bbL / 2) / (FILL * halfV * aspect);
      var dist = Math.max(distV, distH, 6);
      if (this.persCam) {
        this.persCam.position.set(cx + dist * 0.6, dist * 0.6, cz + dist * 0.6);
        this.persCam.lookAt(cx, 0, cz);
      }
      if (this.persControls) {
        this.persControls.target.set(cx, 0, cz);
        this.persControls.update();
      }
      positionDragHandles();
    };

    /* Camera swap only. Deliberately NOT Stage.setView(): its '3d' branch
       calls fitCameraToFootprint(), which would yank the perspective camera
       back to a default framing on every single toggle, and its '2d' branch
       reframes the ortho from scratch. The pool keeps whatever the user set
       up and restores its own ortho framing instead.

       Anything that changes STATE.view outside toggleView() (the PDF
       export does) has to call this, or it renders through whichever
       camera happened to be current. */
    S._applyViewCamera = function () {
      var twoD = (STATE.view === '2d');
      if (twoD) this._ensureOrtho();
      this.camera   = twoD ? this.orthoCam : this.persCam;
      this.controls = twoD ? this.orthoControls : this.persControls;
      if (this.persControls) this.persControls.enabled = !twoD;
      this.view = twoD ? '2d' : '3d';
      if (twoD) this._restoreOrtho();
    };

    S.toggleView = function () {
      _resetAllHandleDrags();
      if (_CornerInserter && _CornerInserter.pendingPlacement) {
        _CornerInserter._setPending(false);
      }
      STATE.view = (STATE.view === '2d') ? '3d' : '2d';
      STATE.vizStage = 0;
      this._applyViewCamera();
      var wrap = document.getElementById('cf-wrap-base');
      if (wrap) {
        wrap.classList.toggle('cf-view-2d', STATE.view === '2d');
        wrap.classList.toggle('cf-view-3d', STATE.view === '3d');
      }
      if (this._gridHelper) _applyGridVisibility(this);
      var viewIcon = document.getElementById('cf-view-icon');
      if (viewIcon) {
        viewIcon.src = (STATE.view === '2d')
          ? 'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/3d.png?v=1772625064'
          : 'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/2d.png?v=1772625064';
      }
      positionDragHandles();
      if (_VisualizationManager && _VisualizationManager.apply) _VisualizationManager.apply();
      if (_MapManager && _MapManager.map && _MapManager.center) {
        if (STATE.view === '2d') {
          _MapManager._set3DLayerVisibility(false);
          _MapManager._syncMapTo2D(true);
        } else {
          _MapManager._set3DLayerVisibility(true);
          _MapManager._syncMapTo3D(true);
        }
      }
      if (_SlopeManager && _SlopeManager._updateAll) _SlopeManager._updateAll();
      if (STATE.view === '2d' && !_poolRoundTrip) _poolCutOff('the plan');   /* pool-v8; pool-v9 not on the redraw's 3D-2D-3D round trip (a stairs / style / unit change turned the cut off) */
      /* Section cut only renders in 3D -- toggle into 2D wipes any
         active clipping planes so the orthographic plan doesn't end
         up with chunks missing from materials that were clipped a
         moment ago. */
      if (_SectionCutManager) _SectionCutManager.refresh();
    };
  }

  function _initEngine() {
    var S = global.ConfiguratorStage;
    if (!S) {
      _dbg('engine init failed: configurator-ui.js asset not loaded');
      return false;
    }
    global.BaseEngine = S;
    _attachEngineSurface(S);

    var ok = S.init({
      rootId:   'cf-wrap-base',
      canvasId: 'cf-canvas-base',
      fov: 40, near: 0.1, far: 200,
      cameraPos: [14, 12, 14],
      target: [0, 0, 0],
      /* The old engine left OrbitControls' distance limits at their
         defaults (0 .. Infinity). Stage defaults to 1.5 .. 40, which the
         60%-fill framing would hit on a large pool -- update() would clamp
         the camera straight back and the framing would collapse. */
      minDistance: 0.5, maxDistance: 500,
      /* No maxPolarAngle: Stage's default (PI * 0.85) is what lets the
         user tilt below the horizon and look at the model from under the
         grid, the same as the container and the A-frame. The inline engine
         stopped dead at PI * 0.49 (horizon). */
      /* Pan off: the pool is the start of a project and belongs on the
         axis. Framing is fitCameraToFootprint()'s job, and the map has its
         own pan pad. */
      enablePan: false,
      enableDamping: true, dampingFactor: 0.08,
      lights: true,
      log: function (m) { _dbg('[stage] ' + m); },
      onResize: function () {
        /* Stage's resize re-runs setView('2d') while in 2D, which
           overwrites the frustum. Put ours back, then re-pin the HTML
           handles to the world. */
        S._restoreOrtho();
        positionDragHandles();
      }
    });
    if (!ok) return false;

    _rebuildGrid(S);
    S._applyViewCamera();

    /* Stage's own loop renders and updates controls; the pool needs one
       more thing on the same frame, and the asset has no hook for it, so
       we replace the loop with the same work plus ours. */
    S.renderer.setAnimationLoop(function () {
      if (S.controls && S.camera === S.persCam) S.controls.update();
      S.renderer.setClearColor(0x000000, 0);
      if (S.camera) S.renderer.render(S.scene, S.camera);
      /* Drive any external per-frame work that needs world-to-screen
         tracking (FloorplanLib's wall-drag handles ride on this). */
      if (global.FloorplanLib && typeof global.FloorplanLib._onFrame === 'function') {
        global.FloorplanLib._onFrame();
      }
    });

    return true;
  }

  global.BaseRenderer = {
    _materials: null,

    /* Lazily generate a tileable gravel texture on a canvas -- small
       light/dark grey pebbles on a medium-grey base. Used as the map
       for the fenceGravel material below. Runs once (per first render
       that needs it) and is cached on the renderer instance. */
    _gravelTexture: null,
    _makeGravelTexture: function () {
      if (this._gravelTexture) return this._gravelTexture;
      var T = global.THREE;
      if (typeof document === 'undefined') return null;
      var size = 256;
      var canvas = document.createElement('canvas');
      canvas.width = size; canvas.height = size;
      var ctx = canvas.getContext('2d');
      /* Base -- darker grey so gravel reads clearly against the lighter
         concrete plug above it. */
      ctx.fillStyle = '#5e5e5e';
      ctx.fillRect(0, 0, size, size);
      /* Pebbles -- random circular blobs of varying grey */
      var pebbleCount = 110;
      for (var i = 0; i < pebbleCount; i++) {
        var x = Math.random() * size;
        var y = Math.random() * size;
        var r = 5 + Math.random() * 14;     /* 5-19 px radius */
        var v = 60 + Math.floor(Math.random() * 80);   /* 60-140 grey (darker) */
        ctx.fillStyle = 'rgb(' + v + ',' + v + ',' + v + ')';
        ctx.beginPath();
        ctx.arc(x, y, r, 0, Math.PI * 2);
        ctx.fill();
        /* Subtle highlight rim on the top-left of each pebble */
        ctx.strokeStyle = 'rgba(255,255,255,0.18)';
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.arc(x - r * 0.25, y - r * 0.25, r * 0.85, Math.PI, Math.PI * 1.5);
        ctx.stroke();
      }
      var tex = new T.CanvasTexture(canvas);
      tex.wrapS = T.RepeatWrapping;
      tex.wrapT = T.RepeatWrapping;
      tex.repeat.set(2, 2);
      this._gravelTexture = tex;
      return tex;
    },

    /* Subtle finish patterns (canvas textures -- robust in r128, no external
       assets). Each is cached and tiled. */
    _makeTilesTexture: function () {
      if (this._tilesTexture) return this._tilesTexture;
      var T = global.THREE; if (typeof document === 'undefined') return null;
      var size = 256, cell = 32;             /* 8x8 mosaic cells */
      var c = document.createElement('canvas'); c.width = c.height = size;
      var x = c.getContext('2d');
      x.fillStyle = '#6fb7d6'; x.fillRect(0, 0, size, size);
      for (var gy = 0; gy < size; gy += cell) {
        for (var gx = 0; gx < size; gx += cell) {
          /* slight per-tile tint variation */
          var d = (Math.random() * 24 - 12) | 0;
          x.fillStyle = 'rgb(' + (111 + d) + ',' + (183 + d) + ',' + (214 + d) + ')';
          x.fillRect(gx + 1, gy + 1, cell - 2, cell - 2);
        }
      }
      /* grout lines */
      x.strokeStyle = 'rgba(255,255,255,0.35)'; x.lineWidth = 2;
      for (var g = 0; g <= size; g += cell) {
        x.beginPath(); x.moveTo(g, 0); x.lineTo(g, size); x.stroke();
        x.beginPath(); x.moveTo(0, g); x.lineTo(size, g); x.stroke();
      }
      var t = new T.CanvasTexture(c);
      t.wrapS = t.wrapT = T.RepeatWrapping; t.repeat.set(6, 6);
      this._tilesTexture = t; return t;
    },
    _makeInoxTexture: function () {
      if (this._inoxTexture) return this._inoxTexture;
      var T = global.THREE; if (typeof document === 'undefined') return null;
      var size = 256;
      var c = document.createElement('canvas'); c.width = c.height = size;
      var x = c.getContext('2d');
      x.fillStyle = '#bfc4c9'; x.fillRect(0, 0, size, size);
      /* fine brushed vertical lines */
      for (var i = 0; i < 600; i++) {
        var px = Math.random() * size;
        var a = 0.04 + Math.random() * 0.06;
        var light = Math.random() > 0.5;
        x.strokeStyle = light ? 'rgba(255,255,255,' + a + ')' : 'rgba(80,90,100,' + a + ')';
        x.lineWidth = 1;
        x.beginPath(); x.moveTo(px, 0); x.lineTo(px, size); x.stroke();
      }
      var t = new T.CanvasTexture(c);
      t.wrapS = t.wrapT = T.RepeatWrapping; t.repeat.set(3, 3);
      this._inoxTexture = t; return t;
    },
    _makePebbleTexture: function () {
      if (this._pebbleTexture) return this._pebbleTexture;
      var T = global.THREE; if (typeof document === 'undefined') return null;
      var size = 256;
      var c = document.createElement('canvas'); c.width = c.height = size;
      var x = c.getContext('2d');
      x.fillStyle = '#b7a98c'; x.fillRect(0, 0, size, size);
      /* dense small speckles in earthy tones */
      var tones = ['#a89878', '#c4b89c', '#8f7f60', '#cabfa3', '#9b8c6e'];
      for (var i = 0; i < 900; i++) {
        var px = Math.random() * size, py = Math.random() * size;
        var r = 1.5 + Math.random() * 3.5;
        x.fillStyle = tones[(Math.random() * tones.length) | 0];
        x.beginPath(); x.arc(px, py, r, 0, Math.PI * 2); x.fill();
      }
      var t = new T.CanvasTexture(c);
      t.wrapS = t.wrapT = T.RepeatWrapping; t.repeat.set(4, 4);
      this._pebbleTexture = t; return t;
    },

    /* Hollow lost-formwork block of REAL size (lenX x height x lenZ, centred),
       with SQUARE vertical cavities along its long horizontal side: a long
       block gets two (or more) square cells, a square/short block gets one --
       as the real blocks are. Built per distinct block size (instances of the
       same size share it -> still few draw calls). */
    _makeHollowBlockGeo: function (lenX, height, lenZ) {
      var T = global.THREE;
      function rect(x0, x1, y0, y1) {
        var p = new T.Path();
        p.moveTo(x0, y0); p.lineTo(x1, y0); p.lineTo(x1, y1); p.lineTo(x0, y1); p.closePath();
        return p;
      }
      var shape = new T.Shape();
      shape.moveTo(-lenX / 2, -lenZ / 2);
      shape.lineTo( lenX / 2, -lenZ / 2);
      shape.lineTo( lenX / 2,  lenZ / 2);
      shape.lineTo(-lenX / 2,  lenZ / 2);
      shape.closePath();
      var wt = 0.045;                                  /* web thickness ~45 mm */
      var longX = lenX >= lenZ;
      var longLen = longX ? lenX : lenZ;
      var shortLen = longX ? lenZ : lenX;
      var cav = shortLen - 2 * wt;                     /* square cavity side (set by the short side) */
      if (cav > 0.03 && longLen - 2 * wt > 0.03) {
        var nCav = Math.max(1, Math.round((longLen - wt) / (cav + wt)));
        var webL = (longLen - nCav * cav) / (nCav + 1);
        if (webL < 0.02 && nCav > 1) { nCav -= 1; webL = (longLen - nCav * cav) / (nCav + 1); }
        for (var c = 0; c < nCav; c++) {
          var a0 = -longLen / 2 + webL + c * (cav + webL), a1 = a0 + cav;  /* along long side */
          var b0 = -cav / 2, b1 = cav / 2;                                  /* centred on short side */
          shape.holes.push(longX ? rect(a0, a1, b0, b1) : rect(b0, b1, a0, a1));
        }
      }
      var geo = new T.ExtrudeGeometry(shape, { depth: height, bevelEnabled: false });
      geo.translate(0, 0, -height / 2);     /* centre the height */
      geo.rotateX(Math.PI / 2);              /* extrude axis (height) -> Y up; depth -> Z */
      return geo;
    },

    _ensureMaterials: function () {
      var T = global.THREE;
      if (this._materials) return this._materials;
      this._materials = {
        fill2D:   new T.MeshBasicMaterial({ color: 0xb8b8b8, transparent: true, opacity: 0.45, side: T.DoubleSide }),
        edge2D:   new T.LineBasicMaterial({ color: 0x222222 }),
        water2D:  new T.MeshBasicMaterial({ color: 0x3fa7d6, transparent: true, opacity: 0.25, side: T.DoubleSide }),
        coping2D: new T.MeshBasicMaterial({ color: 0xb9b1a3, transparent: true, opacity: 0.55, side: T.DoubleSide }),
        tank2D:   new T.MeshBasicMaterial({ color: 0x2f6fb0, transparent: true, opacity: 0.45, side: T.DoubleSide }),
        tile2D:   new T.MeshBasicMaterial({ color: 0xe8e2d4, transparent: true, opacity: 0.55, side: T.DoubleSide }),
        /* Pool 3D materials -- PBR, not Lambert. Stage renders with ACES
           filmic tone mapping and lifts the image with a RoomEnvironment
           PMREM map; MeshLambert does not react to scene.environment at
           all, so a Lambert model under ACES just reads dark. Values follow
           the container: concrete and aggregate 0.92-0.95/0, steel 0.45/0.85,
           glazed / plastered surfaces smoother. */
        poolConcrete: new T.MeshStandardMaterial({ color: 0xcfcfcf, roughness: 0.95, metalness: 0 }),
        poolStairFill: new T.MeshStandardMaterial({ color: 0xe9e6df, roughness: 0.92, metalness: 0 }),  /* own opaque material, lighter so the poured fill reads clearly */
        poolPlaster:  new T.MeshStandardMaterial({ color: 0xdfe7ec, roughness: 0.70, metalness: 0 }),
        /* Interior surface finishes (switch-driven look). Inox is the one
           that changes character here: it was Phong faking a specular
           highlight off the two old lights, and it now gets a real env-map
           reflection from MeshStandard at metalness 0.9. */
        surfLiner:    new T.MeshStandardMaterial({ color: 0xdfe7ec, roughness: 0.55, metalness: 0 }),  /* pale blue-grey liner */
        surfPlaster:  new T.MeshStandardMaterial({ color: 0xeef2f4, roughness: 0.70, metalness: 0 }),  /* white plaster */
        surfTiles:    new T.MeshStandardMaterial({ map: this._makeTilesTexture(),  color: 0xffffff, roughness: 0.18, metalness: 0 }),  /* glazed mosaic */
        surfPebble:   new T.MeshStandardMaterial({ map: this._makePebbleTexture(), color: 0xffffff, roughness: 0.90, metalness: 0 }),  /* pebble aggregate */
        surfInox:     new T.MeshStandardMaterial({ map: this._makeInoxTexture(), color: 0xffffff, roughness: 0.25, metalness: 0.90 }),
        poolCoping:   new T.MeshStandardMaterial({ color: 0xc9c1b2, roughness: 0.85, metalness: 0 }),
        poolEdgeTile:     new T.MeshStandardMaterial({ color: 0xe8e2d4, roughness: 0.35, metalness: 0 }),  /* coping tile face */
        poolEdgeTileCorner: new T.MeshStandardMaterial({ color: 0xd8cfb8, roughness: 0.35, metalness: 0 }), /* corner piece (slightly darker) */
        poolOflTileA:     new T.MeshStandardMaterial({ color: 0xe8e2d4, roughness: 0.35, metalness: 0 }),  /* overflow slope A (inner) */
        poolOflTileB:     new T.MeshStandardMaterial({ color: 0xd0c8b6, roughness: 0.35, metalness: 0 }),  /* overflow slope B (outer) */
        poolOflChannel:   new T.MeshStandardMaterial({ color: 0x5a5a5a, roughness: 0.60, metalness: 0 }),  /* centre catch channel */
        poolWater:    new T.MeshStandardMaterial({ color: 0x2f8fc7, transparent: true, opacity: 0.25, depthWrite: false, roughness: 0.08, metalness: 0 }),
        poolGravel:   new T.MeshStandardMaterial({ map: this._makeGravelTexture(), color: 0xffffff, roughness: 0.95, metalness: 0 }),
        poolGrate:    new T.MeshStandardMaterial({ color: 0x6b6b6b, roughness: 0.45, metalness: 0.85 }),
        poolSkimmer:  new T.MeshStandardMaterial({ color: 0xf4f4f0, roughness: 0.55, metalness: 0 }),   /* white skimmer faceplate */
        poolSkimmerFrame: new T.MeshStandardMaterial({ color: 0xd8d8d2, roughness: 0.55, metalness: 0 }), /* slightly darker frame */
        poolJet:      new T.MeshStandardMaterial({ color: 0xf4f4f0, roughness: 0.55, metalness: 0 }),   /* white return-jet ring */
        poolShaftBox: new T.MeshStandardMaterial({ color: 0x3a3a3a, roughness: 0.60, metalness: 0 }),   /* underground plastic box */
        poolShaftLid: new T.MeshStandardMaterial({ color: 0x5a5a5a, roughness: 0.60, metalness: 0 }),   /* ground-level lid */
        poolTankBox:  new T.MeshStandardMaterial({ color: 0x2f6fb0, roughness: 0.60, metalness: 0 }),   /* overflow balance tank */
        poolTankLid:  new T.MeshStandardMaterial({ color: 0x4a85c2, roughness: 0.60, metalness: 0 }),   /* tank lid */
        blockEdge:    new T.LineBasicMaterial({ color: 0x2a2a2a, transparent: true, opacity: 0.85 }),
        poolStairs:   new T.MeshStandardMaterial({ color: 0xdfe4ea, roughness: 0.80, metalness: 0 }),
        /* Per-variant wall look (block / EPS / gunite). */
        wall_concrete_block: new T.MeshStandardMaterial({ color: 0xc8c8c8, roughness: 0.92, metalness: 0 }),
        wall_eps_block:      new T.MeshStandardMaterial({ color: 0xffffff, roughness: 0.85, metalness: 0 }),
        wall_gunite:         new T.MeshStandardMaterial({ color: 0xb6b6b6, roughness: 0.95, metalness: 0 })
      };
      return this._materials;
    },

    _wallMaterial: function (mats) {
      return mats['wall_' + variantKey()] || mats.poolConcrete;
    },

    /* Material for the visible interior finish, by STATE.surface. */
    _surfaceMaterial: function (mats) {
      switch (getSurface()) {
        case 'plaster': return mats.surfPlaster;
        case 'tiles':   return mats.surfTiles;
        case 'pebble':  return mats.surfPebble;
        case 'inox':    return mats.surfInox;
        default:        return mats.surfLiner;
      }
    },

    build: function () {
      var T = global.THREE;
      var eng = global.BaseEngine;
      if (!T || !eng || !eng.sceneGroup) return;
      var G = eng.sceneGroup;
      while (G.children.length) {
        var c = G.children[0];
        G.remove(c);
        if (c.geometry && c.geometry.dispose) c.geometry.dispose();
      }
      var poly = getFootprintPolygon();
      if (!poly.length) return;

      /* Reinforcement stage (vizStage 3, shown FIRST in the cycle): draw only
         the rebar + KARI mesh, colour-coded, in real position. Hide the grid;
         the map underneath stays as a backdrop. Everything else is skipped. */
      if (STATE.vizStage === 3) {
        this._buildReinforcement(poly);
        if (eng._gridHelper) eng._gridHelper.visible = false;
        return;
      }
      if (eng._gridHelper) eng._gridHelper.visible = true;

      if (STATE.view === '2d') {
        this._build2D(poly);
      } else {
        this._build3D(poly);
        this._build3D_SlopeViz(poly);
      }

      if (_SectionCutManager && STATE.vizStage === 2 && STATE.view === '3d') {
        _SectionCutManager.refresh();
      }
      /* Resize the reference grid to the (possibly changed) footprint. */
      _rebuildGrid(eng);
    },

    /* Reinforcement view geometry -- colour-coded LineSegments for the KARI
       mesh and the dia12 rebar, in their real positions. Cheap (lines), full
       opacity, one group tagged 'reinforcement'. */
    _buildReinforcement: function (poly) {
      var T = global.THREE, eng = global.BaseEngine;
      if (!T || !eng || !eng.sceneGroup || !poly || poly.length < 3) return;
      var d     = getVariantDefaults(variantKey(), STATE.lvl);
      var D     = getCurrentDepth();
      var wallT = _effectiveWallThick(d);
      var slabT = _slabThickness(D);
      var inner = _insetPolygon(poly, wallT);
      var mid   = _insetPolygon(poly, wallT / 2);                 /* wall centreline */
      var slabPoly = _offsetPolygon(poly, (d.slabOverhangM || 0), true);

      var COL = {
        g6: 0x37d35a, g8: 0xf2c200, g10: 0xff8a1f,   /* KARI mesh by gauge */
        rebar: 0x2266cc                                /* dia12 rebar -- ONE product, ONE colour (blue) */
      };

      var grp = new T.Group();
      grp.userData = { assetType: 'reinforcement' };
      function addLines(arr, color) {
        if (!arr.length) return;
        var geo = new T.BufferGeometry();
        geo.setAttribute('position', new T.Float32BufferAttribute(arr, 3));
        var ls = new T.LineSegments(geo, new T.LineBasicMaterial({ color: color }));
        ls.userData = { assetType: 'rebar' };
        grp.add(ls);
      }
      function bbox(p) {
        var a = { x0: Infinity, x1: -Infinity, z0: Infinity, z1: -Infinity };
        for (var i = 0; i < p.length; i++) {
          var x = p[i][0], z = p[i][1];
          if (x < a.x0) a.x0 = x; if (x > a.x1) a.x1 = x;
          if (z < a.z0) a.z0 = z; if (z > a.z1) a.z1 = z;
        }
        return a;
      }
      function centroid(p) {
        var cx = 0, cz = 0;
        for (var i = 0; i < p.length; i++) { cx += p[i][0]; cz += p[i][1]; }
        return [cx / p.length, cz / p.length];
      }

      /* -- 1) KARI welded-wire mesh -- tiled per REAL plate (base deep slab +
         each raised zone shelf), reaching the slab EDGE, with the manufacturer
         LAP: sheets overlap by MSH.lap, so the lap zones show a double grid plus
         dark sheet outlines (the real laying pattern). Base green, shelves
         orange. Sheet 3x2 m metric / 8x20 ft imperial. -- */
      var SP = 0.15, OUTLINE = 0x333333;
      var MSH = STATE.isMetric
        ? { L: 3.0, W: 2.0, lap: 0.25 }
        : { L: 20 * FT, W: 8 * FT, lap: 0.5 * FT };
      function meshPlate(poly, layerYs, color) {
        if (!poly || poly.length < 3 || !layerYs.length) return;
        var bx0 = Infinity, bx1 = -Infinity, bz0 = Infinity, bz1 = -Infinity, v, X, Z;
        for (v = 0; v < poly.length; v++) {
          X = poly[v][0]; Z = poly[v][1];
          if (X < bx0) bx0 = X; if (X > bx1) bx1 = X;
          if (Z < bz0) bz0 = Z; if (Z > bz1) bz1 = Z;
        }
        var alongX = (bx1 - bx0) >= (bz1 - bz0);
        var sx = alongX ? MSH.L : MSH.W, sz = alongX ? MSH.W : MSH.L;   /* long sheet side along the longer plate axis */
        var pX = sx - MSH.lap, pZ = sz - MSH.lap;                       /* pitch = sheet - lap -> overlap */
        for (var li = 0; li < layerYs.length; li++) {
          var yB = layerYs[li], grid = [], outl = [], k = 0, ox, oz, gx, gz, seg, qi, c, es, ei, rx1, rz1, yy;
          for (ox = bx0; ox < bx1 - 1e-6; ox += pX) {
            for (oz = bz0; oz < bz1 - 1e-6; oz += pZ) {
              rx1 = ox + sx; rz1 = oz + sz; yy = yB + (k % 4) * 0.0006; k++;   /* tiny nudge so laps don't z-fight */
              for (gx = ox; gx <= rx1 + 1e-6; gx += SP) {
                seg = _clipSegToPolyMinusHoles(gx, oz, gx, rz1, poly, []);
                for (qi = 0; qi < seg.length; qi++) { c = seg[qi]; grid.push(c[0], yy, c[1], c[2], yy, c[3]); }
              }
              for (gz = oz; gz <= rz1 + 1e-6; gz += SP) {
                seg = _clipSegToPolyMinusHoles(ox, gz, rx1, gz, poly, []);
                for (qi = 0; qi < seg.length; qi++) { c = seg[qi]; grid.push(c[0], yy, c[1], c[2], yy, c[3]); }
              }
              es = [[ox, oz, rx1, oz], [rx1, oz, rx1, rz1], [rx1, rz1, ox, rz1], [ox, rz1, ox, oz]];
              for (ei = 0; ei < 4; ei++) {
                seg = _clipSegToPolyMinusHoles(es[ei][0], es[ei][1], es[ei][2], es[ei][3], poly, []);
                for (qi = 0; qi < seg.length; qi++) { c = seg[qi]; outl.push(c[0], yy + 0.0003, c[1], c[2], yy + 0.0003, c[3]); }
              }
            }
          }
          addLines(grid, color);
          addLines(outl, OUTLINE);
        }
      }

      /* Reinforcement is laid into the SAME concrete plates as _build3D -- the
         base/deep slab over _poolDeepFoot(poly) grown by the overhang (identical
         to the concrete slabPoly), and each raised deck over its own bench-foot.
         No carving, no holes: the mesh outline IS the plate outline. */
      var _ov = (d && d.slabOverhangM) || 0;
      var _zfMesh = _zoneFloors();
      var _slabFoot = _offsetPolygon(_poolDeepFoot(poly), _ov, true) || _poolDeepFoot(poly);
      var _baseLayers = (_slabThickness(D) > 0.15 + 1e-6)
        ? [-D - slabT * 0.30, -D - slabT * 0.70]
        : [-D - slabT * 0.50];
      meshPlate(_slabFoot, _baseLayers, COL.g6);

      /* Each raised deck -- reinforcement over the SAME bench-foot the concrete
         deck uses in _build3D. */
      for (var _mi = 0; _mi < _zfMesh.raised.length; _mi++) {
        var _rz = _zfMesh.raised[_mi];
        if (!_rz.quad || _rz.quad.length < 4) continue;
        var _shelfFoot = _poolBenchFoot(_rz.quad, wallT + _ov, _rz.outerAtPerimeter);
        var _shLayers = ((_rz.slabT || 0) > 0.15 + 1e-6)
          ? [_rz.topY - 0.02, _rz.topY - 0.04]
          : [_rz.topY - 0.02];
        meshPlate(_shelfFoot, _shLayers, COL.g10);
      }

      /* Only the block system has cavities/courses -> wall + stair rebar. */
      if (variantKey() === 'concrete_block') {
        var C = centroid(mid), STEP = 0.25, BEND = 0.20, COVER = 0.05;
        var MAT = Math.max(0.02, wallT / 2 - COVER);     /* offset from wall centreline to each face mat */
        var MATS = [MAT, -MAT];                          /* TWO screens: one near each wall face */
        /* Per-POINT wall bottom. The blocks notch the wall around the WHOLE zone
           -- the cap edge AND both side returns at the corners -- so a bar is
           shortened wherever it stands behind a zone shelf, not only on the
           zone's own wall. A point is "behind a zone" when it is within ~wallT
           of that zone's cap (q0-q1) or a side return (q0-q3 / q1-q2); the riser
           (q3-q2) faces the deep pool and is excluded. There the bar starts at
           the shelf's mesh plane and its L-foot hooks into that mesh; elsewhere
           it runs to the deep floor and foots into the base slab. */
        var COVT = wallT * 0.5 + 0.10;
        var _wallBotAt = function (px, pz) { return _wallBottomYAt(px, pz, D, wallT, _zfMesh.raised); };
        /* -- 2) Wall vertical L-bars -- two bars per cavity, shortened per point -- */
        var vert = [], e, A, B, dx, dz, len, ux, uz, nx, nz, mx, mz, t, cpx, cpz, px, pz, vmi, voff, yBot;
        for (e = 0; e < mid.length; e++) {
          A = mid[e]; B = mid[(e + 1) % mid.length];
          dx = B[0] - A[0]; dz = B[1] - A[1]; len = Math.hypot(dx, dz);
          if (len < 1e-3) continue;
          ux = dx / len; uz = dz / len; nx = -uz; nz = ux;
          mx = (A[0] + B[0]) / 2; mz = (A[1] + B[1]) / 2;
          if ((C[0] - mx) * nx + (C[1] - mz) * nz < 0) { nx = -nx; nz = -nz; }
          for (t = 0; t <= len + 1e-6; t += STEP) {
            cpx = A[0] + ux * t; cpz = A[1] + uz * t;
            yBot = _wallBotAt(cpx, cpz);                  /* shelf mesh plane behind a zone, else -D */
            for (vmi = 0; vmi < 2; vmi++) {
              voff = MATS[vmi];
              px = cpx + nx * voff; pz = cpz + nz * voff;
              vert.push(px, yBot, pz, px, 0, pz);                          /* vertical */
              vert.push(px, yBot, pz, px + nx * BEND, yBot, pz + nz * BEND);  /* L-foot into base slab / shelf mesh */
            }
          }
        }
        addLines(vert, COL.rebar);

        /* -- 3) Wall horizontal course bars -- two mats, clipped per sub-segment
           to where the wall actually exists at that height (full above a shelf,
           absent below it -- the riser covers below). -- */
        var horiz = [], nC = Math.max(1, Math.round(D / 0.20)), ci, hy, e2, A2, B2, hdx, hdz, hlen, hux, huz, hnx, hnz, hmx, hmz, hmi, hoff, ht, hs0, hs1, hsmx, hsmz;
        for (ci = 0; ci < nC; ci++) {
          hy = -D + (ci + 0.5) * (D / nC);
          for (e2 = 0; e2 < mid.length; e2++) {
            A2 = mid[e2]; B2 = mid[(e2 + 1) % mid.length];
            hdx = B2[0] - A2[0]; hdz = B2[1] - A2[1]; hlen = Math.hypot(hdx, hdz);
            if (hlen < 1e-3) continue;
            hux = hdx / hlen; huz = hdz / hlen;
            hnx = -huz; hnz = hux;
            hmx = (A2[0] + B2[0]) / 2; hmz = (A2[1] + B2[1]) / 2;
            if ((C[0] - hmx) * hnx + (C[1] - hmz) * hnz < 0) { hnx = -hnx; hnz = -hnz; }
            for (ht = 0; ht < hlen - 1e-6; ht += STEP) {
              hs0 = ht; hs1 = Math.min(ht + STEP, hlen);
              hsmx = A2[0] + hux * (hs0 + hs1) / 2; hsmz = A2[1] + huz * (hs0 + hs1) / 2;
              if (hy <= _wallBotAt(hsmx, hsmz) + 1e-6) continue;   /* no wall here at this height */
              for (hmi = 0; hmi < 2; hmi++) {
                hoff = MATS[hmi];
                horiz.push(A2[0] + hux * hs0 + hnx * hoff, hy, A2[1] + huz * hs0 + hnz * hoff,
                           A2[0] + hux * hs1 + hnx * hoff, hy, A2[1] + huz * hs1 + hnz * hoff);
              }
            }
          }
        }
        addLines(horiz, COL.rebar);

        /* -- 3b) Zone riser walls (blocks under the shelves) -- vertical L-bars +
           horizontal course bars along each shelf's inner (main-pool-facing)
           edge, from the riser base up to the shelf underside. Same product /
           colour as the wall rebar (dia12). -- */
        var zrebar = [], zri, zr, rQ, E0, E1, rex, rez, rLen, rux, ruz, npx, npz, pcx, pcz, pcl, shx, shz, rBase, rTop, rt, rpx, rpz, rNC, rc, rhy, rmi, moff;
        var rbw = _blockModule().width, rOff = Math.max(0.02, rbw / 2 - COVER);   /* offset to each riser-face mat */
        for (zri = 0; zri < _zfMesh.raised.length; zri++) {
          zr = _zfMesh.raised[zri];
          if (!zr.hasRiser || !zr.quad || zr.quad.length < 4) continue;
          rQ = zr.quad;
          E0 = rQ[3]; E1 = rQ[2];                          /* inner edge (faces the main pool) */
          rex = E1[0] - E0[0]; rez = E1[1] - E0[1]; rLen = Math.hypot(rex, rez);
          if (rLen < 1e-3) continue;
          rux = rex / rLen; ruz = rez / rLen;
          /* L-feet: bottom bends INTO the deep base slab (toward the pool
             centre), top bends INTO the shelf slab (toward the cap). The bar
             ties BOTH plates -- a riser sits between two slabs (kids + relax). */
          npx = rQ[3][0] - rQ[0][0]; npz = rQ[3][1] - rQ[0][1]; pcl = Math.hypot(npx, npz) || 1;
          npx /= pcl; npz /= pcl;                               /* unit perp riser face, toward pool centre */
          pcx = npx * BEND; pcz = npz * BEND;                   /* foot -> bottom (base) slab */
          shx = -pcx; shz = -pcz;                               /* foot -> top (shelf) slab */
          /* Tie the riser bars INTO both KARI meshes (same plane / lap), not at
             the bare block faces: the TOP reaches the shelf-slab mesh plane and
             the BOTTOM the lower slab's mesh plane, so the rebar is coplanar
             with the mesh it laps into. */
          rTop = zr.topY - 0.02;                                            /* shelf-slab mesh plane */
          rBase = (zr.riserBaseY <= -D + 1e-3)
            ? ((slabT > 0.15 + 1e-6) ? (-D - slabT * 0.30) : (-D - slabT * 0.50))   /* deep base-slab mesh */
            : (zr.riserBaseY - 0.02);                                       /* deeper neighbour's mesh */
          for (rt = 0; rt <= rLen + 1e-6; rt += STEP) {     /* two bars per cavity (one mat per face) */
            for (rmi = 0; rmi < 2; rmi++) {
              moff = (rmi === 0) ? rOff : -rOff;
              rpx = E0[0] + rux * rt + npx * moff; rpz = E0[1] + ruz * rt + npz * moff;
              zrebar.push(rpx, rBase, rpz, rpx, rTop, rpz);                      /* vertical */
              zrebar.push(rpx, rBase, rpz, rpx + pcx, rBase, rpz + pcz);         /* L-foot into bottom (base) slab */
              zrebar.push(rpx, rTop,  rpz, rpx + shx, rTop,  rpz + shz);         /* L-foot into top (shelf) slab */
            }
          }
          rNC = Math.max(1, Math.round((rTop - rBase) / 0.20));   /* horizontals per course, two mats */
          for (rc = 0; rc < rNC; rc++) {
            rhy = rBase + (rc + 0.5) * ((rTop - rBase) / rNC);
            for (rmi = 0; rmi < 2; rmi++) {
              moff = (rmi === 0) ? rOff : -rOff;
              zrebar.push(E0[0] + npx * moff, rhy, E0[1] + npz * moff, E1[0] + npx * moff, rhy, E1[1] + npz * moff);
            }
          }
        }
        addLines(zrebar, COL.rebar);

        /* -- 3c) Kids<->Main divider pillars -- vertical dowels (dia12) tying each
           tiled stepping-stone column into the kids deck slab. No wall blocks
           carry rebar here, so 4 corner bars per pillar with an L-foot hooking
           into the shelf mesh. Pillar layout mirrors the 3D build. -- */
        var colRebar = [], _cFoot = STATE.isMetric ? 0.40 : 12 * IN;
        var _cInset = Math.max(0.04, _cFoot / 2 - COVER);
        for (var _pi = 0; _pi < _zfMesh.raised.length; _pi++) {
          var _pz0 = _zfMesh.raised[_pi];
          if (!_pz0.bordersMain || (_pz0.dividerCols | 0) < 1 || !_pz0.quad) continue;
          var _pq = _pz0.quad, _pa = _pq[3], _pb = _pq[2];        /* inner kids/main edge */
          var _peL = Math.hypot(_pb[0] - _pa[0], _pb[1] - _pa[1]) || 1;
          var _pux = (_pb[0] - _pa[0]) / _peL, _puz = (_pb[1] - _pa[1]) / _peL;   /* along the edge */
          var _pkx = ((_pq[0][0] + _pq[1][0]) / 2) - ((_pq[3][0] + _pq[2][0]) / 2);
          var _pkz = ((_pq[0][1] + _pq[1][1]) / 2) - ((_pq[3][1] + _pq[2][1]) / 2);
          var _pkL = Math.hypot(_pkx, _pkz) || 1; _pkx /= _pkL; _pkz /= _pkL;     /* into the kids shelf */
          var _pOff = _cFoot / 2, _pn = _pz0.dividerCols | 0, _ppitch = _peL / _pn;
          var _pMesh = ((_pz0.slabT || 0) > 0.15 + 1e-6) ? (_pz0.topY - 0.04) : (_pz0.topY - 0.02);
          var _pTop = -0.03;                                      /* just under the rim/tile */
          for (var _pc = 0; _pc < _pn; _pc++) {
            var _pt = (_pc + 0.5) * _ppitch;
            var _pcx = _pa[0] + _pux * _pt + _pkx * _pOff, _pcz = _pa[1] + _puz * _pt + _pkz * _pOff;
            for (var _sa = -1; _sa <= 1; _sa += 2) {
              for (var _sb = -1; _sb <= 1; _sb += 2) {
                var _bx = _pcx + _pux * _cInset * _sa + _pkx * _cInset * _sb;
                var _bz = _pcz + _puz * _cInset * _sa + _pkz * _cInset * _sb;
                colRebar.push(_bx, _pMesh, _bz, _bx, _pTop, _bz);                              /* vertical */
                colRebar.push(_bx, _pMesh, _bz, _bx + _pkx * BEND, _pMesh, _bz + _pkz * BEND); /* L-foot into deck mesh */
              }
            }
          }
        }
        addLines(colRebar, COL.rebar);

        /* -- 3d) Slab-to-slab Z-ties at the step between two adjacent zone decks
           (e.g. kids <-> relax on one arm -- there is no riser/blocks there, the
           higher deck simply sits a course above the lower one). Each Z-bar:
           bottom leg into the LOWER slab's mesh, vertical up the step, top leg
           into the UPPER slab's mesh -- tying both plates (dia12). -- */
        var zlink = [], _laid = (typeof _layoutZones === 'function') ? _layoutZones() : [];
        var _zcourse = _blockModule().course, _RAISE = { kids: 2 * _zcourse, relax: 1 * _zcourse };
        var _deckYOf = function (k) { var v = _RAISE[k] || _zcourse; if (v > D - 0.05) v = D - 0.05; return -v; };
        var _byKey = {};
        for (var _li = 0; _li < _laid.length; _li++) { if (_laid[_li].kind) _byKey[_laid[_li].wall + ':' + _laid[_li].slot] = _laid[_li]; }
        for (var _li2 = 0; _li2 < _laid.length; _li2++) {
          var _za = _laid[_li2]; if (!_za.kind) continue;
          var _zb = _byKey[_za.wall + ':' + (_za.slot + 1)]; if (!_zb || !_zb.kind) continue;
          var _ya = _deckYOf(_za.kind), _yb = _deckYOf(_zb.kind);
          if (Math.abs(_ya - _yb) < 0.05) continue;              /* same level -> no step */
          var _qa = _za.quad; if (!_qa || _qa.length < 4) continue;
          var _jA = _qa[3], _jB = _qa[2];                        /* shared edge: a's inner = b's cap */
          var _jL = Math.hypot(_jB[0] - _jA[0], _jB[1] - _jA[1]) || 1;
          var _jux = (_jB[0] - _jA[0]) / _jL, _juz = (_jB[1] - _jA[1]) / _jL;
          var _inAx = ((_qa[0][0] + _qa[1][0]) / 2) - ((_qa[3][0] + _qa[2][0]) / 2);
          var _inAz = ((_qa[0][1] + _qa[1][1]) / 2) - ((_qa[3][1] + _qa[2][1]) / 2);
          var _inAL = Math.hypot(_inAx, _inAz) || 1; _inAx /= _inAL; _inAz /= _inAL;
          var _aLower = _ya < _yb;
          var _loMesh = (_aLower ? _ya : _yb) - 0.02, _hiMesh = (_aLower ? _yb : _ya) - 0.02;
          var _loDx = _aLower ? _inAx : -_inAx, _loDz = _aLower ? _inAz : -_inAz;   /* into lower deck */
          var _hiDx = -_loDx, _hiDz = -_loDz;                                       /* into upper deck */
          for (var _zt = STEP / 2; _zt < _jL; _zt += STEP) {
            var _zx = _jA[0] + _jux * _zt, _zz = _jA[1] + _juz * _zt;
            zlink.push(_zx + _loDx * BEND, _loMesh, _zz + _loDz * BEND, _zx, _loMesh, _zz);   /* bottom leg -> lower slab */
            zlink.push(_zx, _loMesh, _zz, _zx, _hiMesh, _zz);                                 /* vertical step */
            zlink.push(_zx, _hiMesh, _zz, _zx + _hiDx * BEND, _hiMesh, _zz + _hiDz * BEND);   /* top leg -> upper slab */
          }
        }
        addLines(zlink, COL.rebar);

        /* -- 4) Stairs (KARI teal + rebar purple) -- */
        var mode = getStairsMode();
        var place = (mode !== 'none' && mode !== 'ladder') ? getCurrentStairsPlacement() : null;
        if (place && _stairsPlacementFits(place, mode)) {
          var sInner = _stairsBasePoly(); if (!sInner || sInner.length < 3) sInner = inner;
          var sdy = _stairsDeckY(place.edge);
          var n = sInner.length;
          var SA = sInner[place.edge], SB = sInner[(place.edge + 1) % n];
          var sex = SB[0] - SA[0], sez = SB[1] - SA[1], Lp = Math.hypot(sex, sez);
          if (Lp > 0.05) {
            var sux = sex / Lp, suz = sez / Lp;
            var area2 = 0, qi;
            for (qi = 0; qi < n; qi++) { var Q0 = sInner[qi], Q1 = sInner[(qi + 1) % n]; area2 += Q0[0] * Q1[1] - Q1[0] * Q0[1]; }
            var ccw = area2 > 0;
            var swx = ccw ? -suz : suz, swz = ccw ? sux : -sux;
            var Ox, Oz, axx, axz;
            if (!place.atEnd) { Ox = SA[0]; Oz = SA[1]; axx = sux;  axz = suz; }
            else              { Ox = SB[0]; Oz = SB[1]; axx = -sux; axz = -suz; }
            var L2W = function (al, inw) { return [Ox + axx * al + swx * inw, Oz + axz * al + swz * inw]; };

            var mod = _blockModule(), bl = mod.len, bh = mod.course, bw = mod.width;
            var p = _stairsTypeParams(mode);
            var widthBlocks = (mode === 'full') ? Math.max(1, Math.round(Lp / bl)) : p.widthBlocks;
            var stairW = (mode === 'full') ? Lp : widthBlocks * bl;
            var treadDepth = (p.treadHalves || 2) * (bl / 2);
            var stepCount = Math.max(1, Math.floor(_stairsEffectiveDepth(place.edge) / bh) - 1);
            var aL = (mode === 'full') ? 0 : -bw / 2;
            var aR = (mode === 'full') ? stairW : stairW + bw / 2;

            var smesh = [], srebar = [], s, topY, inF, inB, P1, P2, gx, gz, ww;
            /* L-foot points INTO the pool (away from the wall) -- same sense as
               the wall verticals in the parallel wall. sw points wall->water,
               so +sw is "into the pool". */
            var benx = swx, benz = swz;
            var BENDs = 0.20;
            var cheekW = aR;                         /* open (outer) cheek side */
            /* cheek L-foot points 90 deg from the risers: along the WIDTH, away
               from the step's concrete (outward past the open cheek side). */
            var cbenx = axx, cbenz = axz;
            var totalInward = stepCount * treadDepth;
            for (s = 1; s <= stepCount; s++) {
              topY = sdy - s * bh;
              inB = (s - 1) * treadDepth;     /* step back edge (toward wall side of this tread) */
              inF = s * treadDepth;           /* step front edge (toward water)                  */

              /* KARI mesh in the CONCRETE of the WHOLE step -- from the wall
                 (inward 0) out to this step's front face, across full width.
                 Same colour as the slab mesh (product = mesh). */
              for (gz = 0; gz <= inF + 1e-6; gz += SP) { P1 = L2W(aL, gz); P2 = L2W(aR, gz); smesh.push(P1[0], topY, P1[1], P2[0], topY, P2[1]); }
              for (ww = aL; ww <= aR + 1e-6; ww += SP) { P1 = L2W(ww, 0); P2 = L2W(ww, inF); smesh.push(P1[0], topY, P1[1], P2[0], topY, P2[1]); }

              /* REBAR in the BLOCKS (riser across width + one cheek), vertical
                 from the slab up to THIS step's top, L-foot bent INTO the pool.
                 Same colour as the wall verticals (product = dia12 rebar). */
              for (ww = aL; ww <= aR + 1e-6; ww += STEP) {
                P1 = L2W(ww, inF);
                srebar.push(P1[0], -D, P1[1], P1[0], topY, P1[1]);                          /* vertical */
                srebar.push(P1[0], -D, P1[1], P1[0] + benx * BENDs, -D, P1[1] + benz * BENDs); /* L-foot into pool */
              }
              P1 = L2W(cheekW, (inB + inF) / 2);
              srebar.push(P1[0], -D, P1[1], P1[0], topY, P1[1]);
              srebar.push(P1[0], -D, P1[1], P1[0] + cbenx * BENDs, -D, P1[1] + cbenz * BENDs);
            }
            addLines(smesh, COL.g6);                    /* stair KARI mesh -- green, like the base slab */
            addLines(srebar, COL.rebar);                /* same colour -- one rebar product */
          }
        }
      }

      eng.sceneGroup.add(grp);
    },

    _build3D_SlopeViz: function (poly) {
      if (!STATE.slopeActive || STATE.slopeDeg <= 0) return;
      var T = global.THREE;
      var eng = global.BaseEngine;
      if (!eng || !eng.sceneGroup) return;
      if (!poly || !poly.length) return;

      var xMin =  Infinity, xMax = -Infinity;
      var zMin =  Infinity, zMax = -Infinity;
      for (var i = 0; i < poly.length; i++) {
        var p = poly[i];
        if (p[0] < xMin) xMin = p[0];
        if (p[0] > xMax) xMax = p[0];
        if (p[1] < zMin) zMin = p[1];
        if (p[1] > zMax) zMax = p[1];
      }
      var bbL = xMax - xMin;
      var bbW = zMax - zMin;
      if (bbL < 0.1 || bbW < 0.1) return;

      var cx = (xMin + xMax) / 2;
      var cz = (zMin + zMax) / 2;
      var L = bbL * 2.5;
      var W = bbW * 2.0;
      var x0 = cx - L / 2, x1 = cx + L / 2;
      var z0 = cz - W / 2, z1 = cz + W / 2;

      /* A ground GRID (not a filled plane) that conforms to the slope.
         Every vertex is heighted with the SAME terrain formula the fence
         uses (_terrainY = -_padSlopeExtra at absolute world X/Z), so the
         grid lines lie exactly on grade under the model -- same direction,
         same height, no separate beige surface. */
      var step = STATE.isMetric ? 1.0 : 0.3048;
      var verts = [];
      function gy(x, z) { return -_padSlopeExtra(x, z); }

      /* Lines running along Z (constant X), stepping across X. */
      for (var x = x0; x <= x1 + 1e-6; x += step) {
        verts.push(x, gy(x, z0), z0,  x, gy(x, z1), z1);
      }
      /* Lines running along X (constant Z), stepping across Z. */
      for (var z = z0; z <= z1 + 1e-6; z += step) {
        verts.push(x0, gy(x0, z), z,  x1, gy(x1, z), z);
      }

      var geom = new T.BufferGeometry();
      geom.setAttribute('position', new T.Float32BufferAttribute(verts, 3));
      var mat = new T.LineBasicMaterial({ color: 0xd8d8d8, transparent: true, opacity: 0.9 });
      var gridLines = new T.LineSegments(geom, mat);
      gridLines.userData = { assetType: 'slope-terrain' };
      eng.sceneGroup.add(gridLines);
    },

    /* Stage-view ground apron (3D, vizStage 1). A light-grey ground surface the
       size of the reference grid, with the pool opening punched out, sitting at
       coping-top level so the basin reads as recessed into the ground. The hole
       edge follows the finished perimeter and reflects the water-edge style:
         * skimmer  -- the apron meets the coping outer edge directly.
         * overflow -- a recessed darker groove (drainage slot) rings the coping,
                      then the paving apron starts beyond it.
         * infinite -- a recessed concrete channel rings the coping, with the
                      apron beyond it. */
    _build3D_GroundApron: function (poly) {
      var T = global.THREE, eng = global.BaseEngine;
      if (!T || !eng || !eng.sceneGroup || !poly || poly.length < 3) return;
      if (STATE.slopeActive && STATE.slopeDeg > 0) return;   /* slope grid owns the ground */

      var d    = getVariantDefaults(variantKey(), STATE.lvl);
      var cw   = d.copingWidthM || 0.30;
      var edge = getEdgeType();

      if (!this._groundMats) {
        this._groundMats = {
          apron:   new T.MeshStandardMaterial({ color: 0xd2d2d2, roughness: 0.92, metalness: 0 }),   /* light-grey paving */
          groove:  new T.MeshStandardMaterial({ color: 0x8f8f8f, roughness: 0.92, metalness: 0 }),   /* drainage slot     */
          channel: new T.MeshStandardMaterial({ color: 0xb7b0a2, roughness: 0.92, metalness: 0 })    /* concrete channel  */
        };
      }
      var GM = this._groundMats;

      function plate(shape, thick, y0, mat) {
        var g = new T.ExtrudeGeometry(shape, { depth: thick, bevelEnabled: false });
        var m = new T.Mesh(g, mat);
        m.rotation.x = Math.PI / 2;
        m.position.y = y0;
        m.userData = { assetType: 'ground' };
        eng.sceneGroup.add(m);
        return m;
      }

      /* A few mm below the coping/lem tile top (0.05) so the apron never sits
         proud of the tiles. */
      var APRON_TOP = 0.044;

      /* The innermost edge of the ground assembly tucks all the way to the wall
         block (footprint outer face) so there is NEVER a gap to the pool,
         whatever the coping geometry per edge type -- the coping tiles simply sit
         on top. The band just outside reflects the water-edge style. */
      var holeRing = poly;        /* skimmer: apron meets the wall directly */

      if (edge === 'overflow') {
        var grooveOuter = _insetPolygon(poly, -(cw + 0.10));   /* slot ~0.10 m past the coping */
        plate(this._shapeWithHole(grooveOuter, poly), 0.04, APRON_TOP - 0.014, GM.groove);
        holeRing = grooveOuter;
      } else if (edge === 'infinite') {
        var chanOuter = _insetPolygon(poly, -(cw + 0.22));     /* channel ~0.22 m past the coping */
        plate(this._shapeWithHole(chanOuter, poly), 0.05, APRON_TOP - 0.02, GM.channel);
        holeRing = chanOuter;
      }

      /* Apron square -- centred on the grid origin, sized like the reference grid
         but always big enough to fully contain the (possibly off-centre) hole. */
      var step = STATE.isMetric ? 1.0 : 0.3048;
      var xmn = Infinity, xmx = -Infinity, zmn = Infinity, zmx = -Infinity, maxAbs = 0;
      for (var i = 0; i < holeRing.length; i++) {
        var x = holeRing[i][0], z = holeRing[i][1];
        if (x < xmn) xmn = x; if (x > xmx) xmx = x;
        if (z < zmn) zmn = z; if (z > zmx) zmx = z;
        if (Math.abs(x) > maxAbs) maxAbs = Math.abs(x);
        if (Math.abs(z) > maxAbs) maxAbs = Math.abs(z);
      }
      var maxDim = Math.max(xmx - xmn, zmx - zmn);
      var gridSize = Math.max(30, Math.ceil((maxDim * 1.2) / step) * step);
      var H = Math.max(gridSize / 2, maxAbs + 2.0);
      var sq = [[-H, -H], [H, -H], [H, H], [-H, H]];

      plate(this._shapeWithHole(sq, holeRing), 0.04, APRON_TOP, GM.apron);
    },

    _addExcavationPit: function (cx, cz, sizeX, sizeZ, topY, depth) {
      var T = global.THREE;
      var eng = global.BaseEngine;
      /* pool-v8: getBBox() gives { L, W } only, so the caller's minX / maxX came in undefined and this wireframe was all NaN -- never
         drawn, and its NaN bounds emptied the section tool's box. Left undrawn as before (the look unchanged), now without the NaN. */
      if (!isFinite(cx) || !isFinite(cz) || !isFinite(sizeX) || !isFinite(sizeZ) || !isFinite(topY) || !isFinite(depth)) { _dbg('[excavation] pit wireframe skipped (no bounds)'); return; }
      var verts = [
        cx - sizeX/2, topY,         cz - sizeZ/2,
        cx + sizeX/2, topY,         cz - sizeZ/2,
        cx + sizeX/2, topY,         cz + sizeZ/2,
        cx - sizeX/2, topY,         cz + sizeZ/2,
        cx - sizeX/2, topY - depth, cz - sizeZ/2,
        cx + sizeX/2, topY - depth, cz - sizeZ/2,
        cx + sizeX/2, topY - depth, cz + sizeZ/2,
        cx - sizeX/2, topY - depth, cz + sizeZ/2
      ];
      var edges = [
        0,1, 1,2, 2,3, 3,0,
        4,5, 5,6, 6,7, 7,4,
        0,4, 1,5, 2,6, 3,7
      ];
      var lineGeom = new T.BufferGeometry();
      var positions = [];
      for (var e = 0; e < edges.length; e++) {
        var idx = edges[e] * 3;
        positions.push(verts[idx], verts[idx+1], verts[idx+2]);
      }
      lineGeom.setAttribute('position', new T.Float32BufferAttribute(positions, 3));
      var lineMat = new T.LineBasicMaterial({ color: 0xD2A878, transparent: true, opacity: 0.7 });
      var box = new T.LineSegments(lineGeom, lineMat);
      box.userData = { assetType: 'excavation-box' };
      eng.sceneGroup.add(box);
    },

    _polyToShape: function (poly) {
      var T = global.THREE;
      var shape = new T.Shape();
      shape.moveTo(poly[0][0], poly[0][1]);
      for (var i = 1; i < poly.length; i++) shape.lineTo(poly[i][0], poly[i][1]);
      shape.closePath();
      return shape;
    },

    /* Shape (outer ring) with an inner ring punched out as a hole. */
    _shapeWithHole: function (outer, inner) {
      var T = global.THREE;
      var shape = this._polyToShape(outer);
      var hole = new T.Path();
      hole.moveTo(inner[0][0], inner[0][1]);
      for (var i = 1; i < inner.length; i++) hole.lineTo(inner[i][0], inner[i][1]);
      hole.closePath();
      shape.holes.push(hole);
      return shape;
    },

    _build2D: function (poly) {
      var T = global.THREE;
      var mats = this._ensureMaterials();
      var eng = global.BaseEngine;
      var d = getVariantDefaults(variantKey(), STATE.lvl);

      /* Coping band (footprint expanded outward) at low opacity. */
      var coping = _insetPolygon(poly, -d.copingWidthM);
      mats.coping2D.opacity = 0.45;
      var cMesh = new T.Mesh(new T.ShapeGeometry(this._polyToShape(coping)), mats.coping2D);
      cMesh.rotation.x = Math.PI / 2; cMesh.position.y = 0.0005;
      eng.sceneGroup.add(cMesh);

      /* Footprint fill (the pool shell) at low opacity. */
      mats.fill2D.opacity = Math.min(STATE.opacity2D, 0.18);
      var mesh = new T.Mesh(new T.ShapeGeometry(this._polyToShape(poly)), mats.fill2D);
      mesh.rotation.x = Math.PI / 2; mesh.position.y = 0.001;
      eng.sceneGroup.add(mesh);

      /* Water surface (inset by wall thickness). Tagged 'water' so the
         visualization manager keeps its fixed translucency in 2D too. */
      var inner = _insetPolygon(poly, _effectiveWallThick(d));
      var wMesh = new T.Mesh(new T.ShapeGeometry(this._polyToShape(inner)), mats.water2D);
      wMesh.rotation.x = Math.PI / 2; wMesh.position.y = 0.002;
      wMesh.userData = { assetType: 'water' };
      eng.sceneGroup.add(wMesh);

      /* Outer + inner outlines. */
      this._add2DOutline(poly, 0.003);
      this._add2DOutline(inner, 0.0035);

      /* Edge-system markers. Skimmer dots are now the draggable fittings
         drawn in _build2DFittings, so only the overflow ring is added here. */
      if (getEdgeType() === 'overflow') {
        this._add2DOutline(coping, 0.0036);   /* overflow channel ring */
      }

      /* Zone slots (kids / relax) at the shorter walls -- STEP 1: 2D only. */
      this._build2DZones(inner);
      /* Ghost whirlpool card parked outside the longest edge. */
      this._build2DWhirlpoolGhost(poly);

      /* Stairs footprint (top-down) so the type/placement shows in 2D too. */
      this._build2DStairs(inner);

      /* Technology shaft footprint (2D), drawn as a dashed-looking outlined box
         beside the pool. Drag handle (added in rebuildDragHandles) moves it. */
      this._build2DShaft();

      /* Overflow balance tank footprint (2D), overflow mode only. */
      this._build2DTank();

      /* Piping routes (drawn under the fittings) -- colour by diameter. */
      this._build2DPipes();

      /* Electrical: cables, junction boxes, panel. */
      this._build2DElectrical();

      /* Skimmers (long white rectangles) + return jets (small white tiles) on
         the inner edge; both draggable in 2D. */
      this._build2DFittings();
    },

    _build2DPipes: function () {
      var T = global.THREE, eng = global.BaseEngine;
      if (!T || !eng || !eng.sceneGroup) return;
      var pip = computePiping();
      if (!pip || !pip.segs || !pip.segs.length) return;
      var RED  = { d15: 0xe8908f, d20: 0xd1504f, d25: 0x9e1b1b, d40: 0x6e0f0f };  /* suction (intake) */
      var BLUE = { d15: 0x8fb3e8, d20: 0x4f7fd1, d25: 0x1b3f9e };  /* return (outlet) */
      function colFor(circ, dia) { return (circ === 'return' ? BLUE : RED)[dia] || 0x666666; }
      var groups = {};
      for (var i = 0; i < pip.segs.length; i++) {
        var s = pip.segs[i];
        if (Math.hypot(s.x2 - s.x1, s.z2 - s.z1) < 0.02) continue;  /* skip risers in 2D */
        var key = s.circuit + ':' + s.dia;
        (groups[key] = groups[key] || { col: colFor(s.circuit, s.dia), segs: [] }).segs.push(s);
      }
      for (var gk in groups) {
        if (!groups.hasOwnProperty(gk)) continue;
        var pts = [];
        for (var j = 0; j < groups[gk].segs.length; j++) {
          var g = groups[gk].segs[j];
          pts.push(new T.Vector3(g.x1, 0.0040, g.z1), new T.Vector3(g.x2, 0.0040, g.z2));
        }
        var geo = new T.BufferGeometry().setFromPoints(pts);
        var mat = new T.LineBasicMaterial({ color: groups[gk].col });
        var lines = new T.LineSegments(geo, mat);
        lines.userData = { assetType: 'pool-pipe-2d' };
        eng.sceneGroup.add(lines);
      }
    },

    _build2DElectrical: function () {
      var T = global.THREE, eng = global.BaseEngine;
      if (!T || !eng || !eng.sceneGroup) return;
      var li = getLightPositions();
      if (!this._elMat) {
        this._elMat = {
          cable: new T.LineBasicMaterial({ color: 0x111111 }),
          box:   new T.MeshBasicMaterial({ color: 0x111111 }),
          panel: new T.MeshBasicMaterial({ color: 0xf2f2f2 })
        };
      }
      /* Cables (orange) -- only when there are lights. */
      if (li.length) {
        var wire = computeWiring();
        if (wire && wire.segs.length) {
          var pts = [];
          for (var i = 0; i < wire.segs.length; i++) {
            var s = wire.segs[i];
            if (Math.hypot(s.x2 - s.x1, s.z2 - s.z1) < 0.02) continue;
            pts.push(new T.Vector3(s.x1, 0.0042, s.z1), new T.Vector3(s.x2, 0.0042, s.z2));
          }
          if (pts.length) {
            var lines = new T.LineSegments(new T.BufferGeometry().setFromPoints(pts), this._elMat.cable);
            lines.userData = { assetType: 'pool-cable-2d' };
            eng.sceneGroup.add(lines);
          }
        }
        /* Junction boxes -- small orange squares at each light. */
        for (var k = 0; k < li.length; k++) {
          var bx = new T.Mesh(new T.PlaneGeometry(0.10, 0.10), this._elMat.box);
          bx.rotation.x = -Math.PI / 2; bx.position.set(li[k].x, 0.0058, li[k].z);
          bx.userData = { assetType: 'junction-box' };
          eng.sceneGroup.add(bx);
        }
      }
      /* Electrical panel -- orange outlined box (like the shaft). */
      var pp = getPanelPos();
      var pw = 0.45, pl = 0.30, hw = pw / 2, hl = pl / 2;
      var quad = [
        [pp.x - hw, pp.z - hl], [pp.x + hw, pp.z - hl],
        [pp.x + hw, pp.z + hl], [pp.x - hw, pp.z + hl]
      ];
      var shape = new T.Shape();
      shape.moveTo(quad[0][0], quad[0][1]);
      for (var q = 1; q < quad.length; q++) shape.lineTo(quad[q][0], quad[q][1]);
      shape.closePath();
      var fill = new T.Mesh(new T.ShapeGeometry(shape), this._elMat.panel);
      fill.rotation.x = Math.PI / 2; fill.position.y = 0.0044;
      fill.userData = { assetType: 'electrical-panel' };
      eng.sceneGroup.add(fill);
    },

    _build2DFittings: function () {
      var T = global.THREE, eng = global.BaseEngine, mats = this._ensureMaterials();
      if (!T || !eng || !eng.sceneGroup) return;
      var inner = _innerRing();
      if (!inner || inner.length < 3) return;
      var self = this;
      var cx0 = 0, cz0 = 0;
      for (var ci = 0; ci < inner.length; ci++) { cx0 += inner[ci][0]; cz0 += inner[ci][1]; }
      cx0 /= inner.length; cz0 /= inner.length;
      function nearestEdge(x, z) {
        /* nearest inner edge + inward normal. Inward = toward the water
           centroid (radial), which is stable and symmetric on every wall --
           no axis bias, no edge-point ambiguity. */
        var best = 0, bd = Infinity, n = inner.length;
        for (var i = 0; i < n; i++) {
          var a = inner[i], b = inner[(i + 1) % n];
          var ex0 = b[0] - a[0], ez0 = b[1] - a[1], L0 = (ex0 * ex0 + ez0 * ez0) || 1e-9;
          var t = ((x - a[0]) * ex0 + (z - a[1]) * ez0) / L0;
          if (t < 0) t = 0; else if (t > 1) t = 1;
          var px = a[0] + ex0 * t, pz = a[1] + ez0 * t;
          var d2 = (px - x) * (px - x) + (pz - z) * (pz - z);
          if (d2 < bd) { bd = d2; best = i; }
        }
        var A = inner[best], B = inner[(best + 1) % inner.length];
        var ex = B[0] - A[0], ez = B[1] - A[1], L = Math.hypot(ex, ez) || 1;
        var ux = ex / L, uz = ez / L, nx = -uz, nz = ux;
        /* flip the normal so it points from the fitting toward the centroid */
        if ((cx0 - x) * nx + (cz0 - z) * nz < 0) { nx = -nx; nz = -nz; }
        return { ux: ux, uz: uz, nx: nx, nz: nz };
      }
      /* Draw a rectangle that shares the water edge and lies fully INSIDE the
         water, offset along the (centroid-based) inward normal. */
      function rectAt(cx, cz, halfAlong, perp, e, mat, y) {
        var ux = e.ux, uz = e.uz, nx = e.nx, nz = e.nz;
        var q = [
          [cx - ux * halfAlong, cz - uz * halfAlong],
          [cx + ux * halfAlong, cz + uz * halfAlong],
          [cx + ux * halfAlong + nx * perp, cz + uz * halfAlong + nz * perp],
          [cx - ux * halfAlong + nx * perp, cz - uz * halfAlong + nz * perp]
        ];
        var shape = new T.Shape();
        shape.moveTo(q[0][0], q[0][1]);
        for (var i = 1; i < 4; i++) shape.lineTo(q[i][0], q[i][1]);
        shape.closePath();
        var m = new T.Mesh(new T.ShapeGeometry(shape), mat);
        m.rotation.x = Math.PI / 2; m.position.y = y;
        eng.sceneGroup.add(m);
      }
      /* Skimmers: 30x5 (6:1) -- long side on the wall, body into the water. */
      var sk = getSkimmerPositions();
      for (var s = 0; s < sk.length; s++) {
        rectAt(sk[s].x, sk[s].z, 0.15, 0.05, nearestEdge(sk[s].x, sk[s].z), mats.poolSkimmer, 0.0052);
      }
      /* Jets: 10x5 (2:1) -- body into the water. */
      var jt = getJetPositions();
      for (var j = 0; j < jt.length; j++) {
        rectAt(jt[j].x, jt[j].z, 0.05, 0.05, nearestEdge(jt[j].x, jt[j].z), mats.poolJet, 0.0054);
      }
      /* Main drains (floor): white anti-vortex cover disc + dark grate cross. */
      var dr = getDrainPositions();
      for (var dd = 0; dd < dr.length; dd++) {
        var disc = new T.Mesh(new T.CircleGeometry(0.13, 20), mats.poolSkimmer);
        disc.rotation.x = -Math.PI / 2; disc.position.set(dr[dd].x, 0.0050, dr[dd].z);
        eng.sceneGroup.add(disc);
        /* grate cross (two thin dark bars) */
        var barGeoH = new T.PlaneGeometry(0.22, 0.025), barGeoV = new T.PlaneGeometry(0.025, 0.22);
        var bh = new T.Mesh(barGeoH, mats.poolGrate); bh.rotation.x = -Math.PI / 2; bh.position.set(dr[dd].x, 0.0052, dr[dd].z);
        var bv = new T.Mesh(barGeoV, mats.poolGrate); bv.rotation.x = -Math.PI / 2; bv.position.set(dr[dd].x, 0.0052, dr[dd].z);
        eng.sceneGroup.add(bh); eng.sceneGroup.add(bv);
      }
      /* Pool lights: yellow half-disc, flat side on the wall, bulging into
         the water. */
      var li = getLightPositions();
      if (li.length) {
        if (!this._lightMat2D) this._lightMat2D = new T.MeshBasicMaterial({ color: 0xffd11a });
        for (var lq = 0; lq < li.length; lq++) {
          var le = nearestEdge(li[lq].x, li[lq].z);    /* ux,uz wall dir; nx,nz inward */
          var R = 0.16, steps = 16;
          var shape = new T.Shape();
          shape.moveTo(li[lq].x - le.ux * R, li[lq].z - le.uz * R);
          for (var aa = 0; aa <= steps; aa++) {
            var th = Math.PI * (aa / steps);
            var au = Math.cos(th) * R, an = Math.sin(th) * R;
            shape.lineTo(li[lq].x + le.ux * au + le.nx * an, li[lq].z + le.uz * au + le.nz * an);
          }
          shape.closePath();
          var lm = new T.Mesh(new T.ShapeGeometry(shape), this._lightMat2D);
          lm.rotation.x = Math.PI / 2; lm.position.y = 0.0056;
          eng.sceneGroup.add(lm);
        }
      }
    },

    _build2DShaft: function () {
      var T = global.THREE, eng = global.BaseEngine, mats = this._ensureMaterials();
      if (!T || !eng || !eng.sceneGroup) return;
      var pos = getShaftPos(), sz = getShaftSize();
      var hw = sz.w / 2, hl = sz.l / 2;
      var quad = [
        [pos.x - hw, pos.z - hl], [pos.x + hw, pos.z - hl],
        [pos.x + hw, pos.z + hl], [pos.x - hw, pos.z + hl]
      ];
      var shape = new T.Shape();
      shape.moveTo(quad[0][0], quad[0][1]);
      for (var i = 1; i < quad.length; i++) shape.lineTo(quad[i][0], quad[i][1]);
      shape.closePath();
      var fill = new T.Mesh(new T.ShapeGeometry(shape), mats.coping2D);
      fill.rotation.x = Math.PI / 2; fill.position.y = 0.004;
      fill.userData = { assetType: 'shaft' };
      eng.sceneGroup.add(fill);
      this._add2DPolyOutline(quad, 0.0045, mats.edge2D);
    },

    /* Balance/retention tank footprint (2D) -- real-size blue box, like the
       shaft. Drawn in overflow + infinite modes. */
    _build2DTank: function () {
      var et = getEdgeType();
      if (et !== 'overflow' && et !== 'infinite') return;
      var T = global.THREE, eng = global.BaseEngine, mats = this._ensureMaterials();
      if (!T || !eng || !eng.sceneGroup) return;
      var pos = getTankPos(), sz = getTankSize();
      var hw = sz.w / 2, hl = sz.l / 2;
      var quad = [
        [pos.x - hw, pos.z - hl], [pos.x + hw, pos.z - hl],
        [pos.x + hw, pos.z + hl], [pos.x - hw, pos.z + hl]
      ];
      var shape = new T.Shape();
      shape.moveTo(quad[0][0], quad[0][1]);
      for (var i = 1; i < quad.length; i++) shape.lineTo(quad[i][0], quad[i][1]);
      shape.closePath();
      var fill = new T.Mesh(new T.ShapeGeometry(shape), mats.tank2D);
      fill.rotation.x = Math.PI / 2; fill.position.y = 0.0042;
      fill.userData = { assetType: 'tank' };
      eng.sceneGroup.add(fill);
      this._add2DPolyOutline(quad, 0.0045, mats.edge2D);
    },

    /* Zone slots (kids / relax) -- translucent red cards. The "+" add-buttons
       are DOM overlays (see _buildZoneButtons) so they stay a constant size and
       carry tooltips. Block variants only. */
    _build2DZones: function (inner) {
      if (!_variantUsesBlocks()) return;
      var T = global.THREE, eng = global.BaseEngine;
      if (!T || !eng || !eng.sceneGroup) return;
      var dz = _displayZones();
      if (!dz.length) return;
      var PAD = ZONE_PAD_M;
      for (var i = 0; i < dz.length; i++) {
        var q = dz[i].quad;
        var mnx = Math.min(q[0][0], q[1][0], q[2][0], q[3][0]);
        var mxx = Math.max(q[0][0], q[1][0], q[2][0], q[3][0]);
        var mnz = Math.min(q[0][1], q[1][1], q[2][1], q[3][1]);
        var mxz = Math.max(q[0][1], q[1][1], q[2][1], q[3][1]);
        var w = (mxx - mnx) - 2 * PAD, h = (mxz - mnz) - 2 * PAD;
        if (w <= 0.05 || h <= 0.05) continue;
        var cx = (mnx + mxx) / 2, cz = (mnz + mxz) / 2;
        var r = Math.min(0.25, w / 4, h / 4);
        var asgn = dz[i].kind;
        if (STATE._pdfCapture && !asgn) continue;   /* undefined zones are not exported */
        var col = (asgn === 'kids') ? 0xff8c42 : (asgn === 'relax') ? 0x6ec96e : 0xff3b30;
        var op = asgn ? 0.34 : ZONE_OPACITY;
        var fillMat = new T.MeshBasicMaterial({
          color: col, transparent: true, opacity: op, side: T.DoubleSide, depthWrite: false
        });
        var card = new T.Mesh(new T.ShapeGeometry(_roundedRectShape(T, cx, cz, w, h, r)), fillMat);
        card.rotation.x = Math.PI / 2; card.position.y = 0.005;
        card.userData = { assetType: 'zone', zoneWall: dz[i].wall, zoneSlot: dz[i].slot, zoneKind: asgn || null };
        eng.sceneGroup.add(card);
      }
    },

    /* Ghost whirlpool -- small decent red card parked just outside the pool's
       longest edge. Its "+" is a DOM overlay too. Block variants only. */
    _build2DWhirlpoolGhost: function (poly) {
      if (STATE._pdfCapture) return;   /* placeholder jacuzzi is never exported */
      var T = global.THREE, eng = global.BaseEngine;
      if (!T || !eng || !eng.sceneGroup) return;
      var pos; try { pos = getWhirlpoolPos(); } catch (_) { pos = null; }
      if (!pos || !isFinite(pos.x) || !isFinite(pos.z)) return;
      var sz = 2.0, cx = pos.x, cz = pos.z;        /* schematic jacuzzi footprint ~2 m */
      var sq = function (s) { var q = s / 2; return [[cx - q, cz - q], [cx + q, cz - q], [cx + q, cz + q], [cx - q, cz + q]]; };
      /* translucent fill + outer rim + inner seat ring -> reads as a tub */
      var fill = new T.MeshBasicMaterial({
        color: 0x4fc3f7, transparent: true, opacity: 0.16,
        side: T.DoubleSide, depthWrite: false
      });
      var card = new T.Mesh(new T.ShapeGeometry(this._polyToShape(sq(sz))), fill);
      card.rotation.x = Math.PI / 2; card.position.y = 0.005;
      card.userData = { assetType: 'whirlpoolGhost' };
      eng.sceneGroup.add(card);
      this._add2DOutline(sq(sz), 0.0052);          /* outer frame (rim) */
      this._add2DOutline(sq(sz * 0.62), 0.0053);   /* inner frame (seat) */
    },
    _build2DStairs: function (inner) {
      var mode = getStairsMode();
      if (mode === 'none') return;
      var T = global.THREE, eng = global.BaseEngine, mats = this._ensureMaterials();
      if (!T || !eng || !eng.sceneGroup || !inner || inner.length < 3) return;
      var place = getCurrentStairsPlacement();
      if (!place || !_stairsPlacementFits(place, mode)) return;

      var sb = _stairsBasePoly();
      if (sb && sb.length >= 3) inner = sb;
      var n = inner.length;
      var A = inner[place.edge], B = inner[(place.edge + 1) % n];
      var ex = B[0] - A[0], ez = B[1] - A[1];
      var L = Math.hypot(ex, ez);
      if (L < 0.05) return;
      var ux = ex / L, uz = ez / L;
      var area2 = 0;
      for (var ai = 0; ai < n; ai++) { var q0 = inner[ai], q1 = inner[(ai + 1) % n]; area2 += q0[0] * q1[1] - q1[0] * q0[1]; }
      var ccw = area2 > 0;
      var wx = ccw ? -uz : uz, wz = ccw ? ux : -ux;
      var Ox, Oz, axx, axz;
      if (!place.atEnd) { Ox = A[0]; Oz = A[1]; axx = ux;  axz = uz; }
      else              { Ox = B[0]; Oz = B[1]; axx = -ux; axz = -uz; }
      function L2W(al, inw) { return [Ox + axx * al + wx * inw, Oz + axz * al + wz * inw]; }

      var mod = _blockModule();
      var bl = mod.len, bh = mod.course, bw = mod.width;
      var D = getCurrentDepth();
      var p = _stairsTypeParams(mode);

      if (mode === 'ladder') {
        /* Ladder: a small bracket marker on the wall. */
        var la = 0.55, lw = 0.45, lin = 0.18;
        var lp = [L2W(la - lw / 2, 0.06), L2W(la + lw / 2, 0.06), L2W(la + lw / 2, lin), L2W(la - lw / 2, lin)];
        this._add2DPolyOutline(lp, 0.0038, mats.edge2D);
        return;
      }

      var widthBlocks = (mode === 'full') ? Math.max(1, Math.round(L / bl)) : p.widthBlocks;
      var stairW = (mode === 'full') ? L : widthBlocks * bl;
      var treadDepth = (p.treadHalves || 2) * (bl / 2);
      var stepCount = Math.max(1, Math.floor(_stairsEffectiveDepth(place.edge) / bh) - 1);
      var totalInward = stepCount * treadDepth;

      /* Fill the stairs footprint with the water tint so it reads as steps. */
      var aL = (mode === 'full') ? 0 : -bw / 2;
      var aR = (mode === 'full') ? stairW : stairW + bw / 2;
      var quad = [L2W(aL, 0), L2W(aR, 0), L2W(aR, totalInward), L2W(aL, totalInward)];
      var shape = new T.Shape();
      shape.moveTo(quad[0][0], quad[0][1]);
      shape.lineTo(quad[1][0], quad[1][1]);
      shape.lineTo(quad[2][0], quad[2][1]);
      shape.lineTo(quad[3][0], quad[3][1]);
      shape.closePath();
      var fillMesh = new T.Mesh(new T.ShapeGeometry(shape), mats.coping2D);
      fillMesh.rotation.x = Math.PI / 2; fillMesh.position.y = 0.0021;
      eng.sceneGroup.add(fillMesh);

      /* Step nosing lines (one per tread). */
      for (var s = 1; s <= stepCount; s++) {
        var inw = s * treadDepth;
        if (inw > totalInward + 0.001) break;
        var p1 = L2W(aL, inw), p2 = L2W(aR, inw);
        var pts = [new T.Vector3(p1[0], 0.0042, p1[1]), new T.Vector3(p2[0], 0.0042, p2[1])];
        eng.sceneGroup.add(new T.Line(new T.BufferGeometry().setFromPoints(pts), mats.edge2D));
      }
      /* Outline of the whole stairs footprint. */
      this._add2DPolyOutline(quad, 0.0043, mats.edge2D);
    },

    _add2DPolyOutline: function (poly, y, matl) {
      var T = global.THREE, eng = global.BaseEngine;
      var pts = [];
      for (var j = 0; j < poly.length; j++) pts.push(new T.Vector3(poly[j][0], y, poly[j][1]));
      pts.push(new T.Vector3(poly[0][0], y, poly[0][1]));
      eng.sceneGroup.add(new T.Line(new T.BufferGeometry().setFromPoints(pts), matl || this._materials.edge2D));
    },

    /* Coping tiles in plan (skimmer): a thin filled rectangle + outline per
       piece, so the joints read in 2D. Shares _copingTiles() with the BoQ. */
    _add2DOutline: function (poly, y) {
      var T = global.THREE;
      var eng = global.BaseEngine;
      var pts = [];
      for (var j = 0; j < poly.length; j++) pts.push(new T.Vector3(poly[j][0], y, poly[j][1]));
      pts.push(new T.Vector3(poly[0][0], y, poly[0][1]));
      eng.sceneGroup.add(new T.Line(new T.BufferGeometry().setFromPoints(pts), this._materials.edge2D));
    },

    /* ------------------------------------------------------------------
       POOL 3D -- excavated, reinforced basin.
       Layers (grade Y=0, growing downward):
         walls  [0 .. -D]            per-variant shell (block/EPS/gunite)
         slab   [-D .. -D-slabT]     reinforced bottom slab
         gravel [-D-slabT .. lower]  compacted bedding (full pit footprint)
         water  surface at -freeboard (skimmer) or 0 (overflow)
         coping rim just above grade; stairs in one inner corner
       ------------------------------------------------------------------ */
    _build3D: function (poly) {
      var T = global.THREE;
      var mats = this._ensureMaterials();
      var eng = global.BaseEngine;
      if (!T || !eng || !eng.sceneGroup) return;

      var D = getCurrentDepth();
      var d = getVariantDefaults(variantKey(), STATE.lvl);
      var wallT = _effectiveWallThick(d), slabT = _slabThickness(D), gravT = d.bedGravelM;
      var edge = getEdgeType();

      var inner  = _insetPolygon(poly, wallT);
      var pit    = _insetPolygon(poly, -d.excavOversizeM);
      var coping = _insetPolygon(poly, -d.copingWidthM);

      function extrudeY(shape, depthY, y0, mat, rotZflip) {
        var g = new T.ExtrudeGeometry(shape, { depth: depthY, bevelEnabled: false });
        var m = new T.Mesh(g, mat);
        m.rotation.x = Math.PI / 2;
        m.position.y = y0;
        eng.sceneGroup.add(m);
        return m;
      }

      /* Walls -- laid blocks for masonry variants, solid sprayed shell
         for gunite. */
      if (_variantUsesBlocks()) {
        this._layWallBlocks(poly, inner, D, wallT, mats);
      } else {
        extrudeY(this._shapeWithHole(poly, inner), D, 0, this._wallMaterial(mats));
      }

      /* Bottom slab -- generated UNDER THE MAIN POOL only. Instead of running
         the full original footprint and punching a bench-shaped hole (which
         left a nonsensical slab/gravel frame around the bench), we shorten the
         slab by the bench: take the footprint with each bench notched IN to its
         riser line (the main pool's real footprint), then apply the SAME
         overhang rule past its perimeter walls -- including the riser, which now
         gets a proper footing. The bench area carries its own raised deck +
         thin bed instead. */
      var _zf3 = _zoneFloors();
      /* Plate footprints come from the shared single-source-of-truth helpers so
         the concrete here and the reinforcement mesh in _buildReinforcement stay
         identical. */
      var _deepFoot = _poolDeepFoot;
      var _benchFoot = _poolBenchFoot;
      var slabPoly = _offsetPolygon(_deepFoot(poly), (d.slabOverhangM || 0), true) || _deepFoot(poly);
      extrudeY(this._polyToShape(slabPoly), slabT, -D, mats.poolConcrete);
      /* Raised zone slabs (kids/relax): the STRUCTURAL slab grows outward by the
         same overhang (footing under the bench walls); the walkable finish on
         top stays on the bare bench top. */
      for (var _ri = 0; _ri < _zf3.raised.length; _ri++) {
        var _rz = _zf3.raised[_ri];
        extrudeY(this._polyToShape(_benchFoot(_rz.quad, wallT + (d.slabOverhangM || 0), _rz.outerAtPerimeter)), (_rz.slabT || slabT), _rz.topY - 0.02, mats.poolConcrete);
        extrudeY(this._polyToShape(_rz.quad), 0.02, _rz.topY, this._surfaceMaterial(mats));   /* finish top flush with the shelf top (-dft) */
      }
      /* -- Kids<->Main divider ----------------------------------------------
         A row of pillars along the shared kids/main edge, each TWO blocks
         (PWC05004) stacked from the kids floor up to the rim, with ~0.4 m
         swim-through gaps so a child can pass into the main pool. Every pillar
         is capped by a 500x500 tile (SFF00002) at rim level, giving dry-foot
         stepping stones across the pool width. Built only on kids shelves that
         border the main pool directly (dividerCols computed in _zoneFloors). */
      var _colFoot = STATE.isMetric ? 0.40 : 12 * IN;          /* pillar footprint side */
      var _tileSz  = STATE.isMetric ? 0.50 : 20 * IN;          /* SFF00002 tile side */
      var _sqAt = function (cx, cz, ux, uz, s) {
        var hx = ux * s / 2, hz = uz * s / 2, px = -uz * s / 2, pz = ux * s / 2;
        return [[cx - hx - px, cz - hz - pz], [cx + hx - px, cz + hz - pz],
                [cx + hx + px, cz + hz + pz], [cx - hx + px, cz - hz + pz]];
      };
      for (var _di = 0; _di < _zf3.raised.length; _di++) {
        var _dz = _zf3.raised[_di];
        if (!_dz.bordersMain || (_dz.dividerCols | 0) < 1) continue;
        var _dq = _dz.quad, _da = _dq[3], _db = _dq[2];        /* inner edge = kids/main boundary */
        var _dex = _db[0] - _da[0], _dez = _db[1] - _da[1], _deL = Math.hypot(_dex, _dez) || 1;
        var _dux = _dex / _deL, _duz = _dez / _deL;
        /* Unit vector pointing back INTO the kids shelf (inner edge -> perimeter
           edge). Pillars sit with their whole footprint inside the kids zone,
           their main-facing face flush on this edge, so the swim-through gaps
           open between them and the deck/water below is undisturbed. */
        var _kx = ((_dq[0][0] + _dq[1][0]) / 2) - ((_dq[3][0] + _dq[2][0]) / 2);
        var _kz = ((_dq[0][1] + _dq[1][1]) / 2) - ((_dq[3][1] + _dq[2][1]) / 2);
        var _kL = Math.hypot(_kx, _kz) || 1; _kx /= _kL; _kz /= _kL;
        var _off = _colFoot / 2;                               /* shift in by half a block */
        var _dn = _dz.dividerCols | 0, _dpitch = _deL / _dn;
        var _dh = -_dz.topY;                                   /* kids floor -> rim (= 2 blocks) */
        for (var _ci = 0; _ci < _dn; _ci++) {
          var _dt = (_ci + 0.5) * _dpitch;
          var _dcx = _da[0] + _dux * _dt + _kx * _off, _dcz = _da[1] + _duz * _dt + _kz * _off;
          /* Stack the pillar as individual PWC05004 blocks (400x400x250 mm /
             12x12x10") with a recessed joint centred between courses -- same joint
             width as the wall blocks -- so it reads as masonry, not one solid
             post. The stack always spans exactly from the rim (0) to the kids
             floor, divided into whole nominal courses. */
          var _colShape = this._polyToShape(_sqAt(_dcx, _dcz, _dux, _duz, _colFoot));
          var _blkH = STATE.isMetric ? 0.25 : 10 * IN, _jnt = 0.015;
          var _nc = Math.max(1, Math.round(_dh / _blkH));
          var _ch = _dh / _nc;                                /* course height that fills the span exactly */
          for (var _cc = 0; _cc < _nc; _cc++) {
            var _top = (_cc === 0)       ? 0     : -(_cc * _ch) - _jnt / 2;
            var _bot = (_cc === _nc - 1) ? -_dh  : -((_cc + 1) * _ch) + _jnt / 2;
            extrudeY(_colShape, _top - _bot, _top, mats.poolConcrete);
          }
          /* Walk-over tile: its TOP sits just above the water surface so it stays
             a dry-foot step even in overflow / infinite (water at the rim). The
             tile is drawn tall enough to reach there; the vykaz counts the tile
             only (no height) -- the field crew realises the build-up. */
          var _wTop = (edge === 'overflow') ? 0.0 : (edge === 'infinite') ? 0.05 : -(d.freeboardM || 0.15);
          var _tileTopY = Math.max(0.03, _wTop + 0.03);
          extrudeY(this._polyToShape(_sqAt(_dcx, _dcz, _dux, _duz, _tileSz)), _tileTopY + 0.005, _tileTopY, mats.poolCoping);
        }
      }
      /* Riser walls between the main-pool slab and each zone slab are laid as
         real blocks inside _buildBlockWalls (bonded into the perimeter), so no
         solid riser is extruded here. */

      /* Make-up under each zone shelf: a GRAVEL bed of the standard thickness
         (gravT) directly under the shelf slab, grown OUTWARD by the same gravel
         overhang as the main base (cap + sides), with the riser edge fixed so it
         never runs toward the main pool. No earth/backfill is modelled. */
      for (var _bi = 0; _bi < _zf3.raised.length; _bi++) {
        var _bz = _zf3.raised[_bi];
        var _gravTop = _bz.topY - 0.02 - (_bz.slabT || slabT);          /* under the (lowered) shelf slab */
        extrudeY(this._polyToShape(_benchFoot(_bz.quad, wallT + (d.bedGravelOverhangM || 0), _bz.outerAtPerimeter)), gravT, _gravTop, mats.poolGravel);
      }

      /* Gravel base under the bottom slab -- SAME rule as the slab: the main
         pool footprint (benches notched in) plus the gravel overhang. No frame
         around the bench. */
      var gravelPoly = _offsetPolygon(_deepFoot(poly), (d.bedGravelOverhangM || 0), true) || _deepFoot(poly);
      extrudeY(this._polyToShape(gravelPoly), gravT, -D - slabT, mats.poolGravel);

      /* Interior finish lining on the inner basin floor (thin). Built on the
         DEEP-pool polygon (each zone arm's cap edge shifted inward by the shelf
         depth) instead of punching holes -- the zone edge sits exactly on
         'inner', so a hole there would not triangulate and the finish would
         bleed under the bench. The edge-shift gives a clean simple polygon, so
         the deep floor finish stops exactly at the riser line; each bench has
         its own surfaced deck on top + a surfaced riser face. */
      var _finPoly = (typeof _waterDeepPoly === 'function') ? _waterDeepPoly(inner) : inner;
      extrudeY(this._polyToShape(_finPoly), 0.02, -D + 0.02, this._surfaceMaterial(mats));
      /* Pool interior surface on the WALLS -- mapped onto the ACTUAL wetted
         outline, not the original perimeter. Behind a bench the perimeter wall
         is dropped, so finishing the original 'inner' there would paint surface
         onto walls that no longer exist. Instead:
         (a) deep walls + riser faces: a thin shell just inside the DEEP-pool
             outline (_finPoly, full height) -- at a riser line this shell IS the
             riser's deep face;
         (b) above-shelf walls: a thin shell on each bench's cap + side edges
             from the shelf top up to the rim (the deep-facing edge is skipped --
             (a) already finishes it). */
      var _surf = this._surfaceMaterial(mats);
      /* The deep-outline edges that are RISER lines (each bench cap edge, moved
         in to the riser line) must carry surface only from the deep floor (-D)
         UP TO the shelf top (-dft) -- above that there is no wall, it is the open
         step between the bench water and the main pool, so the old full-height
         shell left a stray strip rising to the rim. Cap those edges at -dft;
         every other deep edge runs full height to the rim. */
      var _riserTop = {};
      try {
        var _lzF = _layoutZones();
        var _bcF = _blockModule().course;
        var _RZF = { kids: 2 * _bcF, relax: 1 * _bcF };
        var _deepestS = {};   /* per wall: the innermost filled zone (max reach) owns the riser line on _finPoly */
        for (var _rk = 0; _rk < _lzF.length; _rk++) {
          var _zF = _lzF[_rk];
          if (!_zF.kind || !_zF.geom || !_zF.geom.arm) continue;
          var _wF = _zF.geom.arm.wall;
          var _sF = _zF.geom.start + _zF.geom.depth;   /* reach into the pool -- _waterDeepPoly shifts the edge by the max of these */
          var _dfF = _RZF[_zF.kind] || _bcF; if (_dfF > D - 0.05) _dfF = D - 0.05;
          if (!(_wF in _deepestS) || _sF > _deepestS[_wF]) { _deepestS[_wF] = _sF; _riserTop[_wF] = -_dfF; }   /* surface rises to THAT zone's floor -- its front face is the main/zone divider */
        }
      } catch (_rt) {}
      try {
        var _fp = _finPoly, _nfp = _fp.length;
        var _a2 = 0; for (var _fk = 0; _fk < _nfp; _fk++) { var _fn = (_fk + 1) % _nfp; _a2 += _fp[_fk][0] * _fp[_fn][1] - _fp[_fn][0] * _fp[_fk][1]; }
        var _ccwF = _a2 > 0;
        for (var _fe = 0; _fe < _nfp; _fe++) {
          var _A0 = _fp[_fe], _B0 = _fp[(_fe + 1) % _nfp];
          var _ux0 = _B0[0] - _A0[0], _uz0 = _B0[1] - _A0[1], _L0 = Math.hypot(_ux0, _uz0);
          if (_L0 < 0.05) continue; _ux0 /= _L0; _uz0 /= _L0;
          var _nx0 = _ccwF ? -_uz0 : _uz0, _nz0 = _ccwF ? _ux0 : -_ux0;   /* inward (toward deep water) */
          var _top0 = (_fe in _riserTop) ? _riserTop[_fe] : -0.02;
          var _h0 = _top0 - (-D); if (_h0 <= 0.02) continue;
          var _ax0 = _A0[0] - _ux0 * 0.01, _az0 = _A0[1] - _uz0 * 0.01;   /* small overlap so corners close */
          var _bx0 = _B0[0] + _ux0 * 0.01, _bz0 = _B0[1] + _uz0 * 0.01;
          var _bq0 = [
            [_ax0, _az0], [_bx0, _bz0],
            [_bx0 + _nx0 * 0.02, _bz0 + _nz0 * 0.02], [_ax0 + _nx0 * 0.02, _az0 + _nz0 * 0.02]
          ];
          extrudeY(this._polyToShape(_bq0), _h0, _top0, _surf);
        }
      } catch (_sl) {}
      /* Above-shelf wall surface. Each band rises from the shelf top only as
         high as a real wall exists on that edge: to the rim where the edge faces
         open water / the perimeter, but only up to a SHALLOWER neighbour shelf's
         top (i.e. the step between them) where two shelves meet, and not at all
         where the neighbour is the same height or deeper (open water above).
         Without this, two stacked zones (e.g. kids behind relax) each painted a
         full-height band on their shared edge -> a stray surface climbing to the
         rim on the kids/relax boundary. */
      var _RA3 = _zf3.raised;
      for (var _sf = 0; _sf < _RA3.length; _sf++) {
        var _sq = _RA3[_sf].quad, _sty = _RA3[_sf].topY;                 /* shelf top = -dft */
        var _qsa = 0; for (var _qk = 0; _qk < 4; _qk++) { var _q2 = (_qk + 1) % 4; _qsa += _sq[_qk][0] * _sq[_q2][1] - _sq[_q2][0] * _sq[_qk][1]; }
        var _qccw = _qsa > 0;
        var _edges3 = [0, 1, 2, 3];   /* cap (q0-q1) + two sides (q1-q2, q3-q0) + deep (q2-q3): the deep edge needs a face too where a SHALLOWER shelf sits in front of this one (kids->relax step); it stays wall-less only when it faces open water */
        for (var _ei = 0; _ei < _edges3.length; _ei++) {
          var _i0 = _edges3[_ei], _i1 = (_i0 + 1) % 4, _A = _sq[_i0], _B = _sq[_i1];
          var _ux = _B[0] - _A[0], _uz = _B[1] - _A[1], _L = Math.hypot(_ux, _uz);
          if (_L < 0.05) continue; _ux /= _L; _uz /= _L;
          var _nx = _qccw ? -_uz : _uz, _nz = _qccw ? _ux : -_ux;        /* inward (toward shelf interior) */
          /* probe just OUTSIDE this edge for an adjacent shelf */
          var _mx = (_A[0] + _B[0]) * 0.5 - _nx * 0.05, _mz = (_A[1] + _B[1]) * 0.5 - _nz * 0.05;
          var _isDeep = (_i0 === 2);
          var _topB = _isDeep ? _sty : -0.02;                            /* deep open edge -> no wall (faces main pool); other open edges -> rim */
          for (var _oj = 0; _oj < _RA3.length; _oj++) {
            if (_oj === _sf) continue;
            if (_pointInPoly([_mx, _mz], _RA3[_oj].quad)) {
              _topB = (_RA3[_oj].topY > _sty + 0.005) ? _RA3[_oj].topY : _sty;   /* shallower -> step up to it; same/deeper -> no wall */
              break;
            }
          }
          var _sh = _topB - _sty;
          if (_sh <= 0.02) continue;
          var _bq = [
            [_A[0], _A[1]], [_B[0], _B[1]],
            [_B[0] + _nx * 0.02, _B[1] + _nz * 0.02], [_A[0] + _nx * 0.02, _A[1] + _nz * 0.02]
          ];
          extrudeY(this._polyToShape(_bq), _sh, _topB, _surf);
        }
      }

      /* Water volume -- fills from the surface down to ~3 cm above floor.
         Infinity: the water sits at the CURRENT venec top (0.05); the overflow
         edge keeps its venec there (water spills over), while the other edges
         get their venec + tiles raised a little above the water (see below). */
      var INF_VENEC_TOP = 0.05;                        /* current coping/venec top = water brim */
      var INF_RIM = 0.05;                              /* non-spill venec raised above water */
      var waterTop = (edge === 'overflow') ? 0.0
                   : (edge === 'infinite') ? INF_VENEC_TOP
                   : -d.freeboardM;
      var waterDepth = Math.max(0.1, waterTop + D - 0.03);
      /* In INFINITE the venec inner edge sits at the lining face ('inner'-0.02);
         pull the water in to the same edge so the venec does not overhang the
         water's top surface (that overhang made the transparent water clip
         through the venec -> flicker). Other modes keep the structural 'inner'. */
      /* Water fills the inner cavity but NEVER under a raised shelf. Built per
         region so each column has a single layer (uniform tint, no stacked
         translucency):
           * deep main -> one full-depth block over _waterDeepPoly (shelves cut
             out), so there is no water left under the zone;
           * each shelf -> one shallow block (surface -> shelf top), with its deep
             edge pulled ~30 mm back off the riser so it never shares a coplanar
             face with the deep block (that coincidence was the glitching seam).
         The water VOLUME in the vykaz is computed analytically (shelves + pillars
         subtracted), so it stays correct independent of this mesh. */
      /* Water fills the inner cavity but NEVER over a raised shelf -- the deep
         pool only, with each zone's footprint carved out (_waterDeepPoly =
         'inner' when there are no zones, so this one block covers both cases).
         The water VOLUME in the vykaz is computed analytically (shelves +
         pillars subtracted), independent of this mesh. */
      /* Water = ONE solid generated from the pool shape (not extruded blocks):
         full-depth in the basin, raised to each zone's floor over the shelves,
         joined by a riser step -- a single watertight mesh, so there is no seam
         between touching bodies (that seam was the dark plane) and no water under
         a shelf. Volume in the vykaz is analytic. */
      var _wPoly = (edge === 'infinite') ? _insetPolygon(inner, 0.02) : inner;
      var _wDeep = (typeof _waterDeepPoly === 'function') ? _waterDeepPoly(_wPoly) : _wPoly;
      var _wZones = [];
      var _zfW = _zoneFloors();
      for (var _wi = 0; _wi < _zfW.raised.length; _wi++) {
        var _wz = _zfW.raised[_wi];
        if (_wz.quad && _wz.quad.length >= 4) _wZones.push({ quad: _wz.quad, yZone: _wz.topY });
      }
      var waterMesh = (typeof _buildSteppedWaterMesh === 'function')
        ? _buildSteppedWaterMesh(_wPoly, _wDeep, _wZones, waterTop, waterTop - waterDepth, mats.poolWater)
        : null;
      if (waterMesh) { eng.sceneGroup.add(waterMesh); waterMesh.userData = { assetType: 'water' }; waterMesh.renderOrder = 3; }
      /* pool-v9 THE WATER'S SOLID for the section tool: one closed block a region (deep, each shelf, each tread), drawing nothing
         (colorWrite off) -- the kit counts it into its stencil and fills the water's cut in blue (the visible water is too
         transparent for its fill); first in the group, so a body that touches it caps over it; never picked, never exported */
      /* (the visible water above stays one smooth body through the opaque stairs -- the treads' blocks drawn in it showed their joins
         as blue fins; the free space, the stairs carved out, is these hidden bodies' and the volume's) */
      /* pool-v10 the cut's water a light, clear blue (Marek 09:44 "zbytecne moc tmava plocha vody, vypada to neprirozene"; was
         0x4f9fd1): the cap is lit like a wall, so its colour is set well lighter than the tone it shows */
      if (!mats.poolWaterSolid) mats.poolWaterSolid = new T.MeshBasicMaterial({ color: 0x92cdf0, colorWrite: false, depthWrite: false });
      var _wSt = _stairsWaterCut(_wDeep, waterTop), _wSZ = _wZones.concat(_wSt.treads);
      var _wBodies = [{ poly: (_wSZ.length ? _wSt.deep : _wPoly), y: -D + POOL_FIN_T }];   /* from the floor finish's top (the visible water stops 1 cm over it) */
      for (var _wb = 0; _wb < _wSZ.length; _wb++) _wBodies.push({ poly: _wSZ[_wb].quad, y: _wSZ[_wb].yZone });
      for (_wb = 0; _wb < _wBodies.length; _wb++) {
        var _wB = _wBodies[_wb];
        if (!_wB.poly || _wB.poly.length < 3 || waterTop - _wB.y < 0.005) continue;
        var _wS = _buildSteppedWaterMesh(_wB.poly, _wB.poly, [], waterTop, _wB.y, mats.poolWaterSolid, true);
        if (!_wS) continue;
        _wS.userData = { assetType: 'water-solid' };
        _wS.raycast = function () {};
        eng.sceneGroup.add(_wS);
        var _wCh = eng.sceneGroup.children; _wCh.splice(_wCh.indexOf(_wS), 1); _wCh.unshift(_wS);
      }

      /* Coping rim -- band over the wall top (footprint->coping outer), water
         opening punched out. Seated 1 cm INTO the wall top (spans [-0.01,0.05])
         so the wall's top cap is buried inside the coping solid instead of
         sitting coplanar just under it, and (skimmer/overflow) the inner edge is
         pulled 5 mm over the water so it no longer shares the 'inner' plane with
         the wall/water -- avoids coplanar z-fight in AR at the rim. In INFINITE
         the inner edge is FLUSH with the VISIBLE inner wall -- i.e. the finish
         lining face ('inner' inset 0.02, same as liningInner above), not the bare
         structural 'inner' -- so there is no step between pool blocks and venec.
         Only infinite changes. */
      var copingInner = (edge === 'infinite') ? _insetPolygon(inner, 0.02) : _insetPolygon(inner, 0.005);
      if (edge === 'overflow') {
        /* Overflow: keep the wide lem (footprint -> coping outer). */
        extrudeY(this._shapeWithHole(coping, copingInner), 0.06, 0.05, mats.poolCoping);
      } else {
        /* Skimmer: a narrow band (~tile width) seated at the inner edge, so the
           edge isn't the full wall-top + overhang width. */
        var copingSkim = _insetPolygon(inner, -d.copingWidthM);   /* inner edge + tile width outward */
        if (edge !== 'infinite')
          extrudeY(this._shapeWithHole(copingSkim, copingInner), 0.06, 0.05, mats.poolCoping);
        /* (infinite: NO closed coping ring -- the per-edge bands below build it.
           Non-infinity edges get the full concrete venec (base + raised rim);
           infinity edges KEEP a venec too (so it is still counted as concrete
           in the vykaz via copingLen = full perimeter) but only out to the weir
           edge and clad in the POOL SURFACE -- the water sheets over it, so it
           reads as the finish continuing, not bare concrete.) */
        if (edge === 'infinite' && copingInner && copingSkim && copingInner.length === copingSkim.length) {
          var _infSet = getInfiniteEdges(), _foot = getFootprintPolygon(), _nE = copingInner.length;
          var _hasFoot = _foot && _foot.length === _nE;
          var _vTop = INF_VENEC_TOP + INF_RIM;
          var _cw = (d.copingWidthM || 0.30) + 0.005;          /* venec band width across */
          var _finMat = (this._surfaceMaterial ? this._surfaceMaterial(mats) : mats.poolCoping);
          var _ar = 0;
          for (var _k = 0; _k < _nE; _k++) { var _q0 = copingInner[_k], _q1 = copingInner[(_k + 1) % _nE]; _ar += _q0[0] * _q1[1] - _q1[0] * _q0[1]; }
          var _ccw = _ar > 0;
          for (var _ce = 0; _ce < _nE; _ce++) {
            var _isInf = _infSet.indexOf(_ce) >= 0;
            if (_isInf && !_hasFoot) continue;                 /* need footprint for the weir-edge band */
            var _i0 = copingInner[_ce], _iN = copingInner[(_ce + 1) % _nE];
            /* infinity edge: venec stops at the weir edge (footprint); other
               edges run the full coping width. */
            var _s0 = _isInf ? _foot[_ce]             : copingSkim[_ce];
            var _sN = _isInf ? _foot[(_ce + 1) % _nE] : copingSkim[(_ce + 1) % _nE];
            var _ex = _iN[0] - _i0[0], _ez = _iN[1] - _i0[1], _el = Math.hypot(_ex, _ez) || 1;
            var _ux = _ex / _el, _uz = _ez / _el;
            var _nx = _ccw ? _uz : -_uz, _nz = _ccw ? -_ux : _ux;   /* outward normal */
            var _iA = _i0, _sA = _s0, _iB = _iN, _sB = _sN;
            if (!_isInf) {
              /* square cap where a concrete edge meets an infinity edge, so the
                 venec reaches the footprint corner under the tile (no 45 deg). */
              var _startInf = _hasFoot && _infSet.indexOf((_ce - 1 + _nE) % _nE) >= 0;
              var _endInf   = _hasFoot && _infSet.indexOf((_ce + 1) % _nE) >= 0;
              if (_startInf) {
                var _tS = (_foot[_ce][0] - _i0[0]) * _ux + (_foot[_ce][1] - _i0[1]) * _uz;
                _iA = [_i0[0] + _ux * _tS, _i0[1] + _uz * _tS];
                _sA = [_iA[0] + _nx * _cw, _iA[1] + _nz * _cw];
              }
              if (_endInf) {
                var _vE = (_ce + 1) % _nE;
                var _tE = (_foot[_vE][0] - _i0[0]) * _ux + (_foot[_vE][1] - _i0[1]) * _uz;
                _iB = [_i0[0] + _ux * _tE, _i0[1] + _uz * _tE];
                _sB = [_iB[0] + _nx * _cw, _iB[1] + _nz * _cw];
              }
            }
            var _band = new T.Shape();
            _band.moveTo(_iA[0], _iA[1]);
            _band.lineTo(_iB[0], _iB[1]);
            _band.lineTo(_sB[0], _sB[1]);
            _band.lineTo(_sA[0], _sA[1]);
            _band.closePath();
            if (_isInf) extrudeY(_band, INF_VENEC_TOP + 0.01, INF_VENEC_TOP, _finMat);  /* [-0.01,0.05] pool surface */
            else        extrudeY(_band, _vTop + 0.01, _vTop, mats.poolCoping);           /* [-0.01,0.10] concrete    */
          }
        }
      }

      /* Edge system. */
      if (edge === 'overflow') {
        /* Overflow: the lem cut into pieces -- two sloped halves + centre catch
           channel (replaces the flat grate band). */
        try { this._buildOverflowTiles(mats); } catch (_eo) {}
        this._buildReturnJets(inner, wallT);
      } else {
        this._buildSkimmers(inner, wallT);
        try { this._buildCopingTiles(mats); } catch (_e) {}
      }

      /* Infinity (vanishing) edges: an open overflow gutter just outside each
         ACTIVE edge, with a rounded weir lip on the wall top. Self-guards to
         infinite mode; other edges stay skimmer. */
      try { this._buildInfinityGutters(D, mats, wallT); } catch (_ig) {}

      /* Stairs in one inner corner. */
      this._buildStairs(poly, inner, D, wallT, this._wallMaterial(mats));

      /* Main drains on the pool floor (anti-vortex covers). */
      this._buildDrains(D);

      /* Pool lights (yellow half-domes on the wall). */
      this._buildLights(D, inner);

      /* Technology shaft beside the pool (underground box + lid). */
      this._buildShaft();

      /* Overflow balance tank beside the pool (overflow mode only). */
      this._buildTank();

      /* Piping routes in 3D (thin tubes just below grade). */
      this._build3DPipes();

      /* Electrical: junction boxes, cables, wall-mounted panel. */
      this._build3DElectrical(D, inner);

      /* Excavation wireframe around the basin. */
      var bb = getBBox();
      var pad = wallT + d.excavOversizeM;
      this._addExcavationPit(
        (bb.minX + bb.maxX) / 2,
        (bb.minZ + bb.maxZ) / 2,
        (bb.maxX - bb.minX) + pad * 2,
        (bb.maxZ - bb.minZ) + pad * 2,
        0,
        D + slabT + gravT
      );
    },

    /* Lay the perimeter wall as individual chamfered blocks (masonry
       variants). Each block is slightly smaller than its module cell so
       the recessed joints read as separate units. Running bond: every
       other course is offset by half a block. One InstancedMesh = one
       draw call for the whole wall. */
    _blockGeoCache: null,
    /* View-independent wall-block placement, extracted from _build3D so the
       BoQ takeoff (_wallBlockTakeoff) can run the EXACT same placement in a
       count-only mode -- single source of truth for laid blocks vs. drawn. */
    _layWallBlocks: function (poly, inner, D, wallT, mats) {
        var _wmat = _takeoffActive ? null : this._wallMaterial(mats);
        /* Gather the cap-touching benches: each one wants the perimeter wall
           below its shelf top (-dft) to step IN to the riser line, so the
           main-pool side closes with a real bonded end wall (the riser), tied
           into the side walls by the SAME corner bond as the rest of the
           perimeter. We lay the wall in height BANDS split at each distinct
           shelf top: above a bench -> full footprint; below -> footprint with
           that bench's cap edge notched inward by the shelf depth. */
        var _isEps = (variantKey() === 'eps_block');
        var _layCourse = _isEps ? _facingModule().course : _blockModule().course;   /* EPS 16"/0.25m, concrete 8"/0.20m */
        var _benZ = [];
        try {
          var _lz = _layoutZones();
          var _bcc = _blockModule().course;
          var _RZ2 = { kids: 2 * _bcc, relax: 1 * _bcc };
          for (var _bi = 0; _bi < _lz.length; _bi++) {
            var _bz = _lz[_bi];
            if (!_bz.kind || !_bz.geom || !_bz.geom.arm) continue;   /* every filled zone on the arm -- stacked zones step the wall in progressively */
            var _dz = _RZ2[_bz.kind] || _bcc;
            /* EPS keeps a clean full-course bond: snap the wall step UP to a whole
               EPS course, so a half-deep shelf (relax) never splits a 16" course
               mid-height across the whole perimeter. The shelf DECK still sits at
               its real depth (from _zoneFloors); only the wall reaches a full
               course -> relax shows an optically full block. The BoQ stays
               area-based on the real shelf height, so the count isn't inflated. */
            if (_isEps) _dz = Math.ceil((_dz - 1e-6) / _layCourse) * _layCourse;
            if (_dz > D - 0.05) _dz = D - 0.05;
            var _zSt = (_bz.geom.start || 0), _zEn = _zSt + (_bz.geom.depth || ZONE_LEN_M);
            _benZ.push({ e: _bz.geom.arm.wall, dft: _dz, s: _zEn, arm: _bz.geom.arm, start: _zSt, end: _zEn });
          }
        } catch (_be) { _benZ = []; }

        if (!_benZ.length) {
          this._buildBlockWalls(poly, inner, D, wallT, _wmat);
        } else {
          /* footprint with a given subset of benches notched in (cap edge +
             its two shared corners moved inward by that bench's shelf depth). */
          var _notch = function (sub) {
            var out = poly.map(function (p) { return [p[0], p[1]]; });
            var nn = poly.length;
            var area2 = 0; for (var _a = 0; _a < nn; _a++) { var q0 = poly[_a], q1 = poly[(_a + 1) % nn]; area2 += q0[0] * q1[1] - q1[0] * q0[1]; }
            var ccw = area2 > 0;
            var mxs = {};   /* deepest reach per edge */
            for (var _k = 0; _k < sub.length; _k++) { var z = sub[_k]; if (!(z.e in mxs) || z.s > mxs[z.e]) mxs[z.e] = z.s; }
            var eks = Object.keys(mxs);
            for (var _kk = 0; _kk < eks.length; _kk++) {
              var e = +eks[_kk], w = (e + 1) % nn, s = mxs[e];
              var ax = poly[w][0] - poly[e][0], az = poly[w][1] - poly[e][1], aL = Math.hypot(ax, az) || 1;
              var inx = ccw ? -(az / aL) : (az / aL), inz = ccw ? (ax / aL) : -(ax / aL);
              out[e] = [poly[e][0] + inx * s, poly[e][1] + inz * s];
              out[w] = [poly[w][0] + inx * s, poly[w][1] + inz * s];
            }
            return out;
          };
          /* band split heights: rim (0) and each distinct -dft, down to -D */
          var _cuts = [0];
          for (var _ci = 0; _ci < _benZ.length; _ci++) { var _yy = -_benZ[_ci].dft; if (_cuts.indexOf(_yy) < 0) _cuts.push(_yy); }
          _cuts.sort(function (a, b) { return b - a; });   /* descending: 0, -dft1, -dft2 ... */
          _cuts.push(-D - 0.001);
          for (var _bd = 0; _bd < _cuts.length - 1; _bd++) {
            var _yTop = _cuts[_bd], _yBot = _cuts[_bd + 1];
            if (_yTop - _yBot < 1e-4) continue;
            /* notch every bench whose shelf top is at or above this band's top
               (i.e. the band lies below that shelf -> the riser is the wall) */
            var _sub = [];
            for (var _si = 0; _si < _benZ.length; _si++) { if (_yTop <= -_benZ[_si].dft + 1e-6) _sub.push(_benZ[_si]); }
            var _np = _notch(_sub);
            var _ni = _insetPolygon(_np, wallT);
            this._buildBlockWalls(_np, _ni, D, wallT, _wmat, _yTop, _yBot, _layCourse);
            /* Fronting retained shelves: a shelf whose wall still exists in this
               band (band bottom is at/above its floor) but which sits IN FRONT
               of a deeper under-shelf zone that pulled the perimeter notch past
               it. The notch skipped this shelf's own perimeter/side/inner walls,
               so lay this course around its OWN quad -- restores e.g. the kids
               2nd course, its bonded corners, and the kids<->relax riser. Its
               inner edge (zone end) differs from the deeper notch line, so no
               double wall is created. */
            if (_sub.length) {
              var _bcF = _layCourse, _pn = poly.length;
              /* footprint winding -> inward normal per edge (same basis as _notch) */
              var _fa2 = 0;
              for (var _aa = 0; _aa < _pn; _aa++) { var _w0 = poly[_aa], _w1 = poly[(_aa + 1) % _pn]; _fa2 += _w0[0] * _w1[1] - _w1[0] * _w0[1]; }
              var _fccw = _fa2 > 0;
              for (var _fi = 0; _fi < _benZ.length; _fi++) {
                var _fz = _benZ[_fi];
                if (!(_yBot >= -_fz.dft - 1e-6)) continue;          /* band must be within this shelf's wall (0 ... -dft) */
                var _passed = false, _reach = 0;
                for (var _gi = 0; _gi < _sub.length; _gi++) {
                  if (_sub[_gi].e === _fz.e && _sub[_gi].s > _fz.end + 1e-6) { _passed = true; if (_sub[_gi].s > _reach) _reach = _sub[_gi].s; }
                }
                if (!_passed) continue;
                /* Quad on the FOOTPRINT edge (not the inner arm): outer edge at
                   the real perimeter so the course stacks flush under the band-0
                   wall; inner edge pushed ONE block past this shelf's own depth
                   toward the deeper neighbour (capped at its inner edge) to close
                   the free gap under the step -- may overlap the deeper deck, which
                   is fine. != the main notch line, so still no double perimeter. */
                var _e = _fz.e, _w = (_e + 1) % _pn;
                var _ex = poly[_w][0] - poly[_e][0], _ez = poly[_w][1] - poly[_e][1], _eL = Math.hypot(_ex, _ez) || 1;
                var _inx = _fccw ? -(_ez / _eL) : (_ez / _eL), _inz = _fccw ? (_ex / _eL) : -(_ex / _eL);
                var _s0 = _fz.start, _s1 = Math.min(_fz.end + _facingModule().len, _reach);
                var _fq = [
                  [poly[_e][0] + _inx * _s0, poly[_e][1] + _inz * _s0],
                  [poly[_w][0] + _inx * _s0, poly[_w][1] + _inz * _s0],
                  [poly[_w][0] + _inx * _s1, poly[_w][1] + _inz * _s1],
                  [poly[_e][0] + _inx * _s1, poly[_e][1] + _inz * _s1]
                ];
                this._buildBlockWalls(_fq, _insetPolygon(_fq, wallT), D, wallT, _wmat, _yTop, _yBot, _bcF);
              }
            }
          }
        }
    },
    _buildBlockWalls: function (poly, inner, D, wallT, mat, yHi, yLo, courseH) {
      var T = global.THREE;
      var eng = global.BaseEngine;
      if (!T || !eng || !eng.sceneGroup) return;
      var mats = this._ensureMaterials();
      var mod = _facingModule();
      var bl = mod.len, bh = courseH || mod.course;
      var courses = Math.max(1, Math.round(D / bh));
      var joint = 0.015;                       /* recessed joint width */
      var n = poly.length;
      /* Optional course-height window: lay only courses whose centre yC is in
         (yLo, yHi]. Lets the caller stack walls in height BANDS, each on its own
         footprint -- full perimeter above a bench, NOTCHED-in (riser) below it.
         The course index 'c' stays global, so the running/corner bond is
         continuous across bands. */
      if (yHi == null) yHi = 1e6;
      if (yLo == null) yLo = -1e6;

      /* Collect every block transform: [cx, y, cz, ang, length].
         Blocks are laid on the OUTER footprint edge (their outer face is
         flush with the footprint), offset inward by wallT/2.
         Corner bond ("zamek"): the wallTxwallT corner square is owned by
         exactly one of the two meeting walls per course, alternating each
         course. Even course: every edge owns its START corner (its first
         block reaches the outer corner vertex) and stops wallT short of the
         END corner; odd course: the opposite. The owning corner block
         therefore reaches the outer vertex so its outer edges line up flush
         with the perpendicular wall's outer face. */
      /* Polygon winding decides the inward side consistently for every
         edge -- robust for concave/L-shaped pools where a centroid test can
         pick the wrong side near a re-entrant corner. */
      var area2 = 0;
      for (var ai = 0; ai < n; ai++) {
        var p0 = poly[ai], p1 = poly[(ai + 1) % n];
        area2 += p0[0] * p1[1] - p1[0] * p0[1];
      }
      var ccw = area2 > 0;

      /* Per-vertex convexity. The masonry lock must be flush on the CONVEX
         side of the wall's turn: that is the OUTER (footprint) face at a
         convex pool corner, but the INNER (water) face at a concave/
         re-entrant corner. So at a concave corner the owning block extends
         past the outer vertex to reach the inner (water) vertex, and the
         non-owning wall reaches the outer vertex instead of stopping short. */
      var convex = [];
      for (var vk = 0; vk < n; vk++) {
        var pv = poly[(vk - 1 + n) % n], cv = poly[vk], nv = poly[(vk + 1) % n];
        var aax = cv[0] - pv[0], aaz = cv[1] - pv[1];
        var bbx = nv[0] - cv[0], bbz = nv[1] - cv[1];
        var cr = aax * bbz - aaz * bbx;
        convex[vk] = ccw ? (cr >= 0) : (cr <= 0);
      }

      var transforms = [];

      for (var i = 0; i < n; i++) {
        var oa = poly[i], ob = poly[(i + 1) % n];
        var dx = ob[0] - oa[0], dz = ob[1] - oa[1];
        var Lo = Math.hypot(dx, dz);
        if (Lo < 0.05) continue;
        var ux = dx / Lo, uz = dz / Lo;
        var ang = -Math.atan2(uz, ux);
        /* Inward perpendicular from the winding (left normal for CCW). */
        var nx = ccw ? -uz :  uz;
        var nz = ccw ?  ux : -ux;
        var cStart = convex[i], cEnd = convex[(i + 1) % n];
        var g = Math.min(wallT, Lo * 0.45);
        for (var c = 0; c < courses; c++) {
          var yC = -(c + 0.5) * bh;
          if (yC > yHi + 1e-6 || yC <= yLo + 1e-6) continue;   /* outside this height band */
          var even = (c % 2 === 0);
          var ownStart = even, ownEnd = !even;
          /* Offset from the outer vertex into the edge (negative = extend
             past the vertex toward the inner/water vertex). */
          var gapS = ownStart ? (cStart ? 0 : -g) : (cStart ? g : 0);
          var gapE = ownEnd   ? (cEnd   ? 0 : -g) : (cEnd   ? g : 0);
          var sStart = gapS;
          var sEnd   = Lo - gapE;
          var run = sEnd - sStart;
          if (run < bl * 0.4) {
            var sc = Lo / 2;
            transforms.push([oa[0] + ux * sc + nx * (wallT / 2), yC, oa[1] + uz * sc + nz * (wallT / 2), ang, Math.min(bl, Lo)]);
            continue;
          }
          var count = Math.max(1, Math.round(run / bl));
          var blen = run / count;               /* actual placed length ~ bl */
          for (var j = 0; j < count; j++) {
            var s = sStart + (j + 0.5) * blen;
            transforms.push([
              oa[0] + ux * s + nx * (wallT / 2),
              yC,
              oa[1] + uz * s + nz * (wallT / 2),
              ang, blen
            ]);
          }
        }
      }

      if (!transforms.length) return;
      if (_takeoffActive) { _takeoffBlocks += transforms.length; return; }

      if (mat) mat.side = T.DoubleSide;     /* so the cores read */
      var hy = (bh - joint) / 2, hz = (wallT - joint) / 2;
      var edges = [0,1,1,2,2,3,3,0, 4,5,5,6,6,7,7,4, 0,4,1,5,2,6,3,7];
      var linePos = [];
      var dummy = new T.Object3D();
      /* Group blocks by length so each distinct size shares one real-size
         hollow geometry (square cavities by length); one draw call per size. */
      var groups = {};
      for (var k = 0; k < transforms.length; k++) {
        var t = transforms[k];
        var sx = Math.max(0.02, t[4] - joint);
        var gk = sx.toFixed(3);
        if (!groups[gk]) groups[gk] = { sx: sx, items: [] };
        groups[gk].items.push(t);
      }
      for (var gkey in groups) {
        if (!groups.hasOwnProperty(gkey)) continue;
        var grp = groups[gkey];
        var geo = this._makeHollowBlockGeo(grp.sx, bh - joint, wallT - joint);
        var inst = new T.InstancedMesh(geo, mat, grp.items.length);
        var hx = grp.sx / 2;
        for (var gi = 0; gi < grp.items.length; gi++) {
          var tt = grp.items[gi];
          var px = tt[0], yC2 = tt[1], pz = tt[2], ang2 = tt[3];
          dummy.position.set(px, yC2, pz);
          dummy.rotation.set(0, ang2, 0);
          dummy.scale.set(1, 1, 1);
          dummy.updateMatrix();
          inst.setMatrixAt(gi, dummy.matrix);
          var corners = [
            [-hx,-hy,-hz],[ hx,-hy,-hz],[ hx,-hy, hz],[-hx,-hy, hz],
            [-hx, hy,-hz],[ hx, hy,-hz],[ hx, hy, hz],[-hx, hy, hz]
          ];
          var ca2 = Math.cos(ang2), sa2 = Math.sin(ang2);
          var wc = [];
          for (var ci = 0; ci < 8; ci++) {
            var lx = corners[ci][0], ly = corners[ci][1], lz = corners[ci][2];
            wc.push([px + lx * ca2 + lz * sa2, yC2 + ly, pz - lx * sa2 + lz * ca2]);
          }
          for (var e = 0; e < edges.length; e += 2) {
            var p1 = wc[edges[e]], p2 = wc[edges[e + 1]];
            linePos.push(p1[0], p1[1], p1[2], p2[0], p2[1], p2[2]);
          }
        }
        inst.instanceMatrix.needsUpdate = true;
        inst.userData = { assetType: 'pool-wall-blocks' };
        eng.sceneGroup.add(inst);
      }

      /* Dark edge wireframe -- one merged LineSegments so every block joint
         reads clearly. Single draw call. */
      var lgeo = new T.BufferGeometry();
      lgeo.setAttribute('position', new T.Float32BufferAttribute(linePos, 3));
      var lines = new T.LineSegments(lgeo, mats.blockEdge);
      lines.userData = { assetType: 'pool-wall-block-edges' };
      eng.sceneGroup.add(lines);
    },

    /* Wall skimmers -- long white faceplate + recessed slot at the water line,
       placed at the stored (draggable) positions, oriented to the nearest
       inner edge. */
    _buildSkimmers: function (inner, wallT) {
      var T = global.THREE;
      var eng = global.BaseEngine;
      var mats = this._materials;
      var d = getVariantDefaults(variantKey(), STATE.lvl);
      /* Skimmer throat axis sits 100 mm below the rim (top edge of the highest
         wall-block course, Y = 0). Raising it here keeps the body clear of the
         raised relax/kids shelf slabs (relax top -0.20, kids -0.40) it used to
         clash with, while still sitting at the surface band of the wall. */
      var ySkimAxis = -0.16;
      var plateLen = 0.40, plateH = 0.10;
      function nearestDir(x, z) {
        var bi = _nearestEdgeIndex(inner, x, z), nn = inner.length;
        var A = inner[bi], B = inner[(bi + 1) % nn], L = Math.hypot(B[0] - A[0], B[1] - A[1]) || 1;
        return -Math.atan2((B[1] - A[1]) / L, (B[0] - A[0]) / L);
      }
      var sk = getSkimmerPositions();
      var _fr = 0.015;                                   /* frame border width */
      var _dw = wallT * 0.6;                             /* depth into wall -- same proudness as the old plate */
      for (var i = 0; i < sk.length; i++) {
        var px = sk[i].x, pz = sk[i].z, rotY = nearestDir(px, pz);
        /* White faceplate as a rectangular FRAME: four solid border bars around
           an open centre (15 mm border), built in a group so rotation is trivial
           and it stays as proud/visible as the old solid plate. */
        var grp = new T.Group();
        grp.position.set(px, ySkimAxis, pz); grp.rotation.y = rotY;
        var bTop = new T.Mesh(new T.BoxGeometry(plateLen, _fr, _dw), mats.poolSkimmer); bTop.position.set(0, plateH / 2 - _fr / 2, 0); grp.add(bTop);
        var bBot = new T.Mesh(new T.BoxGeometry(plateLen, _fr, _dw), mats.poolSkimmer); bBot.position.set(0, -(plateH / 2 - _fr / 2), 0); grp.add(bBot);
        var bL = new T.Mesh(new T.BoxGeometry(_fr, plateH - 2 * _fr, _dw), mats.poolSkimmer); bL.position.set(-(plateLen / 2 - _fr / 2), 0, 0); grp.add(bL);
        var bR = new T.Mesh(new T.BoxGeometry(_fr, plateH - 2 * _fr, _dw), mats.poolSkimmer); bR.position.set(plateLen / 2 - _fr / 2, 0, 0); grp.add(bR);
        /* Recessed dark throat seen through the opening. */
        var throat = new T.Mesh(new T.BoxGeometry(plateLen - 2 * _fr - 0.008, plateH - 2 * _fr - 0.008, _dw * 0.6), mats.poolGrate);
        grp.add(throat);
        grp.userData = { assetType: 'skimmer' };
        eng.sceneGroup.add(grp);
      }
      this._buildReturnJets(inner, wallT);
    },

    /* Return jets -- small white rings at stored positions, ~35 cm below the
       surface, oriented to the nearest inner edge. */
    _buildReturnJets: function (inner, wallT) {
      var T = global.THREE;
      var eng = global.BaseEngine;
      var mats = this._materials;
      var d = getVariantDefaults(variantKey(), STATE.lvl);
      /* Return-jet mouth sits in the SAME plane as the skimmer slots (-0.10 m,
         100 mm below the rim) -- raised from the old ~-0.50 m so it clears the
         relax/kids shelf slabs, matching the skimmers around the zone. */
      /* Return-jet mouth height is per-jet: raised (-0.10) only where the jet
         sits on a bench cap edge (so it clears the shelf slab), otherwise the
         original deeper plane (-0.50), oriented down as before. */
      /* Inward unit normal of the nearest wall edge (points into the pool). */
      function nearestNormal(x, z) {
        var bi = _nearestEdgeIndex(inner, x, z), nn = inner.length;
        var A = inner[bi], B = inner[(bi + 1) % nn], L = Math.hypot(B[0] - A[0], B[1] - A[1]) || 1;
        var ex = (B[0] - A[0]) / L, ez = (B[1] - A[1]) / L, nx = -ez, nz = ex;
        var mx = (A[0] + B[0]) / 2, mz = (A[1] + B[1]) / 2;
        if (typeof _pointInPoly === 'function' && !_pointInPoly([mx + nx * 0.1, mz + nz * 0.1], inner)) { nx = -nx; nz = -nz; }
        return [nx, nz];
      }
      var jt = getJetPositions();
      for (var i = 0; i < jt.length; i++) {
        var px = jt[i].x, pz = jt[i].z, my = _jetMouthY(px, pz);
        /* Every jet lies FLAT on the wall facing the pool (disc axis = inward
           wall normal). Jets over a raised zone shelf are lifted by _jetMouthY to
           the skimmer line (-0.10, top block row) so they open into the water
           above the shelf instead of being buried in the shelf slab. */
        var _n = nearestNormal(px, pz);
        var _ang = Math.atan2(_n[1], -_n[0]);                 /* cylinder axis -> inward normal after z=PI/2 */
        var _ox = _n[0] * 0.012, _oz = _n[1] * 0.012;         /* nudge proud of the wall face */
        /* White circular faceplate. */
        var plate = new T.Mesh(new T.CylinderGeometry(0.07, 0.07, 0.02, 24), mats.poolJet);
        plate.rotation.z = Math.PI / 2; plate.rotation.y = _ang;
        plate.position.set(px + _ox, my, pz + _oz);
        plate.userData = { assetType: 'jet' };
        eng.sceneGroup.add(plate);
        /* Concentric inner nozzle eye -- a smaller, darker disc standing a few mm
           proud of the plate, so it reads as a return jet. */
        var eye = new T.Mesh(new T.CylinderGeometry(0.035, 0.035, 0.028, 20), mats.poolGrate);
        eye.rotation.z = Math.PI / 2; eye.rotation.y = _ang;
        eye.position.set(px + _ox, my, pz + _oz);
        eye.userData = { assetType: 'jet' };
        eng.sceneGroup.add(eye);
      }
    },

    /* Technology shaft -- underground plastic box (top at grade Y=0) with a lid
       at ground level. Position from getShaftPos(), size from getShaftSize()
       (driven by water volume). */
    _buildShaft: function () {
      var T = global.THREE, eng = global.BaseEngine, mats = this._ensureMaterials();
      if (!T || !eng || !eng.sceneGroup) return;
      var pos = getShaftPos(), sz = getShaftSize();
      var body = new T.Mesh(new T.BoxGeometry(sz.w, sz.h, sz.l), mats.poolShaftBox);
      body.position.set(pos.x, -sz.h / 2, pos.z);
      body.userData = { assetType: 'shaft' };
      eng.sceneGroup.add(body);
      var lid = new T.Mesh(new T.BoxGeometry(sz.w + 0.10, 0.05, sz.l + 0.10), mats.poolShaftLid);
      lid.position.set(pos.x, 0.025, pos.z);
      lid.userData = { assetType: 'shaft' };
      eng.sceneGroup.add(lid);
    },

    /* Coping edge tiles (skimmer) -- real pieces laid on the coping top with
       visible joint gaps. Straight tiles are single boxes; corners are L
       pieces drawn as two arm boxes hugging the corner. Each mesh carries its
       BoQ code in userData for later asset-drawer mapping. */
    _buildCopingTiles: function (mats) {
      var T = global.THREE, eng = global.BaseEngine;
      if (!T || !eng || !eng.sceneGroup) return;
      var ct = _copingTiles();
      /* Seat on the coping rim top (rim spans [-0.01, 0.05]), 2 mm into it. In
         infinite mode the non-overflow venec is raised 5 cm, and the only tiles
         drawn are on those edges, so lift the tiles to match. */
      var yTop = (getEdgeType() === 'infinite') ? 0.098 : 0.048;
      var th = 0.022;              /* tile thickness */
      var j = 0.008;
      function box(cx, cz, ang, len, w, mat, code) {
        var b = new T.Mesh(new T.BoxGeometry(len, th, w), mat);
        b.position.set(cx, yTop + th / 2, cz);
        b.rotation.y = -ang;
        b.userData = { assetType: 'edge-tile', code: code };
        eng.sceneGroup.add(b);
      }
      /* straight tiles */
      for (var i = 0; i < ct.straight.length; i++) {
        var s = ct.straight[i];
        box(s.cx, s.cz, s.ang, s.len - j, s.w - j, mats.poolEdgeTile, 'PFP05001');
      }
      /* corner pieces -- ONE continuous L per corner: the corner square plus an
         arm reaching toward the straight tiles on each edge. Extruded as a
         single solid mesh, slightly darker than the straight tiles. */
      function corner(rec, code) {
        var cw = rec.w;
        var cornerReturn = (typeof STATE !== 'undefined' && STATE.isMetric) ? 0.10 : (4 * IN);
        var R = (rec.convex ? cornerReturn : (cw + cornerReturn)) - j;  /* outer ~10cm, inner cw+10 */
        var V = [rec.vx, rec.vz];
        var d1 = rec.uOut, d2 = [-rec.uIn[0], -rec.uIn[1]];
        var m1 = rec.nOut, m2 = rec.nIn;
        function P(s1, s2, t1, t2) {
          return [
            V[0] + d1[0]*s1 + d2[0]*s2 + m1[0]*t1 + m2[0]*t2,
            V[1] + d1[1]*s1 + d2[1]*s2 + m1[1]*t1 + m2[1]*t2
          ];
        }
        var q = [
          P(R, 0, 0, 0),     /* outgoing arm inner end */
          P(R, 0, cw, 0),    /* outgoing arm outer end */
          P(0, 0, cw, cw),   /* outer corner */
          P(0, R, 0, cw),    /* incoming arm outer end */
          P(0, R, 0, 0),     /* incoming arm inner end */
          P(0, 0, 0, 0)      /* vertex (inner corner) */
        ];
        var shp = new T.Shape();
        shp.moveTo(q[0][0], q[0][1]);
        for (var k = 1; k < q.length; k++) shp.lineTo(q[k][0], q[k][1]);
        shp.closePath();
        var g = new T.ExtrudeGeometry(shp, { depth: th, bevelEnabled: false });
        var m = new T.Mesh(g, mats.poolEdgeTileCorner);
        m.rotation.x = Math.PI / 2;
        m.position.y = yTop + th;
        m.userData = { assetType: 'edge-tile', code: code };
        eng.sceneGroup.add(m);
      }
      for (var o = 0; o < ct.outer.length; o++) corner(ct.outer[o], 'PFP05002');
      for (var n2 = 0; n2 < ct.inner.length; n2++) corner(ct.inner[n2], 'PFP05003');
    },

    /* Overflow edge tiles -- the full-width lem cut into pieces (same layout as
       the skimmer coping), but each straight piece is split into TWO sloped
       halves (two shades) with a recessed centre catch channel down the
       middle. Corners are single darker L pieces. */
    _buildOverflowTiles: function (mats) {
      var T = global.THREE, eng = global.BaseEngine;
      if (!T || !eng || !eng.sceneGroup) return;
      var d = getVariantDefaults(variantKey(), STATE.lvl);
      var wallT = _effectiveWallThick(d);
      var lemW = wallT + (d.copingWidthM || 0.30);        /* full lem width */
      var ct = _copingTiles(lemW, _innerRing());
      var yTop = 0.048, th = 0.022, j = 0.008, groove = 0.03;   /* seat on the coping rim top (rim spans [-0.01, 0.05]) */
      /* straight pieces -- two sloped halves + centre channel */
      for (var i = 0; i < ct.straight.length; i++) {
        var s = ct.straight[i];
        var nrm = [-Math.sin(s.ang), Math.cos(s.ang)];    /* across-edge unit (tile width dir) */
        var halfW = (s.w - groove) / 2;
        var offA = -(s.w + groove) / 4, offB = (s.w + groove) / 4;
        function placeHalf(off, w, mat) {
          var b = new T.Mesh(new T.BoxGeometry(s.len - j, th, w), mat);
          b.position.set(s.cx + nrm[0] * off, yTop + th / 2, s.cz + nrm[1] * off);
          b.rotation.y = -s.ang;
          b.userData = { assetType: 'overflow-tile', code: 'PPO02501' };
          eng.sceneGroup.add(b);
        }
        placeHalf(offA, halfW, mats.poolOflTileA);        /* inner slope */
        placeHalf(offB, halfW, mats.poolOflTileB);        /* outer slope */
        /* recessed centre catch channel */
        var ch = new T.Mesh(new T.BoxGeometry(s.len - j, th, groove), mats.poolOflChannel);
        ch.position.set(s.cx, yTop + th / 2 - 0.006, s.cz);   /* slightly recessed */
        ch.rotation.y = -s.ang;
        ch.userData = { assetType: 'overflow-channel', code: 'PPO03001' };
        eng.sceneGroup.add(ch);
      }
      /* corner L pieces (single darker piece, like the skimmer corner) */
      function corner(rec, code) {
        var cw = rec.w;
        var cornerReturn = (typeof STATE !== 'undefined' && STATE.isMetric) ? 0.10 : (4 * IN);
        var R = (rec.convex ? cornerReturn : (cw + cornerReturn)) - j;  /* outer ~10cm, inner cw+10 */
        var V = [rec.vx, rec.vz];
        var d1 = rec.uOut, d2 = [-rec.uIn[0], -rec.uIn[1]];
        var m1 = rec.nOut, m2 = rec.nIn;
        function P(s1, s2, t1, t2) {
          return [
            V[0] + d1[0]*s1 + d2[0]*s2 + m1[0]*t1 + m2[0]*t2,
            V[1] + d1[1]*s1 + d2[1]*s2 + m1[1]*t1 + m2[1]*t2
          ];
        }
        var q = [ P(R,0,0,0), P(R,0,cw,0), P(0,0,cw,cw), P(0,R,0,cw), P(0,R,0,0), P(0,0,0,0) ];
        var shp = new T.Shape();
        shp.moveTo(q[0][0], q[0][1]);
        for (var k = 1; k < q.length; k++) shp.lineTo(q[k][0], q[k][1]);
        shp.closePath();
        var g = new T.ExtrudeGeometry(shp, { depth: th, bevelEnabled: false });
        var m = new T.Mesh(g, mats.poolOflTileB);
        m.rotation.x = Math.PI / 2;
        m.position.y = yTop + th;
        m.userData = { assetType: 'overflow-tile', code: code };
        eng.sceneGroup.add(m);
      }
      for (var o = 0; o < ct.outer.length; o++) corner(ct.outer[o], 'PPO02502');
      for (var n3 = 0; n3 < ct.inner.length; n3++) corner(ct.inner[n3], 'PPO02502');
    },

    /* Overflow balance tank -- underground box beside the pool, sized at ~10 %
       of the water volume. Built in overflow + infinite edge modes. */
    _buildTank: function () {
      var et = getEdgeType();
      if (et !== 'overflow' && et !== 'infinite') return;
      var T = global.THREE, eng = global.BaseEngine, mats = this._ensureMaterials();
      if (!T || !eng || !eng.sceneGroup) return;
      var pos = getTankPos(), sz = getTankSize();
      var body = new T.Mesh(new T.BoxGeometry(sz.w, sz.h, sz.l), mats.poolTankBox);
      body.position.set(pos.x, -sz.h / 2, pos.z);
      body.userData = { assetType: 'tank' };
      eng.sceneGroup.add(body);
      var lid = new T.Mesh(new T.BoxGeometry(sz.w + 0.10, 0.05, sz.l + 0.10), mats.poolTankLid);
      lid.position.set(pos.x, 0.025, pos.z);
      lid.userData = { assetType: 'tank' };
      eng.sceneGroup.add(lid);
    },

    /* Piping in 3D: a thin cylinder per route segment, just below grade,
       coloured by diameter (matches the 2D plan + BoQ). */
    _build3DPipes: function () {
      var T = global.THREE, eng = global.BaseEngine;
      if (!T || !eng || !eng.sceneGroup) return;
      var pip = computePiping();
      if (!pip || !pip.segs || !pip.segs.length) return;
      var RED  = { d15: 0xe8908f, d20: 0xd1504f, d25: 0x9e1b1b, d40: 0x6e0f0f };
      var BLUE = { d15: 0x8fb3e8, d20: 0x4f7fd1, d25: 0x1b3f9e };
      var RAD = { d15: 0.024, d20: 0.030, d25: 0.038, d40: 0.055 };
      var mats = {};
      function matFor(circ, dk) {
        var key = circ + ':' + dk;
        if (!mats[key]) mats[key] = new T.MeshStandardMaterial({ color: (circ === 'return' ? BLUE : RED)[dk] || 0x666666, roughness: 0.55, metalness: 0 });
        return mats[key];
      }
      var up = new T.Vector3(0, 1, 0);
      for (var i = 0; i < pip.segs.length; i++) {
        var s = pip.segs[i];
        var a = new T.Vector3(s.x1, s.y1, s.z1), b = new T.Vector3(s.x2, s.y2, s.z2);
        var dir = new T.Vector3().subVectors(b, a);
        var len = dir.length();
        if (len < 0.02) continue;
        var r = RAD[s.dia] || 0.026;
        var geo = new T.CylinderGeometry(r, r, len, 10);
        var m = new T.Mesh(geo, matFor(s.circuit, s.dia));
        m.position.copy(a).add(b).multiplyScalar(0.5);
        var axis = new T.Vector3().crossVectors(up, dir.clone().normalize());
        var ang = Math.acos(Math.max(-1, Math.min(1, up.dot(dir.clone().normalize()))));
        if (axis.length() > 1e-6) m.setRotationFromAxisAngle(axis.normalize(), ang);
        m.userData = { assetType: 'pool-pipe-3d' };
        eng.sceneGroup.add(m);
      }
      if (!this._teeMat) this._teeMat = new T.MeshStandardMaterial({ color: 0x16c60c, roughness: 0.55, metalness: 0 });
      /* Tee junctions -- green T-fittings (run cylinder + branch cylinder). */
      if (pip.teePts && pip.teePts.length) {
        var rT = (RAD[pip.trunkKey] || 0.030) * 1.25;
        var rB = (RAD.d15 || 0.024) * 1.25;
        var runLen = rT * 3.2, brLen = rT * 2.6;
        var upv = new T.Vector3(0, 1, 0);
        function orientTo(mesh, dx, dy, dz) {
          var d = new T.Vector3(dx, dy, dz); var L = d.length(); if (L < 1e-6) return;
          d.normalize();
          var axis = new T.Vector3().crossVectors(upv, d);
          var ang = Math.acos(Math.max(-1, Math.min(1, upv.dot(d))));
          if (axis.length() > 1e-6) mesh.setRotationFromAxisAngle(axis.normalize(), ang);
        }
        for (var t = 0; t < pip.teePts.length; t++) {
          var tp = pip.teePts[t];
          var cy = (tp.y !== undefined) ? tp.y : -0.40;
          var run = new T.Mesh(new T.CylinderGeometry(rT, rT, runLen, 12), this._teeMat);
          run.position.set(tp.x, cy, tp.z);
          orientTo(run, tp.tx, 0, tp.tz);
          run.userData = { assetType: 'pool-tee-3d' };
          eng.sceneGroup.add(run);
          var br = new T.Mesh(new T.CylinderGeometry(rB, rB, brLen, 12), this._teeMat);
          br.position.set(tp.x + tp.bx * brLen / 2, cy, tp.z + tp.bz * brLen / 2);
          orientTo(br, tp.bx, 0, tp.bz);
          br.userData = { assetType: 'pool-tee-3d' };
          eng.sceneGroup.add(br);
        }
      }
      /* Elbow points -- small green spheres for identification. */
      if (pip.elbowPts && pip.elbowPts.length) {
        var rE = (RAD[pip.trunkKey] || 0.030) * 1.35;
        for (var e2 = 0; e2 < pip.elbowPts.length; e2++) {
          var ep = pip.elbowPts[e2];
          var sp = new T.Mesh(new T.SphereGeometry(rE, 10, 8), this._teeMat);
          sp.position.set(ep.x, ep.y, ep.z);
          sp.userData = { assetType: 'pool-elbow-3d' };
          eng.sceneGroup.add(sp);
        }
      }
      /* Electric flow valves -- purple bodies on the vertical drain risers. */
      if (pip.valvePts && pip.valvePts.length) {
        if (!this._valveMat) this._valveMat = new T.MeshStandardMaterial({ color: 0x8e44d0, roughness: 0.55, metalness: 0 });
        var rV = (RAD.d15 || 0.024) * 1.8, hV = (RAD.d15 || 0.024) * 4.5;
        for (var v = 0; v < pip.valvePts.length; v++) {
          var vp = pip.valvePts[v];
          var vb = new T.Mesh(new T.CylinderGeometry(rV, rV, hV, 14), this._valveMat);
          vb.position.set(vp.x, vp.y, vp.z);    /* vertical (along the riser) */
          vb.userData = { assetType: 'pool-valve-3d' };
          eng.sceneGroup.add(vb);
        }
      }
    },

    /* Electrical in 3D: a junction box at each light, thin orange cable tubes
       along the perimeter, and the wall-mounted panel raised above grade. */
    _build3DElectrical: function (D, inner) {
      var T = global.THREE, eng = global.BaseEngine;
      if (!T || !eng || !eng.sceneGroup) return;
      if (!this._elMat3D) {
        this._elMat3D = {
          box:   new T.MeshStandardMaterial({ color: 0x111111, roughness: 0.60, metalness: 0 }),
          cable: new T.MeshStandardMaterial({ color: 0x111111, roughness: 0.60, metalness: 0 }),
          panel: new T.MeshStandardMaterial({ color: 0xf2f2f2, roughness: 0.55, metalness: 0 }),
          door:  new T.MeshStandardMaterial({ color: 0xbfe3ff, transparent: true, opacity: 0.35, roughness: 0.08, metalness: 0 })
        };
      }
      var li = getLightPositions();
      if (li.length) {
        /* Junction boxes -- mounted FLAT on the outer wall face, ~150 mm below
           the wall top (under the coping). Thin dimension goes into the wall;
           the wide face lies along the wall. */
        var foot = getFootprintPolygon();
        var outRing = _offsetPolygon(foot, -0.02, true);   /* basically on the outer face */
        if (!outRing || outRing.length < 3) outRing = foot;
        var yBox = -0.15;                                  /* 150 mm below wall top */
        function edgeAt(x, z) {
          var bd = Infinity, bx2 = x, bz2 = z, bi = 0, n = outRing.length;
          for (var i = 0; i < n; i++) {
            var a = outRing[i], b = outRing[(i + 1) % n];
            var ex=b[0]-a[0], ez=b[1]-a[1], L2=(ex*ex+ez*ez)||1e-9;
            var t=((x-a[0])*ex+(z-a[1])*ez)/L2; if(t<0)t=0;else if(t>1)t=1;
            var px=a[0]+ex*t, pz=a[1]+ez*t; var dd=(px-x)*(px-x)+(pz-z)*(pz-z);
            if(dd<bd){bd=dd;bx2=px;bz2=pz;bi=i;}
          }
          var A=outRing[bi], B=outRing[(bi+1)%n], L=Math.hypot(B[0]-A[0],B[1]-A[1])||1;
          return { x: bx2, z: bz2, ang: Math.atan2(B[1]-A[1], B[0]-A[0]) };
        }
        for (var k = 0; k < li.length; k++) {
          var e = edgeAt(li[k].x, li[k].z);
          /* box: wide (0.14) along the wall, short (0.05) into the wall, tall 0.14 */
          var bx = new T.Mesh(new T.BoxGeometry(0.14, 0.14, 0.05), this._elMat3D.box);
          bx.position.set(e.x, yBox, e.z);
          bx.rotation.y = -e.ang;                          /* wide face along the wall */
          bx.userData = { assetType: 'junction-box' };
          eng.sceneGroup.add(bx);
        }
      }
      /* Cables -- thin tubes along the wiring route. ALWAYS drawn: the
         panel->shaft technology feed (pump power) is present even with no
         lights; light cables are added when lights exist. */
      {
        var wire = computeWiring();
        var up = new T.Vector3(0, 1, 0);
        for (var i = 0; i < wire.segs.length; i++) {
          var s = wire.segs[i];
          var a = new T.Vector3(s.x1, s.y1, s.z1), b = new T.Vector3(s.x2, s.y2, s.z2);
          var dir = new T.Vector3().subVectors(b, a), len = dir.length();
          if (len < 0.02) continue;
          var geo = new T.CylinderGeometry(0.012, 0.012, len, 8);
          var m = new T.Mesh(geo, this._elMat3D.cable);
          m.position.copy(a).add(b).multiplyScalar(0.5);
          var axis = new T.Vector3().crossVectors(up, dir.clone().normalize());
          var ang = Math.acos(Math.max(-1, Math.min(1, up.dot(dir.clone().normalize()))));
          if (axis.length() > 1e-6) m.setRotationFromAxisAngle(axis.normalize(), ang);
          m.userData = { assetType: 'pool-cable-3d' };
          eng.sceneGroup.add(m);
        }
      }
      /* Drain-valve control wiring (overflow): purple junction boxes at each
         valve, a common purple box near the shaft, and purple cables. */
      var vwire = computeValveWiring((computePiping() || {}).valvePts);
      if (vwire.segs.length || vwire.valveBoxes) {
        if (!this._elMatValve) {
          this._elMatValve = {
            box:   new T.MeshStandardMaterial({ color: 0x111111, roughness: 0.60, metalness: 0 }),
            cable: new T.MeshStandardMaterial({ color: 0x111111, roughness: 0.60, metalness: 0 })
          };
        }
        var vfoot = getFootprintPolygon();
        var vRing = _offsetPolygon(vfoot, -0.02, true);
        if (!vRing || vRing.length < 3) vRing = vfoot;
        function vEdgeAt(x, z) {
          var bd = Infinity, bx2 = x, bz2 = z, bi = 0, n = vRing.length;
          for (var i = 0; i < n; i++) {
            var a = vRing[i], b = vRing[(i + 1) % n];
            var ex=b[0]-a[0], ez=b[1]-a[1], L2=(ex*ex+ez*ez)||1e-9;
            var t=((x-a[0])*ex+(z-a[1])*ez)/L2; if(t<0)t=0;else if(t>1)t=1;
            var px=a[0]+ex*t, pz=a[1]+ez*t; var dd=(px-x)*(px-x)+(pz-z)*(pz-z);
            if(dd<bd){bd=dd;bx2=px;bz2=pz;bi=i;}
          }
          var A=vRing[bi], B=vRing[(bi+1)%n], L=Math.hypot(B[0]-A[0],B[1]-A[1])||1;
          return { x: bx2, z: bz2, ang: Math.atan2(B[1]-A[1], B[0]-A[0]) };
        }
        var vyBox = (typeof vwire.yBox === 'number') ? vwire.yBox : -0.15;
        for (var vb2 = 0; vb2 < vwire.boxPts.length; vb2++) {
          var ve = vEdgeAt(vwire.boxPts[vb2].x, vwire.boxPts[vb2].z);
          var vbm = new T.Mesh(new T.BoxGeometry(0.14, 0.14, 0.05), this._elMatValve.box);
          /* sit the box at the actual cable node (not reprojected) so the
             cable terminates exactly at the box, not past it */
          vbm.position.set(vwire.boxPts[vb2].x, vyBox, vwire.boxPts[vb2].z);
          vbm.rotation.y = -ve.ang;
          vbm.userData = { assetType: 'valve-junction-box' };
          eng.sceneGroup.add(vbm);
        }
        if (vwire.commonPt) {
          /* common junction box -- slightly larger */
          var ce = vEdgeAt(vwire.commonPt.x, vwire.commonPt.z);
          var cbm = new T.Mesh(new T.BoxGeometry(0.18, 0.18, 0.07), this._elMatValve.box);
          cbm.position.set(vwire.commonPt.x, vyBox, vwire.commonPt.z);
          cbm.rotation.y = -ce.ang;
          cbm.userData = { assetType: 'valve-common-box' };
          eng.sceneGroup.add(cbm);
        }
        var vup = new T.Vector3(0, 1, 0);
        for (var vi = 0; vi < vwire.segs.length; vi++) {
          var vs = vwire.segs[vi];
          var va = new T.Vector3(vs.x1, vs.y1, vs.z1), vbv = new T.Vector3(vs.x2, vs.y2, vs.z2);
          var vdir = new T.Vector3().subVectors(vbv, va), vlen = vdir.length();
          if (vlen < 0.02) continue;
          var vgeo = new T.CylinderGeometry(0.012, 0.012, vlen, 8);
          var vm = new T.Mesh(vgeo, this._elMatValve.cable);
          vm.position.copy(va).add(vbv).multiplyScalar(0.5);
          var vaxis = new T.Vector3().crossVectors(vup, vdir.clone().normalize());
          var vang = Math.acos(Math.max(-1, Math.min(1, vup.dot(vdir.clone().normalize()))));
          if (vaxis.length() > 1e-6) vm.setRotationFromAxisAngle(vaxis.normalize(), vang);
          vm.userData = { assetType: 'pool-valve-cable-3d' };
          eng.sceneGroup.add(vm);
        }
      }
      /* Wall-mounted panel -- white box raised above grade, with a single
         transparent door facing the pool. */
      var pp = getPanelPos();
      var pw = 0.45, ph = 0.55, pd = 0.18;
      /* heading from the panel toward the pool centroid */
      var fpoly = getFootprintPolygon();
      var fcx = 0, fcz = 0;
      for (var fi = 0; fi < fpoly.length; fi++) { fcx += fpoly[fi][0]; fcz += fpoly[fi][1]; }
      fcx /= fpoly.length; fcz /= fpoly.length;
      var faceAng = Math.atan2(fcz - pp.z, fcx - pp.x);    /* points to pool */
      var panel = new T.Mesh(new T.BoxGeometry(pd, ph, pw), this._elMat3D.panel);
      panel.position.set(pp.x, 0.70, pp.z);
      panel.rotation.y = -faceAng;                          /* depth axis (X) -> toward pool */
      panel.userData = { assetType: 'electrical-panel' };
      eng.sceneGroup.add(panel);
      /* single transparent door on the pool-facing face (local +X) */
      var nx = Math.cos(faceAng), nz = Math.sin(faceAng);
      var door = new T.Mesh(new T.PlaneGeometry(pw * 0.86, ph * 0.86), this._elMat3D.door);
      door.position.set(pp.x + nx * (pd / 2 + 0.003), 0.70, pp.z + nz * (pd / 2 + 0.003));
      door.rotation.y = -faceAng + Math.PI / 2;             /* plane faces along the door normal */
      door.userData = { assetType: 'electrical-panel' };
      eng.sceneGroup.add(door);
      /* simple mounting post */
      var post = new T.Mesh(new T.BoxGeometry(0.06, 0.45, 0.06), this._elMat3D.panel);
      post.position.set(pp.x, 0.22, pp.z);
      post.userData = { assetType: 'electrical-panel' };
      eng.sceneGroup.add(post);
    },

    /* Infinity (vanishing) edges: along each ACTIVE edge build an OPEN overflow
       gutter just outside the wall (bottom + outer wall + two end caps), and a
       rounded weir lip (bull-nose) on the wall top with rounded corners. Other
       edges keep the skimmer execution. Self-guards to infinite mode.
       Dimensions are first-pass and easy to tune (GUT_W / GUT_D / LIP_R). */
    _buildInfinityGutters: function (D, mats, wallT) {
      var T = global.THREE, eng = global.BaseEngine;
      if (!T || !eng || !eng.sceneGroup) return;
      if (getEdgeType() !== 'infinite') return;
      if (!(wallT > 0)) wallT = 0.2;
      var edges = getInfiniteEdges();
      if (!edges || !edges.length) return;
      var poly = getFootprintPolygon();
      if (!poly || poly.length < 3) return;
      var n = poly.length, i;

      /* winding -> outward normal */
      var area = 0;
      for (i = 0; i < n; i++) { var a0 = poly[i], b0 = poly[(i + 1) % n]; area += a0[0] * b0[1] - b0[0] * a0[1]; }
      var ccw = area > 0;

      /* Massive surface concrete gutter, finished like the edge/walls. Layout
         across the edge (outward from the pool's outer wall = footprint):
           [0 .. GUT_W]            open catch channel (inner side = the pool
                                   block wall = the visible weir)
           [GUT_W .. GUT_W+WALL_T] massive outer wall
         The OUTER wall + end caps stop BELOW the weir crest so the pool's outer
         block wall (the vanishing edge) stays visible above the gutter. */
      var GUT_W = 0.26, WALL_T = 0.06, FLOOR_T = 0.12, CREST_R = 0.045;
      var WEIR_TOP = 0.05;                             /* pool wall / coping top -- the weir crest */
      var GUT_OUTER_TOP = -0.03;                       /* gutter outer wall top: below the weir, blocks stay visible */
      var GUT_DEPTH = 0.18;                            /* channel depth below the outer-wall top */
      var yFloor = GUT_OUTER_TOP - GUT_DEPTH;          /* channel floor surface */
      var fullW = GUT_W + WALL_T;                      /* total gutter width across */
      var conMat   = mats.poolCoping || new T.MeshStandardMaterial({ color: 0xc9c1b2, roughness: 0.85, metalness: 0 });
      var finMat   = (this._surfaceMaterial ? this._surfaceMaterial(mats) : conMat); /* pool interior finish */

      function add(mesh, x, y, z, ry, tag) {
        mesh.position.set(x, y, z);
        if (typeof ry === 'number') mesh.rotation.y = ry;
        mesh.userData = { assetType: tag };
        eng.sceneGroup.add(mesh);
      }

      /* Offset rings for the spill-water surfaces, built ONCE so adjacent
         infinity edges share MITERED corners (no double-overlap at outer/convex
         corners, no gap at inner/concave corners). Inner = basin water edge
         (footprint inset by wallT); crest = the weir-lip line (footprint pushed
         out to the rounded crest). */
      var _crestOff = 0.08 - CREST_R;                  /* INNER_T(0.08) - crest radius */
      var _lipInner = _insetPolygon(poly,  wallT);     /* + = inward  */
      var _lipCrest = _insetPolygon(poly, -_crestOff); /* - = outward */
      var _haveLip  = _lipInner && _lipCrest && _lipInner.length === n && _lipCrest.length === n;
      function flatWater(p0, p1, p2, p3, y0, depth) {
        var sh = new T.Shape();
        sh.moveTo(p0[0], p0[1]); sh.lineTo(p1[0], p1[1]);
        sh.lineTo(p2[0], p2[1]); sh.lineTo(p3[0], p3[1]); sh.closePath();
        var m = new T.Mesh(new T.ExtrudeGeometry(sh, { depth: depth, bevelEnabled: false }), mats.poolWater);
        m.rotation.x = Math.PI / 2;
        m.position.y = y0;
        m.userData = { assetType: 'water' };
        m.renderOrder = 3;
        eng.sceneGroup.add(m);
      }

      /* -- Continuous mitred gutter over each RUN of consecutive infinity edges.
         Built from offset rings of the footprint so corners join with a single
         hollow channel: convex (outer) corners wrap around, concave (inner)
         corners bend inward -- no crossing walls, no double troughs. End caps
         only where a run meets a NON-infinity edge.
           0 .. INNER_T  inner wall ; INNER_T .. GUT_W channel ; GUT_W .. fullW outer wall */
      var INNER_T = 0.06, iwH = WEIR_TOP - yFloor, owH = GUT_OUTER_TOP - yFloor, r = CREST_R;
      var Rg0      = poly;
      var Rg_iw    = _insetPolygon(poly, -INNER_T);     /* - = outward */
      var Rg_owIn  = _insetPolygon(poly, -GUT_W);
      var Rg_owMid = _insetPolygon(poly, -(GUT_W + WALL_T / 2));   /* outer-wall mid-line */
      var Rg_owOut = _insetPolygon(poly, -fullW);
      var _ringsOK = Rg_iw && Rg_owIn && Rg_owMid && Rg_owOut &&
                     Rg_iw.length === n && Rg_owIn.length === n && Rg_owMid.length === n && Rg_owOut.length === n;

      function edgeNrm(eIdx) {
        var A = poly[eIdx], B = poly[(eIdx + 1) % n];
        var ex = B[0] - A[0], ez = B[1] - A[1], L = Math.hypot(ex, ez) || 1;
        var ux = ex / L, uz = ez / L;
        return ccw ? [uz, -ux] : [-uz, ux];   /* outward normal */
      }
      function band(Ra, offA, Rb, offB, ev, closed, depthY, y0, mat) {
        var sh = new T.Shape(), k;
        if (closed) {
          sh.moveTo(Rb[0][0], Rb[0][1]);
          for (k = 1; k < n; k++) sh.lineTo(Rb[k][0], Rb[k][1]);
          sh.closePath();
          var hole = new T.Path();
          hole.moveTo(Ra[0][0], Ra[0][1]);
          for (k = 1; k < n; k++) hole.lineTo(Ra[k][0], Ra[k][1]);
          hole.closePath();
          sh.holes.push(hole);
        } else {
          var vlist = ev.slice(); vlist.push((ev[ev.length - 1] + 1) % n);
          var last = vlist.length - 1;
          var nS = edgeNrm(ev[0]), nE = edgeNrm(ev[ev.length - 1]);
          /* boundary point at vlist[idx], ring R, outward offset off. The two
             RUN ENDS are cut PERPENDICULAR to the infinity edge (so the gutter
             finishes flush with the wall's outer edge -- no 45 deg overhang along
             the neighbouring non-infinity wall); internal corners keep the
             mitred offset-ring corner so the channel bends cleanly. */
          function bp(idx, R, off) {
            var v = vlist[idx];
            if (idx === 0)    return [poly[v][0] + nS[0] * off, poly[v][1] + nS[1] * off];
            if (idx === last) return [poly[v][0] + nE[0] * off, poly[v][1] + nE[1] * off];
            return R[v];
          }
          var p0 = bp(0, Ra, offA); sh.moveTo(p0[0], p0[1]);
          for (k = 1; k <= last; k++) { var pa = bp(k, Ra, offA); sh.lineTo(pa[0], pa[1]); }
          for (k = last; k >= 0; k--) { var pb = bp(k, Rb, offB); sh.lineTo(pb[0], pb[1]); }
          sh.closePath();
        }
        var m = new T.Mesh(new T.ExtrudeGeometry(sh, { depth: depthY, bevelEnabled: false }), mat || conMat);
        m.rotation.x = Math.PI / 2; m.position.y = y0;
        m.userData = { assetType: 'infinity-gutter' };
        eng.sceneGroup.add(m);
      }
      function endCap(eIdx, atB) {
        var A = poly[eIdx], B = poly[(eIdx + 1) % n];
        var ex = B[0] - A[0], ez = B[1] - A[1], L = Math.hypot(ex, ez) || 1;
        var uxL = ex / L, uzL = ez / L;
        var nxL = ccw ? uzL : -uzL, nzL = ccw ? -uxL : uxL;
        var ep = atB ? B : A, into = atB ? -1 : 1;
        add(new T.Mesh(new T.BoxGeometry(WALL_T, owH, fullW), conMat),
            ep[0] + nxL * (fullW / 2) + uxL * into * (WALL_T / 2), yFloor + owH / 2,
            ep[1] + nzL * (fullW / 2) + uzL * into * (WALL_T / 2),
            -Math.atan2(uzL, uxL), 'infinity-gutter');
      }

      /* -- Prefab joints (spary) ------------------------------------------
         The concrete gutter is cast/laid in prefab pieces, so score a thin
         dark groove across the CONCRETE profile (outer wall + floor exterior)
         at every piece boundary: straight pieces 1 m, plus a short CORNER
         PIECE delimited by a joint 5 cm from each internal corner (min arm).
         Joints sit only on the outer concrete (they don't dam the channel)
         and stand ~3 mm proud so they read as a scored line. Infinity only
         (whole function is gated to infinite). */
      var JOINT_PIECE = 1.0, JOINT_ARM = 0.05, JOINT_W = 0.006;
      var jointMat = new T.MeshStandardMaterial({ color: 0x7d776d, roughness: 0.90, metalness: 0 });
      var JOINT_H  = GUT_OUTER_TOP - (yFloor - FLOOR_T);      /* floor bottom -> outer-wall top */
      var JOINT_Y  = (GUT_OUTER_TOP + (yFloor - FLOOR_T)) / 2;
      function placeJoint(eIdx, t) {
        var A = poly[eIdx], B = poly[(eIdx + 1) % n];
        var ex = B[0] - A[0], ez = B[1] - A[1], L = Math.hypot(ex, ez) || 1;
        var ux = ex / L, uz = ez / L;
        var nx = ccw ? uz : -uz, nz = ccw ? -ux : ux;        /* outward normal */
        var px = A[0] + ux * t, pz = A[1] + uz * t;          /* point on footprint edge */
        var across = WALL_T + 0.006;                         /* covers outer wall + 3 mm proud */
        var off = GUT_W + WALL_T / 2;                        /* outer-wall centre */
        var m = new T.Mesh(new T.BoxGeometry(JOINT_W, JOINT_H, across), jointMat);
        m.position.set(px + nx * off, JOINT_Y, pz + nz * off);
        m.rotation.y = -Math.atan2(uz, ux);                  /* local X -> run dir, Z -> across */
        m.userData = { assetType: 'infinity-gutter' };
        eng.sceneGroup.add(m);
      }
      function placeRunJoints(ev, closed) {
        var ne = ev.length;
        for (var ii = 0; ii < ne; ii++) {
          var e = ev[ii], A = poly[e], B = poly[(e + 1) % n];
          var L = Math.hypot(B[0] - A[0], B[1] - A[1]);
          if (L < 0.02) continue;
          var hasPrev = closed || ii > 0;                    /* internal corner at start */
          var hasNext = closed || ii < ne - 1;               /* internal corner at end   */
          var startT = hasPrev ? JOINT_ARM : 0;
          var endT   = hasNext ? (L - JOINT_ARM) : L;
          if (hasPrev && JOINT_ARM < L - 0.01) placeJoint(e, JOINT_ARM);          /* corner-piece boundary (start) */
          if (hasNext && (L - JOINT_ARM) > startT + 0.01) placeJoint(e, L - JOINT_ARM); /* corner-piece boundary (end) */
          if (endT - startT > JOINT_PIECE + 0.02) {          /* straight pieces every 1 m */
            var cnt = Math.floor((endT - startT) / JOINT_PIECE);
            for (var s = 1; s <= cnt; s++) {
              var tt = startT + s * JOINT_PIECE;
              if (tt < endT - 0.05) placeJoint(e, tt);
            }
          }
        }
      }

      /* group active infinity edges into ordered runs of consecutive indices */
      var inSet = {}; for (i = 0; i < edges.length; i++) if (edges[i] >= 0 && edges[i] < n) inSet[edges[i]] = true;
      var nIn = 0; for (var kk in inSet) if (inSet[kk]) nIn++;
      var runs = [];
      if (nIn === n) {
        var allE = []; for (i = 0; i < n; i++) allE.push(i);
        runs.push({ e: allE, closed: true });
      } else {
        var seen = {};
        for (var k0 = 0; k0 < n; k0++) {
          if (!inSet[k0] || seen[k0] || inSet[(k0 - 1 + n) % n]) continue;   /* run starts only */
          var run = [], j = k0;
          while (inSet[j] && !seen[j]) { seen[j] = true; run.push(j); j = (j + 1) % n; }
          runs.push({ e: run, closed: false });
        }
      }

      if (_ringsOK) {
        for (var ri = 0; ri < runs.length; ri++) {
          var R = runs[ri], ev = R.e;
          band(Rg0,     0,      Rg_owOut, fullW,   ev, R.closed, FLOOR_T, yFloor);          /* floor slab = CONCRETE (its exterior face must not show finish) */
          band(Rg_iw,   INNER_T, Rg_owIn, GUT_W,   ev, R.closed, 0.012,   yFloor + 0.013, finMat); /* THIN finish lining on channel bottom only */
          band(Rg0,     0,      Rg_iw,    INNER_T, ev, R.closed, iwH,     WEIR_TOP, finMat); /* inner (weir) wall = finish */
          band(Rg_owIn, GUT_W,            Rg_owMid, GUT_W + WALL_T / 2, ev, R.closed, owH, GUT_OUTER_TOP, finMat); /* outer wall, CHANNEL half = finish */
          band(Rg_owMid, GUT_W + WALL_T / 2, Rg_owOut, fullW,          ev, R.closed, owH, GUT_OUTER_TOP);          /* outer wall, EXTERIOR half = concrete */
          if (!R.closed) { endCap(ev[0], false); endCap(ev[ev.length - 1], true); }
          placeRunJoints(ev, R.closed);                       /* prefab joints (spary) on the concrete */
        }
      } else {
        /* fallback: per-edge troughs with caps (degenerate offset rings) */
        for (var fe = 0; fe < edges.length; fe++) {
          var fi = edges[fe]; if (fi < 0 || fi >= n) continue;
          var fA = poly[fi], fB = poly[(fi + 1) % n];
          var fdx = fB[0] - fA[0], fdz = fB[1] - fA[1], flen = Math.hypot(fdx, fdz); if (flen < 0.2) continue;
          var fux = fdx / flen, fuz = fdz / flen;
          var fnx = ccw ? fuz : -fuz, fnz = ccw ? -fux : fux, fang = Math.atan2(fuz, fux);
          var fmx = (fA[0] + fB[0]) / 2, fmz = (fA[1] + fB[1]) / 2;
          add(new T.Mesh(new T.BoxGeometry(flen, FLOOR_T, fullW), conMat), fmx + fnx * (fullW / 2), yFloor - FLOOR_T / 2, fmz + fnz * (fullW / 2), -fang, 'infinity-gutter');
          add(new T.Mesh(new T.BoxGeometry(flen, 0.012, GUT_W - INNER_T), finMat), fmx + fnx * ((INNER_T + GUT_W) / 2), yFloor + 0.013, fmz + fnz * ((INNER_T + GUT_W) / 2), -fang, 'infinity-gutter');
          add(new T.Mesh(new T.BoxGeometry(flen, owH, WALL_T), conMat), fmx + fnx * (GUT_W + WALL_T / 2), yFloor + owH / 2, fmz + fnz * (GUT_W + WALL_T / 2), -fang, 'infinity-gutter');
          add(new T.Mesh(new T.BoxGeometry(flen, iwH, INNER_T), finMat), fmx + fnx * (INNER_T / 2), yFloor + iwH / 2, fmz + fnz * (INNER_T / 2), -fang, 'infinity-gutter');
          for (var fs = -1; fs <= 1; fs += 2) add(new T.Mesh(new T.BoxGeometry(WALL_T, owH, fullW), conMat), fmx + fux * fs * (flen / 2) + fnx * (fullW / 2), yFloor + owH / 2, fmz + fuz * fs * (flen / 2) + fnz * (fullW / 2), -fang, 'infinity-gutter');
        }
      }

      /* Per-edge: water spill lip & sheet only. (The rounded concrete weir
         crest was removed -- the inner wall now ends in a clean weir edge at
         WEIR_TOP, no leftover rounding bead on the inner profile.) */
      for (var e = 0; e < edges.length; e++) {
        var ei = edges[e]; if (ei < 0 || ei >= n) continue;
        var ei1 = (ei + 1) % n;
        if (mats && mats.poolWater && _haveLip) {
          flatWater(_lipInner[ei], _lipInner[ei1], _lipCrest[ei1], _lipCrest[ei], WEIR_TOP + 0.001, 0.006);
          var cA = _lipCrest[ei], cB = _lipCrest[ei1];
          var cdx = cB[0] - cA[0], cdz = cB[1] - cA[1], clen = Math.hypot(cdx, cdz) || 1;
          var sheetH = 0.12;
          var sheet = new T.Mesh(new T.BoxGeometry(clen, sheetH, 0.005), mats.poolWater);
          add(sheet, (cA[0] + cB[0]) / 2, WEIR_TOP - sheetH / 2, (cA[1] + cB[1]) / 2, -Math.atan2(cdz, cdx), 'water');
          sheet.renderOrder = 3;
        }
      }
    },

    /* Main drains: a shallow white disc (anti-vortex cover) sitting on the
       basin floor, with a thin dark grate ring. */
    _buildDrains: function (D) {
      var T = global.THREE, eng = global.BaseEngine, mats = this._ensureMaterials();
      if (!T || !eng || !eng.sceneGroup) return;
      var dr = getDrainPositions();
      var yFloor = -D + 0.03;     /* just above the plaster floor */
      for (var i = 0; i < dr.length; i++) {
        var cover = new T.Mesh(new T.CylinderGeometry(0.13, 0.13, 0.03, 20), mats.poolSkimmer);
        cover.position.set(dr[i].x, yFloor + 0.015, dr[i].z);
        cover.userData = { assetType: 'drain' };
        eng.sceneGroup.add(cover);
        var ring = new T.Mesh(new T.TorusGeometry(0.13, 0.012, 8, 20), mats.poolGrate);
        ring.rotation.x = Math.PI / 2;
        ring.position.set(dr[i].x, yFloor + 0.031, dr[i].z);
        ring.userData = { assetType: 'drain' };
        eng.sceneGroup.add(ring);
      }
    },

    /* Pool lights: a yellow half-dome (hemisphere) on the wall, flat side to
       the wall, bulging into the water. Vertical position from lightPos. */
    _buildLights: function (D, inner) {
      var T = global.THREE, eng = global.BaseEngine;
      if (!T || !eng || !eng.sceneGroup) return;
      var li = getLightPositions();
      var ring = _innerRing();                    /* the ring lights sit on */
      if (!li.length || !ring || ring.length < 3) return;
      if (!this._lightMat3D) this._lightMat3D = new T.MeshBasicMaterial({ color: 0xffd11a });
      var y = _lightY(D);
      var cx = 0, cz = 0;
      for (var c = 0; c < ring.length; c++) { cx += ring[c][0]; cz += ring[c][1]; }
      cx /= ring.length; cz /= ring.length;
      function inwardDir(x, z) {
        var bd = Infinity, bi = 0, n = ring.length;
        for (var i = 0; i < n; i++) {
          var a = ring[i], b = ring[(i + 1) % n];
          var ex = b[0]-a[0], ez = b[1]-a[1], L2=(ex*ex+ez*ez)||1e-9;
          var t=((x-a[0])*ex+(z-a[1])*ez)/L2; if(t<0)t=0;else if(t>1)t=1;
          var px=a[0]+ex*t, pz=a[1]+ez*t; var dd=(px-x)*(px-x)+(pz-z)*(pz-z);
          if(dd<bd){bd=dd;bi=i;}
        }
        var A=ring[bi], B=ring[(bi+1)%n]; var ex2=B[0]-A[0], ez2=B[1]-A[1], L=Math.hypot(ex2,ez2)||1;
        var nx=-ez2/L, nz=ex2/L;
        /* flip toward centroid (radial = always inward) */
        if((cx-x)*nx+(cz-z)*nz<0){nx=-nx;nz=-nz;}
        return { nx: nx, nz: nz };
      }
      for (var k = 0; k < li.length; k++) {
        var dir = inwardDir(li[k].x, li[k].z);
        /* Light = a short cylinder (lens) lying flat against the wall, face
           into the water. Cylinder axis = its local Y; we lay it along the
           inward normal so the round face looks into the pool. */
        var geo = new T.CylinderGeometry(0.13, 0.13, 0.06, 18);
        var m = new T.Mesh(geo, this._lightMat3D);
        var ang = -Math.atan2(dir.nz, dir.nx);            /* inward heading */
        m.rotation.z = Math.PI / 2;                       /* axis Y -> X */
        m.rotation.y = ang;                               /* axis -> inward normal */
        /* push the lens just inside the water so its body is in the pool */
        m.position.set(li[k].x + dir.nx * 0.06, y, li[k].z + dir.nz * 0.06);
        m.renderOrder = 6;
        m.userData = { assetType: 'pool-light' };
        eng.sceneGroup.add(m);
      }
    },

    /* A simple 3-step staircase in the lowest inner corner. */
    _buildStairs: function (poly, inner, D, wallT, mat) {
      var mode = getStairsMode();
      if (mode === 'none') return;
      var T = global.THREE, eng = global.BaseEngine, mats = this._materials;
      if (!T || !eng || !eng.sceneGroup || !inner || inner.length < 3) return;
      var place = getCurrentStairsPlacement();
      if (!place) return;
      /* Whole staircase must lie inside the water polygon -- otherwise skip
         (do not render). Guards against a stale slot after reshape/depth. */
      if (!_stairsPlacementFits(place, mode)) return;

      /* Anchor on the carved MAIN pool (zones pulled in to their risers), so a
         stair next to a zone spans its main-pool frontage and clears the shelf.
         Equals the passed inner ring when there are no zones. */
      var sb = _stairsBasePoly();
      if (sb && sb.length >= 3) inner = sb;
      var n = inner.length;
      var A = inner[place.edge], B = inner[(place.edge + 1) % n];
      var ex = B[0] - A[0], ez = B[1] - A[1];
      var L = Math.hypot(ex, ez);
      if (L < 0.05) return;
      var ux = ex / L, uz = ez / L;
      /* inward normal (into water) from winding */
      var area2 = 0;
      for (var ai = 0; ai < n; ai++) { var q0 = inner[ai], q1 = inner[(ai + 1) % n]; area2 += q0[0] * q1[1] - q1[0] * q0[1]; }
      var ccw = area2 > 0;
      var wx = ccw ? -uz : uz, wz = ccw ? ux : -ux;
      /* anchor + along-direction (from the chosen corner) */
      var Ox, Oz, axx, axz;
      if (!place.atEnd) { Ox = A[0]; Oz = A[1]; axx = ux;  axz = uz; }
      else              { Ox = B[0]; Oz = B[1]; axx = -ux; axz = -uz; }
      var angY = -Math.atan2(axz, axx);
      function L2W(along, inward) {
        return [Ox + axx * along + wx * inward, Oz + axz * along + wz * inward];
      }

      var mod = _blockModule();
      var bl = mod.len, bh = mod.course, bw = mod.width;
      var joint = 0.015;

      if (mode === 'ladder') {
        var lmat = new T.MeshStandardMaterial({ color: 0xe8eaee, roughness: 0.35, metalness: 0.9 });
        var inWater = Math.min(Math.max(0.6, D - 0.1), D);
        var rA = 0.025, spread = 0.45, above = 0.28;
        var a0 = 0.55;                          /* along offset from corner */
        var inward0 = 0.14;                     /* a touch off the wall */
        function addCyl(p1, p2, r) {
          var dx = p2[0] - p1[0], dy = p2[1] - p1[1], dz = p2[2] - p1[2];
          var len = Math.hypot(dx, dy, dz) || 0.001;
          var g = new T.CylinderGeometry(r, r, len, 12);
          var m = new T.Mesh(g, lmat);
          m.position.set((p1[0] + p2[0]) / 2, (p1[1] + p2[1]) / 2, (p1[2] + p2[2]) / 2);
          var up = new T.Vector3(0, 1, 0), dir = new T.Vector3(dx, dy, dz).normalize();
          var quat = new T.Quaternion().setFromUnitVectors(up, dir);
          m.quaternion.copy(quat);
          eng.sceneGroup.add(m);
        }
        for (var sgn = -1; sgn <= 1; sgn += 2) {
          var aOff = a0 + sgn * (spread / 2);
          var top = L2W(aOff, inward0); var topY = above;
          var bot = L2W(aOff, inward0); var botY = -inWater;
          addCyl([top[0], topY, top[1]], [bot[0], botY, bot[1]], rA);   /* rail */
        }
        for (var rg = 0; rg < 4; rg++) {
          var ry = -0.15 - rg * 0.30;
          var pL = L2W(a0 - spread / 2, inward0), pR = L2W(a0 + spread / 2, inward0);
          addCyl([pL[0], ry, pL[1]], [pR[0], ry, pR[1]], 0.02);          /* rung */
        }
        return;
      }

      /* -- Block-built steps (corner1 / corner2 / full) -- */
      var stepMat = mats.poolStairs || mat;
      var p = _stairsTypeParams(mode);
      var widthBlocks = (mode === 'full') ? Math.max(1, Math.round(L / bl)) : p.widthBlocks;
      var stairW = (mode === 'full') ? L : widthBlocks * bl;
      var treadDepth = (p.treadHalves || 2) * (bl / 2);
      var rise = bh;
      var stepCount = Math.max(1, Math.floor(_stairsEffectiveDepth(place.edge) / rise) - 1);
      var totalInward = stepCount * treadDepth;

      var transforms = [];   /* [x,y,z,angY,sAlong,sY,sInward] block facing */
      for (var i = 0; i < stepCount; i++) {
        var stepTopY = -D + (i + 1) * rise;
        var cY = stepTopY - rise / 2;
        var frontDist = (stepCount - i) * treadDepth;       /* riser face inward */
        var riserInward = frontDist - bw / 2;               /* riser centred in its depth */
        var kFromTop = stepCount - i;
        if (mode === 'full') {
          /* full-width stairs: simple riser across the whole edge, no cheeks */
          var riserCount = Math.max(1, Math.round(stairW / bl));
          var riserSeg = stairW / riserCount;
          for (var j = 0; j < riserCount; j++) {
            var w0 = L2W((j + 0.5) * riserSeg, riserInward);
            transforms.push([w0[0], cY, w0[1], angY, riserSeg - joint, rise - joint, bw - joint]);
          }
        } else {
          /* corner stairs: interlocking corner bond between the riser (width)
             and the single open-side cheek (depth). */
          var course = _stairCourse(kFromTop, treadDepth, bl, bw, stairW, widthBlocks);
          for (var ri = 0; ri < course.riser.length; ri++) {
            var rb = course.riser[ri];
            var wr = L2W(rb.c, riserInward);            /* riser laid along the width */
            transforms.push([wr[0], cY, wr[1], angY, rb.len - joint, rise - joint, bw - joint]);
          }
          for (var ci2 = 0; ci2 < course.cheek.length; ci2++) {
            var cb = course.cheek[ci2];
            var wc = L2W(stairW + bw / 2, cb.c);        /* single cheek on the open side, laid along the depth */
            transforms.push([wc[0], cY, wc[1], angY, bw - joint, rise - joint, cb.len - joint]);
          }
        }
      }

      if (transforms.length) {
        if (stepMat) stepMat.side = T.DoubleSide;      /* so the cores read */
        var edges = [0,1,1,2,2,3,3,0, 4,5,5,6,6,7,7,4, 0,4,1,5,2,6,3,7];
        var linePos = [];
        var dummy = new T.Object3D();
        /* Group by (along x inward) size so each distinct block shares one
           real-size hollow geometry (square cavities by its long side). */
        var sgroups = {};
        for (var k = 0; k < transforms.length; k++) {
          var t = transforms[k];
          var gk = t[4].toFixed(3) + '|' + t[6].toFixed(3);
          if (!sgroups[gk]) sgroups[gk] = { sa: t[4], sy: t[5], si: t[6], items: [] };
          sgroups[gk].items.push(t);
        }
        for (var skey in sgroups) {
          if (!sgroups.hasOwnProperty(skey)) continue;
          var sg = sgroups[skey];
          var geo = this._makeHollowBlockGeo(sg.sa, sg.sy, sg.si);
          var inst = new T.InstancedMesh(geo, stepMat, sg.items.length);
          var hx = sg.sa / 2, hy = sg.sy / 2, hz = sg.si / 2;
          for (var gi = 0; gi < sg.items.length; gi++) {
            var tt = sg.items[gi];
            dummy.position.set(tt[0], tt[1], tt[2]);
            dummy.rotation.set(0, tt[3], 0);
            dummy.scale.set(1, 1, 1);
            dummy.updateMatrix();
            inst.setMatrixAt(gi, dummy.matrix);
            var ca = Math.cos(tt[3]), sa = Math.sin(tt[3]);
            var corn = [
              [-hx,-hy,-hz],[hx,-hy,-hz],[hx,-hy,hz],[-hx,-hy,hz],
              [-hx,hy,-hz],[hx,hy,-hz],[hx,hy,hz],[-hx,hy,hz]
            ];
            var wc = [];
            for (var ci = 0; ci < 8; ci++) {
              var lx = corn[ci][0], ly = corn[ci][1], lz = corn[ci][2];
              wc.push([tt[0] + lx * ca + lz * sa, tt[1] + ly, tt[2] - lx * sa + lz * ca]);
            }
            for (var e = 0; e < edges.length; e += 2) {
              var pa = wc[edges[e]], pb = wc[edges[e + 1]];
              linePos.push(pa[0], pa[1], pa[2], pb[0], pb[1], pb[2]);
            }
          }
          inst.instanceMatrix.needsUpdate = true;
          inst.userData = { assetType: 'pool-stairs-blocks' };
          eng.sceneGroup.add(inst);
        }
        var lgeo = new T.BufferGeometry();
        lgeo.setAttribute('position', new T.Float32BufferAttribute(linePos, 3));
        eng.sceneGroup.add(new T.LineSegments(lgeo, mats.blockEdge));
      }

      /* Concrete fill -- ONE extruded stepped wedge. Rule: the slab and the
         stair BODY are modelled; the concrete inside the hollow blocks is only
         counted (BoQ), not modelled. So the wedge stops at the BACK face of the
         block facing (pulled in by the block depth bw on the riser/front and on
         the open cheek side), leaving the masonry as the visible step surface:
         each tread shows the block nosing in front + the poured concrete behind.
         Same concrete code in the BoQ either way. Profile (inward u, height v):
         u = 0 at the wall, v = 0 at the floor. */
      mats.poolStairFill.side = T.DoubleSide;
      var pts = [];
      var u0 = Math.max(0, totalInward - bw);
      pts.push([0, 0], [u0, 0]);
      var su = u0, sv = 0, si;
      for (si = 0; si < stepCount; si++) {
        sv += rise;                       pts.push([su, sv]);   /* riser up   */
        su = Math.max(0, su - treadDepth); pts.push([su, sv]);  /* tread back (behind next nosing) */
      }
      pts.push([0, sv], [0, 0]);
      var shape = new T.Shape();
      var started = false, pu = null, pv = null;
      for (var pi = 0; pi < pts.length; pi++) {
        var qu = pts[pi][0], qv = pts[pi][1];
        if (pu !== null && Math.abs(qu - pu) < 1e-4 && Math.abs(qv - pv) < 1e-4) continue;  /* dedupe */
        if (!started) { shape.moveTo(qu, qv); started = true; } else { shape.lineTo(qu, qv); }
        pu = qu; pv = qv;
      }
      shape.closePath();
      var sgeo = new T.ExtrudeGeometry(shape, { depth: stairW, bevelEnabled: false });
      var solid = new T.Mesh(sgeo, mats.poolStairFill);
      solid.matrixAutoUpdate = false;
      solid.matrix.set(                                /* columns: inward, up, along, origin */
        wx, 0, axx, Ox,
        0,  1, 0,   -D,
        wz, 0, axz, Oz,
        0,  0, 0,   1
      );
      solid.userData = { assetType: 'pool-stairs-fill' };
      solid.matrixWorldNeedsUpdate = true;
      eng.sceneGroup.add(solid);
    },
  };

  function boot() {
    if (global.__BASE_BOOTED__) return;
    global.__BASE_BOOTED__ = true;
    var attempts = 0;
    function tryBoot() {
      if (!global.THREE || !(global.THREE.OrbitControls || global.OrbitControls)) {
        if (++attempts > 100) {
          _dbg('boot aborted: THREE / OrbitControls never loaded after 5s');
          global.__BASE_BOOTED__ = false;
          return;
        }
        setTimeout(tryBoot, 50);
        return;
      }
      if (!_initEngine()) return;
      _readShopifyVariantFromURL();
      _ProjectStore.init();
      _restoreFromProjectStore();
      wireSidebar();
      rebuildDragHandles();
      selectVariant(STATE.variant, true);
      var wrap = document.getElementById('cf-wrap-base');
      if (wrap) wrap.classList.add(STATE.view === '2d' ? 'cf-view-2d' : 'cf-view-3d');
      if (global.BaseEngine && global.BaseEngine._gridHelper) {
        _applyGridVisibility(global.BaseEngine);
      }
      refreshUI();
      if (global.BaseEngine && global.BaseEngine.fitCameraToFootprint) {
        global.BaseEngine.fitCameraToFootprint();
      }
      _initMap();
      setTimeout(_updateMapLockButton, 300);
      _AssetDrawer.init();
      _scheduleOnboardModal();
      _cfgBootApply();
      _dbg('boot complete, version=' + VERSION);
    }
    tryBoot();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (document.getElementById('cf-wrap-base')) boot();
    });
  } else {
    if (document.getElementById('cf-wrap-base')) boot();
  }

  /* PDF PAID IN TOKENS (pool-v5-credits, Marek: PDF za 10 tokenu, kredit = LEVA
     CREDITS). The shared follow-us sheet (configurator-pdf.liquid,
     pdf-pay-v1) says the price, asks for sign-in or a pack, and takes the
     tokens; whoever bought this product before keeps a free PDF (paid:true).
     The key is the bill of quantities and the variant, so the same design
     downloads again for free for 30 days. */
  var _pdfPaidNow = false;
  function _pdfKey() {
    try {
      var rows = computeBoQ() || [];
      return 'pool|' + STATE.variant + '|' + JSON.stringify(rows.map(function (r) { return [r[0], r[1]]; }));
    } catch (e) { return ''; }
  }
  function _openPdfSocialModal() {
    var BOOT = global.BASE_BOOT || {};
    var X = global.ConfiguratorPdfExporter;
    if (X && X.socialGate) {
      X.socialGate(BOOT.hasOwnership ? { paid: true } : { key: _pdfKey() }).then(function () {
        _pdfPaidNow = true;
        var run = exportPdf();
        _pdfPaidNow = false;
        run.catch(function (e) { console.error('[exportPdf]', e); });
      });
      return;
    }
    if (!BOOT.hasOwnership) {
      var T = BOOT.i18n || {};
      var productUrl = '/products/' + (BOOT.productHandle || 'foundations');
      var msg = T.pdfPaywallMsg || 'To download the PDF documentation, please purchase this product first.';
      var ok = window.confirm(msg + '\n\n' + (T.pdfPaywallCta || 'Go to product page?'));
      if (ok) window.location.href = productUrl;
      return;
    }
    var modal = document.getElementById('cf-pdf-modal');
    if (!modal) {
      exportPdf().catch(function (e) { console.error('[exportPdf]', e); });
      return;
    }
    modal.hidden = false;

    function close() {
      modal.hidden = true;
      modal.removeEventListener('click', onClick);
    }
    function onClick(e) {
      var closeEl = e.target.closest('[data-cf-pdf-close]');
      if (closeEl) {
        e.preventDefault();
        close();
        return;
      }
      var goEl = e.target.closest('[data-cf-pdf-go]');
      if (goEl) {
        e.preventDefault();
        var url = goEl.getAttribute('href');
        close();
        if (url) {
          try {
            var w = window.open(url, '_blank', 'noopener,noreferrer');
            if (w) w.opener = null;
          } catch (_) {
            window.open(url, '_blank');
          }
        }
        setTimeout(function () {
          exportPdf().catch(function (err) { console.error('[exportPdf]', err); });
        }, 60);
      }
    }
    modal.addEventListener('click', onClick);
  }

  /* ---------------------------------------------------------------
     Shared budget onboarding modal
     Goal: nudge a brand-new visitor to consider other people's
     real-world budgets without ever overwriting their own work.

     Trigger contract:
       * 15 seconds after page load
       * only on a configurator product page (we already are)
       * at most once every 30 days, per product, stored in
         localStorage keyed by productId
       * skipped if the user already has any budget activity for
         this product (any saved row, any open share drawer click,
         any price edit) -- checked via a permissive interaction
         flag the budget module sets when the user touches data

     On "Show me": close, open the existing share-budget drawer
     ($-icon target). On "Maybe later" / backdrop / X: close +
     write the timestamp so we don't bother them again for 30 days.
     --------------------------------------------------------------- */
  var ONBOARD_THROTTLE_DAYS = 30;
  var ONBOARD_DELAY_MS = 15000;

  function _onboardStorageKey() {
    var BOOT = global.BASE_BOOT || {};
    var pid = BOOT.productId || BOOT.productHandle || 'default';
    return 'cf-onboard-shared-budget-' + pid;
  }

  function _onboardShouldShow() {
    try {
      var raw = localStorage.getItem(_onboardStorageKey());
      if (!raw) return true;
      var ts = parseInt(raw, 10);
      if (!ts || isNaN(ts)) return true;
      var ageMs = Date.now() - ts;
      var maxAge = ONBOARD_THROTTLE_DAYS * 24 * 60 * 60 * 1000;
      return ageMs > maxAge;
    } catch (_) { return true; }
  }

  function _onboardMarkSeen() {
    try { localStorage.setItem(_onboardStorageKey(), String(Date.now())); }
    catch (_) {}
  }

  function _onboardUserHasOwnBudget() {
    /* Conservative interaction detection: if the user already
       opened the budget drawer (= touched the $ icon) or any
       price/qty input on this product, treat them as "engaged"
       and don't pop the onboarding modal at them. We sniff a few
       global flags set by the budget module + any existing rows
       under the well-known budget storage. */
    try {
      if (global.__cfBudgetUserTouched) return true;
      if (global.SharedBudgetUserEngaged) return true;
      var BOOT = global.BASE_BOOT || {};
      var pid = BOOT.productId;
      if (pid) {
        if (localStorage.getItem('cf-budget-touched-' + pid)) return true;
      }
    } catch (_) {}
    return false;
  }

  function _openOnboardModal() {
    var modal = document.getElementById('cf-onboard-modal');
    if (!modal) return;
    modal.hidden = false;

    /* Lock page scroll while the modal is open (prevents scrolling the page
       behind it). Remember previous inline values to restore exactly. */
    var de = document.documentElement, bd = document.body;
    var prevHtmlOv = de ? de.style.overflow : '';
    var prevBodyOv = bd ? bd.style.overflow : '';
    var prevBodyTA = bd ? bd.style.touchAction : '';
    if (de) de.style.overflow = 'hidden';
    if (bd) { bd.style.overflow = 'hidden'; bd.style.touchAction = 'none'; }

    function close() {
      modal.hidden = true;
      modal.removeEventListener('click', onClick);
      if (de) de.style.overflow = prevHtmlOv;
      if (bd) { bd.style.overflow = prevBodyOv; bd.style.touchAction = prevBodyTA; }
      _onboardMarkSeen();
    }
    function onClick(e) {
      if (e.target.closest('[data-cf-onboard-close]')) {
        e.preventDefault();
        close();
        return;
      }
      if (e.target.closest('[data-cf-onboard-go]')) {
        e.preventDefault();
        close();
        /* Tiny delay so the close animation can settle before the
           drawer slides in -- feels less jarring than an instant
           swap. */
        setTimeout(function () {
          try { openBudgetDrawer(); }
          catch (err) { console.warn('[onboard] open budget drawer failed', err); }
        }, 120);
      }
    }
    modal.addEventListener('click', onClick);
  }

  function _scheduleOnboardModal() {
    /* Only on configurator pages -- this script lives in the base
       configurator already, so being here is the gate. We also
       skip if document is hidden so the timer effectively starts
       when the user actually views the page (avoids burning the
       30-day throttle on a background tab). */
    if (!_onboardShouldShow()) return;
    if (_onboardUserHasOwnBudget()) return;

    var elapsed = 0;
    var tick = 1000;
    var timer = setInterval(function () {
      if (document.visibilityState === 'visible') elapsed += tick;
      if (elapsed >= ONBOARD_DELAY_MS) {
        clearInterval(timer);
        /* Re-check guards at fire time -- user may have opened the
           drawer in the meantime. */
        if (_onboardShouldShow() && !_onboardUserHasOwnBudget()) {
          _openOnboardModal();
        }
      }
    }, tick);
  }

  /* ---------------------------------------------------------------
     AR export pipeline
     Click -> export current Three.js scene as GLB -> upload to R2
     via the Cloudflare Worker -> render QR code pointing at the
     viewer page. Phone scans QR -> opens <model-viewer> page ->
     "View in AR" places the model in the user's space.

     Flow:
       1. POST {worker}/upload-url     -> { uploadUrl, viewerUrl }
       2. GLTFExporter.parse(scene)    -> ArrayBuffer (GLB binary)
       3. PUT {uploadUrl} body=glb     -> R2 receives the file
       4. render QR(viewerUrl) in modal

     The full export typically runs in 1-3 s -- slow enough to
     warrant a "Preparing scene..." status under the QR placeholder
     so the user doesn't think it's frozen.
     --------------------------------------------------------------- */
  function _setArStatus(msg) {
    var el = document.getElementById('cf-ar-modal-status');
    if (el) el.textContent = msg || '';
  }

  function _setArQR(dataUrl) {
    var el = document.getElementById('cf-ar-modal-qr');
    if (!el) return;
    el.innerHTML = '';
    if (!dataUrl) return;
    var img = document.createElement('img');
    img.src = dataUrl;
    img.alt = 'AR QR code';
    img.style.width = '200px';
    img.style.height = '200px';
    img.style.borderRadius = '8px';
    img.style.background = '#fff';
    img.style.padding = '8px';
    el.appendChild(img);
  }

  function _setArLink(viewerUrl) {
    var el = document.getElementById('cf-ar-modal-link');
    if (!el) return;
    if (viewerUrl) {
      el.style.display = 'block';
      el.innerHTML = '<a href="' + viewerUrl + '" target="_blank" rel="noopener noreferrer" style="color:inherit;text-decoration:underline;">' + viewerUrl + '</a>';
    } else {
      el.style.display = 'none';
      el.innerHTML = '';
    }
  }

  function _arExportScene() {
    /* Builds a clean GLB from the current Three.js scene. We
       export ONLY the configurator's sceneGroup -- not the grid,
       map, slope visualisation overlays, or section-cut helper
       geometry -- because the AR viewer should show the actual
       foundation, nothing else.

       Returns a Promise<ArrayBuffer> that resolves to the GLB
       bytes ready for upload. */
    return new Promise(function (resolve, reject) {
      var T = global.THREE;
      var Exporter = global.GLTFExporter;
      var eng = global.BaseEngine;
      if (!T || !Exporter || !eng || !eng.sceneGroup) {
        reject(new Error('THREE / GLTFExporter / scene not ready'));
        return;
      }
      /* Build an export-only Group containing clones of the meshes
         we actually want in AR. Each mesh gets its OWN geometry
         clone -- Mesh.clone() is shallow and keeps the geometry
         reference, so without a deep clone the applyMatrix4 below
         would mutate the shared buffer and all-but-one mesh would
         end up at the same world position. This is the bug that
         made the AR scene show a single pier instead of the full
         grid of N piers (they all shared one geometry instance,
         all overwritten by the last transform). */
      var exportRoot = new T.Group();

      /* Pool AR rule: cut the model at the water surface minus 2 cm (so at
         least 2 cm of water stays -- also for skimmer), drop everything below,
         and shift so the cut plane becomes Y=0 -> the AR ground plane. The
         buried basin isn't shown; the model sits on the floor as the rim +
         water surface. Water is exported as light-blue 80 % opacity. */
      var arEdge = getEdgeType();
      var arD = getVariantDefaults(variantKey(), STATE.lvl);
      var arWaterTop = (arEdge === 'overflow') ? 0.0 : -(arD.freeboardM || 0);
      var cutY = arWaterTop - 0.02;
      var arWaterMat = new T.MeshStandardMaterial({
        color: 0xa9d6f5, transparent: true, opacity: 0.4,
        metalness: 0.0, roughness: 0.25, side: T.FrontSide, depthWrite: true
      });

      eng.sceneGroup.traverse(function (node) {
        if (!node.isMesh || !node.geometry || !node.material) return;
        var t = node.userData && node.userData.assetType;
        /* Skip anything that is purely a visualisation aid. */
        if (t === 'section-cut-aux') return;
        if (t === 'slope-terrain') return;
        if (t === 'excavation-box') return;  /* hole-in-ground viz, no real material */
        if (t === 'water-solid') return;     /* pool-v9 the section tool's hidden water body */
        if (!node.visible) return;
        node.updateMatrixWorld(true);
        /* Deep clone: fresh geometry per mesh, then bake the world
           transform into THIS geometry only. */
        var geom = node.geometry.clone();
        geom.applyMatrix4(node.matrixWorld);
        /* Cut: drop meshes fully below the plane; clamp the rest up to it so
           the part above the water-2cm line is kept and bottoms close flat. */
        geom.computeBoundingBox();
        if (geom.boundingBox && geom.boundingBox.max.y <= cutY + 1e-4) return;
        var pos = geom.attributes.position, arr = pos.array;
        for (var vi = 1; vi < arr.length; vi += 3) { if (arr[vi] < cutY) arr[vi] = cutY; }
        pos.needsUpdate = true;
        geom.translate(0, -cutY, 0);          /* cut plane -> Y = 0 (AR ground) */
        geom.computeVertexNormals();
        /* Scene Viewer (Filament) z-fights / mis-sorts DoubleSide faces -- it
           shows back/under faces bleeding through as triangular tears that are
           absent in model-viewer. The pool is a closed solid cut from above, so
           front faces alone read correctly. Clone the material(s) to FrontSide
           (water already is) so no back faces are emitted to the GLB. */
        var srcMat = (t === 'water') ? arWaterMat : node.material;
        var useMat;
        if (Array.isArray(srcMat)) {
          useMat = srcMat.map(function (m) { var c = m.clone(); c.side = T.FrontSide; return c; });
        } else {
          useMat = srcMat.clone(); useMat.side = T.FrontSide;
        }
        var cloned = new T.Mesh(geom, useMat);
        cloned.name = node.name || (t || 'mesh') + '_' + exportRoot.children.length;
        cloned.userData = Object.assign({}, node.userData || {});
        exportRoot.add(cloned);
      });

      if (exportRoot.children.length === 0) {
        reject(new Error('No exportable meshes in scene'));
        return;
      }

      var exporter = new Exporter();
      exporter.parse(
        exportRoot,
        function (glb) {
          /* GLTFExporter returns either ArrayBuffer (binary=true)
             or a JSON object. We requested binary so we always
             expect ArrayBuffer. */
          if (glb instanceof ArrayBuffer) {
            resolve(glb);
          } else {
            reject(new Error('Expected GLB ArrayBuffer, got JSON'));
          }
        },
        function (err) { reject(err); },
        { binary: true }
      );
    });
  }

  async function _arUpload(glbBuffer) {
    var BOOT = global.BASE_BOOT || {};
    var T = BOOT.i18n || {};
    var workerUrl = BOOT.arWorkerUrl || (T.arWorkerUrl);
    if (!workerUrl) throw new Error('Worker URL missing');
    _dbg('[ar] worker URL = ' + workerUrl);

    /* Step 1: ask the worker for an upload URL + the matching
       viewer URL. Use GET to avoid a CORS preflight roundtrip
       (POST with application/json body triggers an OPTIONS check
       which makes "Failed to fetch" much more likely to surface
       on flaky connections). The worker generates a fresh UUID
       per request so two simultaneous exports don't collide. */
    _dbg('[ar] GET ' + workerUrl + '/upload-url');
    var r1;
    try {
      r1 = await fetch(workerUrl + '/upload-url');
    } catch (netErr) {
      _dbg('[ar] network error on /upload-url: ' + netErr);
      throw new Error('Network error: ' + (netErr && netErr.message ? netErr.message : netErr));
    }
    _dbg('[ar] /upload-url response status=' + r1.status + ' ok=' + r1.ok);
    if (!r1.ok) throw new Error('upload-url failed: HTTP ' + r1.status);
    var info = await r1.json();
    _dbg('[ar] /upload-url payload: ' + JSON.stringify(info));
    if (!info || !info.uploadUrl) throw new Error('upload-url response invalid');

    /* Step 2: PUT the GLB straight to the worker's upload endpoint.
       The worker stores it in R2 under {uuid}.glb.

       PUT with a binary body + non-simple content-type triggers a
       CORS preflight OPTIONS request -- the worker handles it, but
       any tunnel / proxy in between can mess it up. Catch the
       network-level TypeError separately from HTTP errors so we
       can log the actual cause. */
    _dbg('[ar] PUT ' + info.uploadUrl + ' (' + (glbBuffer.byteLength / 1024).toFixed(1) + ' KB)');
    var r2;
    try {
      r2 = await fetch(info.uploadUrl, {
        method: 'PUT',
        headers: { 'Content-Type': 'model/gltf-binary' },
        body: glbBuffer
      });
    } catch (netErr) {
      _dbg('[ar] network error on PUT: ' + netErr);
      throw new Error('Network error on PUT: ' + (netErr && netErr.message ? netErr.message : netErr));
    }
    _dbg('[ar] PUT response status=' + r2.status + ' ok=' + r2.ok);
    if (!r2.ok) {
      var errBody = '';
      try { errBody = await r2.text(); } catch (_) {}
      _dbg('[ar] PUT error body: ' + errBody);
      throw new Error('PUT failed: HTTP ' + r2.status + ' ' + errBody);
    }

    return info;  /* { uuid, uploadUrl, publicUrl, viewerUrl } */
  }

  function _arGenerateQR(url) {
    /* Use the same QRCode library the PDF exporter already loaded
       via <script defer>. If it isn't ready yet, fall back to a
       remote QR service so the modal still works on first paint
       before the CDN script lands. */
    return new Promise(function (resolve) {
      function tryLib() {
        if (global.QRCode && global.QRCode.toDataURL) {
          global.QRCode.toDataURL(url, { width: 400, margin: 1, errorCorrectionLevel: 'M' }, function (err, dataUrl) {
            if (err || !dataUrl) {
              resolve('https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=' + encodeURIComponent(url));
            } else {
              resolve(dataUrl);
            }
          });
          return true;
        }
        return false;
      }
      if (tryLib()) return;
      /* Poll for ~2s, then fall back. */
      var attempts = 0;
      var iv = setInterval(function () {
        attempts++;
        if (tryLib()) { clearInterval(iv); return; }
        if (attempts > 20) {
          clearInterval(iv);
          resolve('https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=' + encodeURIComponent(url));
        }
      }, 100);
    });
  }

  async function _openArModal() {
    var modal = document.getElementById('cf-ar-modal');
    if (!modal) return;
    var BOOT = global.BASE_BOOT || {};
    var T = BOOT.i18n || {};

    /* Reset modal to "preparing" state and show it immediately so
       the user sees feedback before the export runs. */
    _setArQR(null);
    _setArLink(null);
    _setArStatus(T.arPreparing || 'Preparing scene\u2026');
    modal.hidden = false;

    function close() {
      modal.hidden = true;
      modal.removeEventListener('click', onClick);
    }
    function onClick(e) {
      if (e.target.closest('[data-cf-ar-close]')) {
        e.preventDefault();
        close();
      }
    }
    modal.addEventListener('click', onClick);

    /* Make sure we're in 3D -- the AR scene is a 3D object. If the
       user clicks AR from the 2D plan view we briefly force a
       build of the 3D version into memory without changing the
       UI view (just so the meshes exist to be exported). */
    var needBuild = false;
    if (STATE.view !== '3d') {
      needBuild = true;
      try {
        if (global.BaseRenderer && global.BaseRenderer._build3D) {
          var poly = getFootprintPolygon();
          if (poly && poly.length >= 3) global.BaseRenderer._build3D(poly);
        }
      } catch (e) { _dbg('[ar] 3D pre-build failed', e); }
    }

    try {
      var glb = await _arExportScene();
      _dbg('[ar] GLB size = ' + (glb.byteLength / 1024).toFixed(1) + ' KB');
      _setArStatus(T.arUploading || 'Uploading to cloud\u2026');

      var info = await _arUpload(glb);
      _dbg('[ar] uploaded uuid=' + info.uuid + ' viewer=' + info.viewerUrl);

      var qrDataUrl = await _arGenerateQR(info.viewerUrl);
      _setArQR(qrDataUrl);
      _setArLink(info.viewerUrl);
      _setArStatus(T.arReady || 'Ready \u2014 scan with your phone');
    } catch (e) {
      console.error('[ar] export failed', e);
      _setArStatus((T.arError || 'AR export failed: ') + (e && e.message ? e.message : e));
    }

    /* If we needed a 3D pre-build for export but the user is back
       in 2D, restore the 2D build so the canvas doesn't show
       stray geometry after the modal closes. */
    if (needBuild && global.BaseRenderer && global.BaseRenderer.build) {
      try { global.BaseRenderer.build(); } catch (_) {}
    }
  }

  /* Build the fence cut list -- one entry per TIMBER part type, each with
     a single representative piece carrying its dimensions + quantity, so
     the PDF draws one outline per part with "N x length" and a width dim.
     Wood variant only; everything follows the live configuration (height,
     spacing, style, mid-rail). Returns [] for non-wood variants. */

  async function exportPdf() {
    var T = (global.BASE_BOOT && global.BASE_BOOT.i18n) || {};
    if (!global.ConfiguratorPdfExporter || !global.ConfiguratorPdfExporter.export) {
      alert(T.pdfLibLoading || 'PDF library not yet loaded \u2014 try again in a moment.');
      return;
    }
    var BOOT = global.BASE_BOOT || {};
    var bridge = global.ConfiguratorBudgetBridge || null;
    var btn = document.getElementById('cf-btn-pdf');

    /* pool-v5-credits: paid in tokens on the shared sheet -> no purchase needed */
    if (!BOOT.hasOwnership && !_pdfPaidNow) {
      var productUrl = '/products/' + (BOOT.productHandle || 'foundations');
      var msg = T.pdfPaywallMsg || 'To download the PDF documentation, please purchase this product first.';
      var ok = window.confirm(msg + '\n\n' + (T.pdfPaywallCta || 'Go to product page?'));
      if (ok) window.location.href = productUrl;
      return;
    }

    if (btn) btn.classList.add('active');

    if (bridge && typeof bridge.isReady === 'function' && !bridge.isReady()) {
      var waited = 0;
      var pollMs = 100;
      var timeoutMs = 5000;
      while (!bridge.isReady() && waited < timeoutMs) {
        await new Promise(function (res) { setTimeout(res, pollMs); });
        waited += pollMs;
      }
      if (!bridge.isReady()) {
        if (btn) btn.classList.remove('active');
        alert(T.pdfWaitingForData || 'Configuration data is still loading. Please wait a moment and try again.');
        return;
      }
    }

    try {
      try { publishBoQToBudget(); } catch (_) {}
      if (typeof global.updateTotal === 'function') {
        try { global.updateTotal(); } catch (_) {}
      }
      await new Promise(function (res) { setTimeout(res, 600); });

      var snapshots = await _captureForPdf();
      var instances = _buildInstancePayload();
      var boqNames  = _buildBoqNamesMap(bridge);
      var boq       = _buildBoq(bridge);
      var totals    = _buildTotals(boq);
      var baseDims  = _buildBaseDimensions();
      var variantName = _variantDisplayName();


      var planSnap  = (snapshots || []).find(function (s) { return s && s.key === 'plan'; });
      var crossSnap = (snapshots || []).find(function (s) { return s && s.key === 'cross-section'; });

      var assemblyPayload = await _buildAssemblyPayload(boq);

      global.ConfiguratorPdfExporter.export({
        productTitle:    (BOOT.productTitle || 'Foundation') + '\n' + (variantName ? variantName.toUpperCase() : ''),
        customerName:    BOOT.customerName || null,
        coverImage:      BOOT.coverImage   || null,
        shareUrl:        _buildShareUrl(),
        totals:          totals,
        baseAssembly:     assemblyPayload,
        basePlan:         planSnap  ? { imageDataUrl: planSnap.imageDataUrl, bottomLeft: planSnap.bottomLeft || null } : null,
        /* Fence layout has no engineering cross-section or cut-list page --
           leaving these out keeps the document at assembly -> plan -> BoQ
           (no blank pages after the plan). */
        baseCrossSection: null,
        baseDims:      baseDims,
        overview:      _buildOverview(),
        instances:     instances,
        boqNames:      boqNames,
        cutList:       [],
        boq:           boq,
        meta: {
          locale:        BOOT.locale         || 'en',
          productHandle: BOOT.productHandle  || 'foundations',
          date:          new Date(),
          variantName:   variantName,
          lvl:           STATE.lvl,
          slope: {
            active: STATE.slopeActive,
            deg:    STATE.slopeDeg
          },
          i18n: {
            pagePlanTitle:           T.pdfPagePlanTitle           || 'Plan view',
            pageCrossSectionTitle:   T.pdfPageCrossSection        || 'Cross-section',
            pageCutListTitle:        T.pdfPageCutListTitle        || 'Cut list',
            pageBoqTitle:            T.pdfPageBoqTitle            || 'Bill of Quantities',
            pageIsoTitle:            T.pdfPageIsoTitle            || '3D visualisation',
            pageOrthosTitle:         T.pdfPageOrthosTitle         || 'Engineering views',
            pageCutListVisualTitle:  T.pdfPageCutListVisualTitle  || 'Cut list \u2014 visual',
            orthoTop:                T.pdfOrthoTop                || 'Top view',
            orthoFront:              T.pdfOrthoFront              || 'Front view',
            orthoSide:               T.pdfOrthoSide               || 'Side view',
            totalsTitle:             T.pdfTotalsTitle             || 'TOTAL',
            materialsLabel:          T.pdfMaterialsLabel          || 'Materials',
            executionLabel:          T.pdfExecutionLabel          || 'Execution',
            grandTotalLabel:         T.pdfGrandTotalLabel         || 'GRAND TOTAL',
            noCutsMessage:           T.pdfNoCutsMessage           || 'No cuttable items for this foundation type.',
            noModelData:             T.pdfNoModelData             || 'No 3D model data available.',
            continued:               T.pdfContinued               || '(continued)',
            pcs:                     T.pdfPcs                     || 'pcs',
            deckingLabel:            T.pdfDeckingLabel            || 'decking',
            slopeLabel:              T.pdfSlopeLabel              || 'Slope',
            lvlLabel:                T.pdfLvlLabel                || 'Reinforcement level',
            lvlNames: {
              1: T.pdfLvl1 || 'Standard',
              2: T.pdfLvl2 || 'Reinforced',
              3: T.pdfLvl3 || 'Robust'
            },
            boq: {
              headerCode:      T.pdfBoqHeaderCode      || 'Code',
              headerName:      T.pdfBoqHeaderName      || 'Description',
              headerQty:       T.pdfBoqHeaderQty       || 'Qty',
              headerUnitPrice: T.pdfBoqHeaderUnitPrice || 'Unit price',
              headerTotal:     T.pdfBoqHeaderTotal     || 'Total',
              grandTotal:      T.pdfBoqGrandTotal      || 'Grand total'
            },
            cutList: {
              headerPart:   T.pdfCutHeaderPart   || 'Part',
              headerDesc:   T.pdfCutHeaderDesc   || 'Description',
              headerLength: T.pdfCutHeaderLength || 'Length',
              headerQty:    T.pdfCutHeaderQty    || 'Qty'
            }
          }
        }
      });
    } catch (e) {
      console.error('[exportPdf]', e);
      alert((T.pdfFailed || 'PDF export failed: ') + (e && e.message ? e.message : 'unknown error'));
    } finally {
      if (btn) btn.classList.remove('active');
    }
  }

  async function _captureForPdf() {
    var T = global.THREE;
    var eng = global.BaseEngine;
    if (!T || !eng || !eng.scene || !eng.renderer) return [];

    var poly = getFootprintPolygon();
    if (!poly || poly.length < 3) return [];

    var prevStage = STATE.vizStage;
    var prevView  = STATE.view;
    var prevSlope = STATE.slopeActive;
    var prevOrthoD = eng._currentOrthoD;
    var prevCamLeft = eng.cameraOrtho ? eng.cameraOrtho.left : null;
    var prevCamRight = eng.cameraOrtho ? eng.cameraOrtho.right : null;
    var prevCamTop = eng.cameraOrtho ? eng.cameraOrtho.top : null;
    var prevCamBottom = eng.cameraOrtho ? eng.cameraOrtho.bottom : null;
    var prevMapZoom = (_MapManager && _MapManager.map) ? _MapManager.map.getZoom() : null;
    var wrap = document.getElementById('cf-wrap-base');
    STATE.vizStage = 1;
    STATE.view = '2d';
    STATE.slopeActive = false;
    STATE._pdfCapture = true;   /* hide undefined zones + the jacuzzi ghost in the export */
    /* Setting STATE.view alone never moved the camera -- toggleView did.
       The export got away with it while the pool booted into 2D: whoever
       had not toggled was already on the ortho camera. Now that a fresh
       load lands in 3D, an export straight after it would render the plan
       page through the perspective camera. */
    if (eng._applyViewCamera) eng._applyViewCamera();
    if (wrap) {
      wrap.classList.add('cf-view-2d');
      wrap.classList.remove('cf-view-3d');
      wrap.classList.add('cf-stage-view');
    }
    /* Deterministic camera framing -- reset the ortho camera to fit
       the polygon with a fixed padding so the export is identical
       for every user regardless of their current pan/zoom state on
       the web. Mapbox follows via _syncMapTo2D so the underlying
       map matches the scene scale. */
    if (eng.fitCameraToFootprint) eng.fitCameraToFootprint();
    if (_MapManager && _MapManager.map && _MapManager._syncMapTo2D) {
      _MapManager._syncMapTo2D(false);
    }
    if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
    if (_VisualizationManager && _VisualizationManager.apply) _VisualizationManager.apply();
    if (_BaseDimensions && _BaseDimensions.refresh) _BaseDimensions.refresh();

    await new Promise(function (res) { setTimeout(res, 600); });

    if (_BaseDimensions && _BaseDimensions.refresh) _BaseDimensions.refresh();

    var threeCanvas = eng.renderer.domElement;
    var mapCanvas = null;
    try {
      var mapEl = document.getElementById('cf-mapbox');
      if (mapEl) {
        var mapboxCanvas = mapEl.querySelector('canvas');
        if (mapboxCanvas) mapCanvas = mapboxCanvas;
      }
    } catch (_) {}

    var wrapRect = wrap ? wrap.getBoundingClientRect() : null;
    var threeRect = threeCanvas.getBoundingClientRect();
    var refRect = wrapRect || threeRect;

    var W_PX = 1600;
    var srcW = refRect.width || 1;
    var srcH = refRect.height || 1;
    var H_PX = Math.round(W_PX * srcH / srcW);
    var scale = W_PX / srcW;

    var tmpCanvas = document.createElement('canvas');
    tmpCanvas.width = W_PX;
    tmpCanvas.height = H_PX;
    var ctx = tmpCanvas.getContext('2d');

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, W_PX, H_PX);

    var mapDrew = false;
    if (mapCanvas) {
      try {
        if (_MapManager && _MapManager.map && _MapManager.map.triggerRepaint) {
          _MapManager.map.triggerRepaint();
        }
        await new Promise(function (res) { setTimeout(res, 250); });
        var mapElRect = mapEl.getBoundingClientRect();
        var mx = (mapElRect.left - refRect.left) * scale;
        var my = (mapElRect.top  - refRect.top)  * scale;
        var mw = mapElRect.width  * scale;
        var mh = mapElRect.height * scale;
        ctx.globalAlpha = 0.7;
        ctx.drawImage(mapCanvas, mx, my, mw, mh);
        ctx.globalAlpha = 1.0;
        mapDrew = true;
      } catch (e) { console.warn('[exportPdf] map composite failed', e); }
    }

    var sceneDrew = false;
    try {
      eng.renderer.render(eng.scene, eng.camera);
      var cx = (threeRect.left - refRect.left) * scale;
      var cy = (threeRect.top  - refRect.top)  * scale;
      var cw = threeRect.width  * scale;
      var ch = threeRect.height * scale;
      ctx.drawImage(threeCanvas, cx, cy, cw, ch);
      sceneDrew = true;
    } catch (e) { console.warn('[exportPdf] scene composite failed', e); }

    var dimLabelData = [];
    try {
      var labels = document.querySelectorAll('.cf-base-dim-label, .cf-dim-chip');
      var labelsVisible = 0;

      var svgEl = document.getElementById('cf-base-dims-svg');
      if (svgEl) {
        try {
          var svgClone = svgEl.cloneNode(true);
          svgClone.style.display = '';
          var svgRect = svgEl.getBoundingClientRect();
          if (svgRect.width && svgRect.height) {
            var svgStr = new XMLSerializer().serializeToString(svgClone);
            var svgBlob = new Blob([svgStr], { type: 'image/svg+xml;charset=utf-8' });
            var svgUrl = URL.createObjectURL(svgBlob);
            var svgImg = new Image();
            await new Promise(function (res) {
              svgImg.onload = function () { res(); };
              svgImg.onerror = function () { res(); };
              svgImg.src = svgUrl;
            });
            var sx2 = (svgRect.left - refRect.left) * scale;
            var sy2 = (svgRect.top  - refRect.top)  * scale;
            var sw2 = svgRect.width  * scale;
            var sh2 = svgRect.height * scale;
            try { ctx.drawImage(svgImg, sx2, sy2, sw2, sh2); } catch (_) {}
            URL.revokeObjectURL(svgUrl);
          }
        } catch (e) { console.warn('[exportPdf] svg dims composite failed', e); }
      }

      /* Collect label positions in source-canvas coords. Drawing
         is deferred until after crop so the font size stays fixed
         in output-canvas pixels (not multiplied by the crop zoom
         ratio). */
      for (var li = 0; li < labels.length; li++) {
        var lel = labels[li];
        var computed = window.getComputedStyle(lel);
        if (computed.display === 'none' || computed.visibility === 'hidden') continue;
        labelsVisible++;
        var lr = lel.getBoundingClientRect();
        if (!lr.width || !lr.height) continue;
        var lcx = ((lr.left + lr.width / 2)  - refRect.left) * scale;
        var lcy = ((lr.top  + lr.height / 2) - refRect.top)  * scale;
        var txt = (lel.textContent || '').trim();
        if (!txt) continue;
        dimLabelData.push({ cx: lcx, cy: lcy, text: txt });
      }
    } catch (e) { console.warn('[exportPdf] labels collect failed', e); }


    var xMin = Infinity, xMax = -Infinity, zMin = Infinity, zMax = -Infinity;
    for (var i = 0; i < poly.length; i++) {
      if (poly[i][0] < xMin) xMin = poly[i][0];
      if (poly[i][0] > xMax) xMax = poly[i][0];
      if (poly[i][1] < zMin) zMin = poly[i][1];
      if (poly[i][1] > zMax) zMax = poly[i][1];
    }
    var bbL = xMax - xMin;
    var bbW = zMax - zMin;

    /* Crop tmpCanvas so the polygon fills ~75% of the cropped area.
       Probe each polygon corner via _worldToScreen to learn the
       polygon's screen bbox, then center the crop on the polygon
       centroid and size it so polygon_w / crop_w == 0.75. Output
       crop matches A4 landscape aspect (1.414) so the PDF page
       maps 1:1 with no further stretching needed. */
    var cropCanvas = tmpCanvas;
    var cropX = 0, cropY = 0, cropW = W_PX, cropH = H_PX;
    try {
      var corners = [
        _worldToScreen(xMin, zMin),
        _worldToScreen(xMax, zMin),
        _worldToScreen(xMax, zMax),
        _worldToScreen(xMin, zMax)
      ];
      var sxMin = Infinity, sxMax = -Infinity, syMin = Infinity, syMax = -Infinity;
      var ok = true;
      for (var ci = 0; ci < corners.length; ci++) {
        if (!corners[ci]) { ok = false; break; }
        var cpx = corners[ci].left * scale;
        var cpy = corners[ci].top  * scale;
        if (cpx < sxMin) sxMin = cpx;
        if (cpx > sxMax) sxMax = cpx;
        if (cpy < syMin) syMin = cpy;
        if (cpy > syMax) syMax = cpy;
      }
      if (ok && isFinite(sxMin) && isFinite(syMin)) {
        var polyW = sxMax - sxMin;
        var polyH = syMax - syMin;
        var polyCx = (sxMin + sxMax) / 2;
        var polyCy = (syMin + syMax) / 2;

        /* Polygon fills 75% of crop along each axis. To preserve
           A4 landscape aspect (1.414), pick crop dimensions that
           satisfy both polyW/cw==0.75 AND polyH/ch==0.75; the
           larger of the two derived crop sizes wins so neither
           axis is over-cropped. */
        /* Camera is now deterministic (forced fitCameraToFootprint
           with PADDING=4m), so this crop pass is mostly a sanity
           clamp. ~15% smaller polygon -> more breathing room around
           it; the crop window is correspondingly wider. */
        var TARGET_FILL = 0.48;
        var PAGE_AR = 297 / 210;
        var cwByX = polyW / TARGET_FILL;
        var cwByY = (polyH / TARGET_FILL) * PAGE_AR;
        var cw = Math.max(cwByX, cwByY);
        var ch = cw / PAGE_AR;

        /* Clamp crop window inside the source canvas so we never
           sample outside the composite (would produce black bands). */
        var cx = polyCx - cw / 2;
        var cy = polyCy - ch / 2;
        if (cx < 0) cx = 0;
        if (cy < 0) cy = 0;
        if (cx + cw > W_PX) cx = W_PX - cw;
        if (cy + ch > H_PX) cy = H_PX - ch;
        if (cw > W_PX) { cw = W_PX; cx = 0; }
        if (ch > H_PX) { ch = H_PX; cy = 0; }

        var OUT_W = 1600;
        var OUT_H = Math.round(OUT_W / PAGE_AR);
        var croppedCanvas = document.createElement('canvas');
        croppedCanvas.width  = OUT_W;
        croppedCanvas.height = OUT_H;
        var cctx = croppedCanvas.getContext('2d');
        cctx.fillStyle = '#ffffff';
        cctx.fillRect(0, 0, OUT_W, OUT_H);
        cctx.drawImage(tmpCanvas, cx, cy, cw, ch, 0, 0, OUT_W, OUT_H);

        cropCanvas = croppedCanvas;
        cropX = cx; cropY = cy; cropW = cw; cropH = ch;
      }
    } catch (e) { console.warn('[exportPdf] crop failed', e); }

    /* Draw dim labels onto the cropped output canvas with a fixed
       font size so they look the same regardless of how aggressive
       the crop was. Also de-collides labels: if any pair would
       overlap, push each one along the axis with more headroom
       (vertical for horizontal-axis dims, horizontal for vertical
       ones). Iterates a few times until stable or capped. */
    try {
      var cctx2 = cropCanvas.getContext('2d');
      var outW = cropCanvas.width;
      var outH = cropCanvas.height;
      var LABEL_FONT_PX = 18;
      var LABEL_PAD_X = 7;
      var LABEL_PAD_Y = 4;

      cctx2.font = '600 ' + LABEL_FONT_PX + 'px Montserrat, sans-serif';
      cctx2.textAlign = 'center';
      cctx2.textBaseline = 'middle';

      /* Project each captured label from source-canvas coords into
         the cropped output coords, measure, and keep the box for
         collision testing. */
      var placed = [];
      for (var di = 0; di < dimLabelData.length; di++) {
        var d = dimLabelData[di];
        var oxLabel = (d.cx - cropX) / cropW * outW;
        var oyLabel = (d.cy - cropY) / cropH * outH;
        if (oxLabel < -50 || oxLabel > outW + 50) continue;
        if (oyLabel < -50 || oyLabel > outH + 50) continue;
        var tw2 = cctx2.measureText(d.text).width;
        var th2 = LABEL_FONT_PX;
        placed.push({
          text: d.text,
          cx: oxLabel, cy: oyLabel,
          w: tw2 + LABEL_PAD_X * 2,
          h: th2 + LABEL_PAD_Y * 2
        });
      }

      /* Simple de-overlap pass: for each colliding pair, nudge the
         later one away from the earlier one along the smaller-cost
         axis. A handful of iterations is enough for typical 4-8
         label scenes. */
      function rectsOverlap(a, b) {
        return Math.abs(a.cx - b.cx) < (a.w + b.w) / 2 - 1 &&
               Math.abs(a.cy - b.cy) < (a.h + b.h) / 2 - 1;
      }
      for (var iter = 0; iter < 8; iter++) {
        var anyMove = false;
        for (var ai = 0; ai < placed.length; ai++) {
          for (var bi = ai + 1; bi < placed.length; bi++) {
            var A = placed[ai], B = placed[bi];
            if (!rectsOverlap(A, B)) continue;
            var dx = B.cx - A.cx;
            var dy = B.cy - A.cy;
            var overlapX = (A.w + B.w) / 2 - Math.abs(dx);
            var overlapY = (A.h + B.h) / 2 - Math.abs(dy);
            if (overlapX < overlapY) {
              var nudge = overlapX / 2 + 1;
              if (dx >= 0) { A.cx -= nudge; B.cx += nudge; }
              else         { A.cx += nudge; B.cx -= nudge; }
            } else {
              var nudgeY = overlapY / 2 + 1;
              if (dy >= 0) { A.cy -= nudgeY; B.cy += nudgeY; }
              else         { A.cy += nudgeY; B.cy -= nudgeY; }
            }
            anyMove = true;
          }
        }
        if (!anyMove) break;
      }

      for (var pi = 0; pi < placed.length; pi++) {
        var P = placed[pi];
        var bx = P.cx - P.w / 2;
        var by = P.cy - P.h / 2;
        cctx2.fillStyle = '#ffffff';
        cctx2.fillRect(bx, by, P.w, P.h);
        cctx2.strokeStyle = '#999';
        cctx2.lineWidth = 0.7;
        cctx2.strokeRect(bx, by, P.w, P.h);
        cctx2.fillStyle = '#1a1a1a';
        cctx2.fillText(P.text, P.cx, P.cy);
      }
    } catch (e) { console.warn('[exportPdf] labels post-crop draw failed', e); }

    var planImg = cropCanvas.toDataURL('image/png');

    var bottomLeft = null;
    try {
      var blScreen = _worldToScreen(xMin, zMax);
      if (blScreen) {
        /* Re-project bottom-left into the cropped image coords.
           The original blScreen is in scaled tmpCanvas space; we
           subtract the crop offset, scale to the output canvas,
           then normalise to 0..1. */
        var blCanvasX = blScreen.left * scale;
        var blCanvasY = blScreen.top  * scale;
        var blCropX = (blCanvasX - cropX) / cropW;
        var blCropY = (blCanvasY - cropY) / cropH;
        var bottomLeftGps = null;
        if (_MapManager && _MapManager.map && mapEl) {
          var mapRect = mapEl.getBoundingClientRect();
          var pixelInMap = [
            (blScreen.left + refRect.left) - mapRect.left,
            (blScreen.top  + refRect.top)  - mapRect.top
          ];
          try {
            var lngLat = _MapManager.map.unproject(pixelInMap);
            if (lngLat) bottomLeftGps = { lng: lngLat.lng, lat: lngLat.lat };
          } catch (e) { console.warn('[exportPdf] unproject failed', e); }
        }
        bottomLeft = {
          worldX: xMin, worldZ: zMax,
          normX: Math.max(0, Math.min(1, blCropX)),
          normY: Math.max(0, Math.min(1, blCropY)),
          gps:   bottomLeftGps
        };
      }
    } catch (e) { console.warn('[exportPdf] bottom-left calc failed', e); }

    STATE.vizStage = prevStage;
    STATE.view = prevView;
    STATE.slopeActive = prevSlope;
    if (eng._applyViewCamera) eng._applyViewCamera();
    STATE._pdfCapture = false;
    if (wrap) {
      wrap.classList.toggle('cf-stage-view', prevStage === 1);
      wrap.classList.toggle('cf-view-2d', prevView === '2d');
      wrap.classList.toggle('cf-view-3d', prevView === '3d');
    }
    /* Restore the user's previous camera framing so the configurator
       looks the same as before the export. Without this, the user
       would end up with the PDF camera fit after every download. */
    if (eng.cameraOrtho && prevCamLeft !== null) {
      eng.cameraOrtho.left   = prevCamLeft;
      eng.cameraOrtho.right  = prevCamRight;
      eng.cameraOrtho.top    = prevCamTop;
      eng.cameraOrtho.bottom = prevCamBottom;
      eng.cameraOrtho.updateProjectionMatrix();
      eng._currentOrthoD = prevOrthoD;
    }
    if (_MapManager && _MapManager.map && prevMapZoom !== null) {
      try { _MapManager.map.setZoom(prevMapZoom); } catch (_) {}
    }
    if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
    if (_VisualizationManager && _VisualizationManager.apply) _VisualizationManager.apply();

    var crossImg = _renderCrossSectionSVG(bbL);

    return [
      {
        key: 'plan',
        label: '',
        imageDataUrl: planImg,
        worldW: bbL, worldH: bbW,
        aspect: W_PX / H_PX,
        bottomLeft: bottomLeft
      },
      {
        key: 'cross-section',
        label: '',
        imageDataUrl: crossImg,
        worldW: bbL, worldH: 2,
        aspect: bbL / 2
      }
    ];
  }

  function _renderCrossSectionSVG(bbL) {
    var d = getVariantDefaults(variantKey(), STATE.lvl);
    var vk = variantKey();
    var slopeRad = STATE.slopeActive && STATE.slopeDeg > 0 ? STATE.slopeDeg * Math.PI / 180 : 0;
    var maxDelta = bbL * Math.tan(slopeRad);
    var TT = (global.BASE_BOOT && global.BASE_BOOT.i18n) || {};

    var L = {
      concreteSlab:    TT.csLabelConcreteSlab    || 'Concrete slab',
      gravel:          TT.csLabelGravel          || 'Gravel',
      mesh:            TT.csLabelMesh            || 'Mesh',
      topSlab:         TT.csLabelTopSlab         || 'Top slab',
      strip:           TT.csLabelStrip           || 'Strip',
      concretePiers:   TT.csLabelConcretePiers   || 'Concrete piers',
      precastBlocks:   TT.csLabelPrecastBlocks   || 'Precast pier blocks',
      groundScrews:    TT.csLabelGroundScrews    || 'Ground screws',
      groundLevel:     TT.csLabelGroundLevel     || 'Ground level',
      slope:           TT.csLabelSlope           || 'Slope',
      slopeOver:       TT.csLabelSlopeOver       || 'over'
    };

    var W = 1400, H = 700;
    var marginX = 80, marginY = 80;
    var drawW = W - 2 * marginX;
    var drawH = H - 2 * marginY;

    var groundY = marginY + drawH * 0.30;
    var foundTopY = groundY + 10;

    var s = drawW / bbL;
    var leftX = marginX, rightX = marginX + drawW;

    var svg = ['<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + W + ' ' + H + '" width="' + W + '" height="' + H + '">'];
    svg.push('<rect width="' + W + '" height="' + H + '" fill="#ffffff"/>');

    var terrainRight = groundY;
    var terrainLeft = groundY - maxDelta * s;
    svg.push('<polygon points="' +
      leftX + ',' + terrainLeft + ' ' +
      rightX + ',' + terrainRight + ' ' +
      rightX + ',' + H + ' ' +
      leftX + ',' + H +
      '" fill="#e8d4b8" stroke="#b39570" stroke-width="1.5"/>');

    svg.push('<line x1="' + leftX + '" y1="' + terrainLeft + '" x2="' + rightX + '" y2="' + terrainRight + '" stroke="#8a6e4a" stroke-width="2" stroke-dasharray="6,4"/>');

    if (vk === 'slab') {
      var slabH = d.slabThicknessM * 50;
      var gravelH = d.gravelDepthM * 50;
      svg.push('<rect x="' + (leftX + 20) + '" y="' + foundTopY + '" width="' + (drawW - 40) + '" height="' + slabH + '" fill="#a8a8a8" stroke="#222" stroke-width="1.5"/>');
      svg.push('<text x="' + (leftX + 30) + '" y="' + (foundTopY + slabH / 2 + 4) + '" font-family="sans-serif" font-size="11" fill="#000">' + L.concreteSlab + ' ' + (d.slabThicknessM * 1000) + ' mm</text>');
      svg.push('<rect x="' + (leftX + 20) + '" y="' + (foundTopY + slabH) + '" width="' + (drawW - 40) + '" height="' + gravelH + '" fill="#c7b9a3" stroke="#7a6b50" stroke-width="1"/>');
      svg.push('<text x="' + (leftX + 30) + '" y="' + (foundTopY + slabH + gravelH / 2 + 4) + '" font-family="sans-serif" font-size="10" fill="#333">' + L.gravel + ' ' + (d.gravelDepthM * 1000) + ' mm</text>');
      svg.push('<line x1="' + (leftX + 20) + '" y1="' + (foundTopY + slabH * 0.5) + '" x2="' + (rightX - 20) + '" y2="' + (foundTopY + slabH * 0.5) + '" stroke="#2266cc" stroke-width="2" stroke-dasharray="3,3"/>');
      svg.push('<text x="' + (rightX - 130) + '" y="' + (foundTopY + slabH * 0.5 - 4) + '" font-family="sans-serif" font-size="9" fill="#2266cc">' + L.mesh + ' ' + POOL_CODES.mesh8 + '</text>');
    } else if (vk === 'strip') {
      var slabH2 = d.slabThicknessM * 50;
      var stripH = d.stripDepthM * 50;
      var stripW = d.stripWidthM * s * 1.5;
      svg.push('<rect x="' + (leftX + 20) + '" y="' + foundTopY + '" width="' + (drawW - 40) + '" height="' + slabH2 + '" fill="#a8a8a8" stroke="#222" stroke-width="1.5"/>');
      svg.push('<text x="' + (leftX + 30) + '" y="' + (foundTopY + slabH2 / 2 + 4) + '" font-family="sans-serif" font-size="11" fill="#000">' + L.topSlab + ' ' + (d.slabThicknessM * 1000) + ' mm</text>');
      svg.push('<rect x="' + (leftX + 30) + '" y="' + (foundTopY + slabH2) + '" width="' + stripW + '" height="' + stripH + '" fill="#888" stroke="#222" stroke-width="1.5"/>');
      svg.push('<rect x="' + (rightX - 30 - stripW) + '" y="' + (foundTopY + slabH2) + '" width="' + stripW + '" height="' + stripH + '" fill="#888" stroke="#222" stroke-width="1.5"/>');
      svg.push('<text x="' + (leftX + 30) + '" y="' + (foundTopY + slabH2 + stripH + 18) + '" font-family="sans-serif" font-size="11" fill="#000">' + L.strip + ' ' + (d.stripWidthM * 1000) + '\u00d7' + (d.stripDepthM * 1000) + ' mm</text>');
    } else if (vk === 'piers') {
      var pierH = d.pierDepthM * 50;
      var pierW = d.pierSideM * s * 1.5;
      var pierSpacing = d.pierSpacingM * s;
      var nPiers = Math.floor(drawW / pierSpacing) + 1;
      for (var pi = 0; pi < nPiers; pi++) {
        var px = leftX + 20 + pi * pierSpacing;
        if (px + pierW > rightX - 20) break;
        var extra = slopeRad > 0 ? ((nPiers - 1 - pi) * pierSpacing / s) * Math.tan(slopeRad) * 50 : 0;
        svg.push('<rect x="' + px + '" y="' + foundTopY + '" width="' + pierW + '" height="' + (pierH + extra) + '" fill="#888" stroke="#222" stroke-width="1.5"/>');
      }
      svg.push('<text x="' + (leftX + 20) + '" y="' + (foundTopY + pierH + 30) + '" font-family="sans-serif" font-size="11" fill="#000">' + L.concretePiers + ' ' + (d.pierSideM * 1000) + '\u00d7' + (d.pierSideM * 1000) + '\u00d7' + (d.pierDepthM * 1000) + ' mm @ ' + (d.pierSpacingM * 1000) + ' mm</text>');
    } else if (vk === 'precast') {
      var blockH = d.blockHeightM * 50;
      var blockW = d.blockBaseM * s * 1.5;
      var blockTopW = d.blockTopM * s * 1.5;
      var bSpacing = d.blockSpacingM * s;
      var nBlocks = Math.floor(drawW / bSpacing) + 1;
      for (var bi = 0; bi < nBlocks; bi++) {
        var bx = leftX + 20 + bi * bSpacing;
        if (bx + blockW > rightX - 20) break;
        var extra2 = slopeRad > 0 ? ((nBlocks - 1 - bi) * bSpacing / s) * Math.tan(slopeRad) * 50 : 0;
        var bTopY = foundTopY;
        var bBotY = bTopY + blockH + extra2;
        svg.push('<polygon points="' +
          (bx + (blockW - blockTopW) / 2) + ',' + bTopY + ' ' +
          (bx + (blockW + blockTopW) / 2) + ',' + bTopY + ' ' +
          (bx + blockW) + ',' + bBotY + ' ' +
          bx + ',' + bBotY +
          '" fill="#999" stroke="#222" stroke-width="1.5"/>');
      }
      svg.push('<text x="' + (leftX + 20) + '" y="' + (foundTopY + blockH + 30) + '" font-family="sans-serif" font-size="11" fill="#000">' + L.precastBlocks + ' ' + (d.blockBaseM * 1000) + '/' + (d.blockTopM * 1000) + '\u00d7' + (d.blockHeightM * 1000) + ' mm @ ' + (d.blockSpacingM * 1000) + ' mm</text>');
    } else if (vk === 'screws') {
      var screwH = d.screwLenM * 50;
      var screwSpacing = d.screwSpacingM * s;
      var nScrews = Math.floor(drawW / screwSpacing) + 1;
      for (var si = 0; si < nScrews; si++) {
        var sx = leftX + 20 + si * screwSpacing;
        if (sx > rightX - 20) break;
        svg.push('<rect x="' + (sx - 4) + '" y="' + foundTopY + '" width="8" height="' + screwH + '" fill="#444" stroke="#111" stroke-width="1"/>');
        svg.push('<rect x="' + (sx - 8) + '" y="' + (foundTopY - 6) + '" width="16" height="8" fill="#222" stroke="#111" stroke-width="1"/>');
      }
      svg.push('<text x="' + (leftX + 20) + '" y="' + (foundTopY + screwH + 24) + '" font-family="sans-serif" font-size="11" fill="#000">' + L.groundScrews + ' \u00d8' + (d.screwDiameterMm || 76) + ' \u00d7 ' + (d.screwLenM * 1000) + ' mm @ ' + (d.screwSpacingM * 1000) + ' mm</text>');
    }

    svg.push('<text x="' + leftX + '" y="' + (groundY - 12) + '" font-family="sans-serif" font-size="12" fill="#5a4a30" font-weight="700">' + L.groundLevel + '</text>');

    if (slopeRad > 0) {
      svg.push('<text x="' + (rightX - 220) + '" y="' + (terrainRight - 8) + '" font-family="sans-serif" font-size="11" fill="#8a6e4a">' + L.slope + ' ' + STATE.slopeDeg + '\u00b0 (\u0394 ' + (maxDelta * 1000).toFixed(0) + ' mm ' + L.slopeOver + ' ' + bbL.toFixed(1) + ' m)</text>');
    }

    svg.push('</svg>');
    return 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg.join(''))));
  }

  function _buildInstancePayload() {
    var poly = getFootprintPolygon();
    var bb = getBBox();
    return {
      polygon:    poly,
      bboxL:      bb.L,
      bboxW:      bb.W,
      area:       computeArea(),
      perimeter:  computePerimeter(),
      variant:    STATE.variant,
      variantKey: variantKey(),
      lvl:        STATE.lvl,
      slope:      { active: STATE.slopeActive, deg: STATE.slopeDeg },
      isMetric:   STATE.isMetric
    };
  }

  function _buildBoqNamesMap(bridge) {
    var rows = computeBoQ();
    var out = {};
    for (var i = 0; i < rows.length; i++) {
      var code = rows[i][0];
      if (!code) continue;
      var item = bridge && bridge.getBoqItem ? bridge.getBoqItem(code) : null;
      out[code] = (item && item.name) || code;
    }
    return out;
  }

  /* Assembly payload removed with the wood-fence assembly stepper.
     Returns an empty list so the PDF / share pipeline keeps working. */
  function _buildAssemblyPayload(boqRows) {
    return Promise.resolve([]);
  }

  function _buildBoq(bridge) {
    var rows = computeBoQ();
    var out = [];
    for (var i = 0; i < rows.length; i++) {
      var code = rows[i][0];
      var qtyMetric = rows[i][1];
      if (qtyMetric == null) continue;
      var item = bridge && bridge.getBoqItem ? bridge.getBoqItem(code) : null;
      var localUnit = item ? (STATE.isMetric ? item.unitMetric : item.unitImperial) : null;
      var displayQty = STATE.isMetric ? qtyMetric : (rows[i][2] != null ? rows[i][2] : qtyMetric);
      var userPrice = bridge && bridge.getUserPrice ? bridge.getUserPrice(code) : null;
      var unitPrice = userPrice && typeof userPrice.price === 'number' ? userPrice.price : null;
      var total = (unitPrice != null) ? unitPrice * displayQty : null;
      out.push({
        code:      code,
        name:      (item && item.name) || code,
        qty:       displayQty,
        unit:      localUnit || (STATE.isMetric ? 'pcs' : 'pcs'),
        unitPrice: unitPrice,
        total:     total
      });
    }
    return out;
  }

  function _buildTotals(boqRows) {
    function $idText(id) {
      var el = document.getElementById(id);
      if (!el || !el.textContent) return '';
      var t = el.textContent.trim();
      if (!t || t === '\u2014' || t === '-') return '';
      return t;
    }
    function $domText(selector) {
      var el = document.querySelector(selector);
      if (!el || !el.textContent) return '';
      var t = el.textContent.trim();
      if (!t || t === '\u2014' || t === '-') return '';
      return t;
    }
    var fmtPrice = (typeof global.formatPrice === 'function')
      ? global.formatPrice
      : function (n) { return Math.round(+n || 0).toLocaleString() + ' ' +
            ((global.Shopify && global.Shopify.currency && global.Shopify.currency.active) || 'USD'); };

    var totalText    = $idText('cf-bw-total');
    var materialText = $idText('cf-bw-material');
    var execText     = $idText('cf-bw-execution');
    var timeText     = $idText('cf-bw-time');
    var capacityText = $idText('cf-bw-capacity');

    if (!totalText)    totalText    = $domText('[data-budget-total-cost]');
    if (!materialText) materialText = $domText('[data-budget-total-material]');
    if (!execText)     execText     = $domText('[data-budget-total-execution]');
    if (!timeText)     timeText     = $domText('[data-budget-total-time]');

    if (!materialText && typeof global.lastMaterialsTotal === 'number') {
      materialText = fmtPrice(global.lastMaterialsTotal);
    }
    if (!execText && typeof global.lastDeliveryTotal === 'number') {
      execText = fmtPrice(global.lastDeliveryTotal);
    }
    if (!totalText) {
      var mNum = (typeof global.lastMaterialsTotal === 'number') ? global.lastMaterialsTotal : 0;
      var eNum = (typeof global.lastDeliveryTotal  === 'number') ? global.lastDeliveryTotal  : 0;
      if (mNum || eNum) totalText = fmtPrice(mNum + eNum);
    }
    if (!timeText && typeof global.lastDurationTotal === 'number') {
      var mins = global.lastDurationTotal;
      timeText = (mins >= 60)
        ? (Math.round(mins / 60 * 10) / 10) + ' h'
        : Math.round(mins) + ' min';
    }

    if (!materialText) {
      var matSum = 0;
      if (Array.isArray(boqRows)) {
        boqRows.forEach(function (r) { if (r.total != null) matSum += r.total; });
      }
      if (matSum) materialText = fmtPrice(matSum);
    }
    if (!totalText && materialText) totalText = materialText;

    if (!capacityText) {
      try {
        /* boqRows[].qty is ALREADY in the display unit (m^3 metric / yd^3 imperial,
           excavation is pushed via _rowYd3) -- so DO NOT reconvert here. */
        var excavQty = 0;
        if (Array.isArray(boqRows)) {
          for (var i = 0; i < boqRows.length; i++) {
            var c2 = boqRows[i].code;
            if (c2 === 'PEE00001' || c2 === 'PEE00002') excavQty += (boqRows[i].qty || 0);
          }
        }
        if (excavQty) {
          capacityText = excavQty.toFixed(1) + (STATE.isMetric ? ' m\u00b3' : ' yd\u00b3');
        }
      } catch (e) {}
    }

    return {
      texts: {
        total:    totalText    || '',
        material: materialText || '',
        execution: execText    || '',
        time:     timeText     || '',
        capacity: capacityText || ''
      },
      materials: { count: 0, value: 0 },
      execution: { count: 0, value: 0, hours: 0 },
      total:     0,
      area:      computeArea(),
      perimeter: computePerimeter(),
      currency:  (global.Shopify && global.Shopify.currency && global.Shopify.currency.active) || 'USD'
    };
  }

  function _buildBaseDimensions() {
    var poly = getFootprintPolygon();
    var bb = getBBox();
    var edges = [];
    for (var i = 0; i < poly.length; i++) {
      var a = poly[i], b = poly[(i + 1) % poly.length];
      var dx = b[0] - a[0], dz = b[1] - a[1];
      edges.push({
        index: i,
        a: { x: a[0], z: a[1] },
        b: { x: b[0], z: b[1] },
        length: Math.sqrt(dx * dx + dz * dz)
      });
    }
    return {
      vertices: poly.map(function (p) { return { x: p[0], z: p[1] }; }),
      edges:    edges,
      bboxL:    bb.L,
      bboxW:    bb.W
    };
  }

  function _buildOverview() {
    var T = (global.BASE_BOOT && global.BASE_BOOT.i18n) || {};
    function txt(id) {
      var el = document.getElementById(id);
      var t = el ? (el.textContent || '').trim() : '';
      return (t && t !== '\u2014' && t !== '-') ? t : '';
    }
    function join(idVal, idUnit) {
      var v = txt(idVal); if (!v) return '';
      var u = idUnit ? txt(idUnit) : '';
      return u ? (v + ' ' + u) : v;
    }
    var rows = [];
    function push(label, val) { if (val) rows.push([label, val]); }

    push(T.base_area         || 'Area',     join('cf-stat-area',  'cf-stat-area-unit'));
    push(T.volume || 'Volume',   join('cf-stat-count', 'cf-stat-count-unit'));
    push(T.pool_edge_label   || 'Water edge', txt('cf-stat-edge-name'));
    push(T.depth        || 'Depth',    txt('cf-stat-height'));   /* unit folded into the value */
    push(T.pool_surface_label || 'Surface', txt('cf-stat-surface-name'));
    var blk = txt('cf-stat-blocks');
    if (blk) push(T.blocks || 'Blocks', blk + ' ' + (T.pcs || 'pcs'));
    push(T.pool_material_label || 'Material', txt('cf-stat-material-name'));
    return rows;
  }

  function _buildShareUrl() {
    var boot = global.BASE_BOOT || {};
    var handle = boot.productHandle || 'foundations';
    var origin = (location && location.origin) || '';
    var url = origin + '/products/' + handle;
    if (boot.variants && boot.variants.length && STATE.variant) {
      var v = boot.variants[STATE.variant - 1];
      if (v && v.id) url += '?variant=' + v.id;
    }
    return url;
  }

  function _variantDisplayName() {
    var boot = global.BASE_BOOT || {};
    var T = boot.i18n || {};
    var key = 'pool_v' + STATE.variant;
    return T[key] || variantKey();
  }

/* ===== ZONE A -- replace from here to the END of the file ============ */

  /* -------------------------------------------------------------------------
     WHAT THIS PROJECT IS, FOR THE ASSISTANT.

     A POOL IS NOT A BUILDING, and the block that describes it was written
     against a house. Asked for a roof, storeys and a foundation it would have
     answered undefined three times and the assistant would have repeated it,
     so none of them are declared here. What a pool has instead - how much
     water, how deep, what the walls are made of, how the water leaves at the
     edge and what the inside is finished in - goes in as the product's own
     sentences.

     Every figure is _poolGeometry's, which is what the bill of quantities is
     built from. Nothing is measured twice, so the assistant and the budget
     cannot disagree.
     ------------------------------------------------------------------------- */
  var POOL_SURFACE_NAMES = {
    liner: 'liner', plaster: 'plaster', tiles: 'tiles',
    pebble: 'pebble finish', inox: 'stainless steel'
  };
  var POOL_EDGE_NAMES = {
    skimmer: 'skimmer - the water sits about 150 mm below the coping and leaves through wall skimmers',
    overflow: 'overflow - the water stands level with the coping and runs into a perimeter channel and a balancing tank',
    infinite: 'vanishing edge - the chosen edges spill over a knife edge into an open gutter, the rest behave as a skimmer pool'
  };
  var POOL_STAIRS_NAMES = {
    none: 'none', ladder: 'a ladder', corner1: 'a short corner stair',
    corner2: 'a long corner stair', full: 'steps along a whole edge'
  };

  function _factPolyBox() {
    var P = STATE.polygon || [], i;
    if (P.length < 3) return null;
    var x0 = P[0][0], x1 = P[0][0], z0 = P[0][1], z1 = P[0][1];
    for (i = 1; i < P.length; i++) {
      x0 = Math.min(x0, P[i][0]); x1 = Math.max(x1, P[i][0]);
      z0 = Math.min(z0, P[i][1]); z1 = Math.max(z1, P[i][1]);
    }
    return { w: Math.round((x1 - x0) * 100) / 100, l: Math.round((z1 - z0) * 100) / 100, corners: P.length };
  }

  function _factName(map, key, fallback) {
    return map[key] || fallback || String(key || '');
  }

  function poolFacts() {
    var S = STATE, g = null, box = _factPolyBox();
    try { g = _poolGeometry(); } catch (e) { g = null; }
    var depth = 0;
    try { depth = getCurrentDepth(); } catch (e) { depth = 0; }
    var range = null;
    try { range = getCurrentDepthRange(); } catch (e) { range = null; }
    var vKey = '';
    try { vKey = variantKey(); } catch (e) { vKey = ''; }
    var vName = POOL_VARIANT_FALLBACK_NAMES[S.variant - 1] || 'pool';

    var water = g ? Math.round((g.waterVol || 0) * 10) / 10 : 0;
    var surfA = g ? Math.round((g.Ain || 0) * 10) / 10 : 0;

    var extra = [];
    extra.push('this project is a swimming pool, not a building: there is no roof, no storeys and no rooms, and it is measured in water rather than in floor area.');
    extra.push('water volume ' + water + ' cubic metres, water surface ' + surfA
      + ' square metres, basin depth ' + (Math.round(depth * 100) / 100) + ' metres'
      + (range ? (' - the depth can be set between ' + (Math.round(range.min * 100) / 100)
        + ' and ' + (Math.round(range.max * 100) / 100) + ' metres') : '') + '.');
    if (box){
      extra.push('the basin is a ' + box.corners + ' cornered shape, ' + box.w + ' by ' + box.l
        + ' metres over its widest points, and every corner can be dragged - it is not limited to a rectangle.');
    }
    extra.push('built as ' + vName + (vKey ? (' (' + vKey + ')') : '')
      + (vKey === 'concrete_block' ? (', walls of ' + (S.wallMaterial === 'eps' ? 'EPS lost formwork with a concrete core' : 'concrete formwork blocks filled with concrete')) : '')
      + '. The wall system is what the wall items in the budget are for.');
    extra.push('the water edge is ' + _factName(POOL_EDGE_NAMES, S.edgeType, S.edgeType)
      + '. This is the single biggest decision in a pool budget: an overflow or vanishing edge adds a channel, a balancing tank and more pipework than a skimmer pool.');
    extra.push('the inside is finished in ' + _factName(POOL_SURFACE_NAMES, S.surface, S.surface)
      + '. The finishes on offer are ' + SURFACES.join(', ') + '.');
    extra.push('stairs into the water: ' + _factName(POOL_STAIRS_NAMES, S.stairsMode, S.stairsMode) + '.');
    extra.push('underwater lights: ' + (S.lightStage ? ('density stage ' + S.lightStage + ' of 5') : 'none') + '.');
    if (g && g.excavVol){
      extra.push('the hole to be dug is about ' + Math.round(g.excavVol) + ' cubic metres, and the coping runs '
        + Math.round((g.copingLen || 0) * 10) / 10 + ' metres round the edge.');
    }
    if (S.slopeActive){
      extra.push('the ground slopes ' + (Math.round((S.slopeDeg || 0) * 10) / 10) + ' degrees across the site, which the excavation and the walls have to take up.');
    }

    return {
      product: 'pool',
      version: VERSION,
      units: S.isMetric ? 'metric' : 'imperial',
      width: box ? box.w : 0,
      length: box ? box.l : 0,
      footprintArea: surfA,
      extra: extra,
      site: { address: String(S.address || '') },
      changeable: [
        'the shape of the basin - every corner of the outline can be dragged, and corners can be added',
        'the depth, within the range stated above',
        'the wall system - block or gunite, and for block walls concrete formwork or EPS',
        'how the water leaves at the edge - skimmer, overflow, or a vanishing edge on chosen sides',
        'the inside finish, from the five listed above',
        'stairs into the water, and where they sit',
        'underwater lights and how many',
        'where the technology shaft, the balancing tank and the electrical panel stand',
        'where the skimmers, the jets and the return fittings sit',
        'the slope of the ground the pool is dug into',
        'metric or imperial display'
      ],
      fixed: [
        'a roof, storeys, rooms or a floor area - this is a pool, and none of those exist on it',
        'the pool being anything other than dug into the ground - there is no above ground or partly raised option here',
        'indoor pools, pool houses and enclosures - the configurator builds the pool itself',
        'heating, covers and heat pumps are not part of this configurator, so never present them as options that can be switched on'
      ]
    };
  }

  global.BaseLib = {
    __version:        VERSION,
    /* WHAT THIS PROJECT IS. Read by the AI drawer, which asks every lib for
       facts() and otherwise guesses at STATE - and STATE is shaped like a
       house, so on a pool it would guess wrongly. */
    facts:            poolFacts,
    exportPdf:        exportPdf,
    STATE:            STATE,
    DEFAULTS:         DEFAULTS,
    VARIANT_DEFAULTS: VARIANT_DEFAULTS,
    boot:             boot,
    refreshUI:        refreshUI,
    reset:            reset,
    undo:             undo,
    cycleLvl:         cycleLvl,
    UndoHistory:      _UndoHistory,
    toggleUnits:      toggleUnits,
    toggleView:       toggleView,
    selectVariant:    selectVariant,
    nextVariant:      nextVariant,
    prevVariant:      prevVariant,
    setPoolDepth:     setPoolDepth,
    getCurrentDepth:  getCurrentDepth,
    getBlockCount:    getBlockCount,
    getStairsMode:    getStairsMode,
    getStairsPlacements: getStairsPlacements,
    cycleStairsType:  cycleStairsType,
    cycleStairsPlacement: cycleStairsPlacement,
    getCurrentDepthRange: getCurrentDepthRange,
    getEdgeType:      getEdgeType,
    setEdgeType:      setEdgeType,
    toggleEdgeType:   toggleEdgeType,
    getInfiniteEdges: getInfiniteEdges,
    setInfiniteEdges: setInfiniteEdges,
    toggleInfiniteEdge: toggleInfiniteEdge,
    isInfiniteEdge:   isInfiniteEdge,
    getCurrentHeight: getCurrentHeight,
    openBudgetDrawer: openBudgetDrawer,
    share:            share,
    shareConfig:      shareConfig,
    applyConfigId:    applyConfigId,
    publishBoQToBudget: publishBoQToBudget,
    computeBoQ:       computeBoQ,
    computePiping:    computePiping,
    getSkimmerPositions: getSkimmerPositions,
    getJetPositions:  getJetPositions,
    getDrainPositions: getDrainPositions,
    getOverflowCollectorPositions: getOverflowCollectorPositions,
    getCopingTiles:   _copingTiles,
    getLightPositions: getLightPositions,
    cycleLightStage:  cycleLightStage,
    getPanelPos:      getPanelPos,
    computeWiring:    computeWiring,
    computeValveWiring: computeValveWiring,
    getShaftPos:      getShaftPos,
    getShaftSize:     getShaftSize,
    getShaftDimensions: getShaftDimensions,
    getTankPos:       getTankPos,
    setTankPos:       setTankPos,
    getTankSize:      getTankSize,
    getTankDimensions: getTankDimensions,
    getWallMaterial:  getWallMaterial,
    setWallMaterial:  setWallMaterial,
    cycleWallMaterial: cycleWallMaterial,
    getSurface:       getSurface,
    setSurface:       setSurface,
    cycleSurface:     cycleSurface,
    getFootprintPolygon: getFootprintPolygon,
    computeArea:      computeArea,
    computePerimeter: computePerimeter,
    VisualizationManager: _VisualizationManager,
    CornerInserter:   _CornerInserter,
    AssetDrawer:      _AssetDrawer,
    ProjectStore:     _ProjectStore
  };

  /* Public alias -- pool configurator uses the same engine as base.
     Other code (status registry, AR worker calls, share generation,
     BoQ pipeline) keys on window.BaseLib so we keep that name as the
     primary export. PoolLib is an additional alias so future
     pool-specific extensions have a clean namespace. */
  global.PoolLib = global.BaseLib;

})(window);